{
  "level": "mt02a",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt02a",
    "objects": "AREAS.E3:mt02a.e3",
    "mesh": "TREES.E3:mt02a.e3"
  },
  "spawn_point": {
    "position": [
      -1400.972873182182,
      -3948.98699975684,
      669.0438232421875
    ],
    "facing_rad": 0.0,
    "look_point": [
      -1400.972873182182,
      -3848.98699975684,
      669.0438232421875
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -1540.0,
      -4050.52392578125,
      645.0438232421875
    ],
    "bbox_max": [
      -772.5545043945312,
      -3838.2373046875,
      1299.46826171875
    ],
    "vertex_count": 1743,
    "vertices": [
      [
        -1356.8096923828125,
        -3905.25341796875,
        723.5
      ],
      [
        -1341.7567138671875,
        -3882.839111328125,
        723.5
      ],
      [
        -1356.8096923828125,
        -3905.25341796875,
        723.5
      ],
      [
        -1349.5,
        -3905.25341796875,
        712.8184204101562
      ],
      [
        -1355.482421875,
        -3900.219970703125,
        726.5
      ],
      [
        -1341.307861328125,
        -3879.11376953125,
        726.5
      ],
      [
        -1355.482421875,
        -3900.219970703125,
        726.5
      ],
      [
        -1353.429443359375,
        -3900.219970703125,
        723.5
      ],
      [
        -1379.059326171875,
        -3932.46435546875,
        737.7821044921875
      ],
      [
        -1389.2474365234375,
        -3902.121826171875,
        773.974365234375
      ],
      [
        -1379.059326171875,
        -3932.46435546875,
        737.7821044921875
      ],
      [
        -1378.423095703125,
        -3934.359375,
        726.5194091796875
      ],
      [
        -1367.848388671875,
        -3865.263427734375,
        745.92578125
      ],
      [
        -1370.0491943359375,
        -3868.984619140625,
        753.1341552734375
      ],
      [
        -1354.001220703125,
        -3869.74658203125,
        723.5
      ],
      [
        -1345.7213134765625,
        -3888.742431640625,
        723.5
      ],
      [
        -1354.001220703125,
        -3869.74658203125,
        723.5
      ],
      [
        -1349.5,
        -3869.74658203125,
        715.0126953125
      ],
      [
        -1353.2979736328125,
        -3875.010009765625,
        726.5
      ],
      [
        -1347.494140625,
        -3888.3251953125,
        726.5
      ],
      [
        -1353.298095703125,
        -3875.010009765625,
        726.5
      ],
      [
        -1351.70703125,
        -3875.010009765625,
        723.5
      ],
      [
        -1370.5,
        -3905.25341796875,
        721.4589233398438
      ],
      [
        -1381.0,
        -3887.5,
        719.1031494140625
      ],
      [
        -1370.5,
        -3869.74658203125,
        718.9722290039062
      ],
      [
        -1350.794677734375,
        -3869.74658203125,
        717.4539184570312
      ],
      [
        -1368.1795654296875,
        -3869.74658203125,
        719.2180786132812
      ],
      [
        -1354.7117919921875,
        -3905.25341796875,
        720.4343872070312
      ],
      [
        -1370.5,
        -3905.25341796875,
        721.4589233398438
      ],
      [
        -1367.71533203125,
        -3905.25341796875,
        721.75390625
      ],
      [
        -1378.0849609375,
        -3935.366455078125,
        720.534423828125
      ],
      [
        -1378.0849609375,
        -3935.366455078125,
        720.534423828125
      ],
      [
        -1378.208740234375,
        -3934.997802734375,
        722.725341796875
      ],
      [
        -1378.6341552734375,
        -3883.5,
        719.1171264648438
      ],
      [
        -1389.3924560546875,
        -3901.68994140625,
        719.260498046875
      ],
      [
        -1374.782470703125,
        -3898.0126953125,
        720.4981079101562
      ],
      [
        -1381.0,
        -3887.5,
        719.1486206054688
      ],
      [
        -1370.5,
        -3869.74658203125,
        719.0086669921875
      ],
      [
        -1368.3123779296875,
        -3869.74658203125,
        719.2315673828125
      ],
      [
        -1370.5,
        -3905.25341796875,
        722.0364990234375
      ],
      [
        -1381.0,
        -3887.5,
        721.810546875
      ],
      [
        -1378.6341552734375,
        -3883.5,
        719.1171264648438
      ],
      [
        -1372.72412109375,
        -3873.50732421875,
        719.9528198242188
      ],
      [
        -1370.5,
        -3869.74658203125,
        719.4535522460938
      ],
      [
        -1370.5,
        -3905.25341796875,
        722.0364990234375
      ],
      [
        -1378.33544921875,
        -3934.620361328125,
        724.9678955078125
      ],
      [
        -1366.89794921875,
        -3863.656494140625,
        742.0647583007812
      ],
      [
        -1367.848388671875,
        -3865.263427734375,
        745.92578125
      ],
      [
        -1366.89794921875,
        -3863.656494140625,
        742.0647583007812
      ],
      [
        -1361.0213623046875,
        -3853.72021484375,
        721.6495361328125
      ],
      [
        -1355.2010498046875,
        -3869.74658203125,
        723.5
      ],
      [
        -1347.458251953125,
        -3884.757568359375,
        723.5
      ],
      [
        -1355.2010498046875,
        -3869.74658203125,
        723.5
      ],
      [
        -1352.494140625,
        -3869.74658203125,
        717.6263427734375
      ],
      [
        -1353.8685302734375,
        -3875.010009765625,
        726.5
      ],
      [
        -1350.1864013671875,
        -3882.148681640625,
        726.5
      ],
      [
        -1353.86865234375,
        -3875.010009765625,
        726.5
      ],
      [
        -1352.4862060546875,
        -3875.010009765625,
        723.5
      ],
      [
        -1361.0213623046875,
        -3853.72021484375,
        721.6495361328125
      ],
      [
        -1361.813232421875,
        -3855.05908203125,
        721.40869140625
      ],
      [
        -1370.5,
        -3869.74658203125,
        719.816162109375
      ],
      [
        -1352.72509765625,
        -3869.74658203125,
        718.1275634765625
      ],
      [
        -1371.9423828125,
        -3872.185546875,
        720.0633544921875
      ],
      [
        -1370.0491943359375,
        -3868.984619140625,
        720.3310546875
      ],
      [
        -1366.89794921875,
        -3863.656494140625,
        719.8624267578125
      ],
      [
        -1370.5,
        -3869.74658203125,
        720.3980712890625
      ],
      [
        -1354.9229736328125,
        -3869.74658203125,
        718.3363647460938
      ],
      [
        -1369.941650390625,
        -3869.74658203125,
        720.32421875
      ],
      [
        -1370.4998779296875,
        -3869.74658203125,
        720.267333984375
      ],
      [
        -1370.0491943359375,
        -3868.984619140625,
        720.3310546875
      ],
      [
        -1366.89794921875,
        -3863.656494140625,
        719.8624267578125
      ],
      [
        -1369.229248046875,
        -3923.746337890625,
        723.5
      ],
      [
        -1370.522705078125,
        -3925.34033203125,
        723.5
      ],
      [
        -1378.6341552734375,
        -3883.5,
        769.3978271484375
      ],
      [
        -1389.3924560546875,
        -3901.68994140625,
        774.1697387695312
      ],
      [
        -1378.6341552734375,
        -3883.5,
        769.3978271484375
      ],
      [
        -1370.0491943359375,
        -3868.984619140625,
        753.1341552734375
      ],
      [
        -1378.364013671875,
        -3934.291259765625,
        726.5
      ],
      [
        -1378.4219970703125,
        -3934.362548828125,
        726.5
      ],
      [
        -1391.7984619140625,
        -3858.22265625,
        773.789794921875
      ],
      [
        -1397.0150146484375,
        -3857.6748046875,
        780.769775390625
      ],
      [
        -1389.0653076171875,
        -3862.045654296875,
        776.71630859375
      ],
      [
        -1391.7984619140625,
        -3858.22265625,
        773.789794921875
      ],
      [
        -1390.3284912109375,
        -3865.114013671875,
        784.3673095703125
      ],
      [
        -1389.0653076171875,
        -3862.045654296875,
        776.71630859375
      ],
      [
        -1397.0150146484375,
        -3857.6748046875,
        780.769775390625
      ],
      [
        -1398.0457763671875,
        -3858.758056640625,
        784.3673095703125
      ],
      [
        -1363.872314453125,
        -3858.540771484375,
        731.5537109375
      ],
      [
        -1376.728515625,
        -3843.845458984375,
        723.9072875976562
      ],
      [
        -1373.2322998046875,
        -3846.438232421875,
        723.3734741210938
      ],
      [
        -1366.4300537109375,
        -3851.5283203125,
        722.4193115234375
      ],
      [
        -1366.4300537109375,
        -3851.5283203125,
        722.4193115234375
      ],
      [
        -1361.7120361328125,
        -3854.88818359375,
        721.4395141601562
      ],
      [
        -1376.728515625,
        -3843.845458984375,
        723.9072875976562
      ],
      [
        -1373.2322998046875,
        -3846.438232421875,
        723.3734741210938
      ],
      [
        -1391.802978515625,
        -3858.22998046875,
        773.6973876953125
      ],
      [
        -1396.95947265625,
        -3857.774169921875,
        779.5045776367188
      ],
      [
        -1396.95947265625,
        -3857.774169921875,
        779.5045776367188
      ],
      [
        -1398.4171142578125,
        -3859.339111328125,
        784.3673095703125
      ],
      [
        -1391.4183349609375,
        -3858.75439453125,
        774.19677734375
      ],
      [
        -1391.802978515625,
        -3858.22998046875,
        773.6973876953125
      ],
      [
        -1402.9146728515625,
        -3861.417236328125,
        719.9188232421875
      ],
      [
        -1402.9146728515625,
        -3861.417236328125,
        756.9188232421875
      ],
      [
        -1402.9146728515625,
        -3861.417236328125,
        774.4298095703125
      ],
      [
        -1406.3299560546875,
        -3851.245361328125,
        759.655517578125
      ],
      [
        -1406.3299560546875,
        -3851.245361328125,
        759.655517578125
      ],
      [
        -1402.9146728515625,
        -3861.417236328125,
        756.9188232421875
      ],
      [
        -1391.687744140625,
        -3866.054931640625,
        776.062255859375
      ],
      [
        -1389.4326171875,
        -3862.06884765625,
        772.8516845703125
      ],
      [
        -1397.113525390625,
        -3866.517333984375,
        783.0116577148438
      ],
      [
        -1391.687744140625,
        -3866.054931640625,
        776.062255859375
      ],
      [
        -1389.4327392578125,
        -3862.06884765625,
        772.8515625
      ],
      [
        -1391.012939453125,
        -3859.3212890625,
        774.6307983398438
      ],
      [
        -1398.2884521484375,
        -3864.862548828125,
        784.3673095703125
      ],
      [
        -1397.113525390625,
        -3866.517333984375,
        783.0115356445312
      ],
      [
        -1398.26220703125,
        -3859.1728515625,
        783.8505859375
      ],
      [
        -1398.6341552734375,
        -3859.6787109375,
        784.3673095703125
      ],
      [
        -1387.34228515625,
        -3898.2236328125,
        773.2603759765625
      ],
      [
        -1367.738037109375,
        -3865.076904296875,
        745.4775390625
      ],
      [
        -1398.4456787109375,
        -3863.218994140625,
        719.7012329101562
      ],
      [
        -1392.5948486328125,
        -3865.887451171875,
        720.1923828125
      ],
      [
        -1396.72412109375,
        -3865.927734375,
        719.5867919921875
      ],
      [
        -1391.3634033203125,
        -3859.107666015625,
        721.2696533203125
      ],
      [
        -1391.2451171875,
        -3859.287353515625,
        721.2344360351562
      ],
      [
        -1392.5948486328125,
        -3865.887451171875,
        720.1923828125
      ],
      [
        -1391.2451171875,
        -3859.287353515625,
        721.2344360351562
      ],
      [
        -1389.420166015625,
        -3862.06787109375,
        720.7523803710938
      ],
      [
        -1391.8099365234375,
        -3865.888427734375,
        720.1781005859375
      ],
      [
        -1391.4534912109375,
        -3858.968017578125,
        721.2765502929688
      ],
      [
        -1391.49755859375,
        -3858.901611328125,
        721.2922973632812
      ],
      [
        -1391.4534912109375,
        -3858.968017578125,
        721.2765502929688
      ],
      [
        -1391.3634033203125,
        -3859.107666015625,
        721.2696533203125
      ],
      [
        -1398.445556640625,
        -3863.218994140625,
        719.7012329101562
      ],
      [
        -1399.16015625,
        -3862.0634765625,
        719.9772338867188
      ],
      [
        -1396.6539306640625,
        -3858.3193359375,
        721.1770629882812
      ],
      [
        -1392.0999755859375,
        -3858.341552734375,
        721.4595947265625
      ],
      [
        -1392.0999755859375,
        -3858.341552734375,
        721.4596557617188
      ],
      [
        -1391.87060546875,
        -3858.3388671875,
        721.4254760742188
      ],
      [
        -1391.871826171875,
        -3860.987060546875,
        755.1765747070312
      ],
      [
        -1390.62451171875,
        -3858.3369140625,
        721.40283203125
      ],
      [
        -1387.0877685546875,
        -3858.333251953125,
        721.3529052734375
      ],
      [
        -1387.9798583984375,
        -3859.76513671875,
        721.0985107421875
      ],
      [
        -1391.3486328125,
        -3858.33251953125,
        721.3475952148438
      ],
      [
        -1390.62451171875,
        -3858.3369140625,
        721.40283203125
      ],
      [
        -1391.3486328125,
        -3858.33251953125,
        721.3475952148438
      ],
      [
        -1391.78759765625,
        -3858.464111328125,
        721.3958129882812
      ],
      [
        -1391.83349609375,
        -3858.33837890625,
        721.419921875
      ],
      [
        -1387.9798583984375,
        -3859.76513671875,
        721.0985107421875
      ],
      [
        -1391.878662109375,
        -3858.351806640625,
        772.1450805664062
      ],
      [
        -1391.805908203125,
        -3858.348876953125,
        772.8980712890625
      ],
      [
        -1391.878662109375,
        -3858.351806640625,
        772.1450805664062
      ],
      [
        -1389.5460205078125,
        -3847.404296875,
        722.5693359375
      ],
      [
        -1383.5577392578125,
        -3838.2373046875,
        723.938232421875
      ],
      [
        -1377.602294921875,
        -3843.1279296875,
        723.9112548828125
      ],
      [
        -1380.5360107421875,
        -3847.816162109375,
        723.2210693359375
      ],
      [
        -1380.5360107421875,
        -3847.816162109375,
        723.2210693359375
      ],
      [
        -1389.546142578125,
        -3847.404296875,
        722.5693359375
      ],
      [
        -1394.368896484375,
        -3854.90576171875,
        722.2710571289062
      ],
      [
        -1394.368896484375,
        -3854.905517578125,
        722.2710571289062
      ],
      [
        -1396.8475341796875,
        -3857.97412109375,
        776.9561767578125
      ],
      [
        -1396.762939453125,
        -3857.79150390625,
        779.2832641601562
      ],
      [
        -1396.8475341796875,
        -3857.97412109375,
        776.9561767578125
      ],
      [
        -1396.83349609375,
        -3858.491943359375,
        773.2911376953125
      ],
      [
        -1394.8709716796875,
        -3861.17626953125,
        776.1468505859375
      ],
      [
        -1393.2872314453125,
        -3860.271240234375,
        775.72314453125
      ],
      [
        -1392.016357421875,
        -3858.468017578125,
        774.426513671875
      ],
      [
        -1392.19677734375,
        -3858.19482421875,
        774.1405639648438
      ],
      [
        -1396.679443359375,
        -3858.27392578125,
        773.134521484375
      ],
      [
        -1393.287353515625,
        -3860.271240234375,
        775.7232055664062
      ],
      [
        -1394.8709716796875,
        -3861.17626953125,
        776.1468505859375
      ],
      [
        -1394.38818359375,
        -3861.91162109375,
        776.2978515625
      ],
      [
        -1394.3349609375,
        -3854.95703125,
        770.7509765625
      ],
      [
        -1402.181884765625,
        -3857.17724609375,
        721.1441650390625
      ],
      [
        -1401.343017578125,
        -3852.32373046875,
        766.7293701171875
      ],
      [
        -1399.5499267578125,
        -3862.03759765625,
        778.07421875
      ],
      [
        -1399.87451171875,
        -3861.619140625,
        784.3673095703125
      ],
      [
        -1399.5499267578125,
        -3862.03759765625,
        778.07421875
      ],
      [
        -1399.3489990234375,
        -3862.051025390625,
        775.8486938476562
      ],
      [
        -1399.2794189453125,
        -3862.17724609375,
        775.9776000976562
      ],
      [
        -1396.5504150390625,
        -3862.135986328125,
        776.5961303710938
      ],
      [
        -1396.83349609375,
        -3858.491943359375,
        773.2911376953125
      ],
      [
        -1396.550537109375,
        -3862.135986328125,
        776.59619140625
      ],
      [
        -1394.54833984375,
        -3862.150146484375,
        776.3814086914062
      ],
      [
        -1402.146484375,
        -3856.97265625,
        770.6661987304688
      ],
      [
        -1402.9146728515625,
        -3861.417236328125,
        774.4298095703125
      ],
      [
        -1402.6424560546875,
        -3862.22802734375,
        775.21533203125
      ],
      [
        -1401.687744140625,
        -3865.071533203125,
        718.9805908203125
      ],
      [
        -1402.9146728515625,
        -3861.417236328125,
        719.9188232421875
      ],
      [
        -1401.385009765625,
        -3865.97314453125,
        718.9031982421875
      ],
      [
        -1401.687744140625,
        -3865.071533203125,
        718.9805908203125
      ],
      [
        -1397.5765380859375,
        -3865.865234375,
        783.5457763671875
      ],
      [
        -1396.706787109375,
        -3865.90185546875,
        773.757080078125
      ],
      [
        -1396.7069091796875,
        -3865.90185546875,
        773.7577514648438
      ],
      [
        -1398.643310546875,
        -3863.331787109375,
        777.1560668945312
      ],
      [
        -1397.0565185546875,
        -3865.88720703125,
        777.6905517578125
      ],
      [
        -1398.643310546875,
        -3863.331787109375,
        777.156005859375
      ],
      [
        -1399.2794189453125,
        -3862.17724609375,
        775.9776000976562
      ],
      [
        -1392.083740234375,
        -3865.88818359375,
        720.18310546875
      ],
      [
        -1391.943603515625,
        -3866.10205078125,
        720.14599609375
      ],
      [
        -1398.0390625,
        -3875.93798828125,
        718.048095703125
      ],
      [
        -1392.876220703125,
        -3867.59326171875,
        719.921875
      ],
      [
        -1392.876220703125,
        -3867.59326171875,
        719.921875
      ],
      [
        -1401.687744140625,
        -3865.071533203125,
        777.9705200195312
      ],
      [
        -1399.9608154296875,
        -3870.21484375,
        779.20654296875
      ],
      [
        -1401.687744140625,
        -3865.071533203125,
        777.9705200195312
      ],
      [
        -1394.34521484375,
        -3882.498291015625,
        717.5402221679688
      ],
      [
        -1387.065673828125,
        -3876.1845703125,
        718.4293823242188
      ],
      [
        -1384.8690185546875,
        -3879.278564453125,
        718.580810546875
      ],
      [
        -1387.78076171875,
        -3883.401123046875,
        718.1878051757812
      ],
      [
        -1393.6771240234375,
        -3883.43115234375,
        717.5864868164062
      ],
      [
        -1395.146484375,
        -3881.35693359375,
        717.7390747070312
      ],
      [
        -1394.271240234375,
        -3876.05078125,
        718.5806274414062
      ],
      [
        -1393.6434326171875,
        -3875.181396484375,
        718.709716796875
      ],
      [
        -1387.7962646484375,
        -3875.177001953125,
        718.6052856445312
      ],
      [
        -1387.065673828125,
        -3876.1845703125,
        718.4293823242188
      ],
      [
        -1394.34521484375,
        -3882.498291015625,
        717.5402221679688
      ],
      [
        -1396.62255859375,
        -3879.281005859375,
        717.803955078125
      ],
      [
        -1394.271240234375,
        -3876.05078125,
        718.5806274414062
      ],
      [
        -1395.146484375,
        -3881.35693359375,
        717.7390747070312
      ],
      [
        -1395.5201416015625,
        -3883.440185546875,
        717.404296875
      ],
      [
        -1396.82373046875,
        -3879.557373046875,
        717.7374877929688
      ],
      [
        -1395.4901123046875,
        -3883.43994140625,
        717.40869140625
      ],
      [
        -1395.4901123046875,
        -3883.43994140625,
        717.40869140625
      ],
      [
        -1395.4307861328125,
        -3883.43994140625,
        717.4076538085938
      ],
      [
        -1395.4307861328125,
        -3883.43994140625,
        717.4076538085938
      ],
      [
        -1387.8507080078125,
        -3883.5,
        718.1783447265625
      ],
      [
        -1393.0506591796875,
        -3890.794677734375,
        718.1456298828125
      ],
      [
        -1387.8507080078125,
        -3883.5,
        718.1783447265625
      ],
      [
        -1394.49755859375,
        -3886.485595703125,
        781.0484619140625
      ],
      [
        -1394.124755859375,
        -3885.98193359375,
        780.8585815429688
      ],
      [
        -1395.4407958984375,
        -3883.140625,
        782.2931518554688
      ],
      [
        -1395.5618896484375,
        -3883.31591796875,
        782.3549194335938
      ],
      [
        -1394.572021484375,
        -3877.874267578125,
        780.739501953125
      ],
      [
        -1397.3843994140625,
        -3877.887939453125,
        781.0504760742188
      ],
      [
        -1397.5579833984375,
        -3875.160400390625,
        718.2227172851562
      ],
      [
        -1394.1279296875,
        -3875.181884765625,
        718.7183837890625
      ],
      [
        -1394.1279296875,
        -3875.181884765625,
        718.7183837890625
      ],
      [
        -1385.90234375,
        -3875.175537109375,
        718.5714721679688
      ],
      [
        -1381.9832763671875,
        -3875.19287109375,
        718.9702758789062
      ],
      [
        -1385.90234375,
        -3875.175537109375,
        718.5714721679688
      ],
      [
        -1373.742431640625,
        -3875.229248046875,
        719.808837890625
      ],
      [
        -1392.6358642578125,
        -3866.135986328125,
        777.2764892578125
      ],
      [
        -1397.056396484375,
        -3865.88720703125,
        777.6905517578125
      ],
      [
        -1396.8824462890625,
        -3866.167236328125,
        777.7491455078125
      ],
      [
        -1397.2462158203125,
        -3866.169921875,
        777.7896118164062
      ],
      [
        -1393.0072021484375,
        -3868.387451171875,
        777.9407348632812
      ],
      [
        -1397.8817138671875,
        -3876.40673828125,
        780.6945190429688
      ],
      [
        -1371.7821044921875,
        -3859.4560546875,
        720.9241943359375
      ],
      [
        -1373.0003662109375,
        -3861.957275390625,
        720.4749755859375
      ],
      [
        -1385.1851806640625,
        -3860.174072265625,
        720.982177734375
      ],
      [
        -1385.5362548828125,
        -3859.4541015625,
        721.1215209960938
      ],
      [
        -1382.0328369140625,
        -3852.915771484375,
        722.2911376953125
      ],
      [
        -1375.32177734375,
        -3852.904296875,
        722.1971435546875
      ],
      [
        -1385.1851806640625,
        -3860.174072265625,
        720.982177734375
      ],
      [
        -1373.0003662109375,
        -3861.957275390625,
        720.4749755859375
      ],
      [
        -1374.734619140625,
        -3865.4892578125,
        719.935546875
      ],
      [
        -1375.6937255859375,
        -3866.321044921875,
        719.8184204101562
      ],
      [
        -1382.177490234375,
        -3866.30419921875,
        719.9376831054688
      ],
      [
        -1375.6937255859375,
        -3866.321044921875,
        719.8184204101562
      ],
      [
        -1374.734619140625,
        -3865.4892578125,
        719.935546875
      ],
      [
        -1375.148681640625,
        -3866.313232421875,
        719.8741455078125
      ],
      [
        -1372.3201904296875,
        -3852.899169921875,
        722.1550903320312
      ],
      [
        -1371.4815673828125,
        -3858.839111328125,
        721.0349731445312
      ],
      [
        -1371.4815673828125,
        -3858.839111328125,
        721.0349731445312
      ],
      [
        -1372.3201904296875,
        -3852.899169921875,
        722.1550903320312
      ],
      [
        -1368.5968017578125,
        -3852.8994140625,
        722.1585693359375
      ],
      [
        -1367.0145263671875,
        -3852.8994140625,
        722.1600341796875
      ],
      [
        -1364.528076171875,
        -3852.8828125,
        722.0242919921875
      ],
      [
        -1367.0145263671875,
        -3852.8994140625,
        722.1600341796875
      ],
      [
        -1374.36572265625,
        -3864.73779296875,
        720.05029296875
      ],
      [
        -1370.43603515625,
        -3866.244873046875,
        720.355712890625
      ],
      [
        -1370.43603515625,
        -3866.244873046875,
        720.355712890625
      ],
      [
        -1368.4508056640625,
        -3866.281982421875,
        720.0933837890625
      ],
      [
        -1377.7353515625,
        -3844.8955078125,
        723.725830078125
      ],
      [
        -1377.0413818359375,
        -3843.58837890625,
        723.90869140625
      ],
      [
        -1377.7353515625,
        -3844.8955078125,
        723.725830078125
      ],
      [
        -1380.2362060546875,
        -3870.260986328125,
        719.2635498046875
      ],
      [
        -1377.674560546875,
        -3875.2119140625,
        719.40869140625
      ],
      [
        -1380.2362060546875,
        -3870.260986328125,
        719.2635498046875
      ],
      [
        -1386.52392578125,
        -3857.427978515625,
        721.513671875
      ],
      [
        -1427.664306640625,
        -3865.94775390625,
        754.5176391601562
      ],
      [
        -1427.664306640625,
        -3865.94775390625,
        754.5176391601562
      ],
      [
        -1427.6661376953125,
        -3865.959716796875,
        754.514892578125
      ],
      [
        -1427.6787109375,
        -3866.0439453125,
        754.4957885742188
      ],
      [
        -1427.6787109375,
        -3866.0439453125,
        754.4957885742188
      ],
      [
        -1418.5003662109375,
        -3874.989990234375,
        717.103759765625
      ],
      [
        -1418.5003662109375,
        -3874.989990234375,
        754.103759765625
      ],
      [
        -1417.985595703125,
        -3860.0419921875,
        756.6641845703125
      ],
      [
        -1418.1497802734375,
        -3864.811767578125,
        763.6357421875
      ],
      [
        -1418.1497802734375,
        -3864.811767578125,
        763.6357421875
      ],
      [
        -1418.5003662109375,
        -3874.989990234375,
        779.577392578125
      ],
      [
        -1418.5003662109375,
        -3874.989990234375,
        754.103759765625
      ],
      [
        -1418.3896484375,
        -3871.775634765625,
        754.1307983398438
      ],
      [
        -1417.985595703125,
        -3860.0419921875,
        756.6641845703125
      ],
      [
        -1418.3896484375,
        -3871.775634765625,
        754.1307983398438
      ],
      [
        -1419.63525390625,
        -3907.945068359375,
        783.0362548828125
      ],
      [
        -1419.63525390625,
        -3907.945068359375,
        717.6714477539062
      ],
      [
        -1421.357177734375,
        -3876.97802734375,
        717.1802368164062
      ],
      [
        -1418.5003662109375,
        -3874.989990234375,
        779.577392578125
      ],
      [
        -1418.5003662109375,
        -3874.989990234375,
        717.103759765625
      ],
      [
        -1431.1163330078125,
        -3961.226318359375,
        735.0143432617188
      ],
      [
        -1431.1163330078125,
        -3961.226318359375,
        718.414794921875
      ],
      [
        -1445.8861083984375,
        -3909.488525390625,
        761.60205078125
      ],
      [
        -1445.5906982421875,
        -3910.59130859375,
        761.635498046875
      ],
      [
        -1432.5994873046875,
        -3933.233154296875,
        760.6152954101562
      ],
      [
        -1445.8861083984375,
        -3909.488525390625,
        761.60205078125
      ],
      [
        -1446.2794189453125,
        -3908.020751953125,
        761.3350219726562
      ],
      [
        -1446.2794189453125,
        -3908.020751953125,
        761.3350219726562
      ],
      [
        -1446.2093505859375,
        -3908.2822265625,
        761.5654907226562
      ],
      [
        -1443.5521240234375,
        -3893.1162109375,
        759.448486328125
      ],
      [
        -1432.5994873046875,
        -3933.233154296875,
        760.6152954101562
      ],
      [
        -1424.679443359375,
        -3946.18505859375,
        759.9111938476562
      ],
      [
        -1445.8861083984375,
        -3909.488525390625,
        762.62890625
      ],
      [
        -1443.6302490234375,
        -3917.90771484375,
        778.3470458984375
      ],
      [
        -1438.673828125,
        -3917.90771484375,
        778.3470458984375
      ],
      [
        -1437.1273193359375,
        -3912.76123046875,
        778.7081298828125
      ],
      [
        -1445.00927734375,
        -3912.76123046875,
        778.7081298828125
      ],
      [
        -1442.5684814453125,
        -3921.870361328125,
        773.8837890625
      ],
      [
        -1442.36474609375,
        -3921.870361328125,
        773.8837890625
      ],
      [
        -1438.673828125,
        -3917.90771484375,
        778.3470458984375
      ],
      [
        -1443.6302490234375,
        -3917.90771484375,
        778.3470458984375
      ],
      [
        -1438.6312255859375,
        -3909.446044921875,
        774.75537109375
      ],
      [
        -1445.5999755859375,
        -3910.556396484375,
        776.079345703125
      ],
      [
        -1445.00927734375,
        -3912.76123046875,
        778.7081298828125
      ],
      [
        -1437.1273193359375,
        -3912.76123046875,
        778.7081298828125
      ],
      [
        -1445.5999755859375,
        -3910.556396484375,
        776.079345703125
      ],
      [
        -1445.888671875,
        -3909.47900390625,
        774.8164672851562
      ],
      [
        -1445.888671875,
        -3909.47900390625,
        774.8164672851562
      ],
      [
        -1445.8912353515625,
        -3909.469482421875,
        774.7830810546875
      ],
      [
        -1442.36474609375,
        -3921.870361328125,
        773.8837890625
      ],
      [
        -1442.5684814453125,
        -3921.870361328125,
        773.8837890625
      ],
      [
        -1442.5618896484375,
        -3921.89501953125,
        773.564453125
      ],
      [
        -1445.9007568359375,
        -3909.433837890625,
        774.6586303710938
      ],
      [
        -1442.3046875,
        -3909.90380859375,
        768.8043212890625
      ],
      [
        -1438.6312255859375,
        -3909.446044921875,
        774.75537109375
      ],
      [
        -1445.77880859375,
        -3909.888916015625,
        768.844482421875
      ],
      [
        -1445.9007568359375,
        -3909.433837890625,
        774.6586303710938
      ],
      [
        -1445.7745361328125,
        -3909.905029296875,
        768.7899780273438
      ],
      [
        -1445.77880859375,
        -3909.888916015625,
        768.844482421875
      ],
      [
        -1444.9996337890625,
        -3912.79736328125,
        765.5453491210938
      ],
      [
        -1445.5999755859375,
        -3910.556640625,
        768.069091796875
      ],
      [
        -1442.3046875,
        -3909.90380859375,
        768.8043212890625
      ],
      [
        -1445.5999755859375,
        -3910.556640625,
        768.069091796875
      ],
      [
        -1445.7716064453125,
        -3909.916259765625,
        768.7513427734375
      ],
      [
        -1445.7716064453125,
        -3909.916259765625,
        768.7513427734375
      ],
      [
        -1445.5906982421875,
        -3910.59130859375,
        761.635498046875
      ],
      [
        -1445.1810302734375,
        -3912.1201171875,
        761.8410034179688
      ],
      [
        -1424.802978515625,
        -3945.26708984375,
        762.4020385742188
      ],
      [
        -1424.9337158203125,
        -3944.29541015625,
        765.0390014648438
      ],
      [
        -1445.4759521484375,
        -3911.01953125,
        762.49609375
      ],
      [
        -1445.3350830078125,
        -3911.54541015625,
        762.18310546875
      ],
      [
        -1445.3350830078125,
        -3911.54541015625,
        762.18310546875
      ],
      [
        -1445.1810302734375,
        -3912.1201171875,
        761.8410034179688
      ],
      [
        -1442.4456787109375,
        -3922.328369140625,
        767.9328002929688
      ],
      [
        -1432.6976318359375,
        -3917.90771484375,
        778.3470458984375
      ],
      [
        -1443.3341064453125,
        -3919.01318359375,
        763.9800415039062
      ],
      [
        -1442.4456787109375,
        -3922.328369140625,
        767.9328002929688
      ],
      [
        -1432.6976318359375,
        -3917.90771484375,
        778.3470458984375
      ],
      [
        -1435.5572509765625,
        -3912.76123046875,
        778.7081298828125
      ],
      [
        -1443.3341064453125,
        -3919.01318359375,
        763.9800415039062
      ],
      [
        -1444.713134765625,
        -3913.866455078125,
        764.3410034179688
      ],
      [
        -1444.713134765625,
        -3913.866455078125,
        764.3410034179688
      ],
      [
        -1442.691650390625,
        -3910.3193359375,
        768.3363647460938
      ],
      [
        -1438.0245361328125,
        -3910.783447265625,
        776.3500366210938
      ],
      [
        -1435.557373046875,
        -3912.76123046875,
        778.7081298828125
      ],
      [
        -1432.64697265625,
        -3921.490966796875,
        774.3112182617188
      ],
      [
        -1432.46875,
        -3917.90771484375,
        778.3470458984375
      ],
      [
        -1435.142578125,
        -3912.76123046875,
        778.7081298828125
      ],
      [
        -1432.64697265625,
        -3921.490966796875,
        774.3112182617188
      ],
      [
        -1432.46875,
        -3917.90771484375,
        778.3470458984375
      ],
      [
        -1442.0723876953125,
        -3909.90380859375,
        768.8043212890625
      ],
      [
        -1442.2171630859375,
        -3912.81982421875,
        765.5198364257812
      ],
      [
        -1445.4759521484375,
        -3911.01953125,
        762.49609375
      ],
      [
        -1442.2171630859375,
        -3912.81982421875,
        765.5198364257812
      ],
      [
        -1444.6141357421875,
        -3909.9287109375,
        764.0624389648438
      ],
      [
        -1445.7662353515625,
        -3909.93603515625,
        762.678466796875
      ],
      [
        -1445.5123291015625,
        -3909.213134765625,
        763.135498046875
      ],
      [
        -1445.8861083984375,
        -3909.488525390625,
        762.62890625
      ],
      [
        -1445.7662353515625,
        -3909.93603515625,
        762.678466796875
      ],
      [
        -1444.6141357421875,
        -3909.9287109375,
        764.0624389648438
      ],
      [
        -1438.333984375,
        -3910.101318359375,
        775.53662109375
      ],
      [
        -1435.142333984375,
        -3912.76123046875,
        778.7081298828125
      ],
      [
        -1442.0723876953125,
        -3909.90380859375,
        768.8043212890625
      ],
      [
        -1441.12158203125,
        -3909.75634765625,
        770.7208862304688
      ],
      [
        -1424.9337158203125,
        -3944.29541015625,
        765.0390014648438
      ],
      [
        -1442.170166015625,
        -3911.874267578125,
        766.5847778320312
      ],
      [
        -1432.5496826171875,
        -3919.53515625,
        776.5139770507812
      ],
      [
        -1431.1163330078125,
        -3961.226318359375,
        735.0143432617188
      ],
      [
        -1428.9951171875,
        -3960.454345703125,
        756.19189453125
      ],
      [
        -1431.1163330078125,
        -3961.226318359375,
        718.414794921875
      ],
      [
        -1424.751220703125,
        -3958.90966796875,
        716.8907470703125
      ],
      [
        -1428.9951171875,
        -3960.454345703125,
        756.19189453125
      ],
      [
        -1428.0263671875,
        -3960.101806640625,
        760.6077270507812
      ],
      [
        -1424.06591796875,
        -3950.7470703125,
        764.3798828125
      ],
      [
        -1424.751220703125,
        -3958.90966796875,
        716.8907470703125
      ],
      [
        -1423.0511474609375,
        -3958.291015625,
        716.7891235351562
      ],
      [
        -1424.06591796875,
        -3950.7470703125,
        764.3798828125
      ],
      [
        -1428.0263671875,
        -3960.101806640625,
        760.6077270507812
      ],
      [
        -1423.841796875,
        -3958.578857421875,
        767.0311889648438
      ],
      [
        -1423.488525390625,
        -3955.0390625,
        766.578857421875
      ],
      [
        -1423.488525390625,
        -3955.0390625,
        766.578857421875
      ],
      [
        -1423.841796875,
        -3958.578857421875,
        767.0311889648438
      ],
      [
        -1423.0511474609375,
        -3958.291015625,
        771.0654907226562
      ],
      [
        -1422.5908203125,
        -3947.6484375,
        766.4901123046875
      ],
      [
        -1422.8682861328125,
        -3958.224365234375,
        771.998291015625
      ],
      [
        -1421.7166748046875,
        -3951.763671875,
        773.8802490234375
      ],
      [
        -1422.5908203125,
        -3947.6484375,
        766.4901123046875
      ],
      [
        -1424.245849609375,
        -3949.4091796875,
        761.02734375
      ],
      [
        -1421.7166748046875,
        -3951.763671875,
        773.8802490234375
      ],
      [
        -1422.8682861328125,
        -3958.224365234375,
        771.998291015625
      ],
      [
        -1421.34765625,
        -3957.6708984375,
        772.7033081054688
      ],
      [
        -1421.2239990234375,
        -3954.083251953125,
        773.5510864257812
      ],
      [
        -1422.605224609375,
        -3947.580810546875,
        718.9324340820312
      ],
      [
        -1421.383056640625,
        -3953.335693359375,
        717.6190185546875
      ],
      [
        -1421.22412109375,
        -3954.084228515625,
        717.4370727539062
      ],
      [
        -1421.34765625,
        -3957.6708984375,
        716.687255859375
      ],
      [
        -1422.605224609375,
        -3947.580810546875,
        718.9324340820312
      ],
      [
        -1421.383056640625,
        -3953.335693359375,
        717.6190185546875
      ],
      [
        -1421.0050048828125,
        -3947.724609375,
        775.0563354492188
      ],
      [
        -1421.005615234375,
        -3947.742431640625,
        775.0214233398438
      ],
      [
        -1421.0069580078125,
        -3947.78173828125,
        775.0402221679688
      ],
      [
        -1421.005615234375,
        -3947.742431640625,
        775.0214233398438
      ],
      [
        -1421.0069580078125,
        -3947.78173828125,
        775.0402221679688
      ],
      [
        -1421.0050048828125,
        -3947.724609375,
        775.0563354492188
      ],
      [
        -1421.0018310546875,
        -3947.633056640625,
        718.6285400390625
      ],
      [
        -1420.54150390625,
        -3934.262939453125,
        719.4093627929688
      ],
      [
        -1420.54150390625,
        -3934.262939453125,
        719.4093627929688
      ],
      [
        -1421.0018310546875,
        -3947.633056640625,
        718.6285400390625
      ],
      [
        -1421.20947265625,
        -3953.65966796875,
        717.5258178710938
      ],
      [
        -1421.20947265625,
        -3953.65966796875,
        717.5258178710938
      ],
      [
        -1405.3941650390625,
        -3854.032470703125,
        758.9057006835938
      ],
      [
        -1418.4893798828125,
        -3874.67236328125,
        779.080078125
      ],
      [
        -1417.9952392578125,
        -3860.322021484375,
        756.6036987304688
      ],
      [
        -1418.4320068359375,
        -3873.00634765625,
        754.1204223632812
      ],
      [
        -1418.4893798828125,
        -3874.67236328125,
        754.1064453125
      ],
      [
        -1415.6341552734375,
        -3873.041015625,
        717.0812377929688
      ],
      [
        -1416.8544921875,
        -3873.8447265625,
        717.0597534179688
      ],
      [
        -1419.84619140625,
        -3914.073486328125,
        717.89453125
      ],
      [
        -1419.84619140625,
        -3914.073486328125,
        783.0482788085938
      ],
      [
        -1395.483154296875,
        -3926.430908203125,
        772.208984375
      ],
      [
        -1396.9710693359375,
        -3929.000244140625,
        772.2662353515625
      ],
      [
        -1395.3927001953125,
        -3931.411865234375,
        769.9641723632812
      ],
      [
        -1392.6915283203125,
        -3931.2666015625,
        767.888671875
      ],
      [
        -1391.38623046875,
        -3928.999755859375,
        767.84423828125
      ],
      [
        -1392.6114501953125,
        -3926.59521484375,
        769.8634643554688
      ],
      [
        -1394.000244140625,
        -3933.53955078125,
        767.9332275390625
      ],
      [
        -1390.0850830078125,
        -3926.73974609375,
        767.7999267578125
      ],
      [
        -1401.4644775390625,
        -3936.7587890625,
        772.4390869140625
      ],
      [
        -1400.6563720703125,
        -3945.10009765625,
        768.1598510742188
      ],
      [
        -1384.8583984375,
        -3917.661865234375,
        767.6219482421875
      ],
      [
        -1390.09375,
        -3917.125,
        772.0016479492188
      ],
      [
        -1388.4871826171875,
        -3917.289794921875,
        720.055419921875
      ],
      [
        -1401.2518310546875,
        -3938.95361328125,
        716.8748168945312
      ],
      [
        -1396.8443603515625,
        -3929.0,
        718.0556640625
      ],
      [
        -1395.380859375,
        -3926.608154296875,
        718.417236328125
      ],
      [
        -1395.380859375,
        -3926.608154296875,
        718.417236328125
      ],
      [
        -1393.8182373046875,
        -3925.535888671875,
        713.0
      ],
      [
        -1394.00830078125,
        -3926.66015625,
        718.6797485351562
      ],
      [
        -1396.9091796875,
        -3930.889404296875,
        713.0
      ],
      [
        -1396.8443603515625,
        -3929.0,
        718.0556640625
      ],
      [
        -1396.111572265625,
        -3930.229736328125,
        718.1557006835938
      ],
      [
        -1394.6248779296875,
        -3929.0,
        727.7659301757812
      ],
      [
        -1394.3125,
        -3928.458740234375,
        727.7659301757812
      ],
      [
        -1394.6248779296875,
        -3929.0,
        727.7659301757812
      ],
      [
        -1394.3125,
        -3928.458740234375,
        727.7659301757812
      ],
      [
        -1398.8841552734375,
        -3949.494873046875,
        764.8391723632812
      ],
      [
        -1396.493896484375,
        -3948.624755859375,
        760.1801147460938
      ],
      [
        -1385.194580078125,
        -3944.51220703125,
        718.9240112304688
      ],
      [
        -1396.493896484375,
        -3948.624755859375,
        760.1801147460938
      ],
      [
        -1398.8841552734375,
        -3949.494873046875,
        764.8391723632812
      ],
      [
        -1400.1846923828125,
        -3949.96826171875,
        765.6624755859375
      ],
      [
        -1398.8841552734375,
        -3949.494873046875,
        716.9786376953125
      ],
      [
        -1390.7677001953125,
        -3946.540771484375,
        718.010009765625
      ],
      [
        -1398.8841552734375,
        -3949.494873046875,
        716.9786376953125
      ],
      [
        -1400.1846923828125,
        -3949.96826171875,
        716.7124633789062
      ],
      [
        -1392.67822265625,
        -3926.71044921875,
        718.9342041015625
      ],
      [
        -1391.3953857421875,
        -3929.0,
        719.1046142578125
      ],
      [
        -1391.3953857421875,
        -3929.0,
        719.1046142578125
      ],
      [
        -1392.6610107421875,
        -3931.3193359375,
        718.7835083007812
      ],
      [
        -1392.6610107421875,
        -3931.3193359375,
        718.7835083007812
      ],
      [
        -1395.399658203125,
        -3931.42431640625,
        718.2529296875
      ],
      [
        -1394.00830078125,
        -3926.66015625,
        718.6798095703125
      ],
      [
        -1392.67822265625,
        -3926.71044921875,
        718.9342041015625
      ],
      [
        -1395.399658203125,
        -3931.42431640625,
        718.2529296875
      ],
      [
        -1396.111572265625,
        -3930.229736328125,
        718.1556396484375
      ],
      [
        -1392.6856689453125,
        -3931.276611328125,
        718.9994506835938
      ],
      [
        -1395.3448486328125,
        -3931.329345703125,
        718.732177734375
      ],
      [
        -1391.439697265625,
        -3929.0,
        719.298583984375
      ],
      [
        -1392.6856689453125,
        -3931.276611328125,
        718.9994506835938
      ],
      [
        -1392.724853515625,
        -3926.791259765625,
        719.342041015625
      ],
      [
        -1391.439697265625,
        -3929.0,
        719.298583984375
      ],
      [
        -1395.3448486328125,
        -3931.329345703125,
        718.732177734375
      ],
      [
        -1396.0186767578125,
        -3930.15283203125,
        718.7564697265625
      ],
      [
        -1394.0262451171875,
        -3926.76611328125,
        719.2152099609375
      ],
      [
        -1392.724853515625,
        -3926.791259765625,
        719.342041015625
      ],
      [
        -1385.194580078125,
        -3944.51220703125,
        718.9240112304688
      ],
      [
        -1390.7677001953125,
        -3946.540771484375,
        718.010009765625
      ],
      [
        -1406.30615234375,
        -3921.0,
        782.2123413085938
      ],
      [
        -1408.124267578125,
        -3917.75146484375,
        782.9224243164062
      ],
      [
        -1411.879638671875,
        -3917.74462890625,
        783.0172729492188
      ],
      [
        -1413.708740234375,
        -3920.999755859375,
        782.3966674804688
      ],
      [
        -1411.826171875,
        -3924.163330078125,
        781.7023315429688
      ],
      [
        -1408.1773681640625,
        -3924.156982421875,
        781.61279296875
      ],
      [
        -1408.748046875,
        -3916.636962890625,
        783.166015625
      ],
      [
        -1411.5205078125,
        -3917.10546875,
        783.13916015625
      ],
      [
        -1411.5205078125,
        -3917.10546875,
        783.13916015625
      ],
      [
        -1408.748046875,
        -3916.636962890625,
        783.166015625
      ],
      [
        -1409.623779296875,
        -3915.1220703125,
        783.1536865234375
      ],
      [
        -1410.3338623046875,
        -3915.04931640625,
        783.1463623046875
      ],
      [
        -1415.614501953125,
        -3917.79736328125,
        783.0995483398438
      ],
      [
        -1417.6309814453125,
        -3914.30078125,
        783.0711059570312
      ],
      [
        -1415.614501953125,
        -3917.79736328125,
        783.0995483398438
      ],
      [
        -1410.0,
        -3927.232177734375,
        781.02880859375
      ],
      [
        -1401.0299072265625,
        -3941.244873046875,
        770.1377563476562
      ],
      [
        -1402.229736328125,
        -3928.861083984375,
        776.49072265625
      ],
      [
        -1405.266357421875,
        -3922.85791015625,
        781.8062133789062
      ],
      [
        -1407.4276123046875,
        -3931.55517578125,
        780.080078125
      ],
      [
        -1407.4276123046875,
        -3931.55517578125,
        780.080078125
      ],
      [
        -1405.266357421875,
        -3922.85791015625,
        781.8062133789062
      ],
      [
        -1409.125244140625,
        -3921.0,
        725.6729736328125
      ],
      [
        -1407.0101318359375,
        -3922.749755859375,
        712.0
      ],
      [
        -1410.0203857421875,
        -3917.535888671875,
        712.0
      ],
      [
        -1409.5626220703125,
        -3920.242431640625,
        725.6729736328125
      ],
      [
        -1409.5626220703125,
        -3920.242431640625,
        725.6729736328125
      ],
      [
        -1409.125244140625,
        -3921.0,
        725.6729736328125
      ],
      [
        -1407.20849609375,
        -3920.999755859375,
        717.2863159179688
      ],
      [
        -1407.8289794921875,
        -3922.072021484375,
        717.2929077148438
      ],
      [
        -1409.836181640625,
        -3918.623291015625,
        717.492919921875
      ],
      [
        -1408.6201171875,
        -3918.610107421875,
        717.426025390625
      ],
      [
        -1405.8077392578125,
        -3918.57958984375,
        717.2713623046875
      ],
      [
        -1404.24267578125,
        -3915.87548828125,
        717.2546997070312
      ],
      [
        -1410.7913818359375,
        -3916.982177734375,
        717.588134765625
      ],
      [
        -1412.0048828125,
        -3914.877685546875,
        717.5694580078125
      ],
      [
        -1404.1302490234375,
        -3915.685302734375,
        717.2429809570312
      ],
      [
        -1410.7913818359375,
        -3916.982177734375,
        717.588134765625
      ],
      [
        -1404.24267578125,
        -3915.87548828125,
        717.2546997070312
      ],
      [
        -1405.896240234375,
        -3925.392822265625,
        717.1002807617188
      ],
      [
        -1401.896240234375,
        -3932.30322265625,
        716.9728393554688
      ],
      [
        -1405.896240234375,
        -3925.392822265625,
        717.1002807617188
      ],
      [
        -1412.1341552734375,
        -3954.3173828125,
        775.7373046875
      ],
      [
        -1417.8084716796875,
        -3956.3828125,
        774.3441162109375
      ],
      [
        -1417.8084716796875,
        -3956.3828125,
        774.3441162109375
      ],
      [
        -1412.1341552734375,
        -3954.3173828125,
        775.7373046875
      ],
      [
        -1411.497314453125,
        -3954.085693359375,
        775.184814453125
      ],
      [
        -1412.1341552734375,
        -3954.3173828125,
        715.7373046875
      ],
      [
        -1419.433349609375,
        -3956.97412109375,
        716.5728149414062
      ],
      [
        -1411.6412353515625,
        -3923.8427734375,
        715.1388549804688
      ],
      [
        -1413.1898193359375,
        -3921.0,
        715.5447998046875
      ],
      [
        -1413.1898193359375,
        -3921.0,
        715.5447998046875
      ],
      [
        -1411.6868896484375,
        -3918.078125,
        714.7395629882812
      ],
      [
        -1408.205810546875,
        -3924.107666015625,
        713.8007202148438
      ],
      [
        -1411.6412353515625,
        -3923.8427734375,
        715.1388549804688
      ],
      [
        -1411.6868896484375,
        -3918.078125,
        714.7395629882812
      ],
      [
        -1409.951904296875,
        -3917.9404296875,
        714.0441284179688
      ],
      [
        -1407.2108154296875,
        -3922.583740234375,
        713.2974243164062
      ],
      [
        -1408.205810546875,
        -3924.107666015625,
        713.80078125
      ],
      [
        -1419.433349609375,
        -3956.97412109375,
        716.5728149414062
      ],
      [
        -1412.1341552734375,
        -3954.3173828125,
        715.7373046875
      ],
      [
        -1409.1751708984375,
        -3953.240478515625,
        716.0484619140625
      ],
      [
        -1408.7110595703125,
        -3953.071533203125,
        716.0972290039062
      ],
      [
        -1405.7728271484375,
        -3952.002197265625,
        716.4061889648438
      ],
      [
        -1408.6058349609375,
        -3923.414794921875,
        717.3011474609375
      ],
      [
        -1411.37646484375,
        -3923.38427734375,
        717.4551391601562
      ],
      [
        -1407.828857421875,
        -3922.072509765625,
        717.2929077148438
      ],
      [
        -1408.6058349609375,
        -3923.414794921875,
        717.3011474609375
      ],
      [
        -1412.7220458984375,
        -3921.0,
        717.5911254882812
      ],
      [
        -1411.3626708984375,
        -3918.639892578125,
        717.576904296875
      ],
      [
        -1411.37646484375,
        -3923.38427734375,
        717.4551391601562
      ],
      [
        -1412.7220458984375,
        -3921.0,
        717.5911254882812
      ],
      [
        -1411.3626708984375,
        -3918.639892578125,
        717.576904296875
      ],
      [
        -1409.83642578125,
        -3918.623046875,
        717.4929809570312
      ],
      [
        -1402.796142578125,
        -3950.918701171875,
        716.71923828125
      ],
      [
        -1400.1846923828125,
        -3949.96826171875,
        716.7124633789062
      ],
      [
        -1402.796142578125,
        -3950.918701171875,
        716.71923828125
      ],
      [
        -1400.1846923828125,
        -3949.96826171875,
        765.6624755859375
      ],
      [
        -1402.796142578125,
        -3950.918701171875,
        767.636962890625
      ],
      [
        -1402.796142578125,
        -3950.918701171875,
        767.636962890625
      ],
      [
        -1462.9000244140625,
        -3922.3115234375,
        764.5520629882812
      ],
      [
        -1462.9000244140625,
        -3924.354248046875,
        771.0297241210938
      ],
      [
        -1462.9000244140625,
        -3924.354248046875,
        771.0297241210938
      ],
      [
        -1462.9000244140625,
        -3924.364013671875,
        771.0635986328125
      ],
      [
        -1462.9000244140625,
        -3922.3115234375,
        764.5520629882812
      ],
      [
        -1462.9000244140625,
        -3919.837890625,
        763.6804809570312
      ],
      [
        -1462.9000244140625,
        -3924.364013671875,
        771.0635986328125
      ],
      [
        -1460.2645263671875,
        -3922.895751953125,
        773.5538330078125
      ],
      [
        -1462.9000244140625,
        -3924.354248046875,
        771.097412109375
      ],
      [
        -1462.9000244140625,
        -3923.123779296875,
        774.9992065429688
      ],
      [
        -1462.9000244140625,
        -3924.354248046875,
        771.097412109375
      ],
      [
        -1460.2645263671875,
        -3922.895751953125,
        773.5538330078125
      ],
      [
        -1462.9000244140625,
        -3922.3115234375,
        777.5751342773438
      ],
      [
        -1462.9000244140625,
        -3922.3115234375,
        777.5751342773438
      ],
      [
        -1462.9000244140625,
        -3920.387939453125,
        778.2529296875
      ],
      [
        -1442.555908203125,
        -3921.917236328125,
        773.2761840820312
      ],
      [
        -1443.71728515625,
        -3917.582763671875,
        778.3698120117188
      ],
      [
        -1442.4757080078125,
        -3922.21630859375,
        767.7991943359375
      ],
      [
        -1462.9000244140625,
        -3916.15380859375,
        762.3815307617188
      ],
      [
        -1462.9000244140625,
        -3916.183349609375,
        762.392822265625
      ],
      [
        -1462.9000244140625,
        -3916.183349609375,
        762.392822265625
      ],
      [
        -1462.9000244140625,
        -3916.12451171875,
        762.392822265625
      ],
      [
        -1460.9468994140625,
        -3914.46533203125,
        763.322021484375
      ],
      [
        -1462.9000244140625,
        -3916.15380859375,
        762.3815307617188
      ],
      [
        -1460.9468994140625,
        -3914.46533203125,
        763.322021484375
      ],
      [
        -1462.9000244140625,
        -3916.12451171875,
        762.392822265625
      ],
      [
        -1462.9000244140625,
        -3913.80908203125,
        763.2086791992188
      ],
      [
        -1443.364013671875,
        -3918.9013671875,
        763.9878540039062
      ],
      [
        -1462.9000244140625,
        -3916.183349609375,
        779.734375
      ],
      [
        -1462.9000244140625,
        -3916.15380859375,
        779.74560546875
      ],
      [
        -1462.9000244140625,
        -3916.183349609375,
        779.734375
      ],
      [
        -1462.9000244140625,
        -3916.15380859375,
        779.74560546875
      ],
      [
        -1461.60888671875,
        -3915.027587890625,
        779.1953125
      ],
      [
        -1462.9000244140625,
        -3916.12451171875,
        779.734375
      ],
      [
        -1462.9000244140625,
        -3914.79248046875,
        779.2650146484375
      ],
      [
        -1462.9000244140625,
        -3916.12451171875,
        779.734375
      ],
      [
        -1461.609130859375,
        -3915.02783203125,
        779.1954345703125
      ],
      [
        -1462.9000244140625,
        -3909.996337890625,
        777.5751342773438
      ],
      [
        -1462.9000244140625,
        -3909.996337890625,
        777.5751342773438
      ],
      [
        -1462.9000244140625,
        -3909.5380859375,
        776.122314453125
      ],
      [
        -1445.0150146484375,
        -3912.739990234375,
        778.6827392578125
      ],
      [
        -1462.9000244140625,
        -3907.95361328125,
        771.097412109375
      ],
      [
        -1462.9000244140625,
        -3907.943603515625,
        771.0635986328125
      ],
      [
        -1462.9000244140625,
        -3907.95361328125,
        771.097412109375
      ],
      [
        -1462.9000244140625,
        -3907.943603515625,
        771.0635986328125
      ],
      [
        -1461.1025390625,
        -3908.721435546875,
        769.4591674804688
      ],
      [
        -1462.9000244140625,
        -3907.95361328125,
        771.0297241210938
      ],
      [
        -1462.9000244140625,
        -3908.639892578125,
        768.8535766601562
      ],
      [
        -1462.9000244140625,
        -3907.95361328125,
        771.0297241210938
      ],
      [
        -1461.1025390625,
        -3908.721435546875,
        769.4591674804688
      ],
      [
        -1462.9000244140625,
        -3909.996337890625,
        764.5520629882812
      ],
      [
        -1462.9000244140625,
        -3909.996337890625,
        764.5520629882812
      ],
      [
        -1462.9000244140625,
        -3910.92626953125,
        764.2244262695312
      ],
      [
        -1444.6588134765625,
        -3914.0693359375,
        764.3267822265625
      ],
      [
        -1503.0,
        -3910.3818359375,
        791.0107421875
      ],
      [
        -1503.0,
        -3909.267822265625,
        791.0107421875
      ],
      [
        -1503.0,
        -3940.732177734375,
        791.0107421875
      ],
      [
        -1503.0,
        -3939.499267578125,
        791.0107421875
      ],
      [
        -1487.61865234375,
        -3905.133544921875,
        769.7703247070312
      ],
      [
        -1487.6126708984375,
        -3905.119384765625,
        769.75
      ],
      [
        -1487.61865234375,
        -3905.133544921875,
        769.7703247070312
      ],
      [
        -1486.026123046875,
        -3933.60546875,
        769.75
      ],
      [
        -1477.620361328125,
        -3932.8173828125,
        781.139892578125
      ],
      [
        -1486.0263671875,
        -3919.0,
        781.7894897460938
      ],
      [
        -1477.625,
        -3905.18505859375,
        781.1380615234375
      ],
      [
        -1477.5,
        -3905.09130859375,
        781.1039428710938
      ],
      [
        -1470.8436279296875,
        -3929.039794921875,
        753.3125
      ],
      [
        -1469.1644287109375,
        -3928.18603515625,
        754.6571044921875
      ],
      [
        -1482.7294921875,
        -3926.287841796875,
        753.3649291992188
      ],
      [
        -1482.65380859375,
        -3926.351318359375,
        753.3125
      ],
      [
        -1462.9000244140625,
        -3915.896728515625,
        762.4730834960938
      ],
      [
        -1462.9000244140625,
        -3916.257568359375,
        762.4189453125
      ],
      [
        -1462.9000244140625,
        -3909.9697265625,
        764.63671875
      ],
      [
        -1462.9000244140625,
        -3922.3408203125,
        764.6449584960938
      ],
      [
        -1477.0780029296875,
        -3934.14453125,
        753.3125
      ],
      [
        -1462.9000244140625,
        -3924.321044921875,
        771.2024536132812
      ],
      [
        -1468.022705078125,
        -3933.202392578125,
        756.8831176757812
      ],
      [
        -1467.4351806640625,
        -3931.7275390625,
        757.077880859375
      ],
      [
        -1462.9000244140625,
        -3922.22705078125,
        777.6049194335938
      ],
      [
        -1462.9375,
        -3915.45263671875,
        779.5020751953125
      ],
      [
        -1462.9375,
        -3915.45263671875,
        779.5020751953125
      ],
      [
        -1462.9000244140625,
        -3915.384765625,
        779.4736938476562
      ],
      [
        -1462.9000244140625,
        -3909.9853515625,
        777.540283203125
      ],
      [
        -1462.9000244140625,
        -3907.963134765625,
        770.999755859375
      ],
      [
        -1469.3846435546875,
        -3926.134765625,
        734.6875
      ],
      [
        -1469.590087890625,
        -3925.59326171875,
        734.7212524414062
      ],
      [
        -1469.590087890625,
        -3925.59326171875,
        734.7212524414062
      ],
      [
        -1455.427978515625,
        -3926.13427734375,
        734.6875
      ],
      [
        -1455.392578125,
        -3925.59326171875,
        734.72119140625
      ],
      [
        -1455.392578125,
        -3925.59326171875,
        734.72119140625
      ],
      [
        -1467.7686767578125,
        -3926.9267578125,
        746.1203002929688
      ],
      [
        -1468.2567138671875,
        -3927.02685546875,
        746.1875
      ],
      [
        -1471.7899169921875,
        -3935.916259765625,
        734.7320556640625
      ],
      [
        -1471.4256591796875,
        -3936.254638671875,
        734.6875
      ],
      [
        -1471.7899169921875,
        -3935.916259765625,
        734.7320556640625
      ],
      [
        -1450.8934326171875,
        -3921.690185546875,
        743.75
      ],
      [
        -1483.9176025390625,
        -3923.191650390625,
        736.25
      ],
      [
        -1483.9024658203125,
        -3923.130859375,
        736.24560546875
      ],
      [
        -1453.2470703125,
        -3935.916748046875,
        734.732177734375
      ],
      [
        -1453.38720703125,
        -3936.255859375,
        734.6875
      ],
      [
        -1453.2470703125,
        -3935.916748046875,
        734.732177734375
      ],
      [
        -1448.777099609375,
        -3923.171142578125,
        736.2408447265625
      ],
      [
        -1448.7698974609375,
        -3923.192138671875,
        736.25
      ],
      [
        -1480.4268798828125,
        -3919.14208984375,
        746.1367797851562
      ],
      [
        -1480.429443359375,
        -3919.54833984375,
        746.1875
      ],
      [
        -1480.4268798828125,
        -3919.14208984375,
        746.1367797851562
      ],
      [
        -1481.9306640625,
        -3927.027587890625,
        746.1875
      ],
      [
        -1485.3594970703125,
        -3921.965087890625,
        743.787109375
      ],
      [
        -1485.378173828125,
        -3921.869873046875,
        743.7911987304688
      ],
      [
        -1485.3594970703125,
        -3921.965087890625,
        743.787109375
      ],
      [
        -1485.4190673828125,
        -3921.690673828125,
        743.75
      ],
      [
        -1455.427978515625,
        -3945.178466796875,
        734.6875
      ],
      [
        -1461.954345703125,
        -3949.8603515625,
        734.382080078125
      ],
      [
        -1461.3519287109375,
        -3948.48779296875,
        734.6875
      ],
      [
        -1461.9541015625,
        -3949.861083984375,
        734.3818969726562
      ],
      [
        -1469.4271240234375,
        -3925.40673828125,
        734.4541015625
      ],
      [
        -1468.2955322265625,
        -3925.17333984375,
        734.6875
      ],
      [
        -1469.4271240234375,
        -3925.40673828125,
        734.4541015625
      ],
      [
        -1461.954345703125,
        -3922.65087890625,
        734.382080078125
      ],
      [
        -1461.3525390625,
        -3922.824462890625,
        734.6875
      ],
      [
        -1461.954345703125,
        -3922.65087890625,
        734.382080078125
      ],
      [
        -1457.5223388671875,
        -3925.31591796875,
        711.8670043945312
      ],
      [
        -1462.9588623046875,
        -3923.09130859375,
        707.3125
      ],
      [
        -1456.5565185546875,
        -3925.37451171875,
        707.3125
      ],
      [
        -1457.5223388671875,
        -3925.31591796875,
        711.8670043945312
      ],
      [
        -1455.0889892578125,
        -3927.615966796875,
        734.6875
      ],
      [
        -1454.70947265625,
        -3930.049560546875,
        708.1603393554688
      ],
      [
        -1455.1004638671875,
        -3928.74072265625,
        707.3125
      ],
      [
        -1454.4638671875,
        -3930.855712890625,
        708.5040893554688
      ],
      [
        -1454.70947265625,
        -3930.049560546875,
        708.1603393554688
      ],
      [
        -1454.43505859375,
        -3930.845703125,
        707.3125
      ],
      [
        -1454.4638671875,
        -3930.855712890625,
        708.5040893554688
      ],
      [
        -1453.379638671875,
        -3936.22314453125,
        734.6875
      ],
      [
        -1453.4171142578125,
        -3936.38671875,
        734.6875
      ],
      [
        -1455.966552734375,
        -3928.4248046875,
        710.8449096679688
      ],
      [
        -1456.9739990234375,
        -3925.34912109375,
        709.2811279296875
      ],
      [
        -1454.9036865234375,
        -3931.707763671875,
        711.967529296875
      ],
      [
        -1455.966552734375,
        -3928.4248046875,
        710.8449096679688
      ],
      [
        -1454.92333984375,
        -3931.974609375,
        707.3125
      ],
      [
        -1454.9036865234375,
        -3931.707763671875,
        711.967529296875
      ],
      [
        -1455.0408935546875,
        -3932.246337890625,
        707.3125
      ],
      [
        -1454.97900390625,
        -3931.853759765625,
        712.5606079101562
      ],
      [
        -1454.9788818359375,
        -3931.853515625,
        712.5597534179688
      ],
      [
        -1456.230712890625,
        -3928.08349609375,
        711.408935546875
      ],
      [
        -1456.230712890625,
        -3928.08349609375,
        711.408935546875
      ],
      [
        -1457.1573486328125,
        -3925.338134765625,
        710.1458740234375
      ],
      [
        -1457.6951904296875,
        -3925.489990234375,
        713.068359375
      ],
      [
        -1462.75146484375,
        -3923.534912109375,
        709.45849609375
      ],
      [
        -1464.7047119140625,
        -3922.78662109375,
        708.2042846679688
      ],
      [
        -1462.75146484375,
        -3923.534912109375,
        709.45849609375
      ],
      [
        -1464.7047119140625,
        -3922.78662109375,
        708.2042846679688
      ],
      [
        -1464.7073974609375,
        -3922.77880859375,
        708.0631713867188
      ],
      [
        -1457.0802001953125,
        -3925.56689453125,
        710.2510986328125
      ],
      [
        -1457.6951904296875,
        -3925.489990234375,
        713.068359375
      ],
      [
        -1464.7220458984375,
        -3922.736572265625,
        707.3125
      ],
      [
        -1456.2723388671875,
        -3935.093505859375,
        707.3125
      ],
      [
        -1457.500244140625,
        -3926.442626953125,
        714.1203002929688
      ],
      [
        -1457.500244140625,
        -3926.442626953125,
        714.1203002929688
      ],
      [
        -1457.8157958984375,
        -3925.611328125,
        713.906982421875
      ],
      [
        -1457.8157958984375,
        -3925.611328125,
        713.906982421875
      ],
      [
        -1458.1865234375,
        -3925.300048828125,
        712.7175903320312
      ],
      [
        -1466.1220703125,
        -3941.38916015625,
        715.1110229492188
      ],
      [
        -1466.1220703125,
        -3941.38916015625,
        715.1110229492188
      ],
      [
        -1466.0474853515625,
        -3941.407958984375,
        715.1100463867188
      ],
      [
        -1458.591796875,
        -3939.1337890625,
        714.473876953125
      ],
      [
        -1457.8890380859375,
        -3938.935302734375,
        714.416015625
      ],
      [
        -1466.0474853515625,
        -3941.407958984375,
        715.1100463867188
      ],
      [
        -1458.591796875,
        -3939.1337890625,
        714.473876953125
      ],
      [
        -1476.605224609375,
        -3932.30517578125,
        714.39599609375
      ],
      [
        -1476.3857421875,
        -3932.866943359375,
        714.4595947265625
      ],
      [
        -1476.3857421875,
        -3932.866943359375,
        714.4595947265625
      ],
      [
        -1457.8890380859375,
        -3938.935302734375,
        714.416015625
      ],
      [
        -1455.6304931640625,
        -3933.311767578125,
        713.5765991210938
      ],
      [
        -1455.6304931640625,
        -3933.311767578125,
        713.5765991210938
      ],
      [
        -1455.5137939453125,
        -3933.0439453125,
        713.5361938476562
      ],
      [
        -1476.605224609375,
        -3932.30517578125,
        714.39599609375
      ],
      [
        -1474.2537841796875,
        -3926.77880859375,
        713.5650024414062
      ],
      [
        -1465.58154296875,
        -3923.28759765625,
        712.7141723632812
      ],
      [
        -1467.8480224609375,
        -3923.880859375,
        712.8947143554688
      ],
      [
        -1473.68115234375,
        -3925.534423828125,
        713.3759765625
      ],
      [
        -1474.2537841796875,
        -3926.77880859375,
        713.5650024414062
      ],
      [
        -1473.68115234375,
        -3925.534423828125,
        713.3759765625
      ],
      [
        -1467.8480224609375,
        -3923.880859375,
        712.8947143554688
      ],
      [
        -1465.58154296875,
        -3923.28759765625,
        712.7141723632812
      ],
      [
        -1460.09326171875,
        -3924.80029296875,
        712.6635131835938
      ],
      [
        -1458.2923583984375,
        -3925.259033203125,
        712.6419677734375
      ],
      [
        -1460.09326171875,
        -3924.80029296875,
        712.6635131835938
      ],
      [
        -1477.366943359375,
        -3932.2099609375,
        715.3463745117188
      ],
      [
        -1473.94873046875,
        -3925.692626953125,
        714.4679565429688
      ],
      [
        -1467.498291015625,
        -3923.818603515625,
        713.3438720703125
      ],
      [
        -1476.4500732421875,
        -3931.603515625,
        715.169189453125
      ],
      [
        -1474.1771240234375,
        -3926.19482421875,
        714.5300903320312
      ],
      [
        -1475.6314697265625,
        -3934.98095703125,
        714.7024536132812
      ],
      [
        -1465.6414794921875,
        -3923.32177734375,
        713.0225219726562
      ],
      [
        -1467.498291015625,
        -3923.818603515625,
        713.3438720703125
      ],
      [
        -1465.6414794921875,
        -3923.32177734375,
        713.0225219726562
      ],
      [
        -1464.3990478515625,
        -3923.63623046875,
        712.840576171875
      ],
      [
        -1463.8594970703125,
        -3923.762451171875,
        712.6983032226562
      ],
      [
        -1473.94873046875,
        -3925.692626953125,
        714.4679565429688
      ],
      [
        -1474.1771240234375,
        -3926.19482421875,
        714.5300903320312
      ],
      [
        -1476.5152587890625,
        -3931.7587890625,
        715.1875
      ],
      [
        -1476.5152587890625,
        -3931.7587890625,
        715.1875
      ],
      [
        -1477.366943359375,
        -3932.2099609375,
        715.3463745117188
      ],
      [
        -1463.3985595703125,
        -3923.889404296875,
        712.6940307617188
      ],
      [
        -1457.9117431640625,
        -3938.989990234375,
        714.5735473632812
      ],
      [
        -1455.5985107421875,
        -3933.230224609375,
        713.738525390625
      ],
      [
        -1455.5985107421875,
        -3933.230224609375,
        713.738525390625
      ],
      [
        -1455.493408203125,
        -3932.989013671875,
        713.7032470703125
      ],
      [
        -1458.4752197265625,
        -3939.1474609375,
        714.614501953125
      ],
      [
        -1458.4752197265625,
        -3939.1474609375,
        714.614501953125
      ],
      [
        -1457.9117431640625,
        -3938.989990234375,
        714.5735473632812
      ],
      [
        -1459.9764404296875,
        -3924.85595703125,
        712.8043212890625
      ],
      [
        -1464.1514892578125,
        -3923.698974609375,
        712.8043212890625
      ],
      [
        -1458.1610107421875,
        -3925.321533203125,
        712.7994384765625
      ],
      [
        -1459.9764404296875,
        -3924.85595703125,
        712.8043212890625
      ],
      [
        -1457.752197265625,
        -3939.34130859375,
        715.3079833984375
      ],
      [
        -1457.741455078125,
        -3938.558349609375,
        715.1875
      ],
      [
        -1455.461669921875,
        -3932.880859375,
        714.4315795898438
      ],
      [
        -1455.461669921875,
        -3932.880859375,
        714.4315795898438
      ],
      [
        -1455.4066162109375,
        -3932.754638671875,
        714.4149169921875
      ],
      [
        -1457.741455078125,
        -3938.558349609375,
        715.1875
      ],
      [
        -1457.752197265625,
        -3939.34130859375,
        715.3079833984375
      ],
      [
        -1459.30029296875,
        -3939.396484375,
        714.6768188476562
      ],
      [
        -1458.0556640625,
        -3925.409912109375,
        713.1372680664062
      ],
      [
        -1459.23779296875,
        -3925.04541015625,
        712.8023071289062
      ],
      [
        -1458.6248779296875,
        -3925.253662109375,
        713.0827026367188
      ],
      [
        -1459.9705810546875,
        -3924.858642578125,
        712.8114013671875
      ],
      [
        -1459.0390625,
        -3925.11279296875,
        712.8931884765625
      ],
      [
        -1459.9705810546875,
        -3924.858642578125,
        712.8114013671875
      ],
      [
        -1460.048583984375,
        -3924.8359375,
        712.8043212890625
      ],
      [
        -1459.842529296875,
        -3924.919677734375,
        712.9658813476562
      ],
      [
        -1461.475830078125,
        -3924.4404296875,
        712.8043212890625
      ],
      [
        -1459.842529296875,
        -3924.919677734375,
        712.9658813476562
      ],
      [
        -1455.60986328125,
        -3931.75830078125,
        715.1875
      ],
      [
        -1456.07080078125,
        -3930.400634765625,
        714.817626953125
      ],
      [
        -1455.3695068359375,
        -3932.2099609375,
        715.346435546875
      ],
      [
        -1455.60986328125,
        -3931.75830078125,
        715.1875
      ],
      [
        -1457.9808349609375,
        -3925.47265625,
        713.377197265625
      ],
      [
        -1458.6248779296875,
        -3925.253662109375,
        713.0827026367188
      ],
      [
        -1474.0911865234375,
        -3925.77685546875,
        715.0494384765625
      ],
      [
        -1467.3382568359375,
        -3923.7900390625,
        713.5494384765625
      ],
      [
        -1474.1357421875,
        -3925.878662109375,
        715.0523681640625
      ],
      [
        -1476.4500732421875,
        -3931.603515625,
        715.169189453125
      ],
      [
        -1465.67138671875,
        -3923.3388671875,
        713.176025390625
      ],
      [
        -1467.3382568359375,
        -3923.7900390625,
        713.5494384765625
      ],
      [
        -1465.67138671875,
        -3923.3388671875,
        713.176025390625
      ],
      [
        -1464.3988037109375,
        -3923.636474609375,
        712.8405151367188
      ],
      [
        -1474.0911865234375,
        -3925.77685546875,
        715.0494384765625
      ],
      [
        -1474.1357421875,
        -3925.878662109375,
        715.0523681640625
      ],
      [
        -1466.621826171875,
        -3923.59619140625,
        713.388916015625
      ],
      [
        -1457.7535400390625,
        -3925.775390625,
        713.9490356445312
      ],
      [
        -1457.7412109375,
        -3926.442138671875,
        715.1875
      ],
      [
        -1457.7412109375,
        -3926.442138671875,
        715.1875
      ],
      [
        -1457.4127197265625,
        -3926.68505859375,
        714.1630249023438
      ],
      [
        -1466.3668212890625,
        -3923.61669921875,
        714.7966918945312
      ],
      [
        -1466.187744140625,
        -3923.570068359375,
        714.784912109375
      ],
      [
        -1466.3668212890625,
        -3923.61669921875,
        714.7966918945312
      ],
      [
        -1474.1798095703125,
        -3925.987548828125,
        715.0545654296875
      ],
      [
        -1475.588134765625,
        -3928.667724609375,
        690.696533203125
      ],
      [
        -1475.588134765625,
        -3928.667724609375,
        690.696533203125
      ],
      [
        -1475.689697265625,
        -3928.46484375,
        690.665283203125
      ],
      [
        -1475.689697265625,
        -3928.46484375,
        690.665283203125
      ],
      [
        -1475.5933837890625,
        -3928.464599609375,
        690.663330078125
      ],
      [
        -1475.3125,
        -3928.46435546875,
        690.6575927734375
      ],
      [
        -1447.9625244140625,
        -3931.110107421875,
        692.7578735351562
      ],
      [
        -1444.20263671875,
        -3929.399658203125,
        704.0625
      ],
      [
        -1503.0,
        -3921.1875,
        694.5859985351562
      ],
      [
        -1503.0,
        -3921.22900390625,
        694.5719604492188
      ],
      [
        -1503.0,
        -3924.75,
        693.3983154296875
      ],
      [
        -1503.0,
        -3921.22900390625,
        694.5719604492188
      ],
      [
        -1503.0,
        -3928.3125,
        694.5859985351562
      ],
      [
        -1503.0,
        -3928.27099609375,
        694.5719604492188
      ],
      [
        -1478.451416015625,
        -3935.50830078125,
        692.5814208984375
      ],
      [
        -1475.4473876953125,
        -3934.227294921875,
        691.6055297851562
      ],
      [
        -1476.6348876953125,
        -3938.09228515625,
        693.1264038085938
      ],
      [
        -1478.451416015625,
        -3935.50830078125,
        692.5814208984375
      ],
      [
        -1475.3125,
        -3940.314697265625,
        693.6384887695312
      ],
      [
        -1476.6348876953125,
        -3938.09228515625,
        693.1264038085938
      ],
      [
        -1503.0,
        -3924.75,
        693.3983154296875
      ],
      [
        -1503.0,
        -3928.27099609375,
        694.5719604492188
      ],
      [
        -1479.0841064453125,
        -3935.383544921875,
        694.3300170898438
      ],
      [
        -1475.3125,
        -3941.830322265625,
        695.9558715820312
      ],
      [
        -1479.0841064453125,
        -3935.383544921875,
        694.3300170898438
      ],
      [
        -1494.5126953125,
        -3924.420166015625,
        691.9595336914062
      ],
      [
        -1476.255859375,
        -3917.84326171875,
        692.9401245117188
      ],
      [
        -1476.255859375,
        -3917.84326171875,
        692.9401245117188
      ],
      [
        -1475.3125,
        -3917.410888671875,
        693.0069580078125
      ],
      [
        -1503.0,
        -3921.17431640625,
        694.6263427734375
      ],
      [
        -1503.0,
        -3920.0,
        698.1490478515625
      ],
      [
        -1503.0,
        -3921.1875,
        694.5859985351562
      ],
      [
        -1503.0,
        -3921.17431640625,
        694.6263427734375
      ],
      [
        -1503.0,
        -3920.0,
        698.1490478515625
      ],
      [
        -1503.0,
        -3920.012939453125,
        698.188232421875
      ],
      [
        -1501.250244140625,
        -3920.23828125,
        698.5670166015625
      ],
      [
        -1501.250244140625,
        -3920.23828125,
        698.5670166015625
      ],
      [
        -1503.0,
        -3920.012939453125,
        698.188232421875
      ],
      [
        -1503.0,
        -3920.299072265625,
        699.0470581054688
      ],
      [
        -1479.0975341796875,
        -3916.841064453125,
        699.0569458007812
      ],
      [
        -1479.0975341796875,
        -3916.841064453125,
        699.0569458007812
      ],
      [
        -1476.01806640625,
        -3915.513671875,
        701.2632446289062
      ],
      [
        -1503.0,
        -3921.1875,
        701.7120971679688
      ],
      [
        -1480.1065673828125,
        -3920.69140625,
        702.9779052734375
      ],
      [
        -1474.1915283203125,
        -3921.223876953125,
        706.0504150390625
      ],
      [
        -1477.589599609375,
        -3921.01123046875,
        704.5180053710938
      ],
      [
        -1480.1065673828125,
        -3920.69140625,
        702.9779052734375
      ],
      [
        -1477.589599609375,
        -3921.01123046875,
        704.5180053710938
      ],
      [
        -1503.0,
        -3921.1875,
        701.7120971679688
      ],
      [
        -1503.0,
        -3923.14208984375,
        702.3635864257812
      ],
      [
        -1495.2076416015625,
        -3920.035400390625,
        696.891357421875
      ],
      [
        -1503.0,
        -3923.205810546875,
        702.3848266601562
      ],
      [
        -1503.0,
        -3928.3125,
        701.7120971679688
      ],
      [
        -1503.0,
        -3929.487060546875,
        698.188232421875
      ],
      [
        -1503.0,
        -3929.5,
        698.1490478515625
      ],
      [
        -1503.0,
        -3929.487060546875,
        698.188232421875
      ],
      [
        -1503.0,
        -3926.78515625,
        702.22119140625
      ],
      [
        -1503.0,
        -3928.3125,
        701.7120971679688
      ],
      [
        -1503.0,
        -3929.5,
        698.1490478515625
      ],
      [
        -1503.0,
        -3928.84228515625,
        696.1762084960938
      ],
      [
        -1484.85009765625,
        -3929.063232421875,
        693.23779296875
      ],
      [
        -1484.85009765625,
        -3929.063232421875,
        693.23779296875
      ],
      [
        -1485.0166015625,
        -3928.904541015625,
        692.7898559570312
      ],
      [
        -1503.0,
        -3928.3125,
        694.5859985351562
      ],
      [
        -1503.0,
        -3928.32568359375,
        694.6263427734375
      ],
      [
        -1503.0,
        -3928.32568359375,
        694.6263427734375
      ],
      [
        -1503.0,
        -3924.75,
        702.8997192382812
      ],
      [
        -1503.0,
        -3924.71142578125,
        702.88671875
      ],
      [
        -1503.0,
        -3924.71142578125,
        702.88671875
      ],
      [
        -1487.702880859375,
        -3920.480712890625,
        700.2144165039062
      ],
      [
        -1485.9100341796875,
        -3923.73095703125,
        701.189453125
      ],
      [
        -1485.9100341796875,
        -3923.73095703125,
        701.189453125
      ],
      [
        -1485.452392578125,
        -3924.54736328125,
        701.471435546875
      ],
      [
        -1485.452392578125,
        -3924.54736328125,
        701.471435546875
      ],
      [
        -1492.7840576171875,
        -3925.01220703125,
        701.268798828125
      ],
      [
        -1485.42724609375,
        -3924.606201171875,
        701.4519653320312
      ],
      [
        -1484.1671142578125,
        -3927.484375,
        700.653076171875
      ],
      [
        -1485.205078125,
        -3925.126220703125,
        701.2802734375
      ],
      [
        -1488.169677734375,
        -3926.21484375,
        700.898193359375
      ],
      [
        -1488.169677734375,
        -3926.21484375,
        700.898193359375
      ],
      [
        -1485.205078125,
        -3925.126220703125,
        701.2802734375
      ],
      [
        -1503.0,
        -3924.75,
        702.8997192382812
      ],
      [
        -1503.0,
        -3924.78857421875,
        702.88671875
      ],
      [
        -1503.0,
        -3924.78857421875,
        702.88671875
      ],
      [
        -1485.891357421875,
        -3920.2734375,
        700.229736328125
      ],
      [
        -1485.42724609375,
        -3924.606201171875,
        701.4519653320312
      ],
      [
        -1483.5,
        -3924.045654296875,
        701.373779296875
      ],
      [
        -1483.22802734375,
        -3924.19482421875,
        701.6184692382812
      ],
      [
        -1483.5,
        -3924.045654296875,
        701.373779296875
      ],
      [
        -1485.4599609375,
        -3920.22412109375,
        700.2333984375
      ],
      [
        -1483.22802734375,
        -3924.19482421875,
        701.6184692382812
      ],
      [
        -1475.055908203125,
        -3932.2021484375,
        706.8676147460938
      ],
      [
        -1535.0,
        -3939.917724609375,
        687.5
      ],
      [
        -1535.0,
        -3938.85986328125,
        670.0
      ],
      [
        -1539.0,
        -3939.917724609375,
        687.5
      ],
      [
        -1535.0,
        -3939.917724609375,
        687.5
      ],
      [
        -1535.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1535.0,
        -3911.14013671875,
        670.0
      ],
      [
        -1539.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1535.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1536.0,
        -3910.0,
        688.8596801757812
      ],
      [
        -1536.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1535.0,
        -3939.87353515625,
        687.5
      ],
      [
        -1535.0,
        -3938.330810546875,
        670.0
      ],
      [
        -1539.0,
        -3937.117431640625,
        687.5
      ],
      [
        -1535.0,
        -3939.87353515625,
        687.5
      ],
      [
        -1539.0,
        -3936.0,
        674.8300170898438
      ],
      [
        -1538.3818359375,
        -3936.0,
        670.0
      ],
      [
        -1539.8736572265625,
        -3937.0,
        693.0
      ],
      [
        -1540.0,
        -3936.912841796875,
        693.0
      ],
      [
        -1535.0,
        -3910.1259765625,
        687.5
      ],
      [
        -1535.0,
        -3911.66943359375,
        670.0
      ],
      [
        -1536.9310302734375,
        -3913.0,
        670.0
      ],
      [
        -1539.0,
        -3913.0,
        686.1683959960938
      ],
      [
        -1536.0,
        -3910.0,
        696.7483520507812
      ],
      [
        -1536.0,
        -3910.815185546875,
        687.5
      ],
      [
        -1539.0,
        -3912.882568359375,
        687.5
      ],
      [
        -1536.0,
        -3910.082275390625,
        687.5
      ],
      [
        -1536.0,
        -3910.815185546875,
        687.5
      ],
      [
        -1537.7191162109375,
        -3912.0,
        687.5
      ],
      [
        -1538.0,
        -3912.0,
        689.6947021484375
      ],
      [
        -1540.0,
        -3913.0,
        693.0
      ],
      [
        -1538.4229736328125,
        -3912.0,
        693.0
      ],
      [
        -1539.8739013671875,
        -3913.0,
        693.0
      ],
      [
        -1535.0,
        -3910.1259765625,
        687.5
      ],
      [
        -1540.0,
        -3913.0869140625,
        693.0
      ],
      [
        -1539.0,
        -3937.0,
        687.5
      ],
      [
        -1536.0,
        -3937.0,
        687.5
      ],
      [
        -1536.0,
        -3939.1845703125,
        687.5
      ],
      [
        -1508.21923828125,
        -3937.0,
        707.8992919921875
      ],
      [
        -1504.5345458984375,
        -3937.0,
        766.5744018554688
      ],
      [
        -1535.0,
        -3937.0,
        687.5
      ],
      [
        -1535.0,
        -3937.0,
        670.0
      ],
      [
        -1535.0,
        -3937.0,
        687.5
      ],
      [
        -1537.7193603515625,
        -3912.0,
        687.5
      ],
      [
        -1536.0,
        -3910.815185546875,
        687.5
      ],
      [
        -1536.0,
        -3912.0,
        687.5
      ],
      [
        -1504.05029296875,
        -3912.0,
        774.285400390625
      ],
      [
        -1506.82080078125,
        -3912.0,
        730.168212890625
      ],
      [
        -1535.0,
        -3911.5,
        687.5
      ],
      [
        -1535.0,
        -3911.5,
        671.9210815429688
      ],
      [
        -1535.0,
        -3911.5,
        687.5
      ],
      [
        -1536.0,
        -3911.5,
        687.5
      ],
      [
        -1535.0,
        -3912.0,
        687.5
      ],
      [
        -1535.0,
        -3912.0,
        670.0
      ],
      [
        -1535.0,
        -3912.0,
        687.5
      ],
      [
        -1509.1553955078125,
        -3937.0,
        693.0
      ],
      [
        -1509.154541015625,
        -3912.0,
        693.0
      ],
      [
        -1503.0,
        -3921.194091796875,
        694.583740234375
      ],
      [
        -1503.0,
        -3920.0029296875,
        698.1576538085938
      ],
      [
        -1503.0,
        -3928.305908203125,
        694.583740234375
      ],
      [
        -1503.0,
        -3929.4970703125,
        698.1575927734375
      ],
      [
        -1503.0,
        -3924.72265625,
        693.4074096679688
      ],
      [
        -1536.5,
        -3913.0,
        670.0
      ],
      [
        -1536.5,
        -3913.0,
        687.5
      ],
      [
        -1536.5,
        -3913.0,
        687.5
      ],
      [
        -1536.5,
        -3912.0,
        687.5
      ],
      [
        -1536.5,
        -3936.0,
        687.5
      ],
      [
        -1536.5,
        -3936.0,
        670.0
      ],
      [
        -1536.5,
        -3936.0,
        687.5
      ],
      [
        -1536.5,
        -3937.0,
        687.5
      ],
      [
        -772.5545043945312,
        -4037.0263671875,
        1299.46826171875
      ],
      [
        -802.7811279296875,
        -4014.572265625,
        1006.7724609375
      ],
      [
        -840.1368408203125,
        -3986.822509765625,
        645.0438232421875
      ],
      [
        -802.7811279296875,
        -4014.572265625,
        1006.7724609375
      ],
      [
        -839.1663818359375,
        -3987.54345703125,
        660.0
      ],
      [
        -839.2600708007812,
        -3987.473876953125,
        657.9761962890625
      ],
      [
        -839.2600708007812,
        -3987.473876953125,
        657.9761962890625
      ],
      [
        -839.1663818359375,
        -3987.54345703125,
        660.0
      ],
      [
        -1180.0,
        -4011.041259765625,
        726.1341552734375
      ],
      [
        -1179.6881103515625,
        -4011.041259765625,
        726.1341552734375
      ],
      [
        -1179.6881103515625,
        -4011.041259765625,
        726.1341552734375
      ],
      [
        -1216.2861328125,
        -4030.0,
        712.7453002929688
      ],
      [
        -1240.0,
        -4028.205322265625,
        707.975830078125
      ],
      [
        -1229.8211669921875,
        -4010.33935546875,
        706.8303833007812
      ],
      [
        -1217.830078125,
        -4009.793212890625,
        709.1525268554688
      ],
      [
        -1232.1380615234375,
        -4010.39306640625,
        706.2138061523438
      ],
      [
        -1229.8211669921875,
        -4010.33935546875,
        706.8303833007812
      ],
      [
        -1356.2720947265625,
        -4033.3935546875,
        709.4754028320312
      ],
      [
        -1356.116455078125,
        -4026.236328125,
        710.9498901367188
      ],
      [
        -1349.1776123046875,
        -4026.177490234375,
        710.2824096679688
      ],
      [
        -1349.0430908203125,
        -4033.456787109375,
        708.7540893554688
      ],
      [
        -1356.116455078125,
        -4026.236328125,
        710.9498901367188
      ],
      [
        -1349.1776123046875,
        -4026.177490234375,
        710.2824096679688
      ],
      [
        -1349.0430908203125,
        -4033.456787109375,
        708.7540893554688
      ],
      [
        -1356.2720947265625,
        -4033.3935546875,
        709.4754028320312
      ],
      [
        -1318.71435546875,
        -3966.71435546875,
        711.0
      ],
      [
        -1318.7142333984375,
        -3973.78564453125,
        711.0
      ],
      [
        -1325.642822265625,
        -3973.78564453125,
        711.0
      ],
      [
        -1325.642822265625,
        -3966.71435546875,
        711.0
      ],
      [
        -1318.7142333984375,
        -3973.78564453125,
        711.0
      ],
      [
        -1325.642822265625,
        -3973.78564453125,
        711.0
      ],
      [
        -1325.642822265625,
        -3966.71435546875,
        711.0
      ],
      [
        -1318.71435546875,
        -3966.71435546875,
        711.0
      ],
      [
        -1289.93798828125,
        -4028.4482421875,
        704.0067138671875
      ],
      [
        -1289.7308349609375,
        -4020.224365234375,
        705.6983642578125
      ],
      [
        -1289.7308349609375,
        -4020.224365234375,
        705.6983642578125
      ],
      [
        -1281.6451416015625,
        -4020.145263671875,
        704.9228515625
      ],
      [
        -1281.6451416015625,
        -4020.145263671875,
        704.9228515625
      ],
      [
        -1281.5,
        -4026.912109375,
        703.5
      ],
      [
        -1284.8746337890625,
        -4028.5,
        703.5
      ],
      [
        -1289.93798828125,
        -4028.4482421875,
        704.0067138671875
      ],
      [
        -1305.7958984375,
        -3955.3876953125,
        711.5816040039062
      ],
      [
        -1306.6861572265625,
        -3956.7373046875,
        711.0
      ],
      [
        -1305.7958984375,
        -3955.3876953125,
        711.5816040039062
      ],
      [
        -1348.3299560546875,
        -3963.21533203125,
        723.305908203125
      ],
      [
        -1315.9375,
        -3953.434326171875,
        722.168701171875
      ],
      [
        -1312.010986328125,
        -3953.10986328125,
        721.8515625
      ],
      [
        -1282.6744384765625,
        -3959.17919921875,
        717.7144165039062
      ],
      [
        -1279.904296875,
        -3959.393310546875,
        717.3984985351562
      ],
      [
        -1282.6744384765625,
        -3959.17919921875,
        717.7144165039062
      ],
      [
        -1279.904296875,
        -3959.393310546875,
        717.3984985351562
      ],
      [
        -1279.7236328125,
        -3959.78955078125,
        717.2982788085938
      ],
      [
        -1382.9248046875,
        -4018.9423828125,
        715.0944213867188
      ],
      [
        -1387.965576171875,
        -4003.412353515625,
        716.0
      ],
      [
        -1387.6134033203125,
        -4001.886962890625,
        716.0
      ],
      [
        -1387.965576171875,
        -4003.412353515625,
        716.0
      ],
      [
        -1387.964111328125,
        -4003.40625,
        716.357421875
      ],
      [
        -1382.9248046875,
        -4018.9423828125,
        715.0944213867188
      ],
      [
        -1383.5570068359375,
        -4015.35400390625,
        715.9033203125
      ],
      [
        -1387.9635009765625,
        -4003.4033203125,
        716.5213012695312
      ],
      [
        -1380.823486328125,
        -3988.08837890625,
        715.8528442382812
      ],
      [
        -1385.56787109375,
        -3993.0263671875,
        716.0
      ],
      [
        -1384.121826171875,
        -3986.76318359375,
        716.0
      ],
      [
        -1381.021728515625,
        -3987.991455078125,
        716.0
      ],
      [
        -1381.021728515625,
        -3987.991455078125,
        716.0
      ],
      [
        -1384.121826171875,
        -3986.76318359375,
        716.0
      ],
      [
        -1384.234619140625,
        -3987.251708984375,
        717.9987182617188
      ],
      [
        -1380.823486328125,
        -3988.08837890625,
        715.8528442382812
      ],
      [
        -1375.9840087890625,
        -3993.164794921875,
        711.0
      ],
      [
        -1274.5794677734375,
        -3977.943603515625,
        713.015380859375
      ],
      [
        -1369.1060791015625,
        -3980.28466796875,
        721.787841796875
      ],
      [
        -1352.2110595703125,
        -3965.38916015625,
        723.2335815429688
      ],
      [
        -1379.0810546875,
        -3988.95947265625,
        720.7971801757812
      ],
      [
        -1379.0211181640625,
        -3988.989501953125,
        720.9471435546875
      ],
      [
        -1373.1279296875,
        -3982.887939453125,
        721.639892578125
      ],
      [
        -1379.0211181640625,
        -3988.989501953125,
        720.9471435546875
      ],
      [
        -1379.0810546875,
        -3988.95947265625,
        720.7971801757812
      ],
      [
        -1381.660888671875,
        -3987.957763671875,
        716.8233032226562
      ],
      [
        -1384.35791015625,
        -3987.785400390625,
        720.1830444335938
      ],
      [
        -1384.396484375,
        -3987.952880859375,
        721.6895141601562
      ],
      [
        -1381.81005859375,
        -3987.81005859375,
        716.4904174804688
      ],
      [
        -1384.35791015625,
        -3987.785400390625,
        720.1830444335938
      ],
      [
        -1381.660888671875,
        -3987.957763671875,
        716.8233032226562
      ],
      [
        -1373.1279296875,
        -3982.887939453125,
        721.639892578125
      ],
      [
        -1369.1060791015625,
        -3980.28466796875,
        721.787841796875
      ],
      [
        -1273.7784423828125,
        -3972.836669921875,
        714.0
      ],
      [
        -1274.5794677734375,
        -3977.943603515625,
        713.015380859375
      ],
      [
        -1273.7784423828125,
        -3972.836669921875,
        714.0
      ],
      [
        -1387.9617919921875,
        -4003.39599609375,
        716.9507446289062
      ],
      [
        -1381.74560546875,
        -3987.8740234375,
        716.6343383789062
      ],
      [
        -1385.6263427734375,
        -4003.607421875,
        718.5511474609375
      ],
      [
        -1385.6263427734375,
        -4003.607421875,
        718.5511474609375
      ],
      [
        -1387.858154296875,
        -4002.94677734375,
        718.9072875976562
      ],
      [
        -1387.9605712890625,
        -4003.390380859375,
        717.2803955078125
      ],
      [
        -1387.9605712890625,
        -4003.390380859375,
        717.2803955078125
      ],
      [
        -1348.3299560546875,
        -3963.21533203125,
        723.305908203125
      ],
      [
        -1352.2110595703125,
        -3965.38916015625,
        723.2335815429688
      ],
      [
        -1324.5341796875,
        -3967.63818359375,
        720.0541381835938
      ],
      [
        -1319.58984375,
        -3967.58984375,
        719.5798950195312
      ],
      [
        -1324.6685791015625,
        -3972.973876953125,
        718.95654296875
      ],
      [
        -1324.5341796875,
        -3967.63818359375,
        720.0541381835938
      ],
      [
        -1319.58984375,
        -3967.58984375,
        719.5798950195312
      ],
      [
        -1319.47314453125,
        -3973.02685546875,
        718.4366455078125
      ],
      [
        -1319.47314453125,
        -3973.02685546875,
        718.4366455078125
      ],
      [
        -1324.6685791015625,
        -3972.973876953125,
        718.95654296875
      ],
      [
        -1312.010986328125,
        -3953.10986328125,
        721.8516845703125
      ],
      [
        -1315.9375,
        -3953.434326171875,
        722.1687622070312
      ],
      [
        -1281.6529541015625,
        -4020.153076171875,
        705.0
      ],
      [
        -1281.653076171875,
        -4028.346923828125,
        705.0
      ],
      [
        -1281.653076171875,
        -4028.346923828125,
        705.0
      ],
      [
        -1289.81640625,
        -4028.346923828125,
        705.0
      ],
      [
        -1289.81640625,
        -4028.346923828125,
        705.0
      ],
      [
        -1289.81640625,
        -4023.619384765625,
        705.0
      ],
      [
        -1282.449462890625,
        -4020.153076171875,
        705.0
      ],
      [
        -1281.6529541015625,
        -4020.153076171875,
        705.0
      ],
      [
        -1346.3004150390625,
        -4043.63525390625,
        756.8819580078125
      ],
      [
        -1348.6331787109375,
        -4025.633056640625,
        757.906005859375
      ],
      [
        -1348.6640625,
        -4033.8359375,
        757.5554809570312
      ],
      [
        -1348.6640625,
        -4033.8359375,
        757.5554809570312
      ],
      [
        -1356.89501953125,
        -4033.91259765625,
        758.425537109375
      ],
      [
        -1356.9334716796875,
        -4025.555419921875,
        758.7901000976562
      ],
      [
        -1348.6331787109375,
        -4025.633056640625,
        757.906005859375
      ],
      [
        -1356.89501953125,
        -4033.91259765625,
        758.425537109375
      ],
      [
        -1356.9334716796875,
        -4025.555419921875,
        758.7901000976562
      ],
      [
        -1337.5,
        -4009.66845703125,
        757.886962890625
      ],
      [
        -1334.2381591796875,
        -4006.300048828125,
        758.7659912109375
      ],
      [
        -1334.2381591796875,
        -4006.300048828125,
        758.7659912109375
      ],
      [
        -1337.5,
        -4002.958251953125,
        757.7028198242188
      ],
      [
        -1337.1583251953125,
        -4003.331787109375,
        757.6504516601562
      ],
      [
        -1337.5,
        -4002.958251953125,
        757.7028198242188
      ],
      [
        -1339.73681640625,
        -4006.300048828125,
        757.7960205078125
      ],
      [
        -1339.73681640625,
        -4006.300048828125,
        757.7960205078125
      ],
      [
        -1337.5,
        -4009.66845703125,
        757.886962890625
      ],
      [
        -1338.3094482421875,
        -4008.40625,
        757.5536499023438
      ],
      [
        -1318.14453125,
        -3966.14453125,
        757.237060546875
      ],
      [
        -1318.1732177734375,
        -3974.326904296875,
        756.88720703125
      ],
      [
        -1318.1732177734375,
        -3974.326904296875,
        756.88720703125
      ],
      [
        -1326.3775634765625,
        -3974.39794921875,
        757.754638671875
      ],
      [
        -1326.4132080078125,
        -3966.072265625,
        758.1175537109375
      ],
      [
        -1318.14453125,
        -3966.14453125,
        757.237060546875
      ],
      [
        -1326.3775634765625,
        -3974.39794921875,
        757.754638671875
      ],
      [
        -1326.4132080078125,
        -3966.072265625,
        758.1175537109375
      ],
      [
        -1337.5,
        -4009.609619140625,
        757.4780883789062
      ],
      [
        -1334.4393310546875,
        -4006.300048828125,
        757.2691650390625
      ],
      [
        -1334.4393310546875,
        -4006.300048828125,
        757.2691650390625
      ],
      [
        -1337.06103515625,
        -4003.4306640625,
        757.6876220703125
      ],
      [
        -1337.5,
        -4009.609619140625,
        757.4780883789062
      ],
      [
        -1338.1962890625,
        -4008.582763671875,
        757.6002807617188
      ],
      [
        -1289.9287109375,
        -4020.059326171875,
        751.9174194335938
      ],
      [
        -1281.6495361328125,
        -4020.1494140625,
        751.0350341796875
      ],
      [
        -1281.6495361328125,
        -4020.1494140625,
        751.0350341796875
      ],
      [
        -1281.68505859375,
        -4028.31494140625,
        750.6865844726562
      ],
      [
        -1281.68505859375,
        -4028.31494140625,
        750.6865844726562
      ],
      [
        -1289.884033203125,
        -4028.4033203125,
        751.5527954101562
      ],
      [
        -1289.884033203125,
        -4028.4033203125,
        751.5527954101562
      ],
      [
        -1289.9287109375,
        -4020.059326171875,
        751.9174194335938
      ],
      [
        -1299.753662109375,
        -4002.800048828125,
        753.7044067382812
      ],
      [
        -1296.5,
        -4006.215087890625,
        753.2119140625
      ],
      [
        -1296.5,
        -4006.215087890625,
        753.2119140625
      ],
      [
        -1293.7841796875,
        -4002.800048828125,
        753.071044921875
      ],
      [
        -1296.5,
        -3999.805908203125,
        753.4883422851562
      ],
      [
        -1299.753662109375,
        -4002.800048828125,
        753.7044067382812
      ],
      [
        -1293.7841796875,
        -4002.800048828125,
        753.071044921875
      ],
      [
        -1296.5,
        -3999.805908203125,
        753.4883422851562
      ],
      [
        -1346.0155029296875,
        -4044.05810546875,
        756.83349609375
      ],
      [
        -1337.5,
        -4009.6005859375,
        757.416259765625
      ],
      [
        -1334.4439697265625,
        -4006.300048828125,
        757.234375
      ],
      [
        -1334.4439697265625,
        -4006.300048828125,
        757.234375
      ],
      [
        -1337.5,
        -4009.6005859375,
        757.416259765625
      ],
      [
        -1346.3004150390625,
        -4043.63525390625,
        756.8819580078125
      ],
      [
        -1346.113525390625,
        -4043.97509765625,
        756.8474731445312
      ],
      [
        -1318.4365234375,
        -3966.4365234375,
        753.6746826171875
      ],
      [
        -1318.4088134765625,
        -3974.09130859375,
        754.0126953125
      ],
      [
        -1326.157470703125,
        -3966.285400390625,
        755.5178833007812
      ],
      [
        -1318.4365234375,
        -3966.4365234375,
        753.6746826171875
      ],
      [
        -1318.4088134765625,
        -3974.09130859375,
        754.0126953125
      ],
      [
        -1326.193603515625,
        -3974.24462890625,
        755.8849487304688
      ],
      [
        -1326.193603515625,
        -3974.24462890625,
        755.8848876953125
      ],
      [
        -1326.157470703125,
        -3966.285400390625,
        755.5178833007812
      ],
      [
        -1289.65234375,
        -4020.289794921875,
        749.6600952148438
      ],
      [
        -1281.945068359375,
        -4020.445068359375,
        748.1385498046875
      ],
      [
        -1289.69091796875,
        -4028.242431640625,
        749.9755859375
      ],
      [
        -1289.65234375,
        -4020.289794921875,
        749.6600952148438
      ],
      [
        -1281.945068359375,
        -4020.445068359375,
        748.1385498046875
      ],
      [
        -1281.9442138671875,
        -4020.660888671875,
        748.146728515625
      ],
      [
        -1281.86767578125,
        -4028.13232421875,
        748.8970947265625
      ],
      [
        -1281.86767578125,
        -4028.13232421875,
        748.8970947265625
      ],
      [
        -1288.9493408203125,
        -4028.227294921875,
        749.8280639648438
      ],
      [
        -1289.69091796875,
        -4028.242431640625,
        749.9755859375
      ],
      [
        -1299.3780517578125,
        -4002.800048828125,
        750.91064453125
      ],
      [
        -1296.5,
        -4005.818359375,
        750.4570922851562
      ],
      [
        -1296.5,
        -4000.21142578125,
        750.2400512695312
      ],
      [
        -1299.3780517578125,
        -4002.800048828125,
        750.91064453125
      ],
      [
        -1296.5,
        -4005.818359375,
        750.4570922851562
      ],
      [
        -1294.15234375,
        -4002.800048828125,
        749.8749389648438
      ],
      [
        -1294.15234375,
        -4002.800048828125,
        749.8749389648438
      ],
      [
        -1296.5,
        -4000.21142578125,
        750.2400512695312
      ],
      [
        -1274.074951171875,
        -4035.074951171875,
        747.14501953125
      ],
      [
        -1278.445068359375,
        -4039.519287109375,
        748.1831665039062
      ],
      [
        -1281.91552734375,
        -4028.08447265625,
        748.4284057617188
      ],
      [
        -1281.91552734375,
        -4028.08447265625,
        748.4284057617188
      ],
      [
        -1274.074951171875,
        -4035.074951171875,
        747.14501953125
      ],
      [
        -1277.7529296875,
        -4039.329345703125,
        748.0386962890625
      ],
      [
        -1278.445068359375,
        -4039.519287109375,
        748.1831665039062
      ],
      [
        -1277.7529296875,
        -4039.329345703125,
        748.0386962890625
      ],
      [
        -1277.979248046875,
        -3982.30615234375,
        745.8762817382812
      ],
      [
        -1279.098876953125,
        -3979.528564453125,
        745.9906005859375
      ],
      [
        -1279.098876953125,
        -3979.528564453125,
        745.9906005859375
      ],
      [
        -1277.979248046875,
        -3982.30615234375,
        745.8762817382812
      ],
      [
        -1279.1322021484375,
        -3978.696533203125,
        744.8090209960938
      ],
      [
        -1277.6239013671875,
        -3982.412841796875,
        744.6149291992188
      ],
      [
        -1272.8385009765625,
        -4009.950439453125,
        744.7081909179688
      ],
      [
        -1272.343505859375,
        -4011.601318359375,
        744.6638793945312
      ],
      [
        -1272.12158203125,
        -4014.07568359375,
        744.7221069335938
      ],
      [
        -1272.343505859375,
        -4011.601318359375,
        744.6638793945312
      ],
      [
        -1272.6741943359375,
        -4010.89599609375,
        744.7113647460938
      ],
      [
        -1270.8746337890625,
        -4031.87451171875,
        745.2247924804688
      ],
      [
        -1270.7230224609375,
        -4029.6708984375,
        745.0892333984375
      ],
      [
        -1278.6912841796875,
        -4039.806640625,
        747.454833984375
      ],
      [
        -1270.7230224609375,
        -4029.6708984375,
        745.0892333984375
      ],
      [
        -1270.8746337890625,
        -4031.87451171875,
        745.2247924804688
      ],
      [
        -1277.6082763671875,
        -4039.522216796875,
        747.1825561523438
      ],
      [
        -1289.6395263671875,
        -4028.199462890625,
        749.5554809570312
      ],
      [
        -1289.5948486328125,
        -4020.337646484375,
        749.1907958984375
      ],
      [
        -1289.5948486328125,
        -4020.337646484375,
        749.1907958984375
      ],
      [
        -1282.02197265625,
        -4020.52197265625,
        747.3846435546875
      ],
      [
        -1281.9884033203125,
        -4028.011474609375,
        747.7138061523438
      ],
      [
        -1289.6395263671875,
        -4028.199462890625,
        749.5554809570312
      ],
      [
        -1282.02197265625,
        -4020.52197265625,
        747.3846435546875
      ],
      [
        -1281.9884033203125,
        -4028.011474609375,
        747.7138061523438
      ],
      [
        -1278.6912841796875,
        -4039.806640625,
        747.454833984375
      ],
      [
        -1277.6082763671875,
        -4039.522216796875,
        747.1825561523438
      ],
      [
        -1279.1322021484375,
        -3978.696533203125,
        744.8090209960938
      ],
      [
        -1277.6239013671875,
        -3982.412841796875,
        744.6149291992188
      ],
      [
        -1272.719482421875,
        -4010.799560546875,
        744.7178955078125
      ],
      [
        -1272.8385009765625,
        -4009.950439453125,
        744.7081909179688
      ],
      [
        -1272.719482421875,
        -4010.799560546875,
        744.7178955078125
      ],
      [
        -1299.3551025390625,
        -4002.800048828125,
        750.7398681640625
      ],
      [
        -1296.5,
        -4005.77978515625,
        750.18994140625
      ],
      [
        -1296.5,
        -4000.248779296875,
        749.9408569335938
      ],
      [
        -1299.3551025390625,
        -4002.800048828125,
        750.7398681640625
      ],
      [
        -1296.5,
        -4005.77978515625,
        750.18994140625
      ],
      [
        -1294.1951904296875,
        -4002.800048828125,
        749.5034790039062
      ],
      [
        -1294.1951904296875,
        -4002.800048828125,
        749.5034790039062
      ],
      [
        -1296.5,
        -4000.248779296875,
        749.9408569335938
      ],
      [
        -1356.3277587890625,
        -4033.43994140625,
        753.051513671875
      ],
      [
        -1356.2864990234375,
        -4026.094482421875,
        752.6614990234375
      ],
      [
        -1356.2864990234375,
        -4026.094482421875,
        752.6614990234375
      ],
      [
        -1348.8831787109375,
        -4025.883056640625,
        755.064697265625
      ],
      [
        -1348.844482421875,
        -4033.655517578125,
        755.504150390625
      ],
      [
        -1356.3277587890625,
        -4033.43994140625,
        753.051513671875
      ],
      [
        -1348.8831787109375,
        -4025.883056640625,
        755.064697265625
      ],
      [
        -1348.844482421875,
        -4033.655517578125,
        755.504150390625
      ],
      [
        -1337.5,
        -4002.984619140625,
        757.5199584960938
      ],
      [
        -1339.66015625,
        -4006.300048828125,
        756.9974975585938
      ],
      [
        -1339.66015625,
        -4006.300048828125,
        756.9974975585938
      ],
      [
        -1338.3094482421875,
        -4008.40625,
        757.5536499023438
      ],
      [
        -1337.1583251953125,
        -4003.331787109375,
        757.6504516601562
      ],
      [
        -1337.5,
        -4002.984619140625,
        757.5199584960938
      ],
      [
        -1365.019287109375,
        -4001.321044921875,
        748.45263671875
      ],
      [
        -1352.9443359375,
        -3991.050048828125,
        751.8270874023438
      ],
      [
        -1365.019287109375,
        -4001.321044921875,
        748.45263671875
      ],
      [
        -1357.06201171875,
        -3993.971435546875,
        750.6444702148438
      ],
      [
        -1357.06201171875,
        -3993.971435546875,
        750.6444702148438
      ],
      [
        -1355.9176025390625,
        -3992.73486328125,
        750.9498291015625
      ],
      [
        -1355.9176025390625,
        -3992.73486328125,
        750.9498291015625
      ],
      [
        -1355.5357666015625,
        -3992.5615234375,
        751.0648803710938
      ],
      [
        -1354.2781982421875,
        -3991.990966796875,
        751.4436645507812
      ],
      [
        -1354.2781982421875,
        -3991.990966796875,
        751.4436645507812
      ],
      [
        -1352.9443359375,
        -3991.050048828125,
        751.8270874023438
      ],
      [
        -1348.626220703125,
        -4040.81103515625,
        755.96826171875
      ],
      [
        -1350.7955322265625,
        -4042.950927734375,
        750.5559692382812
      ],
      [
        -1324.443115234375,
        -3967.714111328125,
        738.0888671875
      ],
      [
        -1319.5819091796875,
        -3967.58203125,
        739.7001342773438
      ],
      [
        -1325.1611328125,
        -3973.38427734375,
        745.38818359375
      ],
      [
        -1324.443115234375,
        -3967.714111328125,
        738.0888671875
      ],
      [
        -1319.5819091796875,
        -3967.58203125,
        739.7001342773438
      ],
      [
        -1318.904052734375,
        -3973.595947265625,
        747.9710083007812
      ],
      [
        -1318.904052734375,
        -3973.595947265625,
        747.9710083007812
      ],
      [
        -1325.1611328125,
        -3973.38427734375,
        745.3882446289062
      ],
      [
        -1272.72119140625,
        -4046.038330078125,
        718.267333984375
      ],
      [
        -1272.243896484375,
        -4033.4296875,
        745.6228637695312
      ],
      [
        -1272.7213134765625,
        -4046.038330078125,
        718.2675170898438
      ],
      [
        -1319.688232421875,
        -3967.688232421875,
        738.4029541015625
      ],
      [
        -1319.1583251953125,
        -3973.341796875,
        744.8693237304688
      ],
      [
        -1319.1583251953125,
        -3973.341796875,
        744.8693237304688
      ],
      [
        -1325.101318359375,
        -3973.33447265625,
        744.7797241210938
      ],
      [
        -1325.101318359375,
        -3973.33447265625,
        744.7796630859375
      ],
      [
        -1324.6839599609375,
        -3969.615966796875,
        740.5371704101562
      ],
      [
        -1319.688232421875,
        -3967.688232421875,
        738.4029541015625
      ],
      [
        -1323.64404296875,
        -3967.6923828125,
        738.3536987304688
      ],
      [
        -1277.478515625,
        -3982.45654296875,
        744.0989990234375
      ],
      [
        -1279.7236328125,
        -3959.78955078125,
        717.2982788085938
      ],
      [
        -1277.478515625,
        -3982.45654296875,
        744.0989990234375
      ],
      [
        -1277.5465087890625,
        -3982.858154296875,
        744.616455078125
      ],
      [
        -1387.3033447265625,
        -4000.54345703125,
        727.7186889648438
      ],
      [
        -1377.806396484375,
        -3998.16064453125,
        734.9609985351562
      ],
      [
        -1386.38134765625,
        -3996.550048828125,
        734.77587890625
      ],
      [
        -1386.9034423828125,
        -3998.811767578125,
        731.4819946289062
      ],
      [
        -1378.6229248046875,
        -3996.718017578125,
        734.2665405273438
      ],
      [
        -1385.3629150390625,
        -3992.138671875,
        732.3817138671875
      ],
      [
        -1386.38134765625,
        -3996.550048828125,
        734.77587890625
      ],
      [
        -1377.806396484375,
        -3998.16064453125,
        734.9609985351562
      ],
      [
        -1382.9024658203125,
        -3989.31640625,
        730.7183837890625
      ],
      [
        -1384.62646484375,
        -3988.948974609375,
        730.6569213867188
      ],
      [
        -1385.3629150390625,
        -3992.138671875,
        732.3817138671875
      ],
      [
        -1378.6229248046875,
        -3996.718017578125,
        734.2665405273438
      ],
      [
        -1380.4974365234375,
        -3993.40234375,
        732.6738891601562
      ],
      [
        -1384.62646484375,
        -3988.948974609375,
        730.6569213867188
      ],
      [
        -1382.9024658203125,
        -3989.31640625,
        730.7183837890625
      ],
      [
        -1382.9080810546875,
        -3989.314208984375,
        730.7099609375
      ],
      [
        -1384.6263427734375,
        -3988.9482421875,
        730.650146484375
      ],
      [
        -1387.3033447265625,
        -4000.54345703125,
        727.7186889648438
      ],
      [
        -1386.9034423828125,
        -3998.811767578125,
        731.4819946289062
      ],
      [
        -1384.56396484375,
        -3988.677978515625,
        728.2182006835938
      ],
      [
        -1382.7137451171875,
        -4019.191162109375,
        715.02197265625
      ],
      [
        -1382.79443359375,
        -3989.33935546875,
        730.7222290039062
      ],
      [
        -1382.79443359375,
        -3989.33935546875,
        730.7222290039062
      ],
      [
        -1384.5567626953125,
        -3988.64697265625,
        727.93798828125
      ],
      [
        -1356.158447265625,
        -4033.298828125,
        751.4480590820312
      ],
      [
        -1354.65673828125,
        -4033.488037109375,
        753.5991821289062
      ],
      [
        -1356.158447265625,
        -4033.298828125,
        751.4480590820312
      ],
      [
        -1356.316650390625,
        -4031.472412109375,
        752.947021484375
      ],
      [
        -1382.4090576171875,
        -3989.42138671875,
        730.7359619140625
      ],
      [
        -1383.4814453125,
        -3989.0693359375,
        729.6368408203125
      ],
      [
        -1382.4093017578125,
        -3989.42138671875,
        730.7359619140625
      ],
      [
        -1382.6114501953125,
        -3989.6630859375,
        730.8777465820312
      ],
      [
        -1381.7431640625,
        -3988.464599609375,
        721.3230590820312
      ],
      [
        -1379.108642578125,
        -3995.85888671875,
        733.8538818359375
      ],
      [
        -1357.017333984375,
        -3993.923095703125,
        750.6564331054688
      ],
      [
        -1375.970703125,
        -3998.280517578125,
        734.8829956054688
      ],
      [
        -1375.970703125,
        -3998.280517578125,
        734.8829956054688
      ],
      [
        -1376.0640869140625,
        -3998.456298828125,
        734.9820556640625
      ],
      [
        -1376.0640869140625,
        -3998.456298828125,
        734.9820556640625
      ],
      [
        -1376.079345703125,
        -3998.485107421875,
        734.998291015625
      ],
      [
        -1376.079345703125,
        -3998.485107421875,
        734.998291015625
      ],
      [
        -1378.4202880859375,
        -3999.235107421875,
        733.2928466796875
      ],
      [
        -1376.060302734375,
        -3998.48876953125,
        734.9987182617188
      ],
      [
        -1376.0704345703125,
        -3998.46826171875,
        734.98876953125
      ],
      [
        -1376.060302734375,
        -3998.48876953125,
        734.9987182617188
      ],
      [
        -1254.0,
        -4027.777099609375,
        707.4548950195312
      ],
      [
        -1256.156494140625,
        -4029.5,
        716.5
      ],
      [
        -1256.156494140625,
        -4029.5,
        716.5
      ],
      [
        -1255.742431640625,
        -4022.77099609375,
        705.8291625976562
      ],
      [
        -1255.742431640625,
        -4022.77099609375,
        705.8291625976562
      ],
      [
        -1254.0,
        -4026.735595703125,
        706.0
      ],
      [
        -1258.131591796875,
        -4020.8486328125,
        709.8750610351562
      ],
      [
        -1256.0740966796875,
        -4022.803466796875,
        705.796630859375
      ],
      [
        -1257.6282958984375,
        -4021.798828125,
        709.6114501953125
      ],
      [
        -1256.0740966796875,
        -4022.803466796875,
        705.796630859375
      ],
      [
        -1254.03955078125,
        -4027.456298828125,
        705.9961547851562
      ],
      [
        -1254.0205078125,
        -4027.5,
        705.9982299804688
      ],
      [
        -1254.03955078125,
        -4027.456298828125,
        705.9961547851562
      ],
      [
        -1254.4373779296875,
        -4028.12646484375,
        709.289306640625
      ],
      [
        -1254.412841796875,
        -4027.866943359375,
        707.9264526367188
      ],
      [
        -1254.0374755859375,
        -4027.515380859375,
        706.0810546875
      ],
      [
        -1254.0205078125,
        -4027.5,
        705.9982299804688
      ],
      [
        -1254.0374755859375,
        -4027.515380859375,
        706.0810546875
      ],
      [
        -1258.131591796875,
        -4020.8486328125,
        709.8750610351562
      ],
      [
        -1257.9136962890625,
        -4021.6142578125,
        710.3118896484375
      ],
      [
        -1257.9136962890625,
        -4021.6142578125,
        710.3118896484375
      ],
      [
        -1269.1884765625,
        -4030.75,
        741.8925170898438
      ],
      [
        -1271.8743896484375,
        -4016.832763671875,
        744.7870483398438
      ],
      [
        -1257.9820556640625,
        -4029.5,
        716.5
      ],
      [
        -1254.4974365234375,
        -4027.946044921875,
        708.3424072265625
      ],
      [
        -1257.9820556640625,
        -4029.5,
        716.5
      ],
      [
        -1268.9581298828125,
        -4031.235107421875,
        741.224853515625
      ],
      [
        -1269.1884765625,
        -4030.75,
        741.8925170898438
      ],
      [
        -1254.4549560546875,
        -4027.5,
        705.9606323242188
      ],
      [
        -1257.9827880859375,
        -4029.48583984375,
        716.4985961914062
      ],
      [
        -1254.3883056640625,
        -4026.65869140625,
        705.9619750976562
      ],
      [
        -1254.4176025390625,
        -4027.039306640625,
        705.9591064453125
      ],
      [
        -1254.4549560546875,
        -4027.5,
        705.9606323242188
      ],
      [
        -1254.41748046875,
        -4027.03955078125,
        705.9591064453125
      ],
      [
        -1262.4078369140625,
        -4034.22509765625,
        715.8250122070312
      ],
      [
        -1268.9581298828125,
        -4031.235107421875,
        741.224853515625
      ],
      [
        -1262.3262939453125,
        -4016.529052734375,
        705.0
      ],
      [
        -1256.66162109375,
        -4022.861083984375,
        705.739013671875
      ],
      [
        -1254.8206787109375,
        -4026.5947265625,
        705.9195556640625
      ],
      [
        -1254.8199462890625,
        -4026.595703125,
        705.9196166992188
      ],
      [
        -1254.443603515625,
        -4027.35986328125,
        705.9601440429688
      ],
      [
        -1256.66162109375,
        -4022.861083984375,
        705.739013671875
      ],
      [
        -1257.6282958984375,
        -4021.798828125,
        709.6114501953125
      ],
      [
        -1260.7738037109375,
        -4028.22509765625,
        705.4912109375
      ],
      [
        -1261.82177734375,
        -4020.060546875,
        705.0
      ],
      [
        -1260.773681640625,
        -4028.22509765625,
        705.4912109375
      ],
      [
        -1262.3331298828125,
        -4030.0966796875,
        713.0686645507812
      ],
      [
        -1262.4078369140625,
        -4034.22509765625,
        715.8250122070312
      ],
      [
        -1262.3331298828125,
        -4030.0966796875,
        713.0686645507812
      ],
      [
        -1256.7203369140625,
        -4022.796630859375,
        705.9742431640625
      ],
      [
        -1288.61376953125,
        -4044.306884765625,
        705.0
      ],
      [
        -1272.736083984375,
        -4046.04443359375,
        718.263671875
      ],
      [
        -1264.201904296875,
        -4029.37939453125,
        705.3180541992188
      ],
      [
        -1266.239501953125,
        -4025.8837890625,
        705.0
      ],
      [
        -1264.201904296875,
        -4029.37939453125,
        705.3180541992188
      ],
      [
        -1261.3240966796875,
        -4028.8857421875,
        708.1655883789062
      ],
      [
        -1376.1182861328125,
        -3998.54052734375,
        734.9104614257812
      ],
      [
        -1368.21240234375,
        -4002.0,
        744.9974365234375
      ],
      [
        -1356.099853515625,
        -4029.75,
        711.1068725585938
      ],
      [
        -1379.84228515625,
        -4030.039794921875,
        714.3994140625
      ],
      [
        -1379.9964599609375,
        -4029.457275390625,
        714.432861328125
      ],
      [
        -1373.8212890625,
        -4029.674072265625,
        711.9686889648438
      ],
      [
        -1373.6956787109375,
        -4029.822265625,
        711.925537109375
      ],
      [
        -1356.194580078125,
        -4029.828857421875,
        710.2097778320312
      ],
      [
        -1352.9228515625,
        -4033.4228515625,
        709.1412353515625
      ],
      [
        -1352.7918701171875,
        -4026.208251953125,
        710.6300659179688
      ],
      [
        -1289.099853515625,
        -4024.25,
        745.1487426757812
      ],
      [
        -1286.0767822265625,
        -4020.42333984375,
        748.3516845703125
      ],
      [
        -1289.6146240234375,
        -4023.821044921875,
        749.3523559570312
      ],
      [
        -1286.1129150390625,
        -4028.11279296875,
        748.7066040039062
      ],
      [
        -1282.571533203125,
        -4050.52392578125,
        714.0
      ],
      [
        -1282.7540283203125,
        -4050.08056640625,
        715.78955078125
      ],
      [
        -1322.6513671875,
        -3967.61962890625,
        719.87353515625
      ],
      [
        -1321.21826171875,
        -3967.605712890625,
        719.736083984375
      ],
      [
        -1324.6251220703125,
        -3971.246826171875,
        719.3118286132812
      ],
      [
        -1319.51220703125,
        -3971.206298828125,
        718.8194580078125
      ],
      [
        -1405.0,
        -4003.74658203125,
        711.1834716796875
      ],
      [
        -1394.5,
        -4021.5,
        713.306884765625
      ],
      [
        -1413.4136962890625,
        -4003.74658203125,
        709.5
      ],
      [
        -1405.0,
        -4003.74658203125,
        711.1834716796875
      ],
      [
        -1445.9959716796875,
        -3989.24658203125,
        717.0
      ],
      [
        -1425.5,
        -3989.24658203125,
        713.0680541992188
      ],
      [
        -1425.5,
        -3989.24658203125,
        713.0680541992188
      ],
      [
        -1415.0,
        -4007.0,
        709.6173706054688
      ],
      [
        -1426.0,
        -4003.74658203125,
        711.9908447265625
      ],
      [
        -1416.92431640625,
        -4003.74658203125,
        709.5
      ],
      [
        -1416.9241943359375,
        -4003.74658203125,
        710.249755859375
      ],
      [
        -1413.218994140625,
        -4003.74658203125,
        709.5389404296875
      ],
      [
        -1433.9688720703125,
        -3971.896484375,
        717.0
      ],
      [
        -1435.273681640625,
        -3975.80078125,
        717.0
      ],
      [
        -1446.0081787109375,
        -3993.027587890625,
        717.0
      ],
      [
        -1435.273681640625,
        -3975.80078125,
        717.0
      ],
      [
        -1443.65185546875,
        -3989.24658203125,
        717.0
      ],
      [
        -1428.2984619140625,
        -3989.24658203125,
        713.6049194335938
      ],
      [
        -1430.4552001953125,
        -3989.24658203125,
        714.2433471679688
      ],
      [
        -1448.4215087890625,
        -3998.638427734375,
        717.0
      ],
      [
        -1448.5,
        -4015.525390625,
        716.9854125976562
      ],
      [
        -1448.492919921875,
        -4015.356689453125,
        717.0
      ],
      [
        -1448.4215087890625,
        -3998.638427734375,
        717.0
      ],
      [
        -1448.4676513671875,
        -3998.4248046875,
        717.0
      ],
      [
        -1448.4676513671875,
        -3998.4248046875,
        717.0
      ],
      [
        -1448.4202880859375,
        -3998.32080078125,
        717.0
      ],
      [
        -1439.7672119140625,
        -3989.24658203125,
        717.0
      ],
      [
        -1446.0081787109375,
        -3993.027587890625,
        717.0
      ],
      [
        -1421.5888671875,
        -4028.91259765625,
        717.0
      ],
      [
        -1421.4879150390625,
        -4028.914306640625,
        717.0
      ],
      [
        -1421.5888671875,
        -4028.91259765625,
        717.0
      ],
      [
        -1426.0,
        -4003.74658203125,
        714.231689453125
      ],
      [
        -1405.0,
        -4003.74658203125,
        711.6390380859375
      ],
      [
        -1405.0,
        -4003.74658203125,
        711.6390380859375
      ],
      [
        -1401.5716552734375,
        -4009.543212890625,
        711.8767700195312
      ],
      [
        -1416.9241943359375,
        -4003.74658203125,
        710.249755859375
      ],
      [
        -1415.0,
        -4007.0,
        713.24462890625
      ],
      [
        -1416.9241943359375,
        -4003.74658203125,
        713.1112060546875
      ],
      [
        -1424.1141357421875,
        -3991.58984375,
        712.6126098632812
      ],
      [
        -1405.0,
        -4003.74658203125,
        712.8204956054688
      ],
      [
        -1394.5,
        -4021.5,
        715.1561889648438
      ],
      [
        -1410.6483154296875,
        -4003.74658203125,
        712.3363647460938
      ],
      [
        -1405.0,
        -4003.74658203125,
        712.8204956054688
      ],
      [
        -1394.638916015625,
        -4021.26513671875,
        717.0
      ],
      [
        -1405.0,
        -4003.74658203125,
        712.8682861328125
      ],
      [
        -1410.768798828125,
        -4003.74658203125,
        712.3512573242188
      ],
      [
        -1405.0,
        -4003.74658203125,
        712.8682861328125
      ],
      [
        -1417.7607421875,
        -4003.74658203125,
        713.2144775390625
      ],
      [
        -1406.18798828125,
        -4003.74658203125,
        712.7618408203125
      ],
      [
        -1416.92431640625,
        -4003.74658203125,
        713.1112060546875
      ],
      [
        -1415.0,
        -4007.0,
        713.5183715820312
      ],
      [
        -1416.92431640625,
        -4003.74658203125,
        713.1817626953125
      ],
      [
        -1417.5924072265625,
        -4002.616943359375,
        713.0648803710938
      ],
      [
        -1417.716552734375,
        -4027.0341796875,
        717.0
      ],
      [
        -1421.4053955078125,
        -4028.847900390625,
        717.0
      ],
      [
        -1421.4053955078125,
        -4028.847900390625,
        717.0
      ],
      [
        -1421.4879150390625,
        -4028.914306640625,
        717.0
      ],
      [
        -1406.99267578125,
        -4003.74658203125,
        712.7933349609375
      ],
      [
        -1406.04541015625,
        -4003.74658203125,
        712.7745971679688
      ],
      [
        -1398.716064453125,
        -3949.43359375,
        717.0
      ],
      [
        -1397.9110107421875,
        -3950.46484375,
        717.0
      ],
      [
        -1412.78564453125,
        -3954.554443359375,
        715.8118896484375
      ],
      [
        -1395.9530029296875,
        -3952.972900390625,
        717.0
      ],
      [
        -1393.2218017578125,
        -3954.992431640625,
        717.0
      ],
      [
        -1395.9530029296875,
        -3952.972900390625,
        717.0
      ],
      [
        -1388.950439453125,
        -3985.1171875,
        717.0
      ],
      [
        -1387.0577392578125,
        -3978.058349609375,
        717.0
      ],
      [
        -1394.7593994140625,
        -4008.16796875,
        715.3499755859375
      ],
      [
        -1394.5927734375,
        -4008.168701171875,
        714.6094970703125
      ],
      [
        -1394.6552734375,
        -4008.374755859375,
        714.6415405273438
      ],
      [
        -1394.7593994140625,
        -4008.16796875,
        715.3499755859375
      ],
      [
        -1397.2388916015625,
        -4016.869140625,
        716.0
      ],
      [
        -1397.2335205078125,
        -4016.878173828125,
        715.96533203125
      ],
      [
        -1397.1466064453125,
        -4017.025146484375,
        716.0
      ],
      [
        -1393.0252685546875,
        -4000.31396484375,
        717.0
      ],
      [
        -1387.961669921875,
        -4003.395263671875,
        717.0
      ],
      [
        -1397.3939208984375,
        -4016.60693359375,
        717.0
      ],
      [
        -1388.950439453125,
        -3985.1171875,
        717.0
      ],
      [
        -1384.17822265625,
        -3987.007568359375,
        717.0
      ],
      [
        -1393.2218017578125,
        -3954.992431640625,
        717.0
      ],
      [
        -1391.919921875,
        -3956.2099609375,
        717.0
      ],
      [
        -1395.349853515625,
        -4008.076171875,
        717.0
      ],
      [
        -1407.50341796875,
        -4021.70263671875,
        717.0
      ],
      [
        -1399.6126708984375,
        -4012.85546875,
        717.0
      ],
      [
        -1399.3099365234375,
        -4013.3671875,
        715.1373291015625
      ],
      [
        -1407.50341796875,
        -4021.70263671875,
        717.0
      ],
      [
        -1407.917236328125,
        -4022.216552734375,
        717.0
      ],
      [
        -1407.917236328125,
        -4022.216552734375,
        717.0
      ],
      [
        -1407.9964599609375,
        -4022.25537109375,
        717.0
      ],
      [
        -1416.9241943359375,
        -4003.74658203125,
        717.0
      ],
      [
        -1416.92431640625,
        -4003.74658203125,
        713.1817626953125
      ],
      [
        -1433.9688720703125,
        -3971.896484375,
        717.0
      ],
      [
        -1425.20751953125,
        -3959.07568359375,
        717.0
      ],
      [
        -1389.8203125,
        -3965.865234375,
        717.0
      ],
      [
        -1391.919921875,
        -3956.2099609375,
        717.0
      ],
      [
        -1389.668701171875,
        -3966.49365234375,
        717.0
      ],
      [
        -1387.0577392578125,
        -3978.058349609375,
        717.0
      ],
      [
        -1389.8203125,
        -3965.865234375,
        717.0
      ],
      [
        -1389.668701171875,
        -3966.49365234375,
        717.0
      ],
      [
        -1394.0118408203125,
        -4002.34765625,
        717.0
      ],
      [
        -1395.349853515625,
        -4008.076171875,
        717.0
      ],
      [
        -1394.0118408203125,
        -4002.34765625,
        717.0
      ],
      [
        -1393.340576171875,
        -4000.916015625,
        717.0
      ],
      [
        -1393.340576171875,
        -4000.916015625,
        717.0
      ],
      [
        -1393.0252685546875,
        -4000.31396484375,
        717.0
      ],
      [
        -1463.4737548828125,
        -4033.225341796875,
        723.0
      ],
      [
        -1449.58544921875,
        -4002.74658203125,
        723.0
      ],
      [
        -1449.58544921875,
        -4002.74658203125,
        723.0
      ],
      [
        -1450.01123046875,
        -4002.74658203125,
        720.0
      ],
      [
        -1431.1163330078125,
        -3961.226318359375,
        730.7922973632812
      ],
      [
        -1428.2015380859375,
        -3960.16552734375,
        759.8094482421875
      ],
      [
        -1460.8944091796875,
        -4037.58642578125,
        723.0
      ],
      [
        -1447.6156005859375,
        -4002.74658203125,
        723.0
      ],
      [
        -1441.945556640625,
        -3986.5078125,
        717.0
      ],
      [
        -1454.2469482421875,
        -4019.464111328125,
        720.0
      ],
      [
        -1447.8924560546875,
        -4002.791748046875,
        720.0
      ],
      [
        -1447.8924560546875,
        -4002.791748046875,
        720.0
      ],
      [
        -1448.6224365234375,
        -4004.02587890625,
        717.0
      ],
      [
        -1447.3736572265625,
        -4001.30712890625,
        719.4558715820312
      ],
      [
        -1448.4425048828125,
        -4003.55419921875,
        717.0
      ],
      [
        -1447.3736572265625,
        -4001.30712890625,
        719.4558715820312
      ],
      [
        -1447.289794921875,
        -4001.210693359375,
        720.0
      ],
      [
        -1447.9393310546875,
        -3998.19970703125,
        720.0
      ],
      [
        -1446.82763671875,
        -4000.678955078125,
        723.0
      ],
      [
        -1447.4110107421875,
        -3997.974609375,
        723.0
      ],
      [
        -1447.615478515625,
        -4002.74658203125,
        723.0
      ],
      [
        -1447.8751220703125,
        -4002.74658203125,
        720.0
      ],
      [
        -1418.433349609375,
        -4018.667724609375,
        749.8118286132812
      ],
      [
        -1418.4185791015625,
        -4018.515625,
        749.8909912109375
      ],
      [
        -1418.4185791015625,
        -4018.515625,
        749.8909912109375
      ],
      [
        -1455.378173828125,
        -4038.25341796875,
        723.0
      ],
      [
        -1459.7193603515625,
        -4034.50341796875,
        723.0
      ],
      [
        -1416.024169921875,
        -3987.5537109375,
        767.2767944335938
      ],
      [
        -1415.418701171875,
        -3987.734130859375,
        767.4558715820312
      ],
      [
        -1416.024169921875,
        -3987.5537109375,
        767.2767944335938
      ],
      [
        -1445.277099609375,
        -4038.25341796875,
        723.0
      ],
      [
        -1448.2198486328125,
        -4004.33203125,
        723.0
      ],
      [
        -1447.6488037109375,
        -4030.620361328125,
        720.0
      ],
      [
        -1449.6605224609375,
        -4007.4306640625,
        720.0
      ],
      [
        -1427.4935302734375,
        -3970.530517578125,
        764.5227661132812
      ],
      [
        -1431.95654296875,
        -3969.385498046875,
        756.8643188476562
      ],
      [
        -1427.4935302734375,
        -3970.530517578125,
        764.5227661132812
      ],
      [
        -1431.95654296875,
        -3969.385498046875,
        756.8643188476562
      ],
      [
        -1432.047607421875,
        -3969.54638671875,
        756.68017578125
      ],
      [
        -1446.1697998046875,
        -3999.92236328125,
        727.2694091796875
      ],
      [
        -1419.178466796875,
        -4026.313720703125,
        720.1367797851562
      ],
      [
        -1418.433349609375,
        -4018.667724609375,
        749.8118286132812
      ],
      [
        -1420.40771484375,
        -4027.334228515625,
        720.0
      ],
      [
        -1429.01953125,
        -4034.25341796875,
        720.0
      ],
      [
        -1420.40771484375,
        -4027.334228515625,
        720.0
      ],
      [
        -1421.210693359375,
        -4028.69189453125,
        717.0
      ],
      [
        -1421.09228515625,
        -4028.49169921875,
        717.4409790039062
      ],
      [
        -1421.260986328125,
        -4028.77685546875,
        717.0
      ],
      [
        -1419.2755126953125,
        -4026.42431640625,
        720.0
      ],
      [
        -1419.3258056640625,
        -4027.825439453125,
        717.0
      ],
      [
        -1419.1849365234375,
        -4026.379638671875,
        720.0
      ],
      [
        -1419.178466796875,
        -4026.313720703125,
        720.1367797851562
      ],
      [
        -1421.215087890625,
        -4027.98291015625,
        720.0
      ],
      [
        -1447.87158203125,
        -4028.051513671875,
        720.0
      ],
      [
        -1423.60791015625,
        -4027.942138671875,
        720.0
      ],
      [
        -1432.84716796875,
        -4027.004638671875,
        723.0
      ],
      [
        -1446.2476806640625,
        -4027.064697265625,
        723.0
      ],
      [
        -1432.84716796875,
        -4027.004638671875,
        723.0
      ],
      [
        -1433.427734375,
        -4027.986328125,
        720.0
      ],
      [
        -1447.9171142578125,
        -4027.52734375,
        720.0
      ],
      [
        -1440.480224609375,
        -4028.018310546875,
        720.0
      ],
      [
        -1440.6337890625,
        -4027.651611328125,
        720.0
      ],
      [
        -1441.0369873046875,
        -4028.340087890625,
        717.7716064453125
      ],
      [
        -1441.264404296875,
        -4028.576904296875,
        717.0
      ],
      [
        -1441.0369873046875,
        -4028.340087890625,
        717.7716064453125
      ],
      [
        -1439.9603271484375,
        -4027.03662109375,
        723.0
      ],
      [
        -1446.286376953125,
        -4026.619140625,
        723.0
      ],
      [
        -1440.091064453125,
        -4026.724609375,
        723.0
      ],
      [
        -1432.7554931640625,
        -4026.849609375,
        723.0
      ],
      [
        -1432.7554931640625,
        -4026.849609375,
        723.0
      ],
      [
        -1433.3037109375,
        -4027.776611328125,
        720.0
      ],
      [
        -1419.05517578125,
        -4025.04736328125,
        720.0
      ],
      [
        -1417.6248779296875,
        -4010.37109375,
        720.0
      ],
      [
        -1417.6248779296875,
        -4010.37109375,
        720.0
      ],
      [
        -1417.6248779296875,
        -4010.37109375,
        717.0
      ],
      [
        -1441.1439208984375,
        -4026.434326171875,
        720.0
      ],
      [
        -1447.204833984375,
        -4016.73681640625,
        720.0
      ],
      [
        -1441.1439208984375,
        -4026.434326171875,
        720.0
      ],
      [
        -1440.6337890625,
        -4027.651611328125,
        720.0
      ],
      [
        -1447.1414794921875,
        -4001.8984375,
        720.0
      ],
      [
        -1447.204833984375,
        -4016.73681640625,
        720.0
      ],
      [
        -1447.139892578125,
        -4001.519287109375,
        720.0
      ],
      [
        -1448.443359375,
        -4003.72314453125,
        717.0
      ],
      [
        -1447.2303466796875,
        -4001.672119140625,
        719.7918090820312
      ],
      [
        -1447.1414794921875,
        -4001.8984375,
        720.0
      ],
      [
        -1447.200927734375,
        -4001.62255859375,
        720.0
      ],
      [
        -1447.289794921875,
        -4001.210693359375,
        720.0
      ],
      [
        -1419.05517578125,
        -4025.04736328125,
        720.0
      ],
      [
        -1419.05517578125,
        -4025.04736328125,
        717.0
      ],
      [
        -1435.5546875,
        -3970.42138671875,
        720.0
      ],
      [
        -1431.1163330078125,
        -3961.226318359375,
        720.0
      ],
      [
        -1445.861328125,
        -4005.158447265625,
        723.0
      ],
      [
        -1445.90966796875,
        -4016.4736328125,
        723.0
      ],
      [
        -1445.861328125,
        -4005.158447265625,
        723.0
      ],
      [
        -1446.82763671875,
        -4000.678955078125,
        723.0
      ],
      [
        -1446.38134765625,
        -4002.74658203125,
        723.0
      ],
      [
        -1447.14501953125,
        -4002.74658203125,
        720.0
      ],
      [
        -1446.8079833984375,
        -4002.74658203125,
        720.7813720703125
      ],
      [
        -1445.8509521484375,
        -4002.74658203125,
        723.0
      ],
      [
        -1441.287841796875,
        -4023.86865234375,
        723.0
      ],
      [
        -1445.90966796875,
        -4016.4736328125,
        723.0
      ],
      [
        -1441.287841796875,
        -4023.86865234375,
        723.0
      ],
      [
        -1440.091064453125,
        -4026.724609375,
        723.0
      ],
      [
        -1445.894287109375,
        -4012.875244140625,
        723.0
      ],
      [
        -1412.1629638671875,
        -3954.327880859375,
        775.730224609375
      ],
      [
        -1393.6937255859375,
        -3980.458251953125,
        741.8031616210938
      ],
      [
        -1393.0284423828125,
        -3980.210693359375,
        739.3707275390625
      ],
      [
        -1400.1346435546875,
        -3976.0,
        759.8096313476562
      ],
      [
        -1401.4674072265625,
        -3973.345458984375,
        762.1338500976562
      ],
      [
        -1401.2969970703125,
        -3978.94970703125,
        766.09619140625
      ],
      [
        -1400.1346435546875,
        -3976.0,
        759.8096313476562
      ],
      [
        -1401.4674072265625,
        -3973.345458984375,
        762.1338500976562
      ],
      [
        -1404.9010009765625,
        -3972.535888671875,
        773.0
      ],
      [
        -1403.2303466796875,
        -3979.464111328125,
        773.0
      ],
      [
        -1401.2969970703125,
        -3978.94970703125,
        766.095947265625
      ],
      [
        -1393.0284423828125,
        -3980.210693359375,
        739.3707275390625
      ],
      [
        -1387.0718994140625,
        -3977.99560546875,
        717.0
      ],
      [
        -1394.115478515625,
        -3980.614990234375,
        742.283447265625
      ],
      [
        -1393.6937255859375,
        -3980.458251953125,
        741.8031616210938
      ],
      [
        -1401.4818115234375,
        -3973.370361328125,
        761.798095703125
      ],
      [
        -1404.9569091796875,
        -3972.535888671875,
        773.0
      ],
      [
        -1404.9278564453125,
        -3972.550048828125,
        772.81005859375
      ],
      [
        -1403.4808349609375,
        -3979.464111328125,
        773.0
      ],
      [
        -1401.329833984375,
        -3978.892822265625,
        765.3327026367188
      ],
      [
        -1401.329833984375,
        -3978.892822265625,
        765.3329467773438
      ],
      [
        -1400.17626953125,
        -3976.0,
        759.325927734375
      ],
      [
        -1400.17626953125,
        -3976.0,
        759.325927734375
      ],
      [
        -1401.4818115234375,
        -3973.370361328125,
        761.798095703125
      ],
      [
        -1403.693115234375,
        -3984.17724609375,
        753.1904296875
      ],
      [
        -1401.72021484375,
        -3973.783203125,
        756.2561645507812
      ],
      [
        -1402.5850830078125,
        -3973.69287109375,
        757.4676513671875
      ],
      [
        -1404.6326904296875,
        -3978.827880859375,
        764.4600830078125
      ],
      [
        -1401.815673828125,
        -3978.05126953125,
        754.0374755859375
      ],
      [
        -1403.058349609375,
        -3978.1708984375,
        755.6411743164062
      ],
      [
        -1401.815673828125,
        -3978.05126953125,
        754.037353515625
      ],
      [
        -1400.6669921875,
        -3976.0,
        753.6220703125
      ],
      [
        -1405.89013671875,
        -3977.92236328125,
        773.0
      ],
      [
        -1404.6326904296875,
        -3978.827880859375,
        764.4600830078125
      ],
      [
        -1400.6669921875,
        -3976.0,
        753.6220703125
      ],
      [
        -1401.72021484375,
        -3973.783203125,
        756.2561645507812
      ],
      [
        -1401.2415771484375,
        -3976.0,
        746.9420776367188
      ],
      [
        -1401.86962890625,
        -3974.0419921875,
        752.7824096679688
      ],
      [
        -1402.0013427734375,
        -3977.729736328125,
        749.7198486328125
      ],
      [
        -1401.2415771484375,
        -3976.0,
        746.9420776367188
      ],
      [
        -1402.0013427734375,
        -3977.729736328125,
        749.7198486328125
      ],
      [
        -1401.86962890625,
        -3974.0419921875,
        752.7824096679688
      ],
      [
        -1392.7236328125,
        -3955.458251953125,
        717.0
      ],
      [
        -1402.67138671875,
        -3973.683837890625,
        757.5884399414062
      ],
      [
        -1403.2183837890625,
        -3978.1865234375,
        755.8472900390625
      ],
      [
        -1403.0582275390625,
        -3978.1708984375,
        755.6406860351562
      ],
      [
        -1402.5849609375,
        -3973.692626953125,
        757.4675903320312
      ],
      [
        -1403.2183837890625,
        -3978.1865234375,
        755.8472290039062
      ],
      [
        -1402.67138671875,
        -3973.683837890625,
        757.5884399414062
      ],
      [
        -1404.4483642578125,
        -3973.4912109375,
        760.17431640625
      ],
      [
        -1405.9578857421875,
        -3976.0,
        760.8845825195312
      ],
      [
        -1404.3258056640625,
        -3978.296875,
        757.3305053710938
      ],
      [
        -1403.3916015625,
        -3979.61181640625,
        755.2960205078125
      ],
      [
        -1403.3916015625,
        -3979.61181640625,
        755.2960815429688
      ],
      [
        -1403.234130859375,
        -3979.8349609375,
        754.9618530273438
      ],
      [
        -1402.1923828125,
        -3969.741943359375,
        759.1128540039062
      ],
      [
        -1402.1619873046875,
        -3969.69140625,
        759.0999145507812
      ],
      [
        -1402.1923828125,
        -3969.741943359375,
        759.1128540039062
      ],
      [
        -1412.949462890625,
        -3987.61962890625,
        764.17431640625
      ],
      [
        -1403.958251953125,
        -3984.27587890625,
        753.492431640625
      ],
      [
        -1403.958251953125,
        -3984.27587890625,
        753.492431640625
      ],
      [
        -1409.16162109375,
        -3961.687744140625,
        770.9019165039062
      ],
      [
        -1413.309326171875,
        -3966.13037109375,
        773.716796875
      ],
      [
        -1413.3138427734375,
        -3966.13623046875,
        773.715087890625
      ],
      [
        -1413.309326171875,
        -3966.13037109375,
        773.716796875
      ],
      [
        -1393.287109375,
        -3954.944091796875,
        717.0
      ],
      [
        -1398.3333740234375,
        -3949.29443359375,
        763.7656860351562
      ],
      [
        -1408.621337890625,
        -4008.000244140625,
        744.1795043945312
      ],
      [
        -1409.6748046875,
        -4005.704345703125,
        747.0025024414062
      ],
      [
        -1412.50927734375,
        -4005.385498046875,
        750.821533203125
      ],
      [
        -1413.683837890625,
        -4007.385009765625,
        751.0299072265625
      ],
      [
        -1413.9822998046875,
        -4008.086669921875,
        750.9581298828125
      ],
      [
        -1412.3460693359375,
        -4010.330810546875,
        747.4255981445312
      ],
      [
        -1409.80224609375,
        -4010.073974609375,
        744.3483276367188
      ],
      [
        -1413.9822998046875,
        -4008.086669921875,
        750.9581298828125
      ],
      [
        -1413.683837890625,
        -4007.384765625,
        751.0299072265625
      ],
      [
        -1414.0472412109375,
        -4008.000244140625,
        751.1144409179688
      ],
      [
        -1415.05322265625,
        -4010.604248046875,
        750.7005004882812
      ],
      [
        -1415.62353515625,
        -4010.66943359375,
        751.4811401367188
      ],
      [
        -1415.05322265625,
        -4010.604248046875,
        750.7005004882812
      ],
      [
        -1417.08203125,
        -4004.80126953125,
        757.8196411132812
      ],
      [
        -1417.6767578125,
        -4010.904052734375,
        754.2914428710938
      ],
      [
        -1412.8184814453125,
        -4005.3505859375,
        751.2380981445312
      ],
      [
        -1412.8184814453125,
        -4005.3505859375,
        751.2380981445312
      ],
      [
        -1415.8338623046875,
        -3991.994384765625,
        765.2237548828125
      ],
      [
        -1411.384033203125,
        -4001.978515625,
        751.5831298828125
      ],
      [
        -1411.3841552734375,
        -4001.978759765625,
        751.5831298828125
      ],
      [
        -1407.7642822265625,
        -4009.8681640625,
        741.8828735351562
      ],
      [
        -1406.8116455078125,
        -4012.240478515625,
        737.556640625
      ],
      [
        -1406.864990234375,
        -4011.828125,
        739.4730834960938
      ],
      [
        -1406.386962890625,
        -4013.516357421875,
        734.3208618164062
      ],
      [
        -1406.8116455078125,
        -4012.240478515625,
        737.556640625
      ],
      [
        -1405.3775634765625,
        -4017.48583984375,
        721.013427734375
      ],
      [
        -1406.386962890625,
        -4013.516357421875,
        734.3208618164062
      ],
      [
        -1405.377685546875,
        -4017.48583984375,
        721.0132446289062
      ],
      [
        -1404.9698486328125,
        -4018.862060546875,
        717.0
      ],
      [
        -1406.864990234375,
        -4011.828125,
        739.4730834960938
      ],
      [
        -1414.135009765625,
        -3995.80615234375,
        760.0159912109375
      ],
      [
        -1391.8992919921875,
        -3999.626708984375,
        726.912353515625
      ],
      [
        -1395.1832275390625,
        -3994.98779296875,
        734.4588623046875
      ],
      [
        -1389.9278564453125,
        -3989.037109375,
        731.1051025390625
      ],
      [
        -1395.2275390625,
        -3994.88818359375,
        734.5848999023438
      ],
      [
        -1389.005126953125,
        -3988.015869140625,
        730.5008544921875
      ],
      [
        -1389.9278564453125,
        -3989.037109375,
        731.1051025390625
      ],
      [
        -1389.005126953125,
        -3988.015869140625,
        730.5008544921875
      ],
      [
        -1384.6263427734375,
        -3988.9482421875,
        730.650146484375
      ],
      [
        -1395.2275390625,
        -3994.88818359375,
        734.5848999023438
      ],
      [
        -1395.1832275390625,
        -3994.98779296875,
        734.4588623046875
      ],
      [
        -1391.8992919921875,
        -3999.626708984375,
        726.912353515625
      ],
      [
        -1387.8389892578125,
        -4002.86376953125,
        719.2109375
      ],
      [
        -1384.45849609375,
        -3988.221435546875,
        724.1074829101562
      ],
      [
        -1404.58154296875,
        -3984.507568359375,
        754.2329711914062
      ],
      [
        -1404.189697265625,
        -3984.36181640625,
        753.7674560546875
      ],
      [
        -1389.517822265625,
        -3988.583251953125,
        730.8366088867188
      ],
      [
        -1397.51904296875,
        -3992.4228515625,
        739.011962890625
      ],
      [
        -1397.51904296875,
        -3992.4228515625,
        739.011962890625
      ],
      [
        -1395.030029296875,
        -3997.711181640625,
        728.9957885742188
      ],
      [
        -1403.1591796875,
        -3983.978759765625,
        752.5824584960938
      ],
      [
        -1393.18701171875,
        -3980.858154296875,
        740.4265747070312
      ],
      [
        -1393.0689697265625,
        -3981.02587890625,
        740.1484375
      ],
      [
        -1393.18701171875,
        -3980.858154296875,
        740.4265747070312
      ],
      [
        -1393.53515625,
        -3980.399169921875,
        741.223388671875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 790.3250732421875,
      "bbox_min": [
        -1406.3299560546875,
        -3935.366455078125,
        709.3673095703125
      ],
      "bbox_max": [
        -1336.280029296875,
        -3835.0,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7218150496482849,
        0.48475712537765503,
        -0.493956983089447
      ],
      "plane_d": 1271.111572265625,
      "bbox_min": [
        -1389.3924560546875,
        -3935.366455078125,
        711.5
      ],
      "bbox_max": [
        -1336.280029296875,
        -3853.72021484375,
        774.1697387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8676849603652954,
        0.3458826243877411,
        -0.35705459117889404
      ],
      "plane_d": 428.0322265625,
      "bbox_min": [
        -1389.2474365234375,
        -3934.359375,
        712.8184204101562
      ],
      "bbox_max": [
        -1336.280029296875,
        -3879.11376953125,
        773.974365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -723.4999389648438,
      "bbox_min": [
        -1356.8096923828125,
        -3905.25341796875,
        712.8184204101562
      ],
      "bbox_max": [
        -1336.280029296875,
        -3879.11376953125,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3905.25341796875,
      "bbox_min": [
        -1356.8096923828125,
        -3905.25341796875,
        712.8184204101562
      ],
      "bbox_max": [
        -1349.5,
        -3905.25341796875,
        723.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -726.4999389648438,
      "bbox_min": [
        -1355.482421875,
        -3900.219970703125,
        723.5
      ],
      "bbox_max": [
        -1336.280029296875,
        -3879.11376953125,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3900.219970703125,
      "bbox_min": [
        -1355.482421875,
        -3900.219970703125,
        723.5
      ],
      "bbox_max": [
        -1343.7349853515625,
        -3900.219970703125,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8383132219314575,
        0.4159788489341736,
        -0.35240957140922546
      ],
      "plane_d": 739.7398681640625,
      "bbox_min": [
        -1389.2474365234375,
        -3934.359375,
        722.9320678710938
      ],
      "bbox_max": [
        -1367.5,
        -3883.5,
        773.974365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6034730672836304,
        0.15154880285263062,
        -0.7828494310379028
      ],
      "plane_d": 358.89385986328125,
      "bbox_min": [
        -1389.2474365234375,
        -3934.359375,
        722.9320678710938
      ],
      "bbox_max": [
        -1367.5,
        -3883.5,
        773.974365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7679734826087952,
        0.623094916343689,
        -0.14822064340114594
      ],
      "plane_d": 1500.572265625,
      "bbox_min": [
        -1379.059326171875,
        -3934.359375,
        722.9320678710938
      ],
      "bbox_max": [
        -1367.5,
        -3921.75,
        737.7821044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.824434757232666,
        -0.3593581020832062,
        -0.4372286796569824
      ],
      "plane_d": -2190.575439453125,
      "bbox_min": [
        -1389.3924560546875,
        -3935.366455078125,
        711.5
      ],
      "bbox_max": [
        -1341.307861328125,
        -3853.72021484375,
        774.1697387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -723.4999389648438,
      "bbox_min": [
        -1354.001220703125,
        -3888.742431640625,
        715.0126953125
      ],
      "bbox_max": [
        -1341.307861328125,
        -3869.74658203125,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3869.74658203125,
      "bbox_min": [
        -1354.001220703125,
        -3869.74658203125,
        715.0126953125
      ],
      "bbox_max": [
        -1349.5,
        -3869.74658203125,
        723.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -726.4999389648438,
      "bbox_min": [
        -1353.298095703125,
        -3888.3251953125,
        723.5
      ],
      "bbox_max": [
        -1341.307861328125,
        -3875.010009765625,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3875.010009765625,
      "bbox_min": [
        -1353.298095703125,
        -3875.010009765625,
        723.5
      ],
      "bbox_max": [
        -1343.7349853515625,
        -3875.010009765625,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10069474577903748,
        0.07218433171510696,
        0.9922953248023987
      ],
      "plane_d": -296.57318115234375,
      "bbox_min": [
        -1389.3924560546875,
        -3935.366455078125,
        711.5
      ],
      "bbox_max": [
        -1342.5,
        -3853.72021484375,
        774.1697387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1050991341471672,
        0.06947540491819382,
        0.9920319318771362
      ],
      "plane_d": -588.4295654296875,
      "bbox_min": [
        -1389.3924560546875,
        -3935.366455078125,
        711.5
      ],
      "bbox_max": [
        -1349.5,
        -3869.74658203125,
        724.9678955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8607280850410461,
        -0.5090650916099548,
        -0.0
      ],
      "plane_d": -3167.65625,
      "bbox_min": [
        -1384.0,
        -3935.366455078125,
        711.5
      ],
      "bbox_max": [
        -1349.5,
        -3869.74658203125,
        722.9320678710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3869.74658203125,
      "bbox_min": [
        -1370.5,
        -3905.25341796875,
        711.5
      ],
      "bbox_max": [
        -1349.5,
        -3869.74658203125,
        721.75390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3905.25341796875,
      "bbox_min": [
        -1370.5,
        -3905.25341796875,
        711.5
      ],
      "bbox_max": [
        -1349.5,
        -3905.25341796875,
        721.75390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13770407438278198,
        -0.06695916503667831,
        0.9882075190544128
      ],
      "plane_d": -1165.3143310546875,
      "bbox_min": [
        -1384.0,
        -3935.366455078125,
        720.534423828125
      ],
      "bbox_max": [
        -1367.5,
        -3917.75,
        722.9320678710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7679734826087952,
        0.623094916343689,
        -0.14822064340114594
      ],
      "plane_d": 1500.572265625,
      "bbox_min": [
        -1378.208740234375,
        -3935.366455078125,
        720.534423828125
      ],
      "bbox_max": [
        -1367.5,
        -3921.75,
        722.9320678710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10110361874103546,
        0.06762003898620605,
        0.9925752878189087
      ],
      "plane_d": -590.5603637695312,
      "bbox_min": [
        -1389.3924560546875,
        -3934.997802734375,
        718.9722290039062
      ],
      "bbox_max": [
        -1367.5,
        -3869.74658203125,
        724.9678955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8607280850410461,
        -0.5090650916099548,
        -0.0
      ],
      "plane_d": -3167.65625,
      "bbox_min": [
        -1381.0,
        -3898.0126953125,
        718.9722290039062
      ],
      "bbox_max": [
        -1368.1795654296875,
        -3869.74658203125,
        720.4981079101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3869.74658203125,
      "bbox_min": [
        -1370.5,
        -3869.74658203125,
        718.9722290039062
      ],
      "bbox_max": [
        -1368.1795654296875,
        -3869.74658203125,
        719.2315673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8607280850410461,
        -0.5090650916099548,
        -0.0
      ],
      "plane_d": -3167.65625,
      "bbox_min": [
        -1381.0,
        -3934.997802734375,
        719.0086669921875
      ],
      "bbox_max": [
        -1367.5,
        -3869.74658203125,
        724.9678955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3869.74658203125,
      "bbox_min": [
        -1370.5,
        -3869.74658203125,
        719.0086669921875
      ],
      "bbox_max": [
        -1368.3123779296875,
        -3869.74658203125,
        719.4535522460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3905.25341796875,
      "bbox_min": [
        -1370.5,
        -3905.25341796875,
        721.4589233398438
      ],
      "bbox_max": [
        -1367.71533203125,
        -3905.25341796875,
        722.0364990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7679734826087952,
        0.623094916343689,
        -0.14822064340114594
      ],
      "plane_d": 1500.572265625,
      "bbox_min": [
        -1378.33544921875,
        -3934.997802734375,
        722.725341796875
      ],
      "bbox_max": [
        -1367.5,
        -3921.75,
        724.9678955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8224278092384338,
        -0.4242217540740967,
        -0.37900978326797485
      ],
      "plane_d": -2481.97216796875,
      "bbox_min": [
        -1389.3924560546875,
        -3934.620361328125,
        717.4539184570312
      ],
      "bbox_max": [
        -1342.5,
        -3853.72021484375,
        774.1697387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8470183610916138,
        -0.33947455883026123,
        -0.4090440571308136
      ],
      "plane_d": -2165.863525390625,
      "bbox_min": [
        -1366.89794921875,
        -3884.757568359375,
        717.4539184570312
      ],
      "bbox_max": [
        -1347.458251953125,
        -3853.72021484375,
        742.0647583007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -723.4999389648438,
      "bbox_min": [
        -1355.2010498046875,
        -3884.757568359375,
        717.4539184570312
      ],
      "bbox_max": [
        -1347.458251953125,
        -3869.74658203125,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3869.74658203125,
      "bbox_min": [
        -1355.2010498046875,
        -3869.74658203125,
        717.4539184570312
      ],
      "bbox_max": [
        -1350.794677734375,
        -3869.74658203125,
        723.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -726.4999389648438,
      "bbox_min": [
        -1353.86865234375,
        -3882.148681640625,
        723.5
      ],
      "bbox_max": [
        -1350.1864013671875,
        -3875.010009765625,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3875.010009765625,
      "bbox_min": [
        -1353.86865234375,
        -3875.010009765625,
        723.5
      ],
      "bbox_max": [
        -1351.70703125,
        -3875.010009765625,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.054703474044799805,
        -0.20800338685512543,
        0.9765971899032593
      ],
      "plane_d": -1431.8951416015625,
      "bbox_min": [
        -1361.813232421875,
        -3868.25,
        718.133544921875
      ],
      "bbox_max": [
        -1353.5,
        -3853.72021484375,
        721.6495361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -723.4999389648438,
      "bbox_min": [
        -1389.3924560546875,
        -3934.620361328125,
        717.6263427734375
      ],
      "bbox_max": [
        -1342.5,
        -3855.05908203125,
        774.1697387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09447456896305084,
        0.04495397210121155,
        0.9945117831230164
      ],
      "plane_d": -412.427734375,
      "bbox_min": [
        -1381.0,
        -3925.34033203125,
        717.6263427734375
      ],
      "bbox_max": [
        -1342.5,
        -3855.05908203125,
        723.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3869.74658203125,
      "bbox_min": [
        -1372.72412109375,
        -3883.5,
        717.6263427734375
      ],
      "bbox_max": [
        -1352.494140625,
        -3869.74658203125,
        720.2003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10130815207958221,
        -0.02326088957488537,
        0.9945830702781677
      ],
      "plane_d": -945.2222900390625,
      "bbox_min": [
        -1372.72412109375,
        -3883.5,
        719.9528198242188
      ],
      "bbox_max": [
        -1368.0,
        -3872.185546875,
        720.2003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8607280850410461,
        -0.5090650916099548,
        -0.0
      ],
      "plane_d": -3167.65625,
      "bbox_min": [
        -1381.0,
        -3925.34033203125,
        718.1275634765625
      ],
      "bbox_max": [
        -1352.72509765625,
        -3855.05908203125,
        723.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1312067061662674,
        0.009594234637916088,
        0.9913086295127869
      ],
      "plane_d": -497.1907958984375,
      "bbox_min": [
        -1371.9423828125,
        -3905.25341796875,
        718.1275634765625
      ],
      "bbox_max": [
        -1352.72509765625,
        -3855.05908203125,
        723.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3869.74658203125,
      "bbox_min": [
        -1371.9423828125,
        -3883.5,
        718.3363647460938
      ],
      "bbox_max": [
        -1354.9229736328125,
        -3868.984619140625,
        720.3980712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10130815207958221,
        -0.02326088957488537,
        0.9945830702781677
      ],
      "plane_d": -945.2222900390625,
      "bbox_min": [
        -1371.9423828125,
        -3883.5,
        720.0633544921875
      ],
      "bbox_max": [
        -1368.0,
        -3869.74658203125,
        720.32421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10130815207958221,
        -0.02326088957488537,
        0.9945830702781677
      ],
      "plane_d": -945.2222900390625,
      "bbox_min": [
        -1370.4998779296875,
        -3869.74658203125,
        720.267333984375
      ],
      "bbox_max": [
        -1369.941650390625,
        -3868.984619140625,
        720.3310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3869.74658203125,
      "bbox_min": [
        -1370.5,
        -3905.25341796875,
        718.1275634765625
      ],
      "bbox_max": [
        -1352.72509765625,
        -3869.74658203125,
        723.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3905.25341796875,
      "bbox_min": [
        -1370.5,
        -3905.25341796875,
        720.4343872070312
      ],
      "bbox_max": [
        -1354.7117919921875,
        -3905.25341796875,
        723.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7679734826087952,
        0.623094916343689,
        -0.14822064340114594
      ],
      "plane_d": 1500.572265625,
      "bbox_min": [
        -1370.522705078125,
        -3925.34033203125,
        722.9320678710938
      ],
      "bbox_max": [
        -1367.5,
        -3921.75,
        723.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6034730672836304,
        0.15154880285263062,
        -0.7828494310379028
      ],
      "plane_d": 358.89385986328125,
      "bbox_min": [
        -1389.3924560546875,
        -3934.620361328125,
        723.5
      ],
      "bbox_max": [
        -1347.494140625,
        -3868.984619140625,
        774.1697387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -726.4999389648438,
      "bbox_min": [
        -1378.423095703125,
        -3934.620361328125,
        723.5
      ],
      "bbox_max": [
        -1347.494140625,
        -3875.010009765625,
        726.5194091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8607302904129028,
        -0.5090612173080444,
        -0.0
      ],
      "plane_d": -3154.877685546875,
      "bbox_min": [
        -1378.4219970703125,
        -3934.620361328125,
        723.5
      ],
      "bbox_max": [
        -1352.4862060546875,
        -3875.010009765625,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8607302904129028,
        0.5090612173080444,
        0.0
      ],
      "plane_d": 803.1904296875,
      "bbox_min": [
        -1366.0999755859375,
        -3900.219970703125,
        723.5
      ],
      "bbox_max": [
        -1352.4862060546875,
        -3875.010009765625,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3875.010009765625,
      "bbox_min": [
        -1358.64501953125,
        -3900.219970703125,
        723.5
      ],
      "bbox_max": [
        -1352.4862060546875,
        -3875.010009765625,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3900.219970703125,
      "bbox_min": [
        -1358.64501953125,
        -3900.219970703125,
        723.5
      ],
      "bbox_max": [
        -1353.429443359375,
        -3900.219970703125,
        726.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7679734826087952,
        0.623094916343689,
        -0.14822064340114594
      ],
      "plane_d": 1500.572265625,
      "bbox_min": [
        -1378.423095703125,
        -3934.362548828125,
        726.5
      ],
      "bbox_max": [
        -1378.364013671875,
        -3934.291259765625,
        726.5194091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9969353675842285,
        -0.07822956889867783
      ],
      "plane_d": 3906.931640625,
      "bbox_min": [
        -1398.0457763671875,
        -3865.114013671875,
        773.789794921875
      ],
      "bbox_max": [
        -1388.3380126953125,
        -3857.392578125,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8396432995796204,
        0.5367552638053894,
        -0.08302326500415802
      ],
      "plane_d": 3303.7783203125,
      "bbox_min": [
        -1398.0457763671875,
        -3865.114013671875,
        773.789794921875
      ],
      "bbox_max": [
        -1388.3380126953125,
        -3857.392578125,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8401049971580505,
        -0.5369810461997986,
        -0.07664807140827179
      ],
      "plane_d": -847.3507080078125,
      "bbox_min": [
        -1398.0457763671875,
        -3865.114013671875,
        776.71630859375
      ],
      "bbox_max": [
        -1388.3380126953125,
        -3857.392578125,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8399407267570496,
        0.5368912220001221,
        -0.07904133945703506
      ],
      "plane_d": 959.455078125,
      "bbox_min": [
        -1398.0457763671875,
        -3858.758056640625,
        780.769775390625
      ],
      "bbox_max": [
        -1397.0150146484375,
        -3857.392578125,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4976440370082855,
        -0.6893792748451233,
        -0.5264092683792114
      ],
      "plane_d": -2950.33837890625,
      "bbox_min": [
        -1387.5,
        -3862.25,
        721.4395141601562
      ],
      "bbox_max": [
        -1361.0213623046875,
        -3835.0,
        749.3917236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8470183610916138,
        -0.33947455883026123,
        -0.4090440571308136
      ],
      "plane_d": -2165.863525390625,
      "bbox_min": [
        -1387.5,
        -3862.25,
        721.4395141601562
      ],
      "bbox_max": [
        -1361.0213623046875,
        -3835.0,
        749.3917236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0762677937746048,
        -0.0983443558216095,
        0.9922255277633667
      ],
      "plane_d": -1201.2998046875,
      "bbox_min": [
        -1387.5,
        -3854.88818359375,
        721.4395141601562
      ],
      "bbox_max": [
        -1361.0213623046875,
        -3835.0,
        724.3990478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.054703474044799805,
        -0.20800338685512543,
        0.9765971899032593
      ],
      "plane_d": -1431.8951416015625,
      "bbox_min": [
        -1366.4300537109375,
        -3854.88818359375,
        721.4395141601562
      ],
      "bbox_max": [
        -1361.0213623046875,
        -3847.0,
        723.2756958007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9969353675842285,
        -0.07822956889867783
      ],
      "plane_d": 3906.931640625,
      "bbox_min": [
        -1398.4171142578125,
        -3859.339111328125,
        773.6973876953125
      ],
      "bbox_max": [
        -1391.4183349609375,
        -3857.6748046875,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8399407267570496,
        0.5368912220001221,
        -0.07904133945703506
      ],
      "plane_d": 959.455078125,
      "bbox_min": [
        -1398.4171142578125,
        -3859.339111328125,
        773.6973876953125
      ],
      "bbox_max": [
        -1391.4183349609375,
        -3857.6748046875,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8396432995796204,
        0.5367552638053894,
        -0.08302326500415802
      ],
      "plane_d": 3303.7783203125,
      "bbox_min": [
        -1391.802978515625,
        -3858.75439453125,
        773.6973876953125
      ],
      "bbox_max": [
        -1391.4183349609375,
        -3858.22265625,
        774.19677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6341709494590759,
        -0.5605663061141968,
        -0.5325341820716858
      ],
      "plane_d": -862.4823608398438,
      "bbox_min": [
        -1406.3299560546875,
        -3861.417236328125,
        756.9188232421875
      ],
      "bbox_max": [
        -1400.25,
        -3846.0,
        774.4298095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03771795332431793,
        -0.2714097797870636,
        0.961724579334259
      ],
      "plane_d": -1828.888916015625,
      "bbox_min": [
        -1406.3299560546875,
        -3861.417236328125,
        756.9188232421875
      ],
      "bbox_max": [
        -1400.25,
        -3846.0,
        761.374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.785436749458313,
        -0.05238540098071098,
        -0.6167211532592773
      ],
      "plane_d": -816.9935913085938,
      "bbox_min": [
        -1402.9146728515625,
        -3901.68994140625,
        709.3673095703125
      ],
      "bbox_max": [
        -1361.7120361328125,
        -3835.0,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.540267288684845,
        -0.46573781967163086,
        -0.7008563280105591
      ],
      "plane_d": -2014.2864990234375,
      "bbox_min": [
        -1398.6341552734375,
        -3898.2236328125,
        745.4775390625
      ],
      "bbox_max": [
        -1367.738037109375,
        -3859.1728515625,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8401049971580505,
        -0.5369810461997986,
        -0.07664807140827179
      ],
      "plane_d": -847.3507080078125,
      "bbox_min": [
        -1398.6341552734375,
        -3866.607421875,
        772.8515625
      ],
      "bbox_max": [
        -1389.0653076171875,
        -3859.1728515625,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9977955222129822,
        -0.06636379659175873
      ],
      "plane_d": -3806.030029296875,
      "bbox_min": [
        -1398.6341552734375,
        -3866.607421875,
        772.8515625
      ],
      "bbox_max": [
        -1389.0653076171875,
        -3859.1728515625,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8396432995796204,
        0.5367552638053894,
        -0.08302326500415802
      ],
      "plane_d": 3303.7783203125,
      "bbox_min": [
        -1398.6341552734375,
        -3866.607421875,
        772.8515625
      ],
      "bbox_max": [
        -1389.0653076171875,
        -3859.1728515625,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8399407267570496,
        0.5368912220001221,
        -0.07904133945703506
      ],
      "plane_d": 959.455078125,
      "bbox_min": [
        -1398.6341552734375,
        -3859.6787109375,
        783.8505859375
      ],
      "bbox_max": [
        -1398.26220703125,
        -3859.1728515625,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8224278092384338,
        -0.4242217540740967,
        -0.37900978326797485
      ],
      "plane_d": -2481.97216796875,
      "bbox_min": [
        -1371.0,
        -3865.263427734375,
        745.4775390625
      ],
      "bbox_max": [
        -1367.738037109375,
        -3862.25,
        749.3917236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.840104877948761,
        -0.5369809865951538,
        0.07664988934993744
      ],
      "plane_d": -961.843994140625,
      "bbox_min": [
        -1402.9146728515625,
        -3901.68994140625,
        709.3673095703125
      ],
      "bbox_max": [
        -1361.7120361328125,
        -3835.0,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9977955222129822,
        0.06636379659175873
      ],
      "plane_d": -3905.159912109375,
      "bbox_min": [
        -1402.9146728515625,
        -3875.93798828125,
        709.3673095703125
      ],
      "bbox_max": [
        -1377.602294921875,
        -3835.0,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8403815627098083,
        -0.537103533744812,
        0.07265381515026093
      ],
      "plane_d": -3302.46533203125,
      "bbox_min": [
        -1402.9146728515625,
        -3866.607421875,
        709.3673095703125
      ],
      "bbox_max": [
        -1377.602294921875,
        -3835.0,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8399408459663391,
        0.5368912816047668,
        0.0790385827422142
      ],
      "plane_d": 841.390380859375,
      "bbox_min": [
        -1402.181884765625,
        -3865.927734375,
        709.3673095703125
      ],
      "bbox_max": [
        -1377.602294921875,
        -3835.0,
        779.2832641601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9969353675842285,
        0.07822957634925842
      ],
      "plane_d": 3790.07763671875,
      "bbox_min": [
        -1399.16015625,
        -3865.927734375,
        709.3673095703125
      ],
      "bbox_max": [
        -1377.602294921875,
        -3838.2373046875,
        772.8980712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8396428227424622,
        0.5367550253868103,
        0.08302991092205048
      ],
      "plane_d": 3179.7568359375,
      "bbox_min": [
        -1399.16015625,
        -3865.927734375,
        709.3673095703125
      ],
      "bbox_max": [
        -1387.0877685546875,
        -3857.392578125,
        755.1765747070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14257681369781494,
        -0.13205188512802124,
        0.9809353351593018
      ],
      "plane_d": -1415.5115966796875,
      "bbox_min": [
        -1399.16015625,
        -3865.927734375,
        719.5867919921875
      ],
      "bbox_max": [
        -1389.420166015625,
        -3858.3193359375,
        721.4596557617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.017750127241015434,
        -0.15946635603904724,
        0.9870438575744629
      ],
      "plane_d": -1302.621826171875,
      "bbox_min": [
        -1392.5948486328125,
        -3865.888427734375,
        720.1781005859375
      ],
      "bbox_max": [
        -1389.420166015625,
        -3858.901611328125,
        721.2922973632812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.14767126739025116,
        -0.13390813767910004,
        0.9799294471740723
      ],
      "plane_d": -1018.0697631835938,
      "bbox_min": [
        -1391.5,
        -3859.25,
        721.2450561523438
      ],
      "bbox_max": [
        -1391.3634033203125,
        -3858.901611328125,
        721.2922973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0762677937746048,
        -0.0983443558216095,
        0.9922255277633667
      ],
      "plane_d": -1201.2998046875,
      "bbox_min": [
        -1391.5,
        -3859.25,
        721.2450561523438
      ],
      "bbox_max": [
        -1391.3634033203125,
        -3858.968017578125,
        721.2765502929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060966286808252335,
        -0.26737356185913086,
        0.9616624116897583
      ],
      "plane_d": -1810.290283203125,
      "bbox_min": [
        -1399.16015625,
        -3863.218994140625,
        719.7012329101562
      ],
      "bbox_max": [
        -1391.49755859375,
        -3858.3193359375,
        721.4596557617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14767126739025116,
        -0.13390813767910004,
        0.9799294471740723
      ],
      "plane_d": -1018.0697631835938,
      "bbox_min": [
        -1392.0999755859375,
        -3859.25,
        721.2450561523438
      ],
      "bbox_max": [
        -1391.49755859375,
        -3858.3388671875,
        721.4596557617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014080512337386608,
        -0.18337534368038177,
        0.9829421043395996
      ],
      "plane_d": -1397.0404052734375,
      "bbox_min": [
        -1391.87060546875,
        -3862.06787109375,
        720.7523803710938
      ],
      "bbox_max": [
        -1387.0877685546875,
        -3858.33251953125,
        721.4254760742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14767126739025116,
        -0.13390813767910004,
        0.9799294471740723
      ],
      "plane_d": -1018.0697631835938,
      "bbox_min": [
        -1391.83349609375,
        -3858.968017578125,
        721.2765502929688
      ],
      "bbox_max": [
        -1391.3486328125,
        -3858.33251953125,
        721.419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.017750127241015434,
        -0.15946635603904724,
        0.9870438575744629
      ],
      "plane_d": -1302.621826171875,
      "bbox_min": [
        -1391.87060546875,
        -3862.06787109375,
        720.7523803710938
      ],
      "bbox_max": [
        -1387.9798583984375,
        -3858.33837890625,
        721.4254760742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0762677937746048,
        -0.0983443558216095,
        0.9922255277633667
      ],
      "plane_d": -1201.2998046875,
      "bbox_min": [
        -1396.6539306640625,
        -3858.341552734375,
        721.1770629882812
      ],
      "bbox_max": [
        -1377.602294921875,
        -3838.2373046875,
        723.938232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14767126739025116,
        -0.13390813767910004,
        0.9799294471740723
      ],
      "plane_d": -1018.0697631835938,
      "bbox_min": [
        -1396.6539306640625,
        -3858.341552734375,
        721.1770629882812
      ],
      "bbox_max": [
        -1389.546142578125,
        -3847.404296875,
        722.5693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060966286808252335,
        -0.26737356185913086,
        0.9616624116897583
      ],
      "plane_d": -1810.290283203125,
      "bbox_min": [
        -1396.6539306640625,
        -3858.341552734375,
        721.1770629882812
      ],
      "bbox_max": [
        -1392.0999755859375,
        -3854.905517578125,
        722.2710571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9969353675842285,
        -0.07822956889867783
      ],
      "plane_d": 3906.931640625,
      "bbox_min": [
        -1396.8475341796875,
        -3861.91162109375,
        746.8673095703125
      ],
      "bbox_max": [
        -1391.802978515625,
        -3854.95703125,
        779.2832641601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17666740715503693,
        -0.6536749601364136,
        -0.7358653545379639
      ],
      "plane_d": -1706.386474609375,
      "bbox_min": [
        -1396.83349609375,
        -3861.91162109375,
        772.1450805664062
      ],
      "bbox_max": [
        -1391.802978515625,
        -3858.19482421875,
        776.2978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10469717532396317,
        -0.26547732949256897,
        -0.9584155082702637
      ],
      "plane_d": -427.22259521484375,
      "bbox_min": [
        -1394.8709716796875,
        -3861.91162109375,
        772.1450805664062
      ],
      "bbox_max": [
        -1391.802978515625,
        -3858.22998046875,
        776.2978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8396432995796204,
        0.5367552638053894,
        -0.08302326500415802
      ],
      "plane_d": 3303.7783203125,
      "bbox_min": [
        -1391.878662109375,
        -3858.351806640625,
        772.1450805664062
      ],
      "bbox_max": [
        -1391.802978515625,
        -3858.22998046875,
        773.6973876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17666740715503693,
        -0.6536749601364136,
        -0.7358653545379639
      ],
      "plane_d": -1706.386474609375,
      "bbox_min": [
        -1396.679443359375,
        -3858.27392578125,
        770.7509765625
      ],
      "bbox_max": [
        -1392.19677734375,
        -3854.95703125,
        774.1405639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060966286808252335,
        -0.26737356185913086,
        0.9616624116897583
      ],
      "plane_d": -1810.290283203125,
      "bbox_min": [
        -1402.181884765625,
        -3862.0634765625,
        719.9772338867188
      ],
      "bbox_max": [
        -1394.368896484375,
        -3846.0,
        724.374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0762677937746048,
        -0.0983443558216095,
        0.9922255277633667
      ],
      "plane_d": -1201.2998046875,
      "bbox_min": [
        -1389.5460205078125,
        -3847.404296875,
        722.5693359375
      ],
      "bbox_max": [
        -1383.5577392578125,
        -3835.0,
        723.9560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8403812050819397,
        -0.5371032953262329,
        -0.07265953719615936
      ],
      "plane_d": -3193.93408203125,
      "bbox_min": [
        -1402.9146728515625,
        -3865.97314453125,
        718.9031982421875
      ],
      "bbox_max": [
        -1394.38818359375,
        -3852.32373046875,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17666740715503693,
        -0.6536749601364136,
        -0.7358653545379639
      ],
      "plane_d": -1706.386474609375,
      "bbox_min": [
        -1399.3489990234375,
        -3862.17724609375,
        773.2911376953125
      ],
      "bbox_max": [
        -1394.38818359375,
        -3857.774169921875,
        779.5045776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9969353675842285,
        -0.07822956889867783
      ],
      "plane_d": 3906.931640625,
      "bbox_min": [
        -1396.95947265625,
        -3857.97412109375,
        776.9561767578125
      ],
      "bbox_max": [
        -1396.762939453125,
        -3857.774169921875,
        779.5045776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10469717532396317,
        -0.26547732949256897,
        -0.9584155082702637
      ],
      "plane_d": -427.22259521484375,
      "bbox_min": [
        -1396.550537109375,
        -3862.150146484375,
        776.1468505859375
      ],
      "bbox_max": [
        -1394.38818359375,
        -3861.17626953125,
        776.59619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17666740715503693,
        -0.6536749601364136,
        -0.7358653545379639
      ],
      "plane_d": -1706.386474609375,
      "bbox_min": [
        -1402.146484375,
        -3862.051025390625,
        766.7293701171875
      ],
      "bbox_max": [
        -1396.83349609375,
        -3852.32373046875,
        775.8486938476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17666740715503693,
        -0.6536749601364136,
        -0.7358653545379639
      ],
      "plane_d": -1706.386474609375,
      "bbox_min": [
        -1402.9146728515625,
        -3865.97314453125,
        718.9031982421875
      ],
      "bbox_max": [
        -1396.72412109375,
        -3856.97265625,
        775.9776000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060966286808252335,
        -0.26737356185913086,
        0.9616624116897583
      ],
      "plane_d": -1810.290283203125,
      "bbox_min": [
        -1402.9146728515625,
        -3865.97314453125,
        718.9031982421875
      ],
      "bbox_max": [
        -1396.72412109375,
        -3857.17724609375,
        721.1441650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14257681369781494,
        -0.13205188512802124,
        0.9809353351593018
      ],
      "plane_d": -1415.5115966796875,
      "bbox_min": [
        -1401.687744140625,
        -3865.97314453125,
        718.9031982421875
      ],
      "bbox_max": [
        -1396.72412109375,
        -3863.218994140625,
        719.7012329101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8403812050819397,
        -0.5371032953262329,
        -0.07265953719615936
      ],
      "plane_d": -3193.93408203125,
      "bbox_min": [
        -1402.6424560546875,
        -3875.93798828125,
        718.048095703125
      ],
      "bbox_max": [
        -1391.8099365234375,
        -3861.619140625,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9977955222129822,
        -0.06636379659175873
      ],
      "plane_d": -3806.030029296875,
      "bbox_min": [
        -1400.1180419921875,
        -3866.10205078125,
        720.14599609375
      ],
      "bbox_max": [
        -1391.8099365234375,
        -3861.619140625,
        784.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10469717532396317,
        -0.26547732949256897,
        -0.9584155082702637
      ],
      "plane_d": -427.22259521484375,
      "bbox_min": [
        -1399.2794189453125,
        -3865.88720703125,
        775.9776000976562
      ],
      "bbox_max": [
        -1394.54833984375,
        -3862.135986328125,
        777.6905517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17666740715503693,
        -0.6536749601364136,
        -0.7358653545379639
      ],
      "plane_d": -1706.386474609375,
      "bbox_min": [
        -1399.2794189453125,
        -3863.331787109375,
        775.9776000976562
      ],
      "bbox_max": [
        -1396.5504150390625,
        -3862.135986328125,
        777.156005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.017750127241015434,
        -0.15946635603904724,
        0.9870438575744629
      ],
      "plane_d": -1302.621826171875,
      "bbox_min": [
        -1392.083740234375,
        -3866.10205078125,
        720.14599609375
      ],
      "bbox_max": [
        -1391.8099365234375,
        -3865.88818359375,
        720.18310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.017750127241015434,
        -0.15946635603904724,
        0.9870438575744629
      ],
      "plane_d": -1302.621826171875,
      "bbox_min": [
        -1392.876220703125,
        -3867.59326171875,
        719.921875
      ],
      "bbox_max": [
        -1391.943603515625,
        -3865.887451171875,
        720.1923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10469717532396317,
        -0.26547732949256897,
        -0.9584155082702637
      ],
      "plane_d": -427.22259521484375,
      "bbox_min": [
        -1402.6424560546875,
        -3870.21484375,
        775.21533203125
      ],
      "bbox_max": [
        -1397.0565185546875,
        -3862.17724609375,
        779.20654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17666740715503693,
        -0.6536749601364136,
        -0.7358653545379639
      ],
      "plane_d": -1706.386474609375,
      "bbox_min": [
        -1402.6424560546875,
        -3865.071533203125,
        775.21533203125
      ],
      "bbox_max": [
        -1398.643310546875,
        -3862.17724609375,
        777.9705200195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9990589618682861,
        0.043371789157390594
      ],
      "plane_d": 3840.363037109375,
      "bbox_min": [
        -1399.9608154296875,
        -3901.68994140625,
        715.0
      ],
      "bbox_max": [
        -1361.7120361328125,
        -3843.1279296875,
        783.5457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.812773585319519,
        -0.5796448588371277,
        0.05840328708291054
      ],
      "plane_d": -1164.986328125,
      "bbox_min": [
        -1398.0390625,
        -3901.68994140625,
        715.0
      ],
      "bbox_max": [
        -1373.742431640625,
        -3875.0205078125,
        782.399169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8129178881645203,
        0.5797995924949646,
        0.05474511533975601
      ],
      "plane_d": 3335.650146484375,
      "bbox_min": [
        -1398.0390625,
        -3890.794677734375,
        715.0
      ],
      "bbox_max": [
        -1381.9832763671875,
        -3875.0205078125,
        782.399169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8131361603736877,
        0.5799552202224731,
        0.04961326718330383
      ],
      "plane_d": 1078.55224609375,
      "bbox_min": [
        -1398.0390625,
        -3890.794677734375,
        715.0
      ],
      "bbox_max": [
        -1384.8690185546875,
        -3875.0205078125,
        782.399169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9987653493881226,
        0.049676697701215744
      ],
      "plane_d": -3914.28369140625,
      "bbox_min": [
        -1396.82373046875,
        -3890.794677734375,
        715.0
      ],
      "bbox_max": [
        -1384.8690185546875,
        -3875.177001953125,
        782.399169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813007116317749,
        -0.5798113942146301,
        0.053273800760507584
      ],
      "plane_d": -3422.95556640625,
      "bbox_min": [
        -1396.82373046875,
        -3883.5595703125,
        715.0
      ],
      "bbox_max": [
        -1384.8690185546875,
        -3875.177001953125,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10130815207958221,
        -0.02326088957488537,
        0.9945830702781677
      ],
      "plane_d": -945.2222900390625,
      "bbox_min": [
        -1396.62255859375,
        -3883.43115234375,
        717.5402221679688
      ],
      "bbox_max": [
        -1384.8690185546875,
        -3875.177001953125,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14257681369781494,
        -0.13205188512802124,
        0.9809353351593018
      ],
      "plane_d": -1415.5115966796875,
      "bbox_min": [
        -1396.62255859375,
        -3881.35693359375,
        717.7390747070312
      ],
      "bbox_max": [
        -1394.271240234375,
        -3876.05078125,
        718.5806274414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.017750127241015434,
        -0.15946635603904724,
        0.9870438575744629
      ],
      "plane_d": -1302.621826171875,
      "bbox_min": [
        -1395.4901123046875,
        -3883.43994140625,
        717.4076538085938
      ],
      "bbox_max": [
        -1393.6771240234375,
        -3881.35693359375,
        717.7390747070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10130815207958221,
        -0.02326088957488537,
        0.9945830702781677
      ],
      "plane_d": -945.2222900390625,
      "bbox_min": [
        -1395.4307861328125,
        -3883.43994140625,
        717.4076538085938
      ],
      "bbox_max": [
        -1393.6771240234375,
        -3882.498291015625,
        717.5864868164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10130815207958221,
        -0.02326088957488537,
        0.9945830702781677
      ],
      "plane_d": -945.2222900390625,
      "bbox_min": [
        -1395.5618896484375,
        -3886.485595703125,
        717.399169921875
      ],
      "bbox_max": [
        -1387.78076171875,
        -3883.140625,
        782.399169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.017750127241015434,
        -0.15946635603904724,
        0.9870438575744629
      ],
      "plane_d": -1302.621826171875,
      "bbox_min": [
        -1395.5618896484375,
        -3883.5,
        717.399169921875
      ],
      "bbox_max": [
        -1395.4307861328125,
        -3883.140625,
        782.399169921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.10469717532396317,
        -0.26547732949256897,
        -0.9584155082702637
      ],
      "plane_d": -427.22259521484375,
      "bbox_min": [
        -1395.5618896484375,
        -3883.5,
        782.2931518554688
      ],
      "bbox_max": [
        -1395.4407958984375,
        -3883.140625,
        782.399169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10469717532396317,
        -0.26547732949256897,
        -0.9584155082702637
      ],
      "plane_d": -427.22259521484375,
      "bbox_min": [
        -1398.0390625,
        -3883.31591796875,
        717.7374877929688
      ],
      "bbox_max": [
        -1393.6434326171875,
        -3875.160400390625,
        782.3549194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14257681369781494,
        -0.13205188512802124,
        0.9809353351593018
      ],
      "plane_d": -1415.5115966796875,
      "bbox_min": [
        -1398.0390625,
        -3879.557373046875,
        717.7374877929688
      ],
      "bbox_max": [
        -1393.6434326171875,
        -3875.160400390625,
        718.7183837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.017750127241015434,
        -0.15946635603904724,
        0.9870438575744629
      ],
      "plane_d": -1302.621826171875,
      "bbox_min": [
        -1387.7962646484375,
        -3876.1845703125,
        718.4293823242188
      ],
      "bbox_max": [
        -1385.90234375,
        -3875.175537109375,
        718.6052856445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10130815207958221,
        -0.02326088957488537,
        0.9945830702781677
      ],
      "plane_d": -945.2222900390625,
      "bbox_min": [
        -1387.8507080078125,
        -3883.5,
        718.1783447265625
      ],
      "bbox_max": [
        -1373.742431640625,
        -3875.19287109375,
        719.808837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8401049971580505,
        -0.5369810461997986,
        -0.07664807140827179
      ],
      "plane_d": -847.3507080078125,
      "bbox_min": [
        -1399.9608154296875,
        -3877.887939453125,
        716.0
      ],
      "bbox_max": [
        -1361.7120361328125,
        -3843.1279296875,
        783.5457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9977955222129822,
        -0.06636379659175873
      ],
      "plane_d": -3806.030029296875,
      "bbox_min": [
        -1399.9608154296875,
        -3876.40673828125,
        746.8673095703125
      ],
      "bbox_max": [
        -1389.4327392578125,
        -3858.22998046875,
        783.5457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8403812050819397,
        -0.5371032953262329,
        -0.07265953719615936
      ],
      "plane_d": -3193.93408203125,
      "bbox_min": [
        -1397.5765380859375,
        -3866.517333984375,
        773.757080078125
      ],
      "bbox_max": [
        -1391.5,
        -3858.468017578125,
        783.5457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17666740715503693,
        -0.6536749601364136,
        -0.7358653545379639
      ],
      "plane_d": -1706.386474609375,
      "bbox_min": [
        -1393.2872314453125,
        -3860.271240234375,
        774.426513671875
      ],
      "bbox_max": [
        -1391.5,
        -3858.468017578125,
        775.72314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10469717532396317,
        -0.26547732949256897,
        -0.9584155082702637
      ],
      "plane_d": -427.22259521484375,
      "bbox_min": [
        -1397.2462158203125,
        -3866.169921875,
        777.6905517578125
      ],
      "bbox_max": [
        -1396.8824462890625,
        -3865.88720703125,
        777.7896118164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10469717532396317,
        -0.26547732949256897,
        -0.9584155082702637
      ],
      "plane_d": -427.22259521484375,
      "bbox_min": [
        -1399.9608154296875,
        -3876.40673828125,
        777.2764892578125
      ],
      "bbox_max": [
        -1392.6358642578125,
        -3866.135986328125,
        780.6945190429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8841344714164734,
        0.4539790749549866,
        0.11049599945545197
      ],
      "plane_d": 447.429931640625,
      "bbox_min": [
        -1386.52392578125,
        -3875.229248046875,
        716.0
      ],
      "bbox_max": [
        -1361.7120361328125,
        -3843.1279296875,
        749.3917236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8470183610916138,
        -0.33947455883026123,
        -0.4090440571308136
      ],
      "plane_d": -2165.863525390625,
      "bbox_min": [
        -1385.5362548828125,
        -3875.229248046875,
        716.0
      ],
      "bbox_max": [
        -1361.7120361328125,
        -3843.58837890625,
        749.3917236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8224278092384338,
        -0.4242217540740967,
        -0.37900978326797485
      ],
      "plane_d": -2481.97216796875,
      "bbox_min": [
        -1371.0,
        -3865.076904296875,
        742.0647583007812
      ],
      "bbox_max": [
        -1366.89794921875,
        -3862.25,
        749.3917236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9901362061500549,
        0.1401081383228302
      ],
      "plane_d": -3929.036865234375,
      "bbox_min": [
        -1385.5362548828125,
        -3875.229248046875,
        716.0
      ],
      "bbox_max": [
        -1361.7120361328125,
        -3843.58837890625,
        736.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9924602508544922,
        0.12256738543510437
      ],
      "plane_d": 3735.33642578125,
      "bbox_min": [
        -1385.5362548828125,
        -3866.861328125,
        716.0
      ],
      "bbox_max": [
        -1361.7120361328125,
        -3843.58837890625,
        736.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.88204425573349,
        -0.45292928814888,
        0.1298188716173172
      ],
      "plane_d": -631.677734375,
      "bbox_min": [
        -1385.5362548828125,
        -3866.861328125,
        716.0
      ],
      "bbox_max": [
        -1361.7120361328125,
        -3852.138671875,
        736.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8829598426818848,
        0.4533759355545044,
        0.12178750336170197
      ],
      "plane_d": 2873.21337890625,
      "bbox_min": [
        -1385.5362548828125,
        -3866.321044921875,
        716.0
      ],
      "bbox_max": [
        -1368.5968017578125,
        -3852.138671875,
        736.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014080512337386608,
        -0.18337534368038177,
        0.9829421043395996
      ],
      "plane_d": -1397.0404052734375,
      "bbox_min": [
        -1385.5362548828125,
        -3866.321044921875,
        719.8184204101562
      ],
      "bbox_max": [
        -1371.7821044921875,
        -3852.904296875,
        736.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.017750127241015434,
        -0.15946635603904724,
        0.9870438575744629
      ],
      "plane_d": -1302.621826171875,
      "bbox_min": [
        -1385.1851806640625,
        -3866.321044921875,
        719.8184204101562
      ],
      "bbox_max": [
        -1373.0003662109375,
        -3854.608642578125,
        736.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10130815207958221,
        -0.02326088957488537,
        0.9945830702781677
      ],
      "plane_d": -945.2222900390625,
      "bbox_min": [
        -1375.6937255859375,
        -3866.321044921875,
        719.8184204101562
      ],
      "bbox_max": [
        -1374.734619140625,
        -3865.4892578125,
        719.935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.054703474044799805,
        -0.20800338685512543,
        0.9765971899032593
      ],
      "plane_d": -1431.8951416015625,
      "bbox_min": [
        -1375.148681640625,
        -3866.313232421875,
        719.8624267578125
      ],
      "bbox_max": [
        -1361.7120361328125,
        -3852.8828125,
        722.1600341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0009230098221451044,
        -0.18543940782546997,
        0.9826552867889404
      ],
      "plane_d": -1425.3756103515625,
      "bbox_min": [
        -1374.36572265625,
        -3864.73779296875,
        720.05029296875
      ],
      "bbox_max": [
        -1367.0145263671875,
        -3852.8994140625,
        722.1600341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014080512337386608,
        -0.18337534368038177,
        0.9829421043395996
      ],
      "plane_d": -1397.0404052734375,
      "bbox_min": [
        -1373.0003662109375,
        -3862.25,
        720.3917236328125
      ],
      "bbox_max": [
        -1371.0,
        -3858.839111328125,
        721.0349731445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1312067061662674,
        0.009594234637916088,
        0.9913086295127869
      ],
      "plane_d": -497.1907958984375,
      "bbox_min": [
        -1371.0,
        -3866.281982421875,
        719.8624267578125
      ],
      "bbox_max": [
        -1366.89794921875,
        -3862.25,
        720.3917236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.054703474044799805,
        -0.20800338685512543,
        0.9765971899032593
      ],
      "plane_d": -1431.8951416015625,
      "bbox_min": [
        -1367.0145263671875,
        -3852.8994140625,
        722.0242919921875
      ],
      "bbox_max": [
        -1364.528076171875,
        -3851.5283203125,
        722.4193115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0762677937746048,
        -0.0983443558216095,
        0.9922255277633667
      ],
      "plane_d": -1201.2998046875,
      "bbox_min": [
        -1377.7353515625,
        -3844.8955078125,
        723.725830078125
      ],
      "bbox_max": [
        -1376.728515625,
        -3843.58837890625,
        723.90869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1312067061662674,
        0.009594234637916088,
        0.9913086295127869
      ],
      "plane_d": -497.1907958984375,
      "bbox_min": [
        -1370.43603515625,
        -3868.984619140625,
        720.0933837890625
      ],
      "bbox_max": [
        -1368.4508056640625,
        -3866.244873046875,
        720.355712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.017750127241015434,
        -0.15946635603904724,
        0.9870438575744629
      ],
      "plane_d": -1302.621826171875,
      "bbox_min": [
        -1382.177490234375,
        -3870.260986328125,
        719.2635498046875
      ],
      "bbox_max": [
        -1375.6937255859375,
        -3866.30419921875,
        719.9376831054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0762677937746048,
        -0.0983443558216095,
        0.9922255277633667
      ],
      "plane_d": -1201.2998046875,
      "bbox_min": [
        -1380.5360107421875,
        -3847.816162109375,
        723.2210693359375
      ],
      "bbox_max": [
        -1377.0413818359375,
        -3843.1279296875,
        723.9112548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.017750127241015434,
        -0.15946635603904724,
        0.9870438575744629
      ],
      "plane_d": -1302.621826171875,
      "bbox_min": [
        -1397.8817138671875,
        -3877.887939453125,
        718.2227172851562
      ],
      "bbox_max": [
        -1377.674560546875,
        -3857.427978515625,
        781.0504760742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10469717532396317,
        -0.26547732949256897,
        -0.9584155082702637
      ],
      "plane_d": -427.22259521484375,
      "bbox_min": [
        -1397.8817138671875,
        -3877.887939453125,
        718.5714721679688
      ],
      "bbox_max": [
        -1377.674560546875,
        -3857.427978515625,
        781.0504760742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014080512337386608,
        -0.18337534368038177,
        0.9829421043395996
      ],
      "plane_d": -1397.0404052734375,
      "bbox_min": [
        -1387.9798583984375,
        -3860.174072265625,
        720.982177734375
      ],
      "bbox_max": [
        -1385.1851806640625,
        -3857.427978515625,
        721.513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45072802901268005,
        -0.737375020980835,
        -0.5031126737594604
      ],
      "plane_d": -1827.5670166015625,
      "bbox_min": [
        -1444.5,
        -3899.813720703125,
        754.3673095703125
      ],
      "bbox_max": [
        -1427.664306640625,
        -3865.94775390625,
        780.4308471679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5334938764572144,
        -0.703869640827179,
        -0.46899014711380005
      ],
      "plane_d": -1605.611572265625,
      "bbox_min": [
        -1430.25,
        -3883.166259765625,
        754.4985961914062
      ],
      "bbox_max": [
        -1427.664306640625,
        -3865.94775390625,
        777.418212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0895972028374672,
        -0.2072516232728958,
        0.9741760492324829
      ],
      "plane_d": -1664.171630859375,
      "bbox_min": [
        -1427.75,
        -3866.0,
        754.4985961914062
      ],
      "bbox_max": [
        -1427.664306640625,
        -3865.94775390625,
        754.5176391601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.837358295917511,
        -0.1895277202129364,
        -0.5127477645874023
      ],
      "plane_d": 860.283447265625,
      "bbox_min": [
        -1444.5,
        -3899.813720703125,
        754.3673095703125
      ],
      "bbox_max": [
        -1427.6661376953125,
        -3865.959716796875,
        780.4308471679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8381749987602234,
        -0.21646416187286377,
        -0.5006055235862732
      ],
      "plane_d": 747.413330078125,
      "bbox_min": [
        -1444.5,
        -3899.813720703125,
        757.607421875
      ],
      "bbox_max": [
        -1430.25,
        -3883.166259765625,
        780.4308471679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10891373455524445,
        0.1679743528366089,
        0.9797563552856445
      ],
      "plane_d": 68.90011596679688,
      "bbox_min": [
        -1444.5,
        -3899.813720703125,
        754.3673095703125
      ],
      "bbox_max": [
        -1427.6661376953125,
        -3865.959716796875,
        757.607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11411676555871964,
        0.16029158234596252,
        0.9804509282112122
      ],
      "plane_d": 45.984375,
      "bbox_min": [
        -1444.5,
        -3899.813720703125,
        754.418212890625
      ],
      "bbox_max": [
        -1430.25,
        -3883.166259765625,
        757.607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00665312260389328,
        -0.0037135733291506767,
        0.9999709129333496
      ],
      "plane_d": -778.332275390625,
      "bbox_min": [
        -1442.5,
        -3883.166259765625,
        754.3673095703125
      ],
      "bbox_max": [
        -1427.6661376953125,
        -3865.959716796875,
        754.514892578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0895972028374672,
        -0.2072516232728958,
        0.9741760492324829
      ],
      "plane_d": -1664.171630859375,
      "bbox_min": [
        -1427.75,
        -3866.0439453125,
        754.4957885742188
      ],
      "bbox_max": [
        -1427.6661376953125,
        -3865.959716796875,
        754.514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5711892247200012,
        -0.820818305015564,
        0.0
      ],
      "plane_d": -2370.4306640625,
      "bbox_min": [
        -1432.75,
        -3907.945068359375,
        717.0
      ],
      "bbox_max": [
        -1417.985595703125,
        -3860.0419921875,
        783.0362548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5334938764572144,
        -0.703869640827179,
        -0.46899014711380005
      ],
      "plane_d": -1605.611572265625,
      "bbox_min": [
        -1430.25,
        -3883.166259765625,
        754.103759765625
      ],
      "bbox_max": [
        -1417.985595703125,
        -3860.0419921875,
        779.577392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5668986439704895,
        -0.6999325752258301,
        -0.4344196915626526
      ],
      "plane_d": -1569.421875,
      "bbox_min": [
        -1430.25,
        -3883.166259765625,
        763.6357421875
      ],
      "bbox_max": [
        -1418.1497802734375,
        -3864.811767578125,
        779.577392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03338504582643509,
        -0.009541824460029602,
        0.9993970394134521
      ],
      "plane_d": -743.266845703125,
      "bbox_min": [
        -1430.25,
        -3883.166259765625,
        754.103759765625
      ],
      "bbox_max": [
        -1417.985595703125,
        -3860.0419921875,
        756.6641845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0895972028374672,
        -0.2072516232728958,
        0.9741760492324829
      ],
      "plane_d": -1664.171630859375,
      "bbox_min": [
        -1427.6787109375,
        -3871.775634765625,
        754.1307983398438
      ],
      "bbox_max": [
        -1417.985595703125,
        -3860.0419921875,
        756.6641845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18979428708553314,
        -0.008465387858450413,
        -0.981787383556366
      ],
      "plane_d": 1005.1314697265625,
      "bbox_min": [
        -1432.75,
        -3907.945068359375,
        717.0
      ],
      "bbox_max": [
        -1418.5003662109375,
        -3874.989990234375,
        783.0362548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03249914571642876,
        -0.008267196826636791,
        0.9994375705718994
      ],
      "plane_d": -702.6357421875,
      "bbox_min": [
        -1430.25,
        -3889.5,
        717.0
      ],
      "bbox_max": [
        -1419.0,
        -3876.97802734375,
        717.418212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3269437849521637,
        -0.2276117503643036,
        -0.9172244071960449
      ],
      "plane_d": 296.82403564453125,
      "bbox_min": [
        -1430.25,
        -3889.5,
        717.0
      ],
      "bbox_max": [
        -1418.5003662109375,
        -3874.989990234375,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03249914571642876,
        -0.008267196826636791,
        0.9994375705718994
      ],
      "plane_d": -702.6357421875,
      "bbox_min": [
        -1421.357177734375,
        -3889.5,
        717.0
      ],
      "bbox_max": [
        -1418.5003662109375,
        -3874.989990234375,
        717.1802368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9781827330589294,
        0.20774628221988678,
        -0.0
      ],
      "plane_d": 2211.6630859375,
      "bbox_min": [
        -1446.2794189453125,
        -3961.226318359375,
        716.687255859375
      ],
      "bbox_max": [
        -1419.63525390625,
        -3892.528564453125,
        783.0570678710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9910751581192017,
        0.13330496847629547,
        -0.0
      ],
      "plane_d": 1938.010498046875,
      "bbox_min": [
        -1446.2794189453125,
        -3961.226318359375,
        716.687255859375
      ],
      "bbox_max": [
        -1421.2239990234375,
        -3892.528564453125,
        781.4675903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9005752205848694,
        -0.4347001016139984,
        0.0
      ],
      "plane_d": -433.1175537109375,
      "bbox_min": [
        -1446.2794189453125,
        -3961.226318359375,
        716.7891235351562
      ],
      "bbox_max": [
        -1423.0511474609375,
        -3892.528564453125,
        781.4675903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23833201825618744,
        0.09318727254867554,
        0.9667025804519653
      ],
      "plane_d": -27.327178955078125,
      "bbox_min": [
        -1446.2794189453125,
        -3947.51904296875,
        756.29150390625
      ],
      "bbox_max": [
        -1424.5,
        -3892.528564453125,
        781.4675903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44109049439430237,
        -0.02147340402007103,
        0.897205650806427
      ],
      "plane_d": -134.98223876953125,
      "bbox_min": [
        -1446.2794189453125,
        -3947.51904296875,
        756.29150390625
      ],
      "bbox_max": [
        -1424.5,
        -3892.528564453125,
        761.60205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8380852341651917,
        -0.2167256474494934,
        -0.500642716884613
      ],
      "plane_d": 746.2940063476562,
      "bbox_min": [
        -1446.2794189453125,
        -3908.2822265625,
        757.607421875
      ],
      "bbox_max": [
        -1443.5521240234375,
        -3892.528564453125,
        761.5654907226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8397397398948669,
        0.5216817259788513,
        -0.1506163477897644
      ],
      "plane_d": 3369.4677734375,
      "bbox_min": [
        -1432.5994873046875,
        -3947.51904296875,
        756.29150390625
      ],
      "bbox_max": [
        -1424.5,
        -3933.233154296875,
        760.6152954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8380852341651917,
        -0.2167256474494934,
        -0.500642716884613
      ],
      "plane_d": 746.2940063476562,
      "bbox_min": [
        -1446.2093505859375,
        -3946.18505859375,
        758.4675903320312
      ],
      "bbox_max": [
        -1424.679443359375,
        -3893.1162109375,
        781.4675903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7477996349334717,
        -0.663924515247345
      ],
      "plane_d": 3446.57373046875,
      "bbox_min": [
        -1445.9007568359375,
        -3921.89501953125,
        765.5453491210938
      ],
      "bbox_max": [
        -1437.1273193359375,
        -3909.433837890625,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7661946415901184,
        -0.6426087021827698
      ],
      "plane_d": -2497.5322265625,
      "bbox_min": [
        -1445.9007568359375,
        -3921.89501953125,
        765.5453491210938
      ],
      "bbox_max": [
        -1437.1273193359375,
        -3909.433837890625,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0486929677426815,
        -0.7652857303619385,
        -0.6418464183807373
      ],
      "plane_d": -2564.9599609375,
      "bbox_min": [
        -1445.8912353515625,
        -3910.556396484375,
        774.75537109375
      ],
      "bbox_max": [
        -1445.5999755859375,
        -3909.446044921875,
        776.079345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.050300877541303635,
        -0.9591306447982788,
        -0.27845728397369385
      ],
      "plane_d": -3461.21826171875,
      "bbox_min": [
        -1445.8912353515625,
        -3909.47900390625,
        774.75537109375
      ],
      "bbox_max": [
        -1445.5999755859375,
        -3909.446044921875,
        774.8164672851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.997051477432251,
        -0.07673638314008713
      ],
      "plane_d": 3969.691650390625,
      "bbox_min": [
        -1445.9007568359375,
        -3921.89501953125,
        765.5453491210938
      ],
      "bbox_max": [
        -1438.6312255859375,
        -3909.433837890625,
        774.7830810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9970546960830688,
        0.07669494301080704
      ],
      "plane_d": -3957.351318359375,
      "bbox_min": [
        -1445.9007568359375,
        -3912.79736328125,
        765.5453491210938
      ],
      "bbox_max": [
        -1438.6312255859375,
        -3909.433837890625,
        774.75537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06532564759254456,
        -0.9949248433113098,
        0.07653111219406128
      ],
      "plane_d": -4043.332763671875,
      "bbox_min": [
        -1445.9007568359375,
        -3909.905029296875,
        768.7899780273438
      ],
      "bbox_max": [
        -1445.5999755859375,
        -3909.433837890625,
        774.75537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0170698594301939,
        -0.9602062702178955,
        0.2787695527076721
      ],
      "plane_d": -3993.309814453125,
      "bbox_min": [
        -1445.77880859375,
        -3909.905029296875,
        768.7899780273438
      ],
      "bbox_max": [
        -1445.5999755859375,
        -3909.888916015625,
        768.844482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7478041648864746,
        0.6639194488525391
      ],
      "plane_d": -3434.2666015625,
      "bbox_min": [
        -1445.7745361328125,
        -3912.79736328125,
        765.5453491210938
      ],
      "bbox_max": [
        -1442.3046875,
        -3909.90380859375,
        768.8043212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0170698594301939,
        -0.9602062702178955,
        0.2787695527076721
      ],
      "plane_d": -3993.309814453125,
      "bbox_min": [
        -1445.7745361328125,
        -3909.916259765625,
        768.7513427734375
      ],
      "bbox_max": [
        -1445.5999755859375,
        -3909.90380859375,
        768.8043212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3136958181858063,
        0.20853279531002045,
        0.9263416528701782
      ],
      "plane_d": 563.4275512695312,
      "bbox_min": [
        -1445.8861083984375,
        -3946.18505859375,
        758.4675903320312
      ],
      "bbox_max": [
        -1424.679443359375,
        -3899.813720703125,
        781.4675903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44109049439430237,
        -0.02147340402007103,
        0.897205650806427
      ],
      "plane_d": -134.98223876953125,
      "bbox_min": [
        -1435.5,
        -3933.233154296875,
        758.4675903320312
      ],
      "bbox_max": [
        -1427.75,
        -3923.3564453125,
        762.1637573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7903053164482117,
        0.44046860933303833,
        -0.4259166419506073
      ],
      "plane_d": 3189.31396484375,
      "bbox_min": [
        -1445.8861083984375,
        -3945.26708984375,
        761.8410034179688
      ],
      "bbox_max": [
        -1424.802978515625,
        -3899.813720703125,
        781.4675903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7777261734008789,
        0.46206316351890564,
        -0.42619210481643677
      ],
      "plane_d": 3256.29248046875,
      "bbox_min": [
        -1445.8861083984375,
        -3928.1171875,
        761.8410034179688
      ],
      "bbox_max": [
        -1427.75,
        -3909.213134765625,
        781.4675903320312
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.997051477432251,
        -0.07673638314008713
      ],
      "plane_d": 3969.691650390625,
      "bbox_min": [
        -1444.9996337890625,
        -3922.328369140625,
        763.9800415039062
      ],
      "bbox_max": [
        -1432.6976318359375,
        -3910.3193359375,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06998923420906067,
        -0.9975477457046509
      ],
      "plane_d": 1050.649658203125,
      "bbox_min": [
        -1444.9996337890625,
        -3919.01318359375,
        763.9800415039062
      ],
      "bbox_max": [
        -1432.6976318359375,
        -3910.3193359375,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.06996238976716995,
        0.9975497126579285
      ],
      "plane_d": -1036.2916259765625,
      "bbox_min": [
        -1444.9996337890625,
        -3919.01318359375,
        763.9800415039062
      ],
      "bbox_max": [
        -1435.557373046875,
        -3910.3193359375,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7478041648864746,
        0.6639194488525391
      ],
      "plane_d": -3434.2666015625,
      "bbox_min": [
        -1444.9996337890625,
        -3913.866455078125,
        764.3410034179688
      ],
      "bbox_max": [
        -1435.557373046875,
        -3910.3193359375,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06998923420906067,
        -0.9975477457046509
      ],
      "plane_d": 1050.649658203125,
      "bbox_min": [
        -1445.8861083984375,
        -3921.870361328125,
        762.49609375
      ],
      "bbox_max": [
        -1432.46875,
        -3909.213134765625,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7477996349334717,
        -0.663924515247345
      ],
      "plane_d": 3446.57373046875,
      "bbox_min": [
        -1445.8861083984375,
        -3921.870361328125,
        762.49609375
      ],
      "bbox_max": [
        -1432.46875,
        -3909.213134765625,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7325798869132996,
        0.2991718351840973,
        -0.6114106178283691
      ],
      "plane_d": 2695.191650390625,
      "bbox_min": [
        -1445.8861083984375,
        -3913.866455078125,
        762.49609375
      ],
      "bbox_max": [
        -1442.2171630859375,
        -3909.213134765625,
        765.5198364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7613047361373901,
        0.13373681902885437,
        -0.634452223777771
      ],
      "plane_d": 2107.4541015625,
      "bbox_min": [
        -1445.8861083984375,
        -3909.93603515625,
        762.62890625
      ],
      "bbox_max": [
        -1444.6141357421875,
        -3909.213134765625,
        764.0624389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7661946415901184,
        -0.6426087021827698
      ],
      "plane_d": -2497.5322265625,
      "bbox_min": [
        -1442.3046875,
        -3912.76123046875,
        768.8043212890625
      ],
      "bbox_max": [
        -1435.142333984375,
        -3909.75634765625,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9970546960830688,
        0.07669494301080704
      ],
      "plane_d": -3957.351318359375,
      "bbox_min": [
        -1442.3046875,
        -3909.90380859375,
        768.8043212890625
      ],
      "bbox_max": [
        -1441.12158203125,
        -3909.75634765625,
        770.7208862304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8397397398948669,
        0.5216817259788513,
        -0.1506163477897644
      ],
      "plane_d": 3369.4677734375,
      "bbox_min": [
        -1445.5123291015625,
        -3945.26708984375,
        762.1637573242188
      ],
      "bbox_max": [
        -1424.802978515625,
        -3899.813720703125,
        781.4675903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7613047361373901,
        0.13373681902885437,
        -0.634452223777771
      ],
      "plane_d": 2107.4541015625,
      "bbox_min": [
        -1445.5123291015625,
        -3923.3564453125,
        763.135498046875
      ],
      "bbox_max": [
        -1427.75,
        -3899.813720703125,
        781.4675903320312
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.9970546960830688,
        0.07669494301080704
      ],
      "plane_d": -3957.351318359375,
      "bbox_min": [
        -1442.170166015625,
        -3919.53515625,
        766.5847778320312
      ],
      "bbox_max": [
        -1431.307861328125,
        -3909.446044921875,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7478041648864746,
        0.6639194488525391
      ],
      "plane_d": -3434.2666015625,
      "bbox_min": [
        -1442.170166015625,
        -3919.53515625,
        766.5847778320312
      ],
      "bbox_max": [
        -1431.307861328125,
        -3909.90380859375,
        778.3470458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7477996349334717,
        -0.663924515247345
      ],
      "plane_d": 3446.57373046875,
      "bbox_min": [
        -1432.5496826171875,
        -3919.53515625,
        776.5139770507812
      ],
      "bbox_max": [
        -1431.307861328125,
        -3917.90771484375,
        778.3470458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8277933597564697,
        0.2540435194969177,
        -0.5002201795578003
      ],
      "plane_d": 2569.4912109375,
      "bbox_min": [
        -1444.6141357421875,
        -3923.3564453125,
        764.0624389648438
      ],
      "bbox_max": [
        -1427.75,
        -3909.90380859375,
        781.4675903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7477996349334717,
        -0.663924515247345
      ],
      "plane_d": 3446.57373046875,
      "bbox_min": [
        -1442.2171630859375,
        -3921.490966796875,
        765.5198364257812
      ],
      "bbox_max": [
        -1431.307861328125,
        -3909.90380859375,
        778.3470458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7478041648864746,
        0.6639194488525391
      ],
      "plane_d": -3434.2666015625,
      "bbox_min": [
        -1442.2171630859375,
        -3912.81982421875,
        765.5198364257812
      ],
      "bbox_max": [
        -1440.666748046875,
        -3909.90380859375,
        768.8043212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415736794471741,
        -0.32656940817832947,
        -0.08240924030542374
      ],
      "plane_d": 114.458251953125,
      "bbox_min": [
        -1431.1163330078125,
        -3961.226318359375,
        716.7891235351562
      ],
      "bbox_max": [
        -1423.0511474609375,
        -3947.51904296875,
        771.0654907226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29733017086982727,
        -0.20318518579006195,
        0.9329044222831726
      ],
      "plane_d": -1049.560791015625,
      "bbox_min": [
        -1431.1163330078125,
        -3961.226318359375,
        716.7891235351562
      ],
      "bbox_max": [
        -1423.0511474609375,
        -3947.51904296875,
        771.0654907226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9298749566078186,
        -0.3217651844024658,
        -0.17832475900650024
      ],
      "plane_d": 189.2982177734375,
      "bbox_min": [
        -1428.9951171875,
        -3960.454345703125,
        716.7891235351562
      ],
      "bbox_max": [
        -1423.0511474609375,
        -3947.51904296875,
        771.0654907226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.844300389289856,
        -0.1500016152858734,
        -0.5144476294517517
      ],
      "plane_d": 1002.954345703125,
      "bbox_min": [
        -1428.0263671875,
        -3960.101806640625,
        760.6077270507812
      ],
      "bbox_max": [
        -1423.0511474609375,
        -3950.7470703125,
        771.0654907226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9757429361343384,
        -0.12071535736322403,
        -0.18262936174869537
      ],
      "plane_d": 1051.5247802734375,
      "bbox_min": [
        -1423.841796875,
        -3958.578857421875,
        766.578857421875
      ],
      "bbox_max": [
        -1423.0511474609375,
        -3955.0390625,
        771.0654907226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7903053164482117,
        0.44046860933303833,
        -0.4259166419506073
      ],
      "plane_d": 3189.31396484375,
      "bbox_min": [
        -1427.75,
        -3958.291015625,
        756.29150390625
      ],
      "bbox_max": [
        -1421.2239990234375,
        -3923.3564453125,
        781.4675903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9298749566078186,
        -0.3217651844024658,
        -0.17832475900650024
      ],
      "plane_d": 189.2982177734375,
      "bbox_min": [
        -1424.245849609375,
        -3950.7470703125,
        761.02734375
      ],
      "bbox_max": [
        -1422.75,
        -3947.638916015625,
        765.6331787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3496655225753784,
        0.20403356850147247,
        -0.9143873453140259
      ],
      "plane_d": 2011.044189453125,
      "bbox_min": [
        -1422.8682861328125,
        -3958.224365234375,
        771.998291015625
      ],
      "bbox_max": [
        -1421.2239990234375,
        -3951.763671875,
        773.8802490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8397397398948669,
        0.5216817259788513,
        -0.1506163477897644
      ],
      "plane_d": 3369.4677734375,
      "bbox_min": [
        -1424.9337158203125,
        -3949.4091796875,
        756.29150390625
      ],
      "bbox_max": [
        -1422.75,
        -3944.29541015625,
        765.6331787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13335657119750977,
        -0.20721040666103363,
        0.9691644906997681
      ],
      "plane_d": -1325.1123046875,
      "bbox_min": [
        -1424.5,
        -3958.291015625,
        716.687255859375
      ],
      "bbox_max": [
        -1421.22412109375,
        -3947.51904296875,
        719.29150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1773027777671814,
        -0.18303455412387848,
        0.9669861197471619
      ],
      "plane_d": -1165.509521484375,
      "bbox_min": [
        -1424.5,
        -3953.335693359375,
        717.6190185546875
      ],
      "bbox_max": [
        -1421.383056640625,
        -3947.51904296875,
        719.29150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9371352791786194,
        0.30432531237602234,
        -0.17077325284481049
      ],
      "plane_d": 2665.42529296875,
      "bbox_min": [
        -1432.75,
        -3954.084228515625,
        717.4370727539062
      ],
      "bbox_max": [
        -1419.63525390625,
        -3899.813720703125,
        783.0570678710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3496655225753784,
        0.20403356850147247,
        -0.9143873453140259
      ],
      "plane_d": 2011.044189453125,
      "bbox_min": [
        -1421.7166748046875,
        -3954.083251953125,
        773.5510864257812
      ],
      "bbox_max": [
        -1421.0069580078125,
        -3947.78173828125,
        775.0402221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1838304102420807,
        -0.06361354887485504,
        0.9808973670005798
      ],
      "plane_d": -694.8004150390625,
      "bbox_min": [
        -1427.75,
        -3954.084228515625,
        717.4370727539062
      ],
      "bbox_max": [
        -1420.0,
        -3918.53857421875,
        721.4675903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13335657119750977,
        -0.20721040666103363,
        0.9691644906997681
      ],
      "plane_d": -1325.1123046875,
      "bbox_min": [
        -1421.383056640625,
        -3954.084228515625,
        717.4370727539062
      ],
      "bbox_max": [
        -1421.20947265625,
        -3953.335693359375,
        717.6190185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22230501472949982,
        0.02782134711742401,
        0.9745801687240601
      ],
      "plane_d": -275.112060546875,
      "bbox_min": [
        -1432.75,
        -3918.53857421875,
        717.6714477539062
      ],
      "bbox_max": [
        -1419.63525390625,
        -3899.813720703125,
        720.4308471679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613893032073975,
        -0.8682431578636169,
        0.0
      ],
      "plane_d": -2660.39013671875,
      "bbox_min": [
        -1419.84619140625,
        -3917.75,
        717.0
      ],
      "bbox_max": [
        -1384.0,
        -3851.245361328125,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853898286819458,
        -0.17031429708003998,
        0.0
      ],
      "plane_d": 724.7633056640625,
      "bbox_min": [
        -1418.4893798828125,
        -3874.67236328125,
        718.522216796875
      ],
      "bbox_max": [
        -1401.687744140625,
        -3851.245361328125,
        780.036865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3775213956832886,
        -0.7714802622795105,
        -0.5121483206748962
      ],
      "plane_d": -2054.071044921875,
      "bbox_min": [
        -1418.4893798828125,
        -3874.67236328125,
        754.036865234375
      ],
      "bbox_max": [
        -1402.9146728515625,
        -3851.245361328125,
        780.036865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6341709494590759,
        -0.5605663061141968,
        -0.5325341820716858
      ],
      "plane_d": -862.4823608398438,
      "bbox_min": [
        -1413.0,
        -3866.25,
        757.7698974609375
      ],
      "bbox_max": [
        -1402.9146728515625,
        -3851.245361328125,
        778.522216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03771795332431793,
        -0.2714097797870636,
        0.961724579334259
      ],
      "plane_d": -1828.888916015625,
      "bbox_min": [
        -1413.0,
        -3857.0,
        757.7698974609375
      ],
      "bbox_max": [
        -1405.3941650390625,
        -3851.245361328125,
        759.655517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5668986439704895,
        -0.6999325752258301,
        -0.4344196915626526
      ],
      "plane_d": -1569.421875,
      "bbox_min": [
        -1418.4893798828125,
        -3874.67236328125,
        754.036865234375
      ],
      "bbox_max": [
        -1402.9146728515625,
        -3854.032470703125,
        780.036865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5334938764572144,
        -0.703869640827179,
        -0.46899014711380005
      ],
      "plane_d": -1605.611572265625,
      "bbox_min": [
        -1418.1497802734375,
        -3864.811767578125,
        756.6036987304688
      ],
      "bbox_max": [
        -1413.0,
        -3857.0,
        763.6357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0895972028374672,
        -0.2072516232728958,
        0.9741760492324829
      ],
      "plane_d": -1664.171630859375,
      "bbox_min": [
        -1417.9952392578125,
        -3860.322021484375,
        756.6036987304688
      ],
      "bbox_max": [
        -1413.0,
        -3857.0,
        757.7698974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01090987678617239,
        -0.22579258680343628,
        0.9741142392158508
      ],
      "plane_d": -1593.6207275390625,
      "bbox_min": [
        -1418.4893798828125,
        -3874.67236328125,
        754.036865234375
      ],
      "bbox_max": [
        -1402.9146728515625,
        -3854.032470703125,
        758.9057006835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0895972028374672,
        -0.2072516232728958,
        0.9741760492324829
      ],
      "plane_d": -1664.171630859375,
      "bbox_min": [
        -1418.4320068359375,
        -3873.25,
        754.036865234375
      ],
      "bbox_max": [
        -1413.0,
        -3857.0,
        757.7698974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03338504582643509,
        -0.009541824460029602,
        0.9993970394134521
      ],
      "plane_d": -743.266845703125,
      "bbox_min": [
        -1418.4320068359375,
        -3873.25,
        754.036865234375
      ],
      "bbox_max": [
        -1416.0,
        -3871.775634765625,
        754.1307983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03771795332431793,
        -0.2714097797870636,
        0.961724579334259
      ],
      "plane_d": -1828.888916015625,
      "bbox_min": [
        -1418.4893798828125,
        -3874.67236328125,
        754.036865234375
      ],
      "bbox_max": [
        -1402.9146728515625,
        -3854.032470703125,
        758.9057006835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03338504582643509,
        -0.009541824460029602,
        0.9993970394134521
      ],
      "plane_d": -743.266845703125,
      "bbox_min": [
        -1418.4893798828125,
        -3874.67236328125,
        754.036865234375
      ],
      "bbox_max": [
        -1416.0,
        -3873.00634765625,
        754.1204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17666740715503693,
        -0.6536749601364136,
        -0.7358653545379639
      ],
      "plane_d": -1706.386474609375,
      "bbox_min": [
        -1403.75,
        -3866.25,
        718.522216796875
      ],
      "bbox_max": [
        -1401.687744140625,
        -3861.417236328125,
        778.522216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060966286808252335,
        -0.26737356185913086,
        0.9616624116897583
      ],
      "plane_d": -1810.290283203125,
      "bbox_min": [
        -1403.75,
        -3866.25,
        718.522216796875
      ],
      "bbox_max": [
        -1401.687744140625,
        -3861.417236328125,
        719.9188232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18172518908977509,
        0.03952465578913689,
        0.9825546741485596
      ],
      "plane_d": -804.9874267578125,
      "bbox_min": [
        -1419.84619140625,
        -3917.75,
        717.0
      ],
      "bbox_max": [
        -1384.0,
        -3865.071533203125,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5711892247200012,
        -0.820818305015564,
        0.0
      ],
      "plane_d": -2370.4306640625,
      "bbox_min": [
        -1419.84619140625,
        -3915.75,
        717.0
      ],
      "bbox_max": [
        -1395.5,
        -3865.071533203125,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5668986439704895,
        -0.6999325752258301,
        -0.4344196915626526
      ],
      "plane_d": -1569.421875,
      "bbox_min": [
        -1418.5003662109375,
        -3874.989990234375,
        754.036865234375
      ],
      "bbox_max": [
        -1416.0,
        -3873.25,
        780.036865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03338504582643509,
        -0.009541824460029602,
        0.9993970394134521
      ],
      "plane_d": -743.266845703125,
      "bbox_min": [
        -1418.5003662109375,
        -3874.989990234375,
        754.036865234375
      ],
      "bbox_max": [
        -1416.0,
        -3873.25,
        754.1064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02037634328007698,
        -0.02028958685696125,
        -0.9995865225791931
      ],
      "plane_d": 674.8458251953125,
      "bbox_min": [
        -1419.84619140625,
        -3915.75,
        717.0
      ],
      "bbox_max": [
        -1395.5,
        -3865.071533203125,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016591262072324753,
        -0.0015366387087851763,
        0.9998611211776733
      ],
      "plane_d": -746.4202270507812,
      "bbox_min": [
        -1419.84619140625,
        -3915.75,
        717.0
      ],
      "bbox_max": [
        -1395.5,
        -3865.071533203125,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.017215771600604057,
        0.0009100034949369729,
        0.9998514652252197
      ],
      "plane_d": -737.783203125,
      "bbox_min": [
        -1419.0,
        -3889.5,
        717.0
      ],
      "bbox_max": [
        -1395.5,
        -3873.041015625,
        717.399169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06556294113397598,
        -0.09601881355047226,
        0.993217945098877
      ],
      "plane_d": -1176.9158935546875,
      "bbox_min": [
        -1419.0,
        -3889.5,
        717.0
      ],
      "bbox_max": [
        -1395.5,
        -3873.041015625,
        717.399169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010074477642774582,
        -0.0023120727855712175,
        -0.9999465942382812
      ],
      "plane_d": 788.2610473632812,
      "bbox_min": [
        -1419.84619140625,
        -3915.75,
        717.0
      ],
      "bbox_max": [
        -1395.5,
        -3865.071533203125,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0036673706490546465,
        -0.2176094353199005,
        -0.9760289788246155
      ],
      "plane_d": -76.32414245605469,
      "bbox_min": [
        -1419.0,
        -3889.5,
        717.0
      ],
      "bbox_max": [
        -1395.5,
        -3865.071533203125,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10469717532396317,
        -0.26547732949256897,
        -0.9584155082702637
      ],
      "plane_d": -427.22259521484375,
      "bbox_min": [
        -1419.0,
        -3889.5,
        717.0
      ],
      "bbox_max": [
        -1395.5,
        -3865.071533203125,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14257681369781494,
        -0.13205188512802124,
        0.9809353351593018
      ],
      "plane_d": -1415.5115966796875,
      "bbox_min": [
        -1419.0,
        -3889.5,
        717.0
      ],
      "bbox_max": [
        -1395.5,
        -3865.071533203125,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3269437849521637,
        -0.2276117503643036,
        -0.9172244071960449
      ],
      "plane_d": 296.82403564453125,
      "bbox_min": [
        -1419.0,
        -3889.5,
        717.0
      ],
      "bbox_max": [
        -1416.0,
        -3873.25,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03249914571642876,
        -0.008267196826636791,
        0.9994375705718994
      ],
      "plane_d": -702.6357421875,
      "bbox_min": [
        -1419.0,
        -3889.5,
        717.0
      ],
      "bbox_max": [
        -1416.8544921875,
        -3873.8447265625,
        717.103759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8639131188392639,
        -0.4987790584564209,
        -0.06981115788221359
      ],
      "plane_d": -704.0618896484375,
      "bbox_min": [
        -1403.5,
        -3949.96826171875,
        713.0
      ],
      "bbox_max": [
        -1378.0849609375,
        -3915.75,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8639131188392639,
        0.4987790584564209,
        -0.06981115788221359
      ],
      "plane_d": 806.7540283203125,
      "bbox_min": [
        -1403.5,
        -3945.10009765625,
        713.0
      ],
      "bbox_max": [
        -1384.8583984375,
        -3915.75,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9975602626800537,
        -0.06981130689382553
      ],
      "plane_d": 3970.760498046875,
      "bbox_min": [
        -1401.4644775390625,
        -3945.10009765625,
        735.5
      ],
      "bbox_max": [
        -1384.8583984375,
        -3917.125,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8639131188392639,
        -0.4987790584564209,
        -0.06981115788221359
      ],
      "plane_d": -3112.65185546875,
      "bbox_min": [
        -1401.4644775390625,
        -3945.10009765625,
        735.5
      ],
      "bbox_max": [
        -1390.0,
        -3925.535888671875,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8639131188392639,
        0.4987790584564209,
        -0.06981115788221359
      ],
      "plane_d": 3215.34375,
      "bbox_min": [
        -1396.9710693359375,
        -3933.53955078125,
        735.5
      ],
      "bbox_max": [
        -1390.0,
        -3925.535888671875,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9975602626800537,
        -0.06981130689382553
      ],
      "plane_d": -3868.068115234375,
      "bbox_min": [
        -1396.9710693359375,
        -3933.53955078125,
        735.5
      ],
      "bbox_max": [
        -1391.38623046875,
        -3926.430908203125,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5873640775680542,
        0.3236426115036011,
        -0.7417944669723511
      ],
      "plane_d": 1023.924072265625,
      "bbox_min": [
        -1396.9710693359375,
        -3931.411865234375,
        767.84423828125
      ],
      "bbox_max": [
        -1391.38623046875,
        -3926.430908203125,
        772.2662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5873640775680542,
        0.3236426115036011,
        -0.7417944669723511
      ],
      "plane_d": 1023.924072265625,
      "bbox_min": [
        -1395.3927001953125,
        -3933.53955078125,
        767.888671875
      ],
      "bbox_max": [
        -1392.6915283203125,
        -3931.2666015625,
        769.9641723632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5873640775680542,
        0.3236426115036011,
        -0.7417944669723511
      ],
      "plane_d": 1023.924072265625,
      "bbox_min": [
        -1392.6114501953125,
        -3928.999755859375,
        767.7999267578125
      ],
      "bbox_max": [
        -1390.0850830078125,
        -3926.59521484375,
        769.8634643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5873640775680542,
        0.3236426115036011,
        -0.7417944669723511
      ],
      "plane_d": 1023.924072265625,
      "bbox_min": [
        -1401.4644775390625,
        -3945.10009765625,
        767.9332275390625
      ],
      "bbox_max": [
        -1394.000244140625,
        -3929.000244140625,
        772.4390869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5873640775680542,
        0.3236426115036011,
        -0.7417944669723511
      ],
      "plane_d": 1023.924072265625,
      "bbox_min": [
        -1395.483154296875,
        -3926.73974609375,
        767.6219482421875
      ],
      "bbox_max": [
        -1384.8583984375,
        -3917.125,
        772.208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5873640775680542,
        0.3236426115036011,
        -0.7417944669723511
      ],
      "plane_d": 1023.924072265625,
      "bbox_min": [
        -1403.5,
        -3938.95361328125,
        713.0
      ],
      "bbox_max": [
        -1388.4871826171875,
        -3915.75,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18893006443977356,
        -0.03277101740241051,
        0.9814436435699463
      ],
      "plane_d": -1097.3944091796875,
      "bbox_min": [
        -1403.5,
        -3938.95361328125,
        713.0
      ],
      "bbox_max": [
        -1388.4871826171875,
        -3915.75,
        727.7659301757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": 600.9925537109375,
      "bbox_min": [
        -1398.0,
        -3930.889404296875,
        713.0
      ],
      "bbox_max": [
        -1393.8182373046875,
        -3925.535888671875,
        718.6797485351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": 600.9925537109375,
      "bbox_min": [
        -1396.8443603515625,
        -3930.229736328125,
        718.0556640625
      ],
      "bbox_max": [
        -1394.00830078125,
        -3926.608154296875,
        727.7659301757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9809656739234924,
        0.1941813975572586
      ],
      "plane_d": 3712.364501953125,
      "bbox_min": [
        -1395.380859375,
        -3928.458740234375,
        718.417236328125
      ],
      "bbox_max": [
        -1394.00830078125,
        -3926.608154296875,
        727.7659301757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5873640775680542,
        0.3236426115036011,
        -0.7417944669723511
      ],
      "plane_d": 1023.924072265625,
      "bbox_min": [
        -1401.2518310546875,
        -3949.96826171875,
        713.0
      ],
      "bbox_max": [
        -1378.0849609375,
        -3917.289794921875,
        768.1598510742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09817931801080704,
        -0.0766526460647583,
        0.9922122359275818
      ],
      "plane_d": -1151.4757080078125,
      "bbox_min": [
        -1401.2518310546875,
        -3949.96826171875,
        713.0
      ],
      "bbox_max": [
        -1378.0849609375,
        -3917.289794921875,
        730.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18893006443977356,
        -0.03277101740241051,
        0.9814436435699463
      ],
      "plane_d": -1097.3944091796875,
      "bbox_min": [
        -1401.2518310546875,
        -3949.96826171875,
        713.0
      ],
      "bbox_max": [
        -1384.0,
        -3917.289794921875,
        720.9038696289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8495417833328247,
        0.49048179388046265,
        0.19418098032474518
      ],
      "plane_d": 2969.51513671875,
      "bbox_min": [
        -1396.9091796875,
        -3932.464111328125,
        713.0
      ],
      "bbox_max": [
        -1390.0,
        -3925.535888671875,
        719.1046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8495417833328247,
        -0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": -884.69091796875,
      "bbox_min": [
        -1396.9091796875,
        -3932.464111328125,
        713.0
      ],
      "bbox_max": [
        -1390.0,
        -3925.535888671875,
        719.1046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9809656739234924,
        0.1941813975572586
      ],
      "plane_d": -3996.063720703125,
      "bbox_min": [
        -1396.9091796875,
        -3932.464111328125,
        713.0
      ],
      "bbox_max": [
        -1392.0,
        -3925.535888671875,
        718.9342041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        -0.49048179388046265,
        0.19418098032474518
      ],
      "plane_d": -3253.21337890625,
      "bbox_min": [
        -1396.9091796875,
        -3932.464111328125,
        713.0
      ],
      "bbox_max": [
        -1395.399658203125,
        -3930.229736328125,
        718.2529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8495417833328247,
        0.49048179388046265,
        0.19418098032474518
      ],
      "plane_d": 2969.51513671875,
      "bbox_min": [
        -1396.111572265625,
        -3931.42431640625,
        718.1556396484375
      ],
      "bbox_max": [
        -1391.3953857421875,
        -3926.66015625,
        719.342041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        -0.49048179388046265,
        0.19418098032474518
      ],
      "plane_d": -3253.21337890625,
      "bbox_min": [
        -1396.111572265625,
        -3931.42431640625,
        718.1556396484375
      ],
      "bbox_max": [
        -1392.67822265625,
        -3926.66015625,
        719.342041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9809656739234924,
        0.1941813975572586
      ],
      "plane_d": 3712.364501953125,
      "bbox_min": [
        -1394.0262451171875,
        -3926.791259765625,
        718.6798095703125
      ],
      "bbox_max": [
        -1392.67822265625,
        -3926.66015625,
        719.342041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13770407438278198,
        -0.06695916503667831,
        0.9882075190544128
      ],
      "plane_d": -1165.3143310546875,
      "bbox_min": [
        -1396.0186767578125,
        -3946.540771484375,
        718.010009765625
      ],
      "bbox_max": [
        -1378.0849609375,
        -3917.75,
        730.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8495417833328247,
        -0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": -884.69091796875,
      "bbox_min": [
        -1396.0186767578125,
        -3931.329345703125,
        718.732177734375
      ],
      "bbox_max": [
        -1391.439697265625,
        -3926.76611328125,
        730.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8495417833328247,
        0.49048179388046265,
        0.19418098032474518
      ],
      "plane_d": 2969.51513671875,
      "bbox_min": [
        -1396.0186767578125,
        -3931.329345703125,
        718.732177734375
      ],
      "bbox_max": [
        -1391.439697265625,
        -3926.76611328125,
        730.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        -0.49048179388046265,
        0.19418098032474518
      ],
      "plane_d": -3253.21337890625,
      "bbox_min": [
        -1396.0186767578125,
        -3931.329345703125,
        718.732177734375
      ],
      "bbox_max": [
        -1392.724853515625,
        -3926.76611328125,
        730.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9809656739234924,
        0.1941813975572586
      ],
      "plane_d": 3712.364501953125,
      "bbox_min": [
        -1394.6248779296875,
        -3929.0,
        719.2152099609375
      ],
      "bbox_max": [
        -1392.724853515625,
        -3926.76611328125,
        730.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": 600.9925537109375,
      "bbox_min": [
        -1394.6248779296875,
        -3929.0,
        727.7659301757812
      ],
      "bbox_max": [
        -1394.0,
        -3928.458740234375,
        730.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8639131188392639,
        -0.4987790584564209,
        -0.06981115788221359
      ],
      "plane_d": -3122.414306640625,
      "bbox_min": [
        -1421.34765625,
        -3957.6708984375,
        712.0
      ],
      "bbox_max": [
        -1400.1846923828125,
        -3914.073486328125,
        786.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8639131188392639,
        0.4987790584564209,
        -0.06981115788221359
      ],
      "plane_d": 3225.24609375,
      "bbox_min": [
        -1417.6309814453125,
        -3941.244873046875,
        712.0
      ],
      "bbox_max": [
        -1401.0299072265625,
        -3914.30078125,
        786.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8639131188392639,
        -0.4987790584564209,
        -0.06981115788221359
      ],
      "plane_d": -686.17919921875,
      "bbox_min": [
        -1417.6309814453125,
        -3941.244873046875,
        736.5
      ],
      "bbox_max": [
        -1401.0299072265625,
        -3914.30078125,
        786.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9975602626800537,
        -0.06981130689382553
      ],
      "plane_d": -3860.017822265625,
      "bbox_min": [
        -1417.6309814453125,
        -3927.232177734375,
        736.5
      ],
      "bbox_max": [
        -1406.30615234375,
        -3914.30078125,
        786.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8639131188392639,
        0.4987790584564209,
        -0.06981115788221359
      ],
      "plane_d": 789.010986328125,
      "bbox_min": [
        -1417.6309814453125,
        -3924.163330078125,
        736.5
      ],
      "bbox_max": [
        -1406.30615234375,
        -3914.30078125,
        786.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9975602626800537,
        -0.06981130689382553
      ],
      "plane_d": 3962.849853515625,
      "bbox_min": [
        -1413.708740234375,
        -3924.163330078125,
        736.5
      ],
      "bbox_max": [
        -1406.30615234375,
        -3915.04931640625,
        786.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.024390442296862602,
        0.20043973624706268,
        -0.9794023036956787
      ],
      "plane_d": 1517.7242431640625,
      "bbox_min": [
        -1413.708740234375,
        -3924.163330078125,
        781.61279296875
      ],
      "bbox_max": [
        -1406.30615234375,
        -3917.74462890625,
        783.0172729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.024390442296862602,
        0.20043973624706268,
        -0.9794023036956787
      ],
      "plane_d": 1517.7242431640625,
      "bbox_min": [
        -1411.879638671875,
        -3917.75146484375,
        782.9224243164062
      ],
      "bbox_max": [
        -1408.124267578125,
        -3915.04931640625,
        783.166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010074477642774582,
        -0.0023120727855712175,
        -0.9999465942382812
      ],
      "plane_d": 788.2610473632812,
      "bbox_min": [
        -1411.5205078125,
        -3917.10546875,
        783.13916015625
      ],
      "bbox_max": [
        -1408.748046875,
        -3915.04931640625,
        783.166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010074477642774582,
        -0.0023120727855712175,
        -0.9999465942382812
      ],
      "plane_d": 788.2610473632812,
      "bbox_min": [
        -1417.6309814453125,
        -3920.999755859375,
        782.3966674804688
      ],
      "bbox_max": [
        -1410.3338623046875,
        -3914.30078125,
        783.1463623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.024390442296862602,
        0.20043973624706268,
        -0.9794023036956787
      ],
      "plane_d": 1517.7242431640625,
      "bbox_min": [
        -1415.614501953125,
        -3920.999755859375,
        782.3966674804688
      ],
      "bbox_max": [
        -1411.5205078125,
        -3917.10546875,
        783.13916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.024390442296862602,
        0.20043973624706268,
        -0.9794023036956787
      ],
      "plane_d": 1517.7242431640625,
      "bbox_min": [
        -1411.826171875,
        -3927.232177734375,
        781.02880859375
      ],
      "bbox_max": [
        -1408.1773681640625,
        -3924.156982421875,
        781.7023315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.024390442296862602,
        0.20043973624706268,
        -0.9794023036956787
      ],
      "plane_d": 1517.7242431640625,
      "bbox_min": [
        -1410.0,
        -3931.55517578125,
        780.080078125
      ],
      "bbox_max": [
        -1405.266357421875,
        -3921.0,
        782.2123413085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6423875093460083,
        0.29963013529777527,
        -0.70537930727005
      ],
      "plane_d": 824.150634765625,
      "bbox_min": [
        -1412.0048828125,
        -3932.30322265625,
        712.0
      ],
      "bbox_max": [
        -1401.896240234375,
        -3914.877685546875,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8495417833328247,
        -0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": -866.9801025390625,
      "bbox_min": [
        -1412.0048828125,
        -3932.30322265625,
        712.0
      ],
      "bbox_max": [
        -1401.896240234375,
        -3914.877685546875,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9809656739234924,
        0.1941813975572586
      ],
      "plane_d": 3704.711181640625,
      "bbox_min": [
        -1412.0048828125,
        -3922.072021484375,
        712.0
      ],
      "bbox_max": [
        -1404.1302490234375,
        -3914.877685546875,
        725.6729736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8495417833328247,
        0.49048179388046265,
        0.19418098032474518
      ],
      "plane_d": 2979.3779296875,
      "bbox_min": [
        -1409.836181640625,
        -3922.072021484375,
        712.0
      ],
      "bbox_max": [
        -1405.8077392578125,
        -3917.535888671875,
        725.6729736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055184122174978256,
        -0.025779524818062782,
        0.9981432557106018
      ],
      "plane_d": -739.3804321289062,
      "bbox_min": [
        -1409.836181640625,
        -3922.072021484375,
        717.2863159179688
      ],
      "bbox_max": [
        -1407.20849609375,
        -3918.610107421875,
        717.492919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055184122174978256,
        -0.025779524818062782,
        0.9981432557106018
      ],
      "plane_d": -739.3804321289062,
      "bbox_min": [
        -1408.6201171875,
        -3920.999755859375,
        717.2713623046875
      ],
      "bbox_max": [
        -1405.8077392578125,
        -3918.57958984375,
        717.426025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055184122174978256,
        -0.025779524818062782,
        0.9981432557106018
      ],
      "plane_d": -739.3804321289062,
      "bbox_min": [
        -1410.7913818359375,
        -3918.623291015625,
        717.2546997070312
      ],
      "bbox_max": [
        -1404.24267578125,
        -3915.87548828125,
        717.588134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007675220258533955,
        -0.01399427093565464,
        0.9998726844787598
      ],
      "plane_d": -761.1514282226562,
      "bbox_min": [
        -1409.623779296875,
        -3932.30322265625,
        716.9728393554688
      ],
      "bbox_max": [
        -1401.896240234375,
        -3915.1220703125,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055184122174978256,
        -0.025779524818062782,
        0.9981432557106018
      ],
      "plane_d": -739.3804321289062,
      "bbox_min": [
        -1409.623779296875,
        -3925.392822265625,
        717.1002807617188
      ],
      "bbox_max": [
        -1403.5,
        -3915.1220703125,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0449589341878891,
        0.03479507192969322,
        0.9983827471733093
      ],
      "plane_d": -516.708251953125,
      "bbox_min": [
        -1404.24267578125,
        -3915.87548828125,
        717.2168579101562
      ],
      "bbox_max": [
        -1403.5,
        -3915.685302734375,
        717.2546997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.024390442296862602,
        0.20043973624706268,
        -0.9794023036956787
      ],
      "plane_d": 1517.7242431640625,
      "bbox_min": [
        -1409.623779296875,
        -3922.85791015625,
        781.8062133789062
      ],
      "bbox_max": [
        -1403.5,
        -3915.1220703125,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010074477642774582,
        -0.0023120727855712175,
        -0.9999465942382812
      ],
      "plane_d": 788.2610473632812,
      "bbox_min": [
        -1409.623779296875,
        -3916.636962890625,
        783.1536865234375
      ],
      "bbox_max": [
        -1403.5,
        -3915.1220703125,
        783.2168579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18290962278842926,
        0.25407907366752625,
        -0.9497304558753967
      ],
      "plane_d": 1999.04345703125,
      "bbox_min": [
        -1421.34765625,
        -3957.6708984375,
        712.0
      ],
      "bbox_max": [
        -1400.1846923828125,
        -3914.073486328125,
        783.0995483398438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3496655225753784,
        0.20403356850147247,
        -0.9143873453140259
      ],
      "plane_d": 2011.044189453125,
      "bbox_min": [
        -1421.34765625,
        -3957.6708984375,
        772.7033081054688
      ],
      "bbox_max": [
        -1411.497314453125,
        -3947.74267578125,
        776.8276977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6817938685417175,
        0.1887175291776657,
        -0.7067834138870239
      ],
      "plane_d": 331.74285888671875,
      "bbox_min": [
        -1412.1341552734375,
        -3954.3173828125,
        775.184814453125
      ],
      "bbox_max": [
        -1411.497314453125,
        -3947.942626953125,
        776.8276977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.024390442296862602,
        0.20043973624706268,
        -0.9794023036956787
      ],
      "plane_d": 1517.7242431640625,
      "bbox_min": [
        -1421.34765625,
        -3957.6708984375,
        712.0
      ],
      "bbox_max": [
        -1400.1846923828125,
        -3914.073486328125,
        783.0995483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36659905314445496,
        0.06717772036790848,
        0.9279505610466003
      ],
      "plane_d": 117.4876708984375,
      "bbox_min": [
        -1421.34765625,
        -3957.6708984375,
        712.0
      ],
      "bbox_max": [
        -1400.1846923828125,
        -3914.073486328125,
        783.0995483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1773027777671814,
        -0.18303455412387848,
        0.9669861197471619
      ],
      "plane_d": -1165.509521484375,
      "bbox_min": [
        -1421.34765625,
        -3957.6708984375,
        712.0
      ],
      "bbox_max": [
        -1407.0101318359375,
        -3917.535888671875,
        718.6285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        -0.49048179388046265,
        0.19418098032474518
      ],
      "plane_d": -3262.68798828125,
      "bbox_min": [
        -1421.34765625,
        -3957.6708984375,
        712.0
      ],
      "bbox_max": [
        -1407.0101318359375,
        -3917.535888671875,
        717.5258178710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": 583.670166015625,
      "bbox_min": [
        -1414.0,
        -3924.464111328125,
        712.0
      ],
      "bbox_max": [
        -1407.0101318359375,
        -3917.535888671875,
        715.5447998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9809656739234924,
        0.1941813975572586
      ],
      "plane_d": -3988.021728515625,
      "bbox_min": [
        -1412.0,
        -3924.464111328125,
        712.0
      ],
      "bbox_max": [
        -1407.0101318359375,
        -3917.535888671875,
        715.1388549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8495417833328247,
        -0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": -866.9801025390625,
      "bbox_min": [
        -1408.205810546875,
        -3924.464111328125,
        712.0
      ],
      "bbox_max": [
        -1407.0101318359375,
        -3922.583740234375,
        713.80078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13335657119750977,
        -0.20721040666103363,
        0.9691644906997681
      ],
      "plane_d": -1325.1123046875,
      "bbox_min": [
        -1421.34765625,
        -3957.6708984375,
        716.5728149414062
      ],
      "bbox_max": [
        -1419.433349609375,
        -3953.65966796875,
        717.5258178710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04386037960648537,
        -0.16419099271297455,
        0.9854530096054077
      ],
      "plane_d": -1416.5255126953125,
      "bbox_min": [
        -1412.1341552734375,
        -3954.3173828125,
        715.7373046875
      ],
      "bbox_max": [
        -1409.1751708984375,
        -3947.942626953125,
        716.8276977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04386037960648537,
        -0.16419099271297455,
        0.9854530096054077
      ],
      "plane_d": -1416.5255126953125,
      "bbox_min": [
        -1411.5,
        -3953.240478515625,
        716.0484619140625
      ],
      "bbox_max": [
        -1408.7110595703125,
        -3947.942626953125,
        716.8276977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055184122174978256,
        -0.025779524818062782,
        0.9981432557106018
      ],
      "plane_d": -739.3804321289062,
      "bbox_min": [
        -1421.0069580078125,
        -3954.085693359375,
        713.2974243164062
      ],
      "bbox_max": [
        -1400.1846923828125,
        -3914.073486328125,
        783.0995483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0449589341878891,
        0.03479507192969322,
        0.9983827471733093
      ],
      "plane_d": -516.708251953125,
      "bbox_min": [
        -1420.0,
        -3953.071533203125,
        713.2974243164062
      ],
      "bbox_max": [
        -1405.7728271484375,
        -3914.073486328125,
        718.0570678710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9809656739234924,
        0.1941813975572586
      ],
      "plane_d": -3988.021728515625,
      "bbox_min": [
        -1413.1898193359375,
        -3924.107666015625,
        713.2974243164062
      ],
      "bbox_max": [
        -1407.2108154296875,
        -3917.9404296875,
        717.5911254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8495417833328247,
        -0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": -866.9801025390625,
      "bbox_min": [
        -1413.1898193359375,
        -3924.107666015625,
        713.2974243164062
      ],
      "bbox_max": [
        -1407.2108154296875,
        -3917.9404296875,
        717.5911254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": 583.670166015625,
      "bbox_min": [
        -1413.1898193359375,
        -3923.8427734375,
        714.0441284179688
      ],
      "bbox_max": [
        -1409.83642578125,
        -3917.9404296875,
        717.5911254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        -0.49048179388046265,
        0.19418098032474518
      ],
      "plane_d": -3262.68798828125,
      "bbox_min": [
        -1413.1898193359375,
        -3923.8427734375,
        714.0441284179688
      ],
      "bbox_max": [
        -1409.83642578125,
        -3917.9404296875,
        717.5911254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9809656739234924,
        0.1941813975572586
      ],
      "plane_d": 3704.711181640625,
      "bbox_min": [
        -1411.6868896484375,
        -3918.639892578125,
        714.0441284179688
      ],
      "bbox_max": [
        -1409.83642578125,
        -3917.9404296875,
        717.576904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007675220258533955,
        -0.01399427093565464,
        0.9998726844787598
      ],
      "plane_d": -761.1514282226562,
      "bbox_min": [
        -1421.0069580078125,
        -3954.085693359375,
        716.4061889648438
      ],
      "bbox_max": [
        -1400.1846923828125,
        -3914.073486328125,
        783.0995483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04386037960648537,
        -0.16419099271297455,
        0.9854530096054077
      ],
      "plane_d": -1416.5255126953125,
      "bbox_min": [
        -1411.5,
        -3952.002197265625,
        716.4061889648438
      ],
      "bbox_max": [
        -1402.796142578125,
        -3947.942626953125,
        716.8276977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6423875093460083,
        0.29963013529777527,
        -0.70537930727005
      ],
      "plane_d": 824.150634765625,
      "bbox_min": [
        -1421.0069580078125,
        -3954.085693359375,
        717.2929077148438
      ],
      "bbox_max": [
        -1400.1846923828125,
        -3914.073486328125,
        783.0995483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6817938685417175,
        0.1887175291776657,
        -0.7067834138870239
      ],
      "plane_d": 331.74285888671875,
      "bbox_min": [
        -1411.5,
        -3954.085693359375,
        767.636962890625
      ],
      "bbox_max": [
        -1402.796142578125,
        -3947.942626953125,
        776.8276977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9809656739234924,
        0.1941813975572586
      ],
      "plane_d": -3988.021728515625,
      "bbox_min": [
        -1421.0069580078125,
        -3947.78173828125,
        717.2929077148438
      ],
      "bbox_max": [
        -1407.828857421875,
        -3914.073486328125,
        783.0995483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        -0.49048179388046265,
        0.19418098032474518
      ],
      "plane_d": -3262.68798828125,
      "bbox_min": [
        -1412.7220458984375,
        -3923.414794921875,
        717.2929077148438
      ],
      "bbox_max": [
        -1407.828857421875,
        -3918.623046875,
        729.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8495417833328247,
        0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": 583.670166015625,
      "bbox_min": [
        -1412.7220458984375,
        -3923.414794921875,
        717.2929077148438
      ],
      "bbox_max": [
        -1407.828857421875,
        -3918.623046875,
        729.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8495417833328247,
        -0.49048179388046265,
        0.19418099522590637
      ],
      "plane_d": -866.9801025390625,
      "bbox_min": [
        -1411.3626708984375,
        -3923.414794921875,
        717.2929077148438
      ],
      "bbox_max": [
        -1407.828857421875,
        -3918.623046875,
        729.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9809656739234924,
        0.1941813975572586
      ],
      "plane_d": 3704.711181640625,
      "bbox_min": [
        -1411.3626708984375,
        -3921.0,
        717.4929809570312
      ],
      "bbox_max": [
        -1409.125244140625,
        -3918.623046875,
        729.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8495417833328247,
        0.49048179388046265,
        0.19418098032474518
      ],
      "plane_d": 2979.3779296875,
      "bbox_min": [
        -1410.0,
        -3921.0,
        725.6729736328125
      ],
      "bbox_max": [
        -1409.125244140625,
        -3920.242431640625,
        729.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010074477642774582,
        -0.0023120727855712175,
        -0.9999465942382812
      ],
      "plane_d": 788.2610473632812,
      "bbox_min": [
        -1421.0069580078125,
        -3947.78173828125,
        775.0214233398438
      ],
      "bbox_max": [
        -1415.614501953125,
        -3914.073486328125,
        783.0995483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9371352791786194,
        0.30432531237602234,
        -0.17077325284481049
      ],
      "plane_d": 2665.42529296875,
      "bbox_min": [
        -1421.005615234375,
        -3947.74267578125,
        775.0214233398438
      ],
      "bbox_max": [
        -1421.0,
        -3947.724609375,
        775.0563354492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7777302265167236,
        0.4620647430419922,
        -0.4261828064918518
      ],
      "plane_d": 3256.29736328125,
      "bbox_min": [
        -1462.9000244140625,
        -3924.364013671875,
        761.3350219726562
      ],
      "bbox_max": [
        -1442.4456787109375,
        -3907.943603515625,
        779.74560546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.06955976039171219,
        0.9580200910568237,
        0.27813485264778137
      ],
      "plane_d": 3644.63623046875,
      "bbox_min": [
        -1462.9000244140625,
        -3924.364013671875,
        762.3815307617188
      ],
      "bbox_max": [
        -1442.4456787109375,
        -3907.943603515625,
        779.74560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2561473548412323,
        0.9218859076499939,
        0.2907146215438843
      ],
      "plane_d": 3018.939208984375,
      "bbox_min": [
        -1462.9000244140625,
        -3924.364013671875,
        763.6804809570312
      ],
      "bbox_max": [
        -1456.5,
        -3919.837890625,
        774.9992065429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.276603102684021,
        0.9228775501251221,
        0.2679321765899658
      ],
      "plane_d": 3010.471923828125,
      "bbox_min": [
        -1462.9000244140625,
        -3924.364013671875,
        763.6804809570312
      ],
      "bbox_max": [
        -1456.5,
        -3919.837890625,
        774.9992065429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20394521951675415,
        0.3253352642059326,
        0.9233435392379761
      ],
      "plane_d": 271.7706298828125,
      "bbox_min": [
        -1462.9000244140625,
        -3924.364013671875,
        763.6804809570312
      ],
      "bbox_max": [
        -1456.5,
        -3919.837890625,
        774.9992065429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01189418975263834,
        0.9602782726287842,
        -0.2787904739379883
      ],
      "plane_d": 3999.03271484375,
      "bbox_min": [
        -1462.9000244140625,
        -3923.123779296875,
        762.3815307617188
      ],
      "bbox_max": [
        -1442.4456787109375,
        -3907.943603515625,
        779.74560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2402222454547882,
        0.9257771372795105,
        -0.29194170236587524
      ],
      "plane_d": 3506.771728515625,
      "bbox_min": [
        -1462.9000244140625,
        -3923.123779296875,
        771.25
      ],
      "bbox_max": [
        -1456.5,
        -3920.387939453125,
        778.2529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2620973587036133,
        0.9267739057540894,
        -0.26906341314315796
      ],
      "plane_d": 3461.040771484375,
      "bbox_min": [
        -1460.2645263671875,
        -3922.895751953125,
        771.25
      ],
      "bbox_max": [
        -1456.5,
        -3920.8125,
        777.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.997051477432251,
        -0.07673638314008713
      ],
      "plane_d": 3969.691650390625,
      "bbox_min": [
        -1445.5999755859375,
        -3921.917236328125,
        773.2761840820312
      ],
      "bbox_max": [
        -1442.555908203125,
        -3917.582763671875,
        778.3698120117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06998923420906067,
        -0.9975477457046509
      ],
      "plane_d": 1050.649658203125,
      "bbox_min": [
        -1445.5999755859375,
        -3917.90771484375,
        778.3470458984375
      ],
      "bbox_max": [
        -1443.6302490234375,
        -3917.582763671875,
        778.3698120117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.039022885262966156,
        0.9962919354438782,
        -0.07667793333530426
      ],
      "plane_d": 3910.25634765625,
      "bbox_min": [
        -1462.9000244140625,
        -3922.5,
        762.3815307617188
      ],
      "bbox_max": [
        -1442.4456787109375,
        -3907.943603515625,
        779.74560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.997051477432251,
        -0.07673638314008713
      ],
      "plane_d": 3969.691650390625,
      "bbox_min": [
        -1445.5999755859375,
        -3922.328369140625,
        767.7991943359375
      ],
      "bbox_max": [
        -1442.4456787109375,
        -3921.870361328125,
        773.8837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7661945223808289,
        0.6426087021827698
      ],
      "plane_d": 2511.7861328125,
      "bbox_min": [
        -1445.5999755859375,
        -3922.328369140625,
        767.7991943359375
      ],
      "bbox_max": [
        -1442.4456787109375,
        -3922.21630859375,
        767.9328002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06573271751403809,
        0.35666027665138245,
        0.9319188594818115
      ],
      "plane_d": 780.8121337890625,
      "bbox_min": [
        -1462.9000244140625,
        -3922.328369140625,
        762.3815307617188
      ],
      "bbox_max": [
        -1442.4757080078125,
        -3907.943603515625,
        779.74560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18264424800872803,
        0.35142093896865845,
        0.9182289838790894
      ],
      "plane_d": 408.9873962402344,
      "bbox_min": [
        -1462.9000244140625,
        -3920.8125,
        762.3815307617188
      ],
      "bbox_max": [
        -1456.5,
        -3913.80908203125,
        765.4375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20394521951675415,
        0.3253352642059326,
        0.9233435392379761
      ],
      "plane_d": 271.7706298828125,
      "bbox_min": [
        -1462.9000244140625,
        -3920.8125,
        762.392822265625
      ],
      "bbox_max": [
        -1456.5,
        -3916.183349609375,
        765.4375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1641242653131485,
        -0.3278135061264038,
        0.9303771257400513
      ],
      "plane_d": -2233.168701171875,
      "bbox_min": [
        -1462.9000244140625,
        -3916.12451171875,
        762.392822265625
      ],
      "bbox_max": [
        -1460.9468994140625,
        -3913.80908203125,
        763.322021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.06996238976716995,
        0.9975497126579285
      ],
      "plane_d": -1036.2916259765625,
      "bbox_min": [
        -1445.5999755859375,
        -3919.01318359375,
        763.9800415039062
      ],
      "bbox_max": [
        -1443.3341064453125,
        -3918.9013671875,
        763.9878540039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01480752695351839,
        0.35739409923553467,
        -0.9338362216949463
      ],
      "plane_d": 2148.491455078125,
      "bbox_min": [
        -1462.9000244140625,
        -3920.8125,
        763.2086791992188
      ],
      "bbox_max": [
        -1443.364013671875,
        -3907.943603515625,
        779.74560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1302458643913269,
        0.35438859462738037,
        -0.9259830713272095
      ],
      "plane_d": 1919.3349609375,
      "bbox_min": [
        -1462.9000244140625,
        -3920.8125,
        777.0625
      ],
      "bbox_max": [
        -1456.5,
        -3914.79248046875,
        779.74560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15160894393920898,
        0.3284784257411957,
        -0.9322642087936401
      ],
      "plane_d": 1791.511474609375,
      "bbox_min": [
        -1462.9000244140625,
        -3920.8125,
        777.0625
      ],
      "bbox_max": [
        -1456.5,
        -3916.183349609375,
        779.734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07280582934617996,
        -0.35648471117019653,
        -0.9314600229263306
      ],
      "plane_d": -564.2559814453125,
      "bbox_min": [
        -1462.9000244140625,
        -3919.01318359375,
        763.2086791992188
      ],
      "bbox_max": [
        -1443.364013671875,
        -3907.943603515625,
        779.2650146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08593286573886871,
        -0.3561111390590668,
        -0.9304839372634888
      ],
      "plane_d": -794.7564697265625,
      "bbox_min": [
        -1461.60888671875,
        -3915.75,
        777.0625
      ],
      "bbox_max": [
        -1456.5,
        -3910.6875,
        779.1953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06998923420906067,
        -0.9975477457046509
      ],
      "plane_d": 1050.649658203125,
      "bbox_min": [
        -1445.5999755859375,
        -3917.90771484375,
        778.3470458984375
      ],
      "bbox_max": [
        -1443.71728515625,
        -3912.739990234375,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7661946415901184,
        -0.6426087021827698
      ],
      "plane_d": -2497.5322265625,
      "bbox_min": [
        -1445.5999755859375,
        -3912.76123046875,
        778.6827392578125
      ],
      "bbox_max": [
        -1445.00927734375,
        -3912.739990234375,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0486929677426815,
        -0.7652857303619385,
        -0.6418464183807373
      ],
      "plane_d": -2564.9599609375,
      "bbox_min": [
        -1462.9000244140625,
        -3919.01318359375,
        763.2086791992188
      ],
      "bbox_max": [
        -1443.364013671875,
        -3907.943603515625,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7661946415901184,
        -0.6426087021827698
      ],
      "plane_d": -2497.5322265625,
      "bbox_min": [
        -1445.5999755859375,
        -3912.76123046875,
        776.079345703125
      ],
      "bbox_max": [
        -1445.0150146484375,
        -3910.556396484375,
        778.7081298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.050300877541303635,
        -0.9591306447982788,
        -0.27845728397369385
      ],
      "plane_d": -3461.21826171875,
      "bbox_min": [
        -1462.9000244140625,
        -3919.01318359375,
        763.2086791992188
      ],
      "bbox_max": [
        -1443.364013671875,
        -3907.943603515625,
        777.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1487109363079071,
        -0.9496678709983826,
        -0.2757100462913513
      ],
      "plane_d": -3716.2080078125,
      "bbox_min": [
        -1462.9000244140625,
        -3910.6875,
        768.8535766601562
      ],
      "bbox_max": [
        -1456.5,
        -3907.943603515625,
        777.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12608399987220764,
        -0.9460926055908203,
        -0.29834815859794617
      ],
      "plane_d": -3651.6787109375,
      "bbox_min": [
        -1462.9000244140625,
        -3910.6875,
        768.8535766601562
      ],
      "bbox_max": [
        -1456.5,
        -3907.943603515625,
        777.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1643584668636322,
        -0.9472861886024475,
        0.2750186026096344
      ],
      "plane_d": -4154.43798828125,
      "bbox_min": [
        -1462.9000244140625,
        -3909.0,
        768.8535766601562
      ],
      "bbox_max": [
        -1456.5,
        -3907.943603515625,
        771.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1431286484003067,
        -0.9438844323158264,
        0.2976517975330353
      ],
      "plane_d": -4127.53759765625,
      "bbox_min": [
        -1462.9000244140625,
        -3910.92626953125,
        764.2244262695312
      ],
      "bbox_max": [
        -1456.5,
        -3908.639892578125,
        771.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1643584668636322,
        -0.9472861886024475,
        0.2750186026096344
      ],
      "plane_d": -4154.43798828125,
      "bbox_min": [
        -1462.9000244140625,
        -3910.92626953125,
        764.2244262695312
      ],
      "bbox_max": [
        -1456.5,
        -3908.721435546875,
        771.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1641242653131485,
        -0.3278135061264038,
        0.9303771257400513
      ],
      "plane_d": -2233.168701171875,
      "bbox_min": [
        -1462.9000244140625,
        -3910.92626953125,
        764.2244262695312
      ],
      "bbox_max": [
        -1456.5,
        -3909.996337890625,
        765.4375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06532564759254456,
        -0.9949248433113098,
        0.07653111219406128
      ],
      "plane_d": -4043.332763671875,
      "bbox_min": [
        -1462.9000244140625,
        -3919.01318359375,
        763.2086791992188
      ],
      "bbox_max": [
        -1443.364013671875,
        -3909.0,
        774.6586303710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1496042013168335,
        -0.7393882870674133,
        0.6564476490020752
      ],
      "plane_d": -3611.884521484375,
      "bbox_min": [
        -1462.9000244140625,
        -3919.01318359375,
        763.2086791992188
      ],
      "bbox_max": [
        -1443.364013671875,
        -3909.916259765625,
        768.7513427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7478041648864746,
        0.6639194488525391
      ],
      "plane_d": -3434.2666015625,
      "bbox_min": [
        -1445.5999755859375,
        -3914.0693359375,
        764.3267822265625
      ],
      "bbox_max": [
        -1444.6588134765625,
        -3910.556640625,
        768.069091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.06996238976716995,
        0.9975497126579285
      ],
      "plane_d": -1036.2916259765625,
      "bbox_min": [
        -1445.5999755859375,
        -3914.0693359375,
        764.3267822265625
      ],
      "bbox_max": [
        -1444.6588134765625,
        -3913.866455078125,
        764.3410034179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.010293365456163883,
        -0.3574143946170807,
        0.9338892698287964
      ],
      "plane_d": -2127.562255859375,
      "bbox_min": [
        -1462.9000244140625,
        -3919.01318359375,
        763.2086791992188
      ],
      "bbox_max": [
        -1443.364013671875,
        -3910.6875,
        765.4375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1641242653131485,
        -0.3278135061264038,
        0.9303771257400513
      ],
      "plane_d": -2233.168701171875,
      "bbox_min": [
        -1462.9000244140625,
        -3915.75,
        763.2086791992188
      ],
      "bbox_max": [
        -1456.5,
        -3910.6875,
        765.4375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.06996238976716995,
        0.9975497126579285
      ],
      "plane_d": -1036.2916259765625,
      "bbox_min": [
        -1445.5999755859375,
        -3919.01318359375,
        763.9800415039062
      ],
      "bbox_max": [
        -1443.364013671875,
        -3913.866455078125,
        764.3410034179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14797143638134003,
        0.21526241302490234,
        0.9652805328369141
      ],
      "plane_d": 320.3561706542969,
      "bbox_min": [
        -1446.5,
        -3912.1201171875,
        761.3350219726562
      ],
      "bbox_max": [
        -1445.1810302734375,
        -3908.020751953125,
        762.678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3136958181858063,
        0.20853279531002045,
        0.9263416528701782
      ],
      "plane_d": 563.4275512695312,
      "bbox_min": [
        -1446.5,
        -3912.1201171875,
        761.60205078125
      ],
      "bbox_max": [
        -1445.1810302734375,
        -3909.488525390625,
        761.8410034179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23833201825618744,
        0.09318727254867554,
        0.9667025804519653
      ],
      "plane_d": -27.327178955078125,
      "bbox_min": [
        -1446.5,
        -3910.59130859375,
        761.60205078125
      ],
      "bbox_max": [
        -1445.5906982421875,
        -3909.488525390625,
        761.7969970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8380852341651917,
        -0.2167256474494934,
        -0.500642716884613
      ],
      "plane_d": 746.2940063476562,
      "bbox_min": [
        -1446.5,
        -3911.01953125,
        761.3350219726562
      ],
      "bbox_max": [
        -1445.4759521484375,
        -3908.020751953125,
        762.678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7325798869132996,
        0.2991718351840973,
        -0.6114106178283691
      ],
      "plane_d": 2695.191650390625,
      "bbox_min": [
        -1446.5,
        -3911.01953125,
        761.7969970703125
      ],
      "bbox_max": [
        -1445.4759521484375,
        -3909.488525390625,
        762.678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7613047361373901,
        0.13373681902885437,
        -0.634452223777771
      ],
      "plane_d": 2107.4541015625,
      "bbox_min": [
        -1446.5,
        -3909.940673828125,
        761.7969970703125
      ],
      "bbox_max": [
        -1445.7662353515625,
        -3909.488525390625,
        762.678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980340003967285,
        9.878495802695397e-06,
        0.06267527490854263
      ],
      "plane_d": -1549.5830078125,
      "bbox_min": [
        -1503.0,
        -3941.697265625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        812.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.06695997714996338,
        -0.31928202509880066,
        0.9452911019325256
      ],
      "plane_d": -2061.90673828125,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9686058759689331,
        0.235606849193573,
        0.07932239770889282
      ],
      "plane_d": 2306.476318359375,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9683636426925659,
        0.2363162785768509,
        0.08016538619995117
      ],
      "plane_d": 2308.257080078125,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12191759794950485,
        -0.27952972054481506,
        0.9523650407791138
      ],
      "plane_d": -1992.625732421875,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40715810656547546,
        -0.8913462162017822,
        0.19930964708328247
      ],
      "plane_d": -3028.538330078125,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1552453339099884,
        0.9158328175544739,
        -0.37033674120903015
      ],
      "plane_d": 3661.783447265625,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1972864717245102,
        -0.9379555583000183,
        0.28516218066215515
      ],
      "plane_d": -4168.54248046875,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3077267110347748,
        0.9399482607841492,
        0.14765377342700958
      ],
      "plane_d": 3134.049072265625,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08247396349906921,
        -0.9239143133163452,
        -0.3736046850681305
      ],
      "plane_d": -3438.0009765625,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4059664309024811,
        -0.8916363716125488,
        0.20043917000293732
      ],
      "plane_d": -3032.300537109375,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16309674084186554,
        0.9170992970466614,
        -0.36376938223838806
      ],
      "plane_d": 3650.11474609375,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4151727557182312,
        0.9088917970657349,
        0.03933446481823921
      ],
      "plane_d": 4161.9013671875,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09034606069326401,
        -0.9257445335388184,
        -0.36719852685928345
      ],
      "plane_d": -3461.70166015625,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1058797612786293,
        -0.9717442393302917,
        0.2109566628932953
      ],
      "plane_d": -4109.10986328125,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1348046362400055,
        -0.30907678604125977,
        0.9414348006248474
      ],
      "plane_d": -1721.131103515625,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1390167474746704,
        -0.3053266704082489,
        0.9420456290245056
      ],
      "plane_d": -1700.679443359375,
      "bbox_min": [
        -1486.6953125,
        -3918.0,
        753.3125
      ],
      "bbox_max": [
        -1476.40625,
        -3903.0,
        758.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41403675079345703,
        0.9093614816665649,
        0.04044055938720703
      ],
      "plane_d": 4161.22119140625,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18260537087917328,
        0.9825599193572998,
        0.035089652985334396
      ],
      "plane_d": 3572.02001953125,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9643122553825378,
        -0.2353275865316391,
        0.12133791297674179
      ],
      "plane_d": 422.1409912109375,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9643934369087219,
        -0.23458218574523926,
        0.12213371694087982
      ],
      "plane_d": 424.570556640625,
      "bbox_min": [
        -1491.0,
        -3919.0,
        758.3125
      ],
      "bbox_max": [
        -1486.6953125,
        -3905.119384765625,
        769.7703247070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9017321467399597,
        -0.2193402498960495,
        -0.3725171387195587
      ],
      "plane_d": 771.63330078125,
      "bbox_min": [
        -1491.0,
        -3919.0,
        769.75
      ],
      "bbox_max": [
        -1487.6126708984375,
        -3905.119384765625,
        769.7703247070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36939653754234314,
        -0.8086789846420288,
        -0.45780402421951294
      ],
      "plane_d": -2256.07421875,
      "bbox_min": [
        -1487.625,
        -3905.133544921875,
        769.75
      ],
      "bbox_max": [
        -1487.6126708984375,
        -3905.119384765625,
        769.7703247070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9117169380187988,
        0.3104747235774994,
        -0.26903122663497925
      ],
      "plane_d": 2783.20703125,
      "bbox_min": [
        -1491.0,
        -3937.5,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9017320871353149,
        0.2193402498960495,
        -0.37251710891723633
      ],
      "plane_d": 2490.822021484375,
      "bbox_min": [
        -1491.0,
        -3933.60546875,
        769.75
      ],
      "bbox_max": [
        -1485.0,
        -3919.0,
        778.2222290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3693965673446655,
        0.8086789846420288,
        -0.45780399441719055
      ],
      "plane_d": 4082.3515625,
      "bbox_min": [
        -1487.625,
        -3933.60546875,
        769.75
      ],
      "bbox_max": [
        -1485.0,
        -3929.27783203125,
        778.2222290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3693965673446655,
        0.8086789846420288,
        -0.45780399441719055
      ],
      "plane_d": 4082.3515625,
      "bbox_min": [
        -1486.026123046875,
        -3937.5,
        769.75
      ],
      "bbox_max": [
        -1477.5,
        -3929.27783203125,
        778.2222290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45313534140586853,
        0.2361915409564972,
        -0.8595823049545288
      ],
      "plane_d": 2269.914306640625,
      "bbox_min": [
        -1477.620361328125,
        -3932.875,
        781.139892578125
      ],
      "bbox_max": [
        -1477.5,
        -3919.0,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45313534140586853,
        0.2361915409564972,
        -0.8595823049545288
      ],
      "plane_d": 2269.914306640625,
      "bbox_min": [
        -1485.0,
        -3932.8173828125,
        778.2222290039062
      ],
      "bbox_max": [
        -1477.5,
        -3919.0,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.911716878414154,
        -0.3104747533798218,
        -0.26903122663497925
      ],
      "plane_d": 349.7060546875,
      "bbox_min": [
        -1491.0,
        -3919.0,
        769.75
      ],
      "bbox_max": [
        -1485.0,
        -3908.72216796875,
        781.7894897460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3315580189228058,
        -0.3387244641780853,
        -0.8805310726165771
      ],
      "plane_d": -146.36737060546875,
      "bbox_min": [
        -1487.625,
        -3919.0,
        778.2222290039062
      ],
      "bbox_max": [
        -1485.0,
        -3908.72216796875,
        781.7894897460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3315580189228058,
        -0.3387244641780853,
        -0.8805310726165771
      ],
      "plane_d": -146.36737060546875,
      "bbox_min": [
        -1486.0263671875,
        -3919.0,
        778.2222290039062
      ],
      "bbox_max": [
        -1477.5,
        -3908.72216796875,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5099736452102661,
        -0.7974585890769958,
        -0.3224696218967438
      ],
      "plane_d": -2108.780029296875,
      "bbox_min": [
        -1477.625,
        -3905.18505859375,
        781.1039428710938
      ],
      "bbox_max": [
        -1477.5,
        -3905.09130859375,
        781.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5099736452102661,
        -0.7974585890769958,
        -0.3224696218967438
      ],
      "plane_d": -2108.780029296875,
      "bbox_min": [
        -1489.8125,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3900.5,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36939653754234314,
        -0.8086789846420288,
        -0.45780402421951294
      ],
      "plane_d": -2256.07421875,
      "bbox_min": [
        -1487.61865234375,
        -3908.72216796875,
        769.75
      ],
      "bbox_max": [
        -1477.5,
        -3900.5,
        778.2222290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7567570209503174,
        0.07440971583127975,
        0.6494474411010742
      ],
      "plane_d": -1309.615478515625,
      "bbox_min": [
        -1489.8125,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6060804128646851,
        -0.05744043365120888,
        0.7933266162872314
      ],
      "plane_d": -1714.7581787109375,
      "bbox_min": [
        -1489.8125,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5960910320281982,
        -0.15185588598251343,
        0.7884258031845093
      ],
      "plane_d": -2066.478759765625,
      "bbox_min": [
        -1471.6953125,
        -3929.039794921875,
        753.3125
      ],
      "bbox_max": [
        -1465.1749267578125,
        -3919.625,
        758.3250122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.66717529296875,
        0.16996480524539948,
        0.7252509593963623
      ],
      "plane_d": -859.8526611328125,
      "bbox_min": [
        -1470.8436279296875,
        -3929.039794921875,
        753.3125
      ],
      "bbox_max": [
        -1469.1644287109375,
        -3926.21875,
        754.6571044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6564341187477112,
        0.1601940244436264,
        0.7371785044670105
      ],
      "plane_d": 1046.917724609375,
      "bbox_min": [
        -1489.8125,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49459683895111084,
        -0.12069978564977646,
        0.8607006669044495
      ],
      "plane_d": -388.970458984375,
      "bbox_min": [
        -1489.8125,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.494263231754303,
        -0.12591496109962463,
        0.860144853591919
      ],
      "plane_d": -409.4896240234375,
      "bbox_min": [
        -1489.8125,
        -3926.351318359375,
        753.3125
      ],
      "bbox_max": [
        -1481.1171875,
        -3920.03125,
        758.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6512287259101868,
        0.16590237617492676,
        0.7405251860618591
      ],
      "plane_d": 1059.0908203125,
      "bbox_min": [
        -1482.7294921875,
        -3926.351318359375,
        753.3125
      ],
      "bbox_max": [
        -1482.65380859375,
        -3926.21875,
        753.3649291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3647519052028656,
        0.8011156916618347,
        0.4745204746723175
      ],
      "plane_d": 3333.07177734375,
      "bbox_min": [
        -1486.6953125,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8417451977729797,
        -0.08036928623914719,
        0.5338594317436218
      ],
      "plane_d": -1953.160400390625,
      "bbox_min": [
        -1486.6953125,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1641242653131485,
        -0.3278135061264038,
        0.9303771257400513
      ],
      "plane_d": -2233.168701171875,
      "bbox_min": [
        -1462.9375,
        -3916.257568359375,
        762.375
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3915.896728515625,
        762.4730834960938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.20394521951675415,
        0.3253352642059326,
        0.9233435392379761
      ],
      "plane_d": 271.7706298828125,
      "bbox_min": [
        -1462.9375,
        -3916.257568359375,
        762.375
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3916.15380859375,
        762.4189453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6512287259101868,
        0.16590237617492676,
        0.7405251860618591
      ],
      "plane_d": 1059.0908203125,
      "bbox_min": [
        -1486.6953125,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.899595320224762,
        -0.14513225853443146,
        0.41190412640571594
      ],
      "plane_d": -2198.437744140625,
      "bbox_min": [
        -1481.1171875,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1641242653131485,
        -0.3278135061264038,
        0.9303771257400513
      ],
      "plane_d": -2233.168701171875,
      "bbox_min": [
        -1462.9375,
        -3916.15625,
        762.375
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3909.9697265625,
        764.63671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1431286484003067,
        -0.9438844323158264,
        0.2976517975330353
      ],
      "plane_d": -4127.53759765625,
      "bbox_min": [
        -1462.9375,
        -3909.996337890625,
        764.546875
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3909.9697265625,
        764.63671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238280057907104,
        0.09129200875759125,
        0.3717629313468933
      ],
      "plane_d": -1277.6563720703125,
      "bbox_min": [
        -1481.1171875,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9119365811347961,
        0.13636118173599243,
        0.3870106637477875
      ],
      "plane_d": -1095.141845703125,
      "bbox_min": [
        -1465.1749267578125,
        -3922.3408203125,
        758.3250122070312
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3916.15625,
        764.6449584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20394521951675415,
        0.3253352642059326,
        0.9233435392379761
      ],
      "plane_d": 271.7706298828125,
      "bbox_min": [
        -1462.9375,
        -3922.3408203125,
        762.375
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3916.15625,
        764.6449584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2561473548412323,
        0.9218859076499939,
        0.2907146215438843
      ],
      "plane_d": 3018.939208984375,
      "bbox_min": [
        -1462.9375,
        -3922.3408203125,
        764.546875
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3922.3115234375,
        764.6449584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27391543984413147,
        0.8369146585464478,
        0.4738609492778778
      ],
      "plane_d": 2530.9833984375,
      "bbox_min": [
        -1481.1171875,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3703831434249878,
        0.8492054343223572,
        0.37638604640960693
      ],
      "plane_d": 2510.7734375,
      "bbox_min": [
        -1477.34375,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1471.6953125,
        -3932.3828125,
        758.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34937968850135803,
        0.8010492920875549,
        0.4860595464706421
      ],
      "plane_d": 3301.35009765625,
      "bbox_min": [
        -1477.34375,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1476.40625,
        -3934.14453125,
        758.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9498645067214966,
        0.31247952580451965,
        -0.010681776329874992
      ],
      "plane_d": -155.7808837890625,
      "bbox_min": [
        -1468.022705078125,
        -3935.625,
        756.8831176757812
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3922.3203125,
        771.2024536132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2561473548412323,
        0.9218859076499939,
        0.2907146215438843
      ],
      "plane_d": 3018.939208984375,
      "bbox_min": [
        -1462.9375,
        -3924.375,
        764.546875
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3922.3203125,
        771.2024536132812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2402222454547882,
        0.9257771372795105,
        -0.29194170236587524
      ],
      "plane_d": 3506.771728515625,
      "bbox_min": [
        -1462.9375,
        -3924.375,
        771.0625
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3924.321044921875,
        771.2024536132812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.66717529296875,
        0.16996480524539948,
        0.7252509593963623
      ],
      "plane_d": -859.8526611328125,
      "bbox_min": [
        -1468.022705078125,
        -3933.530029296875,
        756.8831176757812
      ],
      "bbox_max": [
        -1466.5550537109375,
        -3931.7275390625,
        758.3099975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9070220589637756,
        0.40158820152282715,
        -0.1266399323940277
      ],
      "plane_d": 346.71337890625,
      "bbox_min": [
        -1481.1171875,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9146841764450073,
        0.37569406628608704,
        -0.14901982247829437
      ],
      "plane_d": 251.1422119140625,
      "bbox_min": [
        -1467.375,
        -3935.625,
        769.9375
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3922.22705078125,
        780.671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2402222454547882,
        0.9257771372795105,
        -0.29194170236587524
      ],
      "plane_d": 3506.771728515625,
      "bbox_min": [
        -1462.9375,
        -3924.375,
        771.0625
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3922.22705078125,
        777.6049194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15160894393920898,
        0.3284784257411957,
        -0.9322642087936401
      ],
      "plane_d": 1791.511474609375,
      "bbox_min": [
        -1462.9375,
        -3922.3203125,
        777.5751342773438
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3922.22705078125,
        777.6049194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.773714542388916,
        0.17088903486728668,
        -0.6100514531135559
      ],
      "plane_d": 12.748291015625,
      "bbox_min": [
        -1481.1171875,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6120323538780212,
        -0.2628094255924225,
        -0.7458871006965637
      ],
      "plane_d": -1342.96240234375,
      "bbox_min": [
        -1467.375,
        -3922.3203125,
        777.578125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3915.384765625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11075310409069061,
        -0.33027541637420654,
        -0.9373643398284912
      ],
      "plane_d": -724.5250854492188,
      "bbox_min": [
        -1462.9375,
        -3916.183349609375,
        779.4736938476562
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3915.384765625,
        779.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1302458643913269,
        0.35438859462738037,
        -0.9259830713272095
      ],
      "plane_d": 1919.3349609375,
      "bbox_min": [
        -1462.9375,
        -3916.183349609375,
        779.734375
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3916.15380859375,
        779.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7514700293540955,
        0.21925373375415802,
        -0.6222704648971558
      ],
      "plane_d": 244.4935302734375,
      "bbox_min": [
        -1467.375,
        -3922.3203125,
        777.578125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3916.15625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15160894393920898,
        0.3284784257411957,
        -0.9322642087936401
      ],
      "plane_d": 1791.511474609375,
      "bbox_min": [
        -1462.9375,
        -3922.3203125,
        777.578125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3916.15625,
        779.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6790157556533813,
        -0.19802190363407135,
        -0.7069122195243835
      ],
      "plane_d": -1217.942138671875,
      "bbox_min": [
        -1481.1171875,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6120323538780212,
        -0.2628094255924225,
        -0.7458871006965637
      ],
      "plane_d": -1342.96240234375,
      "bbox_min": [
        -1467.375,
        -3918.59375,
        777.540283203125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3909.9853515625,
        784.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11075310409069061,
        -0.33027541637420654,
        -0.9373643398284912
      ],
      "plane_d": -724.5250854492188,
      "bbox_min": [
        -1462.9375,
        -3915.45263671875,
        777.540283203125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3909.9853515625,
        779.5020751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12608399987220764,
        -0.9460926055908203,
        -0.29834815859794617
      ],
      "plane_d": -3651.6787109375,
      "bbox_min": [
        -1462.9375,
        -3909.996337890625,
        777.540283203125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3909.9853515625,
        777.578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7788897156715393,
        -0.5829750299453735,
        -0.2312382608652115
      ],
      "plane_d": -3239.39794921875,
      "bbox_min": [
        -1481.1171875,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        780.671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7418463230133057,
        -0.6395248770713806,
        -0.2016727179288864
      ],
      "plane_d": -3428.99560546875,
      "bbox_min": [
        -1467.375,
        -3909.9921875,
        770.999755859375
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3905.8203125,
        780.671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12608399987220764,
        -0.9460926055908203,
        -0.29834815859794617
      ],
      "plane_d": -3651.6787109375,
      "bbox_min": [
        -1462.9375,
        -3909.9921875,
        770.999755859375
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3907.9375,
        777.578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1431286484003067,
        -0.9438844323158264,
        0.2976517975330353
      ],
      "plane_d": -4127.53759765625,
      "bbox_min": [
        -1462.9375,
        -3907.963134765625,
        770.999755859375
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3907.9375,
        771.0635986328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8511062264442444,
        -0.5145772695541382,
        0.10405880212783813
      ],
      "plane_d": -3336.666259765625,
      "bbox_min": [
        -1481.1171875,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        771.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8225441575050354,
        -0.542372465133667,
        0.17103590071201324
      ],
      "plane_d": -3454.767822265625,
      "bbox_min": [
        -1467.375,
        -3909.9921875,
        764.546875
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3901.5625,
        771.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1431286484003067,
        -0.9438844323158264,
        0.2976517975330353
      ],
      "plane_d": -4127.53759765625,
      "bbox_min": [
        -1462.9375,
        -3909.9921875,
        764.546875
      ],
      "bbox_max": [
        -1462.9000244140625,
        -3907.9375,
        771.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34937968850135803,
        0.8010492920875549,
        0.4860595464706421
      ],
      "plane_d": 3301.35009765625,
      "bbox_min": [
        -1481.1171875,
        -3937.0625,
        753.3125
      ],
      "bbox_max": [
        -1467.4351806640625,
        -3928.18603515625,
        758.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.66717529296875,
        0.16996480524539948,
        0.7252509593963623
      ],
      "plane_d": -859.8526611328125,
      "bbox_min": [
        -1471.6953125,
        -3933.202392578125,
        753.3125
      ],
      "bbox_max": [
        -1467.4351806640625,
        -3928.18603515625,
        757.077880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4084957242012024,
        0.8675671219825745,
        -0.28365200757980347
      ],
      "plane_d": 3024.103271484375,
      "bbox_min": [
        -1482.6875,
        -3936.3125,
        746.1875
      ],
      "bbox_max": [
        -1468.125,
        -3916.625,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9329955577850342,
        0.2376832813024521,
        -0.27023327350616455
      ],
      "plane_d": -234.853515625,
      "bbox_min": [
        -1482.6875,
        -3936.3125,
        746.1875
      ],
      "bbox_max": [
        -1468.125,
        -3916.625,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9329724907875061,
        0.22016175091266632,
        -0.2847653031349182
      ],
      "plane_d": -292.773681640625,
      "bbox_min": [
        -1471.6953125,
        -3933.8515625,
        746.1875
      ],
      "bbox_max": [
        -1468.125,
        -3926.46875,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9369915723800659,
        -0.22111019492149353,
        -0.2704755365848541
      ],
      "plane_d": -2041.9775390625,
      "bbox_min": [
        -1482.6875,
        -3936.3125,
        746.1875
      ],
      "bbox_max": [
        -1468.125,
        -3916.625,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9370980262756348,
        -0.23872840404510498,
        -0.25466862320899963
      ],
      "plane_d": -2123.106201171875,
      "bbox_min": [
        -1471.6953125,
        -3926.46875,
        746.1875
      ],
      "bbox_max": [
        -1468.125,
        -3920.0546875,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41494256258010864,
        -0.8812589645385742,
        -0.22628584504127502
      ],
      "plane_d": -3894.788330078125,
      "bbox_min": [
        -1482.6875,
        -3936.3125,
        746.1875
      ],
      "bbox_max": [
        -1469.8671875,
        -3916.625,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3813270330429077,
        0.8742973208427429,
        -0.30032268166542053
      ],
      "plane_d": 3103.111328125,
      "bbox_min": [
        -1482.6875,
        -3936.3125,
        746.1875
      ],
      "bbox_max": [
        -1471.6953125,
        -3916.625,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38779667019844055,
        -0.8891307711601257,
        -0.2430228888988495
      ],
      "plane_d": -3873.087646484375,
      "bbox_min": [
        -1482.6875,
        -3936.3125,
        746.1875
      ],
      "bbox_max": [
        -1471.6953125,
        -3916.625,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.395687073469162,
        0.9072216749191284,
        -0.1427605301141739
      ],
      "plane_d": 4261.14501953125,
      "bbox_min": [
        -1482.6875,
        -3936.3125,
        746.1875
      ],
      "bbox_max": [
        -1475.09375,
        -3916.625,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4206675589084625,
        0.8934177756309509,
        -0.15761855244636536
      ],
      "plane_d": 4254.90869140625,
      "bbox_min": [
        -1480.3203125,
        -3936.3125,
        746.1875
      ],
      "bbox_max": [
        -1475.09375,
        -3933.8515625,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9662375450134277,
        0.24615176022052765,
        0.0761207714676857
      ],
      "plane_d": 2341.731201171875,
      "bbox_min": [
        -1482.6875,
        -3933.8515625,
        746.1875
      ],
      "bbox_max": [
        -1475.09375,
        -3916.625,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9714325666427612,
        0.22923754155635834,
        0.061391957104206085
      ],
      "plane_d": 2294.0078125,
      "bbox_min": [
        -1482.0625,
        -3933.8515625,
        746.1875
      ],
      "bbox_max": [
        -1480.3203125,
        -3926.46875,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9703493118286133,
        -0.22898191213607788,
        0.07739239931106567
      ],
      "plane_d": 481.27874755859375,
      "bbox_min": [
        -1482.6875,
        -3926.46875,
        746.1875
      ],
      "bbox_max": [
        -1475.09375,
        -3916.625,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9648259282112122,
        -0.24579216539859772,
        0.09325814247131348
      ],
      "plane_d": 395.2490234375,
      "bbox_min": [
        -1482.6875,
        -3926.46875,
        746.1875
      ],
      "bbox_max": [
        -1481.1171875,
        -3920.0546875,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4240378737449646,
        -0.9005756378173828,
        -0.09568306803703308
      ],
      "plane_d": -2830.323974609375,
      "bbox_min": [
        -1481.1171875,
        -3920.0546875,
        746.1875
      ],
      "bbox_max": [
        -1475.09375,
        -3916.625,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3985114097595215,
        -0.9136973023414612,
        -0.07966041564941406
      ],
      "plane_d": -2931.491943359375,
      "bbox_min": [
        -1481.1171875,
        -3920.0546875,
        746.1875
      ],
      "bbox_max": [
        -1476.40625,
        -3918.0,
        753.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.028210168704390526,
        -0.05151024088263512,
        0.998274028301239
      ],
      "plane_d": -894.2039794921875,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02592954784631729,
        -0.053377218544483185,
        0.9982377886772156
      ],
      "plane_d": -904.8353881835938,
      "bbox_min": [
        -1479.5390625,
        -3926.134765625,
        734.6875
      ],
      "bbox_max": [
        -1462.40625,
        -3901.4140625,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10235264897346497,
        -0.020765598863363266,
        0.9945313334465027
      ],
      "plane_d": -661.8041381835938,
      "bbox_min": [
        -1479.5390625,
        -3926.134765625,
        734.6875
      ],
      "bbox_max": [
        -1469.2734375,
        -3901.4140625,
        736.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.03287489339709282,
        -0.060027774423360825,
        0.9976552724838257
      ],
      "plane_d": -1016.489013671875,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2089107781648636,
        -0.04238441586494446,
        0.9770157933235168
      ],
      "plane_d": -1188.265380859375,
      "bbox_min": [
        -1462.40625,
        -3926.13427734375,
        734.6875
      ],
      "bbox_max": [
        -1453.1484375,
        -3901.4140625,
        736.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.029818473383784294,
        -0.061382755637168884,
        0.9976688623428345
      ],
      "plane_d": -1017.3439331054688,
      "bbox_min": [
        -1462.40625,
        -3925.6484375,
        734.6875
      ],
      "bbox_max": [
        -1453.1484375,
        -3901.4140625,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043060798197984695,
        -0.0914529338479042,
        -0.9948779940605164
      ],
      "plane_d": 320.6599426269531,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.147833913564682,
        0.029978789389133453,
        -0.988557755947113
      ],
      "plane_d": 638.321533203125,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1309601366519928,
        -0.026557007804512978,
        -0.99103182554245
      ],
      "plane_d": 442.92236328125,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13157033920288086,
        -0.031047815456986427,
        -0.9908205270767212
      ],
      "plane_d": 424.26788330078125,
      "bbox_min": [
        -1469.8671875,
        -3927.02685546875,
        743.75
      ],
      "bbox_max": [
        -1450.875,
        -3919.0859375,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14307864010334015,
        0.03376353159546852,
        -0.989135205745697
      ],
      "plane_d": 660.594482421875,
      "bbox_min": [
        -1468.2567138671875,
        -3927.02685546875,
        746.1203002929688
      ],
      "bbox_max": [
        -1467.7686767578125,
        -3926.46875,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10235264897346497,
        -0.020765598863363266,
        0.9945313334465027
      ],
      "plane_d": -661.8041381835938,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.156959667801857,
        0.031844429671764374,
        0.9870914220809937
      ],
      "plane_d": -368.89898681640625,
      "bbox_min": [
        -1483.9375,
        -3936.254638671875,
        734.6875
      ],
      "bbox_max": [
        -1469.3846435546875,
        -3923.09375,
        736.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.10190834850072861,
        -0.023309247568249702,
        0.9945206046104431
      ],
      "plane_d": -672.4345703125,
      "bbox_min": [
        -1483.9375,
        -3935.65625,
        734.6875
      ],
      "bbox_max": [
        -1469.3846435546875,
        -3923.09375,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9767735004425049,
        0.19638830423355103,
        0.08570455759763718
      ],
      "plane_d": -707.7508544921875,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9009217619895935,
        0.18113769590854645,
        0.39437171816825867
      ],
      "plane_d": 1757.175537109375,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7955414652824402,
        0.1599501371383667,
        -0.5844054818153381
      ],
      "plane_d": -92.3194580078125,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7991294860839844,
        0.16205301880836487,
        -0.5789048671722412
      ],
      "plane_d": -93.340087890625,
      "bbox_min": [
        -1455.1953125,
        -3943.0859375,
        740.0
      ],
      "bbox_max": [
        -1448.0,
        -3921.0,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7679901719093323,
        -0.15573838353157043,
        -0.6212379932403564
      ],
      "plane_d": -1262.98388671875,
      "bbox_min": [
        -1450.8934326171875,
        -3921.78125,
        740.0
      ],
      "bbox_max": [
        -1448.0,
        -3921.0,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7679901719093323,
        -0.15573838353157043,
        -0.6212379932403564
      ],
      "plane_d": -1262.98388671875,
      "bbox_min": [
        -1455.1953125,
        -3921.690185546875,
        740.0
      ],
      "bbox_max": [
        -1448.0,
        -3900.4765625,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8183830380439758,
        -0.16454261541366577,
        0.5506134033203125
      ],
      "plane_d": 163.49169921875,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.821690559387207,
        -0.16670694947242737,
        0.5450078248977661
      ],
      "plane_d": 164.0684814453125,
      "bbox_min": [
        -1486.0,
        -3923.191650390625,
        736.24560546875
      ],
      "bbox_max": [
        -1479.5390625,
        -3901.4140625,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.156959667801857,
        0.031844429671764374,
        0.9870914220809937
      ],
      "plane_d": -368.89898681640625,
      "bbox_min": [
        -1483.9375,
        -3923.191650390625,
        736.24560546875
      ],
      "bbox_max": [
        -1483.9024658203125,
        -3923.09375,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2089107781648636,
        -0.04238441586494446,
        0.9770157933235168
      ],
      "plane_d": -1188.265380859375,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5762691497802734,
        0.13180863857269287,
        0.8065608143806458
      ],
      "plane_d": -911.27978515625,
      "bbox_min": [
        -1453.38720703125,
        -3936.255859375,
        734.6875
      ],
      "bbox_max": [
        -1453.2470703125,
        -3935.65625,
        734.732177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9346903562545776,
        -0.18792714178562164,
        0.30172404646873474
      ],
      "plane_d": -2313.56982421875,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.0,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.936872124671936,
        -0.19007530808448792,
        0.29349979758262634
      ],
      "plane_d": -2319.06591796875,
      "bbox_min": [
        -1453.1484375,
        -3923.192138671875,
        736.2408447265625
      ],
      "bbox_max": [
        -1448.0,
        -3901.4140625,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6200881600379944,
        0.12580528855323792,
        0.7743796110153198
      ],
      "plane_d": -974.9437255859375,
      "bbox_min": [
        -1448.777099609375,
        -3923.192138671875,
        736.2408447265625
      ],
      "bbox_max": [
        -1448.75,
        -3923.09375,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06797967106103897,
        -0.12406852841377258,
        -0.9899423122406006
      ],
      "plane_d": 353.029052734375,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.7698974609375,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46843618154525757,
        -0.0949927493929863,
        -0.8783756494522095
      ],
      "plane_d": 976.583740234375,
      "bbox_min": [
        -1481.1171875,
        -3919.54833984375,
        743.75
      ],
      "bbox_max": [
        -1475.09375,
        -3900.4765625,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4748208820819855,
        -0.11204768717288971,
        -0.8729206323623657
      ],
      "plane_d": 915.125,
      "bbox_min": [
        -1480.429443359375,
        -3919.54833984375,
        746.1367797851562
      ],
      "bbox_max": [
        -1480.3203125,
        -3919.0859375,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985468253493309,
        -0.12711995840072632,
        -0.9900797605514526
      ],
      "plane_d": 329.1951904296875,
      "bbox_min": [
        -1481.1171875,
        -3919.0859375,
        743.75
      ],
      "bbox_max": [
        -1475.09375,
        -3900.4765625,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07633677124977112,
        0.13932090997695923,
        -0.9873005151748657
      ],
      "plane_d": 1172.5740966796875,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.7698974609375,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14307864010334015,
        0.03376353159546852,
        -0.989135205745697
      ],
      "plane_d": 660.594482421875,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.7698974609375,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46843618154525757,
        -0.0949927493929863,
        -0.8783756494522095
      ],
      "plane_d": 976.583740234375,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.7698974609375,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7212948799133301,
        0.1702103167772293,
        -0.6713883280754089
      ],
      "plane_d": 2238.31103515625,
      "bbox_min": [
        -1485.4375,
        -3927.027587890625,
        743.75
      ],
      "bbox_max": [
        -1481.9306640625,
        -3921.78125,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9746323823928833,
        0.1976427286863327,
        -0.10501929372549057
      ],
      "plane_d": 2300.97509765625,
      "bbox_min": [
        -1486.0,
        -3943.0859375,
        740.0
      ],
      "bbox_max": [
        -1481.1171875,
        -3921.0,
        743.7911987304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9617559909820557,
        -0.19336891174316406,
        -0.193994402885437
      ],
      "plane_d": 814.5258178710938,
      "bbox_min": [
        -1486.0,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1448.7698974609375,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9631062746047974,
        -0.19530539214611053,
        -0.18515457212924957
      ],
      "plane_d": 802.3978271484375,
      "bbox_min": [
        -1486.0,
        -3921.690673828125,
        740.0
      ],
      "bbox_max": [
        -1481.1171875,
        -3900.4765625,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7212948799133301,
        0.1702103167772293,
        -0.6713883280754089
      ],
      "plane_d": 2238.31103515625,
      "bbox_min": [
        -1485.378173828125,
        -3933.8515625,
        743.787109375
      ],
      "bbox_max": [
        -1480.3203125,
        -3921.869873046875,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33298537135124207,
        -0.6025449633598328,
        -0.7253002524375916
      ],
      "plane_d": -2295.3662109375,
      "bbox_min": [
        -1481.25,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3332713544368744,
        -0.6082477569580078,
        -0.7203922271728516
      ],
      "plane_d": -2321.639404296875,
      "bbox_min": [
        -1468.15625,
        -3900.4765625,
        740.0
      ],
      "bbox_max": [
        -1452.75,
        -3893.375,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06614244729280472,
        0.14047396183013916,
        -0.9878726005554199
      ],
      "plane_d": 1192.521240234375,
      "bbox_min": [
        -1481.25,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1278020143508911,
        0.233249232172966,
        -0.9639820456504822
      ],
      "plane_d": 1825.97314453125,
      "bbox_min": [
        -1481.25,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3889.5,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11499880999326706,
        0.2442355751991272,
        -0.9628729224205017
      ],
      "plane_d": 1849.50537109375,
      "bbox_min": [
        -1481.1171875,
        -3943.0859375,
        743.75
      ],
      "bbox_max": [
        -1475.09375,
        -3933.8515625,
        746.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3129146099090576,
        -0.5662264227867126,
        0.7625430822372437
      ],
      "plane_d": -2307.57373046875,
      "bbox_min": [
        -1481.25,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3889.5,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3130393326282501,
        -0.5715928673744202,
        0.7584773302078247
      ],
      "plane_d": -2325.295654296875,
      "bbox_min": [
        -1481.25,
        -3901.4140625,
        736.25
      ],
      "bbox_max": [
        -1466.34375,
        -3894.1875,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40097367763519287,
        0.7255714535713196,
        -0.5592549443244934
      ],
      "plane_d": 2693.44140625,
      "bbox_min": [
        -1481.25,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3889.5,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552719712257385,
        0.8604777455329895,
        0.18289855122566223
      ],
      "plane_d": 3963.29150390625,
      "bbox_min": [
        -1481.25,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3889.5,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3404128849506378,
        -0.6159852743148804,
        0.7104092240333557
      ],
      "plane_d": -3420.96337890625,
      "bbox_min": [
        -1481.25,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3889.5,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34038063883781433,
        -0.6215166449546814,
        0.7055906057357788
      ],
      "plane_d": -3438.908447265625,
      "bbox_min": [
        -1466.34375,
        -3901.4140625,
        736.25
      ],
      "bbox_max": [
        -1452.75,
        -3894.1875,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4505375027656555,
        0.815258264541626,
        -0.3638268709182739
      ],
      "plane_d": 4152.47900390625,
      "bbox_min": [
        -1481.25,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3889.5,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4496343731880188,
        0.8206198811531067,
        -0.35272061824798584
      ],
      "plane_d": 4164.07177734375,
      "bbox_min": [
        -1481.25,
        -3950.1875,
        740.0
      ],
      "bbox_max": [
        -1468.15625,
        -3943.0859375,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38596853613853455,
        -0.6984192728996277,
        -0.6026929020881653
      ],
      "plane_d": -1704.293212890625,
      "bbox_min": [
        -1481.25,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3889.5,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3858250081539154,
        -0.7041624784469604,
        -0.5960657596588135
      ],
      "plane_d": -1731.7933349609375,
      "bbox_min": [
        -1481.25,
        -3900.4765625,
        740.0
      ],
      "bbox_max": [
        -1468.15625,
        -3893.375,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39569568634033203,
        0.7221773266792297,
        -0.567348837852478
      ],
      "plane_d": 2693.75830078125,
      "bbox_min": [
        -1479.5390625,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3935.916259765625,
        743.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4709240794181824,
        0.8598818778991699,
        0.1970626264810562
      ],
      "plane_d": 3943.702392578125,
      "bbox_min": [
        -1479.5390625,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3935.916259765625,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48027920722961426,
        0.8769639134407043,
        0.016316518187522888
      ],
      "plane_d": 2749.494140625,
      "bbox_min": [
        -1479.5390625,
        -3952.5,
        734.6875
      ],
      "bbox_max": [
        -1452.75,
        -3935.916259765625,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48343783617019653,
        0.874792218208313,
        0.032037340104579926
      ],
      "plane_d": 2724.70556640625,
      "bbox_min": [
        -1467.0,
        -3952.5,
        736.25
      ],
      "bbox_max": [
        -1452.75,
        -3944.625,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16925770044326782,
        0.309055358171463,
        0.9358614087104797
      ],
      "plane_d": 780.5487060546875,
      "bbox_min": [
        -1479.5390625,
        -3952.0,
        734.6875
      ],
      "bbox_max": [
        -1453.1484375,
        -3935.916259765625,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1533549576997757,
        0.035076506435871124,
        0.9875484704971313
      ],
      "plane_d": -361.819091796875,
      "bbox_min": [
        -1479.5390625,
        -3952.0,
        734.6875
      ],
      "bbox_max": [
        -1453.1484375,
        -3935.916259765625,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4341301918029785,
        0.7926982045173645,
        0.4279724061489105
      ],
      "plane_d": 2181.064453125,
      "bbox_min": [
        -1469.2734375,
        -3952.0,
        734.6875
      ],
      "bbox_max": [
        -1453.1484375,
        -3935.916748046875,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43174082040786743,
        0.888759195804596,
        0.15397071838378906
      ],
      "plane_d": 2765.209228515625,
      "bbox_min": [
        -1462.40625,
        -3949.0,
        734.6875
      ],
      "bbox_max": [
        -1453.1484375,
        -3944.7734375,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5762691497802734,
        0.13180863857269287,
        0.8065608143806458
      ],
      "plane_d": -911.27978515625,
      "bbox_min": [
        -1455.5390625,
        -3945.6640625,
        734.6875
      ],
      "bbox_max": [
        -1453.1484375,
        -3944.7734375,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5762691497802734,
        0.13180863857269287,
        0.8065608143806458
      ],
      "plane_d": -911.27978515625,
      "bbox_min": [
        -1469.2734375,
        -3952.0,
        734.6875
      ],
      "bbox_max": [
        -1453.1484375,
        -3935.916748046875,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14566411077976227,
        0.299856573343277,
        0.9427980184555054
      ],
      "plane_d": 704.4918212890625,
      "bbox_min": [
        -1469.2734375,
        -3952.0,
        734.6875
      ],
      "bbox_max": [
        -1462.40625,
        -3945.6640625,
        736.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1766626238822937,
        0.05505414307117462,
        -0.9827305674552917
      ],
      "plane_d": 1198.790771484375,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17570413649082184,
        0.04018837586045265,
        -0.9836223125457764
      ],
      "plane_d": 1139.3822021484375,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0672343522310257,
        0.18857279419898987,
        -0.9797550439834595
      ],
      "plane_d": 1562.644287109375,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0900174006819725,
        0.18530511856079102,
        -0.9785494208335876
      ],
      "plane_d": 1582.3399658203125,
      "bbox_min": [
        -1472.03125,
        -3966.4375,
        730.5
      ],
      "bbox_max": [
        -1461.3519287109375,
        -3945.6640625,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1016048938035965,
        0.2849721610546112,
        -0.9531355500221252
      ],
      "plane_d": 1677.024169921875,
      "bbox_min": [
        -1472.03125,
        -3966.4375,
        730.5
      ],
      "bbox_max": [
        -1461.3519287109375,
        -3948.48779296875,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1310606449842453,
        0.26979461312294006,
        -0.9539570212364197
      ],
      "plane_d": 1574.6153564453125,
      "bbox_min": [
        -1462.40625,
        -3949.861083984375,
        734.3818969726562
      ],
      "bbox_max": [
        -1461.3519287109375,
        -3948.48779296875,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21473351120948792,
        -0.06691833585500717,
        -0.9743775725364685
      ],
      "plane_d": 768.4892578125,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22300444543361664,
        -0.051007263362407684,
        -0.973482072353363
      ],
      "plane_d": 842.623046875,
      "bbox_min": [
        -1487.8515625,
        -3935.65625,
        730.5
      ],
      "bbox_max": [
        -1468.2955322265625,
        -3925.17333984375,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21536868810653687,
        -0.6040465235710144,
        -0.7672966718673706
      ],
      "plane_d": -1491.1156005859375,
      "bbox_min": [
        -1487.8515625,
        -3926.953125,
        730.5
      ],
      "bbox_max": [
        -1468.2955322265625,
        -3925.17333984375,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2771126925945282,
        -0.5704497694969177,
        -0.7731724381446838
      ],
      "plane_d": -1264.19091796875,
      "bbox_min": [
        -1469.4271240234375,
        -3925.6484375,
        734.4541015625
      ],
      "bbox_max": [
        -1468.2955322265625,
        -3925.17333984375,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1016048938035965,
        0.2849721610546112,
        -0.9531355500221252
      ],
      "plane_d": 1677.024169921875,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2761721909046173,
        0.7858095765113831,
        0.553382396697998
      ],
      "plane_d": 3124.892578125,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8257091641426086,
        0.2573193609714508,
        -0.5019871592521667
      ],
      "plane_d": 2614.424072265625,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486250281333923,
        0.29990893602371216,
        -0.100822813808918
      ],
      "plane_d": -119.86865234375,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8973995447158813,
        -0.2837139368057251,
        0.337906152009964
      ],
      "plane_d": -21.03515625,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27068567276000977,
        0.7821512222290039,
        0.5612207055091858
      ],
      "plane_d": 3096.609130859375,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486770033836365,
        0.29564031958580017,
        -0.11228857934474945
      ],
      "plane_d": -128.4757080078125,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31563204526901245,
        0.8980870842933655,
        -0.30629390478134155
      ],
      "plane_d": 3321.333984375,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32943272590637207,
        -0.9373549222946167,
        0.11331325024366379
      ],
      "plane_d": -3271.576416015625,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8925857543945312,
        -0.2865714430809021,
        0.3480912148952484
      ],
      "plane_d": -46.8106689453125,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31855079531669617,
        0.8934422135353088,
        -0.3166802227497101
      ],
      "plane_d": 3306.200927734375,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2969474196434021,
        0.8449226021766663,
        -0.4448910057544708
      ],
      "plane_d": 4113.37353515625,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30223217606544495,
        0.8476732969284058,
        -0.43601104617118835
      ],
      "plane_d": 4125.64453125,
      "bbox_min": [
        -1487.8515625,
        -3969.0,
        724.5
      ],
      "bbox_max": [
        -1472.03125,
        -3960.796875,
        730.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8393697738647461,
        0.26948606967926025,
        0.47205469012260437
      ],
      "plane_d": 1977.16845703125,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8362443447113037,
        0.2643796503543854,
        0.4804154336452484
      ],
      "plane_d": 1946.290283203125,
      "bbox_min": [
        -1496.5,
        -3962.9375,
        718.5
      ],
      "bbox_max": [
        -1488.375,
        -3944.75,
        724.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8605071902275085,
        -0.26816362142562866,
        -0.43314629793167114
      ],
      "plane_d": 543.6544189453125,
      "bbox_min": [
        -1496.5,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8554150462150574,
        -0.2704404890537262,
        -0.4417317509651184
      ],
      "plane_d": 533.3431396484375,
      "bbox_min": [
        -1496.5,
        -3944.75,
        724.5
      ],
      "bbox_max": [
        -1490.75,
        -3926.5625,
        730.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2868472933769226,
        0.828850507736206,
        0.4803388714790344
      ],
      "plane_d": 2518.955810546875,
      "bbox_min": [
        -1493.6875,
        -3969.0,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28924453258514404,
        0.8230050206184387,
        0.4888765811920166
      ],
      "plane_d": 2486.114013671875,
      "bbox_min": [
        -1473.5,
        -3969.0,
        718.5
      ],
      "bbox_max": [
        -1456.25,
        -3962.9375,
        724.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9339532256126404,
        0.29985278844833374,
        0.194472536444664
      ],
      "plane_d": -312.750244140625,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9331156611442566,
        0.2950056493282318,
        0.20558877289295197
      ],
      "plane_d": -338.70977783203125,
      "bbox_min": [
        -1456.5,
        -3962.9375,
        718.5
      ],
      "bbox_max": [
        -1450.5,
        -3944.75,
        724.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3244481384754181,
        -0.937498927116394,
        0.12581366300582886
      ],
      "plane_d": -3288.54248046875,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3286823034286499,
        -0.9218582510948181,
        -0.2052936553955078
      ],
      "plane_d": -2981.0966796875,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3237157166004181,
        -0.9210879802703857,
        -0.21634496748447418
      ],
      "plane_d": -2977.388427734375,
      "bbox_min": [
        -1490.75,
        -3926.953125,
        724.5
      ],
      "bbox_max": [
        -1473.5,
        -3920.5,
        730.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7019027471542358,
        0.21873700618743896,
        -0.6778542995452881
      ],
      "plane_d": 339.427001953125,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21536868810653687,
        -0.6040465235710144,
        -0.7672966718673706
      ],
      "plane_d": -1491.1156005859375,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4123740792274475,
        -0.8488917946815491,
        0.33065131306648254
      ],
      "plane_d": -4175.6025390625,
      "bbox_min": [
        -1462.40625,
        -3922.824462890625,
        734.382080078125
      ],
      "bbox_max": [
        -1461.3525390625,
        -3922.3125,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1310606449842453,
        0.26979461312294006,
        -0.9539570212364197
      ],
      "plane_d": 1574.6153564453125,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33524972200393677,
        -0.9402779340744019,
        -0.05903339385986328
      ],
      "plane_d": -4137.498046875,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29463881254196167,
        -0.8263760209083557,
        0.47988593578338623
      ],
      "plane_d": -4024.752685546875,
      "bbox_min": [
        -1472.03125,
        -3927.615966796875,
        707.3125
      ],
      "bbox_max": [
        -1455.0889892578125,
        -3921.3125,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9017677307128906,
        -0.39005035161972046,
        -0.18621394038200378
      ],
      "plane_d": -2712.85791015625,
      "bbox_min": [
        -1457.5223388671875,
        -3925.37451171875,
        707.3125
      ],
      "bbox_max": [
        -1456.5565185546875,
        -3924.65625,
        711.8670043945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4123740792274475,
        -0.8488917946815491,
        0.33065131306648254
      ],
      "plane_d": -4175.6025390625,
      "bbox_min": [
        -1461.954345703125,
        -3927.615966796875,
        730.5
      ],
      "bbox_max": [
        -1455.0889892578125,
        -3922.65087890625,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9508699774742126,
        -0.21749018132686615,
        0.2203277349472046
      ],
      "plane_d": -2399.6904296875,
      "bbox_min": [
        -1456.2109375,
        -3927.615966796875,
        730.5
      ],
      "bbox_max": [
        -1455.0889892578125,
        -3925.6484375,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9531833529472351,
        -0.29704466462135315,
        0.056620772927999496
      ],
      "plane_d": -2595.8779296875,
      "bbox_min": [
        -1456.2109375,
        -3943.875,
        707.3125
      ],
      "bbox_max": [
        -1450.9375,
        -3926.953125,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9508699774742126,
        -0.21749018132686615,
        0.2203277349472046
      ],
      "plane_d": -2399.6904296875,
      "bbox_min": [
        -1456.2109375,
        -3935.65625,
        707.3125
      ],
      "bbox_max": [
        -1453.25,
        -3926.953125,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9084702134132385,
        -0.36423513293266296,
        -0.2049747109413147
      ],
      "plane_d": -2607.8671875,
      "bbox_min": [
        -1454.70947265625,
        -3930.855712890625,
        707.3125
      ],
      "bbox_max": [
        -1454.3125,
        -3930.049560546875,
        708.5040893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9176576733589172,
        0.39692336320877075,
        -0.018872221931815147
      ],
      "plane_d": 238.919677734375,
      "bbox_min": [
        -1454.4638671875,
        -3930.855712890625,
        707.3125
      ],
      "bbox_max": [
        -1454.3125,
        -3930.5625,
        708.5040893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.697641909122467,
        0.15956993401050568,
        -0.6984506845474243
      ],
      "plane_d": 127.30731201171875,
      "bbox_min": [
        -1453.379638671875,
        -3943.875,
        730.5
      ],
      "bbox_max": [
        -1450.9375,
        -3935.65625,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.697641909122467,
        0.15956993401050568,
        -0.6984506845474243
      ],
      "plane_d": 127.30731201171875,
      "bbox_min": [
        -1453.4171142578125,
        -3943.875,
        730.5
      ],
      "bbox_max": [
        -1450.9375,
        -3936.22314453125,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9532666206359863,
        -0.3013763725757599,
        0.021327022463083267
      ],
      "plane_d": -2587.01904296875,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        707.3125
      ],
      "bbox_max": [
        -1450.5,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9017677307128906,
        -0.39005035161972046,
        -0.18621394038200378
      ],
      "plane_d": -2712.85791015625,
      "bbox_min": [
        -1456.9739990234375,
        -3931.974609375,
        707.3125
      ],
      "bbox_max": [
        -1454.43505859375,
        -3925.34912109375,
        711.967529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9176576733589172,
        0.39692336320877075,
        -0.018872221931815147
      ],
      "plane_d": 238.919677734375,
      "bbox_min": [
        -1454.92333984375,
        -3931.974609375,
        707.3125
      ],
      "bbox_max": [
        -1454.43505859375,
        -3930.845703125,
        711.967529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9515782594680786,
        -0.3055114448070526,
        0.03407987952232361
      ],
      "plane_d": -2610.03662109375,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        707.3125
      ],
      "bbox_max": [
        -1450.9375,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9176576733589172,
        0.39692336320877075,
        -0.018872221931815147
      ],
      "plane_d": 238.919677734375,
      "bbox_min": [
        -1457.1573486328125,
        -3932.246337890625,
        707.3125
      ],
      "bbox_max": [
        -1454.9036865234375,
        -3925.338134765625,
        712.5606079101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9084702134132385,
        -0.36423513293266296,
        -0.2049747109413147
      ],
      "plane_d": -2607.8671875,
      "bbox_min": [
        -1457.1573486328125,
        -3931.853515625,
        709.2811279296875
      ],
      "bbox_max": [
        -1454.9036865234375,
        -3925.338134765625,
        712.5597534179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9017677307128906,
        -0.39005035161972046,
        -0.18621394038200378
      ],
      "plane_d": -2712.85791015625,
      "bbox_min": [
        -1457.1573486328125,
        -3928.4248046875,
        709.2811279296875
      ],
      "bbox_max": [
        -1455.966552734375,
        -3925.338134765625,
        711.408935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3312089443206787,
        -0.9424089193344116,
        -0.04654068499803543
      ],
      "plane_d": -4149.03173828125,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        707.3125
      ],
      "bbox_max": [
        -1450.9375,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24503350257873535,
        -0.9538804292678833,
        -0.1734091192483902
      ],
      "plane_d": -3977.9794921875,
      "bbox_min": [
        -1464.7220458984375,
        -3925.56689453125,
        707.3125
      ],
      "bbox_max": [
        -1457.0802001953125,
        -3922.6875,
        713.068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2637524902820587,
        -0.9517223238945007,
        -0.15703214704990387
      ],
      "plane_d": -4008.51220703125,
      "bbox_min": [
        -1464.7073974609375,
        -3923.534912109375,
        707.3125
      ],
      "bbox_max": [
        -1462.75146484375,
        -3922.6875,
        709.45849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24836750328540802,
        -0.9668591618537903,
        -0.05913512036204338
      ],
      "plane_d": -3387.117431640625,
      "bbox_min": [
        -1464.7073974609375,
        -3922.78662109375,
        707.3125
      ],
      "bbox_max": [
        -1464.53125,
        -3922.6875,
        708.2042846679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9017677307128906,
        -0.39005035161972046,
        -0.18621394038200378
      ],
      "plane_d": -2712.85791015625,
      "bbox_min": [
        -1464.7220458984375,
        -3925.56689453125,
        707.3125
      ],
      "bbox_max": [
        -1457.0802001953125,
        -3922.6875,
        713.068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24836750328540802,
        -0.9668591618537903,
        -0.05913512036204338
      ],
      "plane_d": -3387.117431640625,
      "bbox_min": [
        -1464.7220458984375,
        -3922.77880859375,
        707.3125
      ],
      "bbox_max": [
        -1464.53125,
        -3922.6875,
        708.0631713867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.697641909122467,
        0.15956993401050568,
        -0.6984506845474243
      ],
      "plane_d": 127.30731201171875,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        707.3125
      ],
      "bbox_max": [
        -1450.9375,
        -3920.5,
        734.6875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9017677307128906,
        -0.39005035161972046,
        -0.18621394038200378
      ],
      "plane_d": -2712.85791015625,
      "bbox_min": [
        -1458.1865234375,
        -3928.08349609375,
        710.2510986328125
      ],
      "bbox_max": [
        -1456.230712890625,
        -3925.300048828125,
        714.1203002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24795998632907867,
        0.8947367072105408,
        0.37143251299858093
      ],
      "plane_d": 3624.429931640625,
      "bbox_min": [
        -1476.605224609375,
        -3941.407958984375,
        707.3125
      ],
      "bbox_max": [
        -1455.5137939453125,
        -3922.736572265625,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23827627301216125,
        0.9275754690170288,
        0.2877989411354065
      ],
      "plane_d": 3100.67138671875,
      "bbox_min": [
        -1476.605224609375,
        -3941.407958984375,
        707.3125
      ],
      "bbox_max": [
        -1455.5137939453125,
        -3922.736572265625,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2547135055065155,
        0.9191060662269592,
        0.3006080090999603
      ],
      "plane_d": 3034.181884765625,
      "bbox_min": [
        -1466.0474853515625,
        -3941.407958984375,
        707.3125
      ],
      "bbox_max": [
        -1458.591796875,
        -3938.4375,
        715.1100463867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.869482159614563,
        0.3760855197906494,
        0.3202504813671112
      ],
      "plane_d": 2533.979248046875,
      "bbox_min": [
        -1476.605224609375,
        -3939.203125,
        707.3125
      ],
      "bbox_max": [
        -1455.5137939453125,
        -3922.736572265625,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9281693696975708,
        0.37213316559791565,
        -0.004303516820073128
      ],
      "plane_d": 115.715087890625,
      "bbox_min": [
        -1476.605224609375,
        -3938.935302734375,
        707.3125
      ],
      "bbox_max": [
        -1455.5137939453125,
        -3922.736572265625,
        714.416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9176576733589172,
        0.39692336320877075,
        -0.018872221931815147
      ],
      "plane_d": 238.919677734375,
      "bbox_min": [
        -1456.8671875,
        -3936.46875,
        707.3125
      ],
      "bbox_max": [
        -1455.5137939453125,
        -3933.0439453125,
        713.5765991210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9052252173423767,
        -0.391545832157135,
        0.16510409116744995
      ],
      "plane_d": -320.7945556640625,
      "bbox_min": [
        -1474.75,
        -3930.5625,
        707.3125
      ],
      "bbox_max": [
        -1458.2923583984375,
        -3922.78662109375,
        713.5650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2663349509239197,
        -0.961040735244751,
        -0.07393573224544525
      ],
      "plane_d": -3327.36181640625,
      "bbox_min": [
        -1473.68115234375,
        -3925.534423828125,
        707.3125
      ],
      "bbox_max": [
        -1458.2923583984375,
        -3922.78662109375,
        713.3759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2637524902820587,
        -0.9517223238945007,
        -0.15703214704990387
      ],
      "plane_d": -4008.51220703125,
      "bbox_min": [
        -1465.58154296875,
        -3925.259033203125,
        708.2042846679688
      ],
      "bbox_max": [
        -1458.2923583984375,
        -3922.78662109375,
        712.7141723632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15720869600772858,
        0.05047304928302765,
        0.9862747192382812
      ],
      "plane_d": -274.8024597167969,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        712.6419677734375
      ],
      "bbox_max": [
        -1451.1875,
        -3920.5,
        724.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23754285275936127,
        -0.07626493275165558,
        0.968378484249115
      ],
      "plane_d": -641.6777954101562,
      "bbox_min": [
        -1493.6875,
        -3943.0,
        712.6940307617188
      ],
      "bbox_max": [
        -1463.3985595703125,
        -3923.28759765625,
        718.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9177009463310242,
        -0.36793604493141174,
        0.149826318025589
      ],
      "plane_d": -198.7901611328125,
      "bbox_min": [
        -1476.8125,
        -3934.98095703125,
        712.6983032226562
      ],
      "bbox_max": [
        -1463.8594970703125,
        -3923.28759765625,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8742392063140869,
        0.3505108058452606,
        0.33592844009399414
      ],
      "plane_d": 2429.21923828125,
      "bbox_min": [
        -1476.8125,
        -3934.98095703125,
        712.6983032226562
      ],
      "bbox_max": [
        -1463.8594970703125,
        -3923.28759765625,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.869482159614563,
        0.3760855197906494,
        0.3202504813671112
      ],
      "plane_d": 2533.979248046875,
      "bbox_min": [
        -1476.8125,
        -3932.866943359375,
        714.39599609375
      ],
      "bbox_max": [
        -1476.3857421875,
        -3932.30517578125,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24836750328540802,
        -0.9668591618537903,
        -0.05913512036204338
      ],
      "plane_d": -3387.117431640625,
      "bbox_min": [
        -1474.2537841796875,
        -3926.77880859375,
        712.6983032226562
      ],
      "bbox_max": [
        -1463.8594970703125,
        -3923.28759765625,
        714.5300903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2637524902820587,
        -0.9517223238945007,
        -0.15703214704990387
      ],
      "plane_d": -4008.51220703125,
      "bbox_min": [
        -1474.2537841796875,
        -3926.77880859375,
        712.6983032226562
      ],
      "bbox_max": [
        -1463.8594970703125,
        -3923.28759765625,
        714.5300903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9052252173423767,
        -0.391545832157135,
        0.16510409116744995
      ],
      "plane_d": -320.7945556640625,
      "bbox_min": [
        -1474.2537841796875,
        -3926.77880859375,
        713.3759765625
      ],
      "bbox_max": [
        -1473.68115234375,
        -3925.534423828125,
        714.5300903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15490055084228516,
        0.06210464611649513,
        0.985975980758667
      ],
      "plane_d": -232.17214965820312,
      "bbox_min": [
        -1493.6875,
        -3943.0,
        712.6940307617188
      ],
      "bbox_max": [
        -1463.3985595703125,
        -3923.63623046875,
        718.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8742392063140869,
        0.3505108058452606,
        0.33592844009399414
      ],
      "plane_d": 2429.21923828125,
      "bbox_min": [
        -1476.8125,
        -3939.203125,
        714.7024536132812
      ],
      "bbox_max": [
        -1474.125,
        -3932.5,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9177009463310242,
        -0.36793604493141174,
        0.149826318025589
      ],
      "plane_d": -198.7901611328125,
      "bbox_min": [
        -1477.366943359375,
        -3932.5,
        712.6940307617188
      ],
      "bbox_max": [
        -1463.3985595703125,
        -3923.63623046875,
        715.3463745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22947680950164795,
        -0.0920046791434288,
        0.968955934047699
      ],
      "plane_d": -715.8993530273438,
      "bbox_min": [
        -1477.366943359375,
        -3932.5,
        715.1875
      ],
      "bbox_max": [
        -1476.5152587890625,
        -3931.7587890625,
        715.3463745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2637524902820587,
        -0.9517223238945007,
        -0.15703214704990387
      ],
      "plane_d": -4008.51220703125,
      "bbox_min": [
        -1464.3990478515625,
        -3923.889404296875,
        712.6940307617188
      ],
      "bbox_max": [
        -1463.3985595703125,
        -3923.63623046875,
        712.840576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24795998632907867,
        0.8947367072105408,
        0.37143251299858093
      ],
      "plane_d": 3624.429931640625,
      "bbox_min": [
        -1474.125,
        -3941.4375,
        712.6419677734375
      ],
      "bbox_max": [
        -1455.493408203125,
        -3923.698974609375,
        715.1875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9176576733589172,
        0.39692336320877075,
        -0.018872221931815147
      ],
      "plane_d": 238.919677734375,
      "bbox_min": [
        -1455.6304931640625,
        -3933.311767578125,
        713.5361938476562
      ],
      "bbox_max": [
        -1455.493408203125,
        -3932.989013671875,
        713.738525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2547135055065155,
        0.9191060662269592,
        0.3006080090999603
      ],
      "plane_d": 3034.181884765625,
      "bbox_min": [
        -1466.0625,
        -3941.4375,
        712.6419677734375
      ],
      "bbox_max": [
        -1457.8890380859375,
        -3923.698974609375,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23827627301216125,
        0.9275754690170288,
        0.2877989411354065
      ],
      "plane_d": 3100.67138671875,
      "bbox_min": [
        -1458.591796875,
        -3939.1474609375,
        714.416015625
      ],
      "bbox_max": [
        -1457.8890380859375,
        -3938.935302734375,
        714.614501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2637524902820587,
        -0.9517223238945007,
        -0.15703214704990387
      ],
      "plane_d": -4008.51220703125,
      "bbox_min": [
        -1464.1514892578125,
        -3925.321533203125,
        712.6419677734375
      ],
      "bbox_max": [
        -1458.1610107421875,
        -3923.698974609375,
        712.8043212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05281984061002731,
        0.15262390673160553,
        0.9868718981742859
      ],
      "plane_d": -181.67800903320312,
      "bbox_min": [
        -1493.6875,
        -3965.0625,
        712.7994384765625
      ],
      "bbox_max": [
        -1451.1875,
        -3920.5,
        724.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37845665216445923,
        0.12150638550519943,
        0.9176092147827148
      ],
      "plane_d": -729.4141235351562,
      "bbox_min": [
        -1466.0625,
        -3959.546875,
        712.7994384765625
      ],
      "bbox_max": [
        -1455.4066162109375,
        -3924.4404296875,
        718.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9176576733589172,
        0.39692336320877075,
        -0.018872221931815147
      ],
      "plane_d": 238.919677734375,
      "bbox_min": [
        -1458.0,
        -3939.34130859375,
        713.7032470703125
      ],
      "bbox_max": [
        -1455.4066162109375,
        -3932.754638671875,
        715.3079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36534762382507324,
        0.14647971093654633,
        0.919274091720581
      ],
      "plane_d": -613.1168823242188,
      "bbox_min": [
        -1458.0,
        -3939.34130859375,
        715.1875
      ],
      "bbox_max": [
        -1457.741455078125,
        -3938.558349609375,
        715.3079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2547135055065155,
        0.9191060662269592,
        0.3006080090999603
      ],
      "plane_d": 3034.181884765625,
      "bbox_min": [
        -1459.30029296875,
        -3939.396484375,
        712.7994384765625
      ],
      "bbox_max": [
        -1457.9117431640625,
        -3925.04541015625,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23827627301216125,
        0.9275754690170288,
        0.2877989411354065
      ],
      "plane_d": 3100.67138671875,
      "bbox_min": [
        -1458.4752197265625,
        -3939.203125,
        714.5735473632812
      ],
      "bbox_max": [
        -1457.9117431640625,
        -3938.989990234375,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24503350257873535,
        -0.9538804292678833,
        -0.1734091192483902
      ],
      "plane_d": -3977.9794921875,
      "bbox_min": [
        -1459.23779296875,
        -3925.409912109375,
        712.7994384765625
      ],
      "bbox_max": [
        -1458.0556640625,
        -3925.04541015625,
        713.1372680664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043626781553030014,
        0.1574225127696991,
        0.9865672588348389
      ],
      "plane_d": -149.06915283203125,
      "bbox_min": [
        -1466.0625,
        -3959.546875,
        712.8023071289062
      ],
      "bbox_max": [
        -1456.5,
        -3924.4404296875,
        718.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2547135055065155,
        0.9191060662269592,
        0.3006080090999603
      ],
      "plane_d": 3034.181884765625,
      "bbox_min": [
        -1466.0625,
        -3941.4375,
        712.8023071289062
      ],
      "bbox_max": [
        -1458.0,
        -3924.8359375,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24503350257873535,
        -0.9538804292678833,
        -0.1734091192483902
      ],
      "plane_d": -3977.9794921875,
      "bbox_min": [
        -1460.048583984375,
        -3925.11279296875,
        712.8023071289062
      ],
      "bbox_max": [
        -1459.0390625,
        -3924.8359375,
        712.8931884765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24503350257873535,
        -0.9538804292678833,
        -0.1734091192483902
      ],
      "plane_d": -3977.9794921875,
      "bbox_min": [
        -1459.9705810546875,
        -3925.253662109375,
        712.8114013671875
      ],
      "bbox_max": [
        -1458.6248779296875,
        -3924.858642578125,
        713.0827026367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37845665216445923,
        0.12150638550519943,
        0.9176092147827148
      ],
      "plane_d": -729.4141235351562,
      "bbox_min": [
        -1493.6875,
        -3959.546875,
        712.8043212890625
      ],
      "bbox_max": [
        -1451.1875,
        -3920.5,
        724.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9281693696975708,
        0.37213316559791565,
        -0.004303516820073128
      ],
      "plane_d": 115.715087890625,
      "bbox_min": [
        -1457.741455078125,
        -3938.558349609375,
        714.4149169921875
      ],
      "bbox_max": [
        -1455.3125,
        -3932.5,
        715.1875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9084702134132385,
        -0.36423513293266296,
        -0.2049747109413147
      ],
      "plane_d": -2607.8671875,
      "bbox_min": [
        -1458.6248779296875,
        -3932.5,
        713.0827026367188
      ],
      "bbox_max": [
        -1455.3125,
        -3925.253662109375,
        715.346435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8769991993904114,
        -0.35161736607551575,
        0.32747167348861694
      ],
      "plane_d": -2893.246826171875,
      "bbox_min": [
        -1455.60986328125,
        -3932.5,
        715.1875
      ],
      "bbox_max": [
        -1455.3125,
        -3931.75830078125,
        715.346435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24503350257873535,
        -0.9538804292678833,
        -0.1734091192483902
      ],
      "plane_d": -3977.9794921875,
      "bbox_min": [
        -1458.6248779296875,
        -3925.47265625,
        713.0827026367188
      ],
      "bbox_max": [
        -1457.9808349609375,
        -3925.253662109375,
        713.377197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2663349509239197,
        -0.961040735244751,
        -0.07393573224544525
      ],
      "plane_d": -3327.36181640625,
      "bbox_min": [
        -1476.4500732421875,
        -3931.603515625,
        712.8405151367188
      ],
      "bbox_max": [
        -1464.3988037109375,
        -3923.32177734375,
        715.169189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9177009463310242,
        -0.36793604493141174,
        0.149826318025589
      ],
      "plane_d": -198.7901611328125,
      "bbox_min": [
        -1476.4500732421875,
        -3931.603515625,
        712.8405151367188
      ],
      "bbox_max": [
        -1464.3988037109375,
        -3923.32177734375,
        715.169189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2637524902820587,
        -0.9517223238945007,
        -0.15703214704990387
      ],
      "plane_d": -4008.51220703125,
      "bbox_min": [
        -1474.1771240234375,
        -3926.19482421875,
        712.8405151367188
      ],
      "bbox_max": [
        -1464.3988037109375,
        -3923.32177734375,
        715.0523681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9052252173423767,
        -0.391545832157135,
        0.16510409116744995
      ],
      "plane_d": -320.7945556640625,
      "bbox_min": [
        -1474.1771240234375,
        -3926.19482421875,
        714.4679565429688
      ],
      "bbox_max": [
        -1473.94873046875,
        -3925.692626953125,
        715.0523681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32473787665367126,
        -0.9383360743522644,
        0.11861982941627502
      ],
      "plane_d": -4242.54150390625,
      "bbox_min": [
        -1488.375,
        -3932.2099609375,
        712.8043212890625
      ],
      "bbox_max": [
        -1455.3695068359375,
        -3920.5,
        724.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24836750328540802,
        -0.9668591618537903,
        -0.05913512036204338
      ],
      "plane_d": -3387.117431640625,
      "bbox_min": [
        -1466.621826171875,
        -3926.68505859375,
        712.8043212890625
      ],
      "bbox_max": [
        -1456.5,
        -3923.3388671875,
        718.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2664143145084381,
        -0.9613271951675415,
        -0.06981116533279419
      ],
      "plane_d": -4112.47900390625,
      "bbox_min": [
        -1466.0625,
        -3926.68505859375,
        712.8043212890625
      ],
      "bbox_max": [
        -1456.5,
        -3923.3388671875,
        718.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24503350257873535,
        -0.9538804292678833,
        -0.1734091192483902
      ],
      "plane_d": -3977.9794921875,
      "bbox_min": [
        -1466.0625,
        -3925.796875,
        712.8043212890625
      ],
      "bbox_max": [
        -1457.7535400390625,
        -3923.3388671875,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9017677307128906,
        -0.39005035161972046,
        -0.18621394038200378
      ],
      "plane_d": -2712.85791015625,
      "bbox_min": [
        -1458.0,
        -3925.796875,
        713.906982421875
      ],
      "bbox_max": [
        -1457.7535400390625,
        -3925.611328125,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8769991993904114,
        -0.35161736607551575,
        0.32747167348861694
      ],
      "plane_d": -2893.246826171875,
      "bbox_min": [
        -1458.0,
        -3926.68505859375,
        713.9490356445312
      ],
      "bbox_max": [
        -1456.5,
        -3925.775390625,
        718.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9084702134132385,
        -0.36423513293266296,
        -0.2049747109413147
      ],
      "plane_d": -2607.8671875,
      "bbox_min": [
        -1458.0,
        -3926.68505859375,
        714.1203002929688
      ],
      "bbox_max": [
        -1457.4127197265625,
        -3925.796875,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3270447850227356,
        -0.9450019598007202,
        -0.00359973032027483
      ],
      "plane_d": -4184.26025390625,
      "bbox_min": [
        -1488.375,
        -3932.2099609375,
        713.388916015625
      ],
      "bbox_max": [
        -1455.3695068359375,
        -3920.5,
        724.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33155137300491333,
        -0.9433832764625549,
        0.010076137259602547
      ],
      "plane_d": -4194.375,
      "bbox_min": [
        -1473.5,
        -3926.5625,
        718.5
      ],
      "bbox_max": [
        -1456.25,
        -3920.5,
        724.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20735463500022888,
        -0.5991551280021667,
        0.7733157277107239
      ],
      "plane_d": -2599.560546875,
      "bbox_min": [
        -1488.375,
        -3932.2099609375,
        713.388916015625
      ],
      "bbox_max": [
        -1455.3695068359375,
        -3920.9375,
        718.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2663349509239197,
        -0.961040735244751,
        -0.07393573224544525
      ],
      "plane_d": -3327.36181640625,
      "bbox_min": [
        -1474.1798095703125,
        -3925.987548828125,
        713.388916015625
      ],
      "bbox_max": [
        -1466.187744140625,
        -3923.570068359375,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9177009463310242,
        -0.36793604493141174,
        0.149826318025589
      ],
      "plane_d": -198.7901611328125,
      "bbox_min": [
        -1474.1798095703125,
        -3925.987548828125,
        715.0494384765625
      ],
      "bbox_max": [
        -1474.0911865234375,
        -3925.77685546875,
        715.1875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22947680950164795,
        -0.0920046791434288,
        0.968955934047699
      ],
      "plane_d": -715.8993530273438,
      "bbox_min": [
        -1488.375,
        -3932.2099609375,
        714.1630249023438
      ],
      "bbox_max": [
        -1455.3695068359375,
        -3920.9375,
        718.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9177009463310242,
        -0.36793604493141174,
        0.149826318025589
      ],
      "plane_d": -198.7901611328125,
      "bbox_min": [
        -1476.5152587890625,
        -3931.7587890625,
        715.0545654296875
      ],
      "bbox_max": [
        -1474.125,
        -3925.796875,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16460548341274261,
        -0.5939610004425049,
        0.7874740362167358
      ],
      "plane_d": -2652.312744140625,
      "bbox_min": [
        -1474.125,
        -3932.2099609375,
        714.1630249023438
      ],
      "bbox_max": [
        -1455.3695068359375,
        -3920.9375,
        718.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2663349509239197,
        -0.961040735244751,
        -0.07393573224544525
      ],
      "plane_d": -3327.36181640625,
      "bbox_min": [
        -1474.125,
        -3925.796875,
        714.784912109375
      ],
      "bbox_max": [
        -1466.0625,
        -3923.5625,
        715.1875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9084702134132385,
        -0.36423513293266296,
        -0.2049747109413147
      ],
      "plane_d": -2607.8671875,
      "bbox_min": [
        -1457.7412109375,
        -3931.75830078125,
        714.1630249023438
      ],
      "bbox_max": [
        -1455.60986328125,
        -3926.442138671875,
        715.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0019376554992049932,
        -0.16185809671878815,
        0.986812174320221
      ],
      "plane_d": -1314.5433349609375,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.006553501822054386,
        -0.16748885810375214,
        0.9858521223068237
      ],
      "plane_d": -1329.19189453125,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18019546568393707,
        0.9461699724197388,
        -0.26887190341949463
      ],
      "plane_d": 4184.451171875,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11765758693218231,
        -0.9214613437652588,
        -0.37022385001182556
      ],
      "plane_d": -3174.705322265625,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.029871653765439987,
        -0.39041465520858765,
        -0.920154333114624
      ],
      "plane_d": -836.8900756835938,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2624799311161041,
        -0.9374282956123352,
        -0.22876274585723877
      ],
      "plane_d": -3892.44091796875,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26568931341171265,
        0.9488904476165771,
        -0.17034120857715607
      ],
      "plane_d": 3474.0751953125,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12868881225585938,
        0.9806114435195923,
        -0.147785022854805
      ],
      "plane_d": 4159.74951171875,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.046708062291145325,
        -0.975179135799408,
        -0.21643495559692383
      ],
      "plane_d": -3596.98583984375,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08262120932340622,
        0.5292174220085144,
        -0.8444540500640869
      ],
      "plane_d": 2802.583984375,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29177701473236084,
        -0.11658614128828049,
        -0.949354350566864
      ],
      "plane_d": -211.0938720703125,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26056161522865295,
        -0.9370196461677551,
        -0.23259812593460083
      ],
      "plane_d": -3885.3603515625,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2638090252876282,
        0.9486978650093079,
        -0.1742907017469406
      ],
      "plane_d": 3478.8203125,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09887856245040894,
        -0.35558247566223145,
        -0.9293999075889587
      ],
      "plane_d": -882.2156982421875,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31587088108062744,
        0.12621335685253143,
        -0.9403700828552246
      ],
      "plane_d": 701.8499755859375,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7437391877174377,
        0.29513460397720337,
        0.5997896790504456
      ],
      "plane_d": -331.9893798828125,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7437391877174377,
        -0.29513460397720337,
        0.5997896790504456
      ],
      "plane_d": -2651.3046875,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12733206152915955,
        0.45790573954582214,
        -0.8798345327377319
      ],
      "plane_d": 2239.34375,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02009190246462822,
        0.16182571649551392,
        0.9866148233413696
      ],
      "plane_d": -16.044567108154297,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.015833238139748573,
        0.16747146844863892,
        0.9857497811317444
      ],
      "plane_d": 0.5133323669433594,
      "bbox_min": [
        -1475.689697265625,
        -3939.5546875,
        690.5
      ],
      "bbox_max": [
        -1461.25,
        -3928.46435546875,
        692.4765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24147915840148926,
        0.16253572702407837,
        0.9566975235939026
      ],
      "plane_d": 334.0849914550781,
      "bbox_min": [
        -1475.689697265625,
        -3939.5546875,
        690.625
      ],
      "bbox_max": [
        -1475.3125,
        -3928.46435546875,
        692.4765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020331501960754395,
        -0.16745783388614655,
        0.9856695532798767
      ],
      "plane_d": -1308.616943359375,
      "bbox_min": [
        -1475.689697265625,
        -3928.65625,
        690.625
      ],
      "bbox_max": [
        -1475.3125,
        -3928.464599609375,
        690.665283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020331501960754395,
        -0.16745783388614655,
        0.9856695532798767
      ],
      "plane_d": -1308.616943359375,
      "bbox_min": [
        -1475.5933837890625,
        -3928.65625,
        690.625
      ],
      "bbox_max": [
        -1475.3125,
        -3928.46435546875,
        690.663330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28186365962028503,
        -0.12191721051931381,
        -0.9516770243644714
      ],
      "plane_d": -215.98800659179688,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07803153991699219,
        -0.3037656545639038,
        -0.9495460391044617
      ],
      "plane_d": -405.67236328125,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020331501960754395,
        -0.16745783388614655,
        0.9856695532798767
      ],
      "plane_d": -1308.616943359375,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5672225952148438,
        0.36361002922058105,
        0.7389494180679321
      ],
      "plane_d": 96.1610107421875,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5672225952148438,
        -0.36361002922058105,
        0.7389494180679321
      ],
      "plane_d": -2761.2685546875,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18699008226394653,
        -0.15900349617004395,
        0.9694083333015442
      ],
      "plane_d": -1567.380126953125,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.5
      ],
      "bbox_max": [
        -1442.5,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13308829069137573,
        -0.22181592881679535,
        0.9659633040428162
      ],
      "plane_d": -1733.043212890625,
      "bbox_min": [
        -1461.25,
        -3931.110107421875,
        690.5
      ],
      "bbox_max": [
        -1447.1875,
        -3920.5,
        693.9444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13308829069137573,
        0.22181592881679535,
        0.9659633636474609
      ],
      "plane_d": 10.09722900390625,
      "bbox_min": [
        -1461.25,
        -3931.110107421875,
        690.5
      ],
      "bbox_max": [
        -1447.1875,
        -3929.25,
        692.7578735351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13308829069137573,
        0.22181592881679535,
        0.9659633636474609
      ],
      "plane_d": 10.09722900390625,
      "bbox_min": [
        -1461.25,
        -3938.0,
        690.5
      ],
      "bbox_max": [
        -1447.9625244140625,
        -3929.25,
        693.9444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8938567638397217,
        -0.3571607172489166,
        -0.2710281312465668
      ],
      "plane_d": -2503.5166015625,
      "bbox_min": [
        -1444.20263671875,
        -3929.4375,
        698.25
      ],
      "bbox_max": [
        -1442.5,
        -3929.25,
        704.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8938567638397217,
        -0.3571607172489166,
        -0.2710281312465668
      ],
      "plane_d": -2503.5166015625,
      "bbox_min": [
        -1448.5703125,
        -3929.399658203125,
        698.25
      ],
      "bbox_max": [
        -1442.5,
        -3918.46875,
        704.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30869561433792114,
        0.7874838709831238,
        0.5334568023681641
      ],
      "plane_d": 2283.05615234375,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.665283203125
      ],
      "bbox_max": [
        -1447.1875,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19909551739692688,
        0.7110554575920105,
        0.6743597984313965
      ],
      "plane_d": 2043.313720703125,
      "bbox_min": [
        -1461.25,
        -3945.0,
        693.9444580078125
      ],
      "bbox_max": [
        -1447.1875,
        -3938.0,
        698.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09087786078453064,
        0.833444356918335,
        0.5450796484947205
      ],
      "plane_d": 3040.01806640625,
      "bbox_min": [
        -1503.0,
        -3945.0,
        690.665283203125
      ],
      "bbox_max": [
        -1447.1875,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.097518190741539,
        0.8239725828170776,
        0.5581750273704529
      ],
      "plane_d": 3003.32470703125,
      "bbox_min": [
        -1475.3125,
        -3945.0,
        692.4375
      ],
      "bbox_max": [
        -1461.25,
        -3941.0625,
        698.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30869561433792114,
        -0.7874839305877686,
        0.5334568619728088
      ],
      "plane_d": -3905.38623046875,
      "bbox_min": [
        -1503.0,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1447.1875,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19909550249576569,
        -0.7110553979873657,
        0.6743597984313965
      ],
      "plane_d": -3544.515380859375,
      "bbox_min": [
        -1461.25,
        -3920.5,
        693.9444580078125
      ],
      "bbox_max": [
        -1447.1875,
        -3913.5,
        698.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020578935742378235,
        -0.8367301821708679,
        0.5472285747528076
      ],
      "plane_d": -3626.688720703125,
      "bbox_min": [
        -1503.0,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1448.5703125,
        -3913.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.028061026707291603,
        -0.8275926113128662,
        0.560627281665802
      ],
      "plane_d": -3589.23779296875,
      "bbox_min": [
        -1475.3125,
        -3917.4375,
        692.4375
      ],
      "bbox_max": [
        -1461.25,
        -3913.5,
        698.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30636030435562134,
        0.13251300156116486,
        -0.9426472187042236
      ],
      "plane_d": 742.05322265625,
      "bbox_min": [
        -1503.0,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1448.5703125,
        -3914.125,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11300017684698105,
        0.43989354372024536,
        -0.8909121751785278
      ],
      "plane_d": 2528.138916015625,
      "bbox_min": [
        -1503.0,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1456.8671875,
        -3914.125,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09045987576246262,
        -0.3521473705768585,
        -0.9315627813339233
      ],
      "plane_d": -854.939453125,
      "bbox_min": [
        -1503.0,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1456.8671875,
        -3914.125,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11627884209156036,
        0.45265692472457886,
        -0.8840705752372742
      ],
      "plane_d": 2237.781005859375,
      "bbox_min": [
        -1503.0,
        -3944.0625,
        690.665283203125
      ],
      "bbox_max": [
        -1456.8671875,
        -3914.125,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1687573939561844,
        -0.31558758020401,
        0.9337694644927979
      ],
      "plane_d": -1632.4189453125,
      "bbox_min": [
        -1503.0,
        -3943.1875,
        690.665283203125
      ],
      "bbox_max": [
        -1472.1953125,
        -3914.125,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17073573172092438,
        -0.3115845322608948,
        0.9347536563873291
      ],
      "plane_d": -1614.43212890625,
      "bbox_min": [
        -1503.0,
        -3943.1875,
        690.665283203125
      ],
      "bbox_max": [
        -1472.1953125,
        -3914.125,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1687573939561844,
        0.31558758020401,
        0.9337694644927979
      ],
      "plane_d": 844.7857666015625,
      "bbox_min": [
        -1503.0,
        -3943.1875,
        690.665283203125
      ],
      "bbox_max": [
        -1472.1953125,
        -3914.125,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24147915840148926,
        0.16253572702407837,
        0.9566975235939026
      ],
      "plane_d": 334.0849914550781,
      "bbox_min": [
        -1478.451416015625,
        -3940.314697265625,
        691.6055297851562
      ],
      "bbox_max": [
        -1475.3125,
        -3934.227294921875,
        693.6384887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7706506252288818,
        0.5916789770126343,
        0.2366715967655182
      ],
      "plane_d": 3304.0126953125,
      "bbox_min": [
        -1478.451416015625,
        -3940.314697265625,
        692.4765625
      ],
      "bbox_max": [
        -1475.3125,
        -3935.50830078125,
        693.6384887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7667779922485352,
        0.5372213125228882,
        0.3513472378253937
      ],
      "plane_d": 3004.350341796875,
      "bbox_min": [
        -1476.6348876953125,
        -3940.314697265625,
        692.4765625
      ],
      "bbox_max": [
        -1475.3125,
        -3938.09228515625,
        693.6384887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17073573172092438,
        0.3115845322608948,
        0.9347536563873291
      ],
      "plane_d": 831.3506469726562,
      "bbox_min": [
        -1503.0,
        -3943.1875,
        690.665283203125
      ],
      "bbox_max": [
        -1472.1953125,
        -3914.125,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04210839793086052,
        0.2674064636230469,
        0.9626632928848267
      ],
      "plane_d": 446.2228088378906,
      "bbox_min": [
        -1503.0,
        -3943.1875,
        690.665283203125
      ],
      "bbox_max": [
        -1472.1953125,
        -3914.125,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.022897079586982727,
        0.31667372584342957,
        0.948258101940155
      ],
      "plane_d": 621.0333862304688,
      "bbox_min": [
        -1494.5211181640625,
        -3941.830322265625,
        690.665283203125
      ],
      "bbox_max": [
        -1475.3125,
        -3924.420166015625,
        695.9558715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24147915840148926,
        0.16253572702407837,
        0.9566975235939026
      ],
      "plane_d": 334.0849914550781,
      "bbox_min": [
        -1483.5,
        -3941.830322265625,
        690.665283203125
      ],
      "bbox_max": [
        -1475.3125,
        -3924.5,
        695.9558715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23230266571044922,
        0.26032206416130066,
        0.9371594190597534
      ],
      "plane_d": 718.209228515625,
      "bbox_min": [
        -1483.5,
        -3929.0,
        690.665283203125
      ],
      "bbox_max": [
        -1475.588134765625,
        -3924.5,
        692.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7706506252288818,
        0.5916789770126343,
        0.2366715967655182
      ],
      "plane_d": 3304.0126953125,
      "bbox_min": [
        -1483.5,
        -3941.830322265625,
        692.5814208984375
      ],
      "bbox_max": [
        -1475.3125,
        -3929.0,
        695.9558715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7667779922485352,
        0.5372213125228882,
        0.3513472378253937
      ],
      "plane_d": 3004.350341796875,
      "bbox_min": [
        -1479.0841064453125,
        -3941.830322265625,
        693.1264038085938
      ],
      "bbox_max": [
        -1475.3125,
        -3935.383544921875,
        695.9558715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03725166991353035,
        -0.3168686032295227,
        0.9477375745773315
      ],
      "plane_d": -1843.6485595703125,
      "bbox_min": [
        -1494.5211181640625,
        -3924.75,
        691.5
      ],
      "bbox_max": [
        -1483.5,
        -3924.420166015625,
        691.9595336914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03725166991353035,
        -0.3168686032295227,
        0.9477375745773315
      ],
      "plane_d": -1843.6485595703125,
      "bbox_min": [
        -1494.5126953125,
        -3924.5,
        691.5
      ],
      "bbox_max": [
        -1475.3125,
        -3917.410888671875,
        693.037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766676664352417,
        -0.8971255421638489,
        0.35885024070739746
      ],
      "plane_d": -3383.0771484375,
      "bbox_min": [
        -1483.5,
        -3920.0,
        692.4765625
      ],
      "bbox_max": [
        -1475.3125,
        -3917.410888671875,
        693.0069580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3259982168674469,
        -0.7911874651908875,
        0.5174433588981628
      ],
      "plane_d": -2977.049072265625,
      "bbox_min": [
        -1476.255859375,
        -3917.84326171875,
        692.4765625
      ],
      "bbox_max": [
        -1475.3125,
        -3917.410888671875,
        693.0069580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13298223912715912,
        -0.9202303290367126,
        0.3680921196937561
      ],
      "plane_d": -3665.01953125,
      "bbox_min": [
        -1503.0,
        -3943.1875,
        692.75
      ],
      "bbox_max": [
        -1472.1953125,
        -3914.125,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3259982168674469,
        -0.7911874651908875,
        0.5174433588981628
      ],
      "plane_d": -2977.049072265625,
      "bbox_min": [
        -1503.0,
        -3921.1875,
        692.75
      ],
      "bbox_max": [
        -1475.3125,
        -3914.125,
        701.2632446289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05531502515077591,
        -0.9472308158874512,
        0.3157435655593872
      ],
      "plane_d": -3850.4423828125,
      "bbox_min": [
        -1503.0,
        -3921.1875,
        692.75
      ],
      "bbox_max": [
        -1476.255859375,
        -3917.84326171875,
        699.0470581054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1107676699757576,
        -0.9453705549240112,
        0.3066026568412781
      ],
      "plane_d": -3753.927734375,
      "bbox_min": [
        -1503.0,
        -3921.1875,
        692.75
      ],
      "bbox_max": [
        -1476.255859375,
        -3917.84326171875,
        696.599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05635448172688484,
        -0.9484681487083435,
        0.31182095408439636
      ],
      "plane_d": -3851.007080078125,
      "bbox_min": [
        -1503.0,
        -3921.1875,
        692.75
      ],
      "bbox_max": [
        -1476.255859375,
        -3917.84326171875,
        696.599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766676664352417,
        -0.8971255421638489,
        0.35885024070739746
      ],
      "plane_d": -3383.0771484375,
      "bbox_min": [
        -1483.5,
        -3920.0,
        692.75
      ],
      "bbox_max": [
        -1476.255859375,
        -3917.84326171875,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05465400218963623,
        -0.9485185742378235,
        -0.31197038292884827
      ],
      "plane_d": -3582.535888671875,
      "bbox_min": [
        -1503.0,
        -3920.299072265625,
        696.599609375
      ],
      "bbox_max": [
        -1494.1556396484375,
        -3920.0,
        699.0470581054688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4923037588596344,
        -0.8081678748130798,
        -0.3232671618461609
      ],
      "plane_d": -2211.3173828125,
      "bbox_min": [
        -1483.5,
        -3920.0,
        696.5
      ],
      "bbox_max": [
        -1479.0975341796875,
        -3916.841064453125,
        700.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40387651324272156,
        -0.09949204325675964,
        -0.9093872308731079
      ],
      "plane_d": 847.333984375,
      "bbox_min": [
        -1480.1065673828125,
        -3921.223876953125,
        702.9779052734375
      ],
      "bbox_max": [
        -1474.1915283203125,
        -3916.885009765625,
        706.0504150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5069491863250732,
        -0.12048893421888351,
        -0.8535131812095642
      ],
      "plane_d": 877.9398193359375,
      "bbox_min": [
        -1480.1065673828125,
        -3921.01123046875,
        702.9779052734375
      ],
      "bbox_max": [
        -1476.7149658203125,
        -3916.885009765625,
        704.5180053710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15920408070087433,
        -0.31219449639320374,
        -0.9365835785865784
      ],
      "plane_d": -806.2449951171875,
      "bbox_min": [
        -1503.0,
        -3923.14208984375,
        696.891357421875
      ],
      "bbox_max": [
        -1493.8817138671875,
        -3920.035400390625,
        702.3635864257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05465400218963623,
        -0.9485185742378235,
        -0.31197038292884827
      ],
      "plane_d": -3582.535888671875,
      "bbox_min": [
        -1501.250244140625,
        -3921.1875,
        696.891357421875
      ],
      "bbox_max": [
        -1493.8817138671875,
        -3920.035400390625,
        700.162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12899142503738403,
        -0.9377398490905762,
        -0.32249829173088074
      ],
      "plane_d": -3258.5546875,
      "bbox_min": [
        -1503.0,
        -3943.1875,
        692.75
      ],
      "bbox_max": [
        -1472.1953125,
        -3918.5,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15920408070087433,
        -0.31219449639320374,
        -0.9365835785865784
      ],
      "plane_d": -806.2449951171875,
      "bbox_min": [
        -1503.0,
        -3923.205810546875,
        696.599609375
      ],
      "bbox_max": [
        -1493.8817138671875,
        -3920.0,
        702.3848266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05465400218963623,
        -0.9485185742378235,
        -0.31197038292884827
      ],
      "plane_d": -3582.535888671875,
      "bbox_min": [
        -1495.2076416015625,
        -3921.1875,
        696.599609375
      ],
      "bbox_max": [
        -1493.8817138671875,
        -3920.0,
        700.162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08551756292581558,
        0.9432168006896973,
        -0.32098114490509033
      ],
      "plane_d": 4057.742431640625,
      "bbox_min": [
        -1503.0,
        -3930.5,
        692.7898559570312
      ],
      "bbox_max": [
        -1483.5,
        -3920.480712890625,
        702.8997192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.053676117211580276,
        0.9473156332969666,
        -0.31577184796333313
      ],
      "plane_d": 3862.257568359375,
      "bbox_min": [
        -1503.0,
        -3929.5,
        696.1762084960938
      ],
      "bbox_max": [
        -1493.8817138671875,
        -3926.78515625,
        702.22119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05465400218963623,
        0.9485185742378235,
        -0.31197038292884827
      ],
      "plane_d": 3862.86083984375,
      "bbox_min": [
        -1503.0,
        -3929.5,
        696.1762084960938
      ],
      "bbox_max": [
        -1493.8817138671875,
        -3926.78515625,
        702.22119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15920408070087433,
        0.31219446659088135,
        -0.9365835189819336
      ],
      "plane_d": 1644.32568359375,
      "bbox_min": [
        -1503.0,
        -3929.5,
        696.1762084960938
      ],
      "bbox_max": [
        -1493.8817138671875,
        -3926.78515625,
        702.22119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055315032601356506,
        0.947230875492096,
        0.315743625164032
      ],
      "plane_d": 3584.84619140625,
      "bbox_min": [
        -1503.0,
        -3929.5,
        696.1762084960938
      ],
      "bbox_max": [
        -1494.1556396484375,
        -3928.84228515625,
        698.1490478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06449536979198456,
        0.9265435934066772,
        -0.37061744928359985
      ],
      "plane_d": 3995.593505859375,
      "bbox_min": [
        -1503.0,
        -3930.5,
        692.7898559570312
      ],
      "bbox_max": [
        -1483.5,
        -3920.480712890625,
        702.8997192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09023689478635788,
        0.9246887564659119,
        0.3698755204677582
      ],
      "plane_d": 3510.7373046875,
      "bbox_min": [
        -1503.0,
        -3930.5,
        692.7898559570312
      ],
      "bbox_max": [
        -1483.5,
        -3920.480712890625,
        702.8997192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05635448172688484,
        0.9484681487083435,
        0.31182095408439636
      ],
      "plane_d": 3593.99365234375,
      "bbox_min": [
        -1503.0,
        -3929.5,
        693.037109375
      ],
      "bbox_max": [
        -1494.1556396484375,
        -3928.3125,
        696.599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055315032601356506,
        0.947230875492096,
        0.315743625164032
      ],
      "plane_d": 3584.84619140625,
      "bbox_min": [
        -1503.0,
        -3929.5,
        694.6263427734375
      ],
      "bbox_max": [
        -1494.1556396484375,
        -3928.32568359375,
        696.599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15748168528079987,
        -0.3159121870994568,
        -0.9356275796890259
      ],
      "plane_d": -818.9189453125,
      "bbox_min": [
        -1503.0,
        -3929.0,
        700.162109375
      ],
      "bbox_max": [
        -1483.5,
        -3920.480712890625,
        702.8997192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15920408070087433,
        -0.31219449639320374,
        -0.9365835785865784
      ],
      "plane_d": -806.2449951171875,
      "bbox_min": [
        -1503.0,
        -3927.484375,
        700.162109375
      ],
      "bbox_max": [
        -1484.1671142578125,
        -3920.480712890625,
        702.88671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0387420654296875,
        -0.267442911863327,
        -0.9627945423126221
      ],
      "plane_d": -316.7054748535156,
      "bbox_min": [
        -1493.8817138671875,
        -3927.484375,
        700.162109375
      ],
      "bbox_max": [
        -1484.1671142578125,
        -3920.480712890625,
        701.471435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.021532606333494186,
        -0.31565773487091064,
        -0.948628842830658
      ],
      "plane_d": -541.39208984375,
      "bbox_min": [
        -1493.8817138671875,
        -3925.01220703125,
        700.162109375
      ],
      "bbox_max": [
        -1485.42724609375,
        -3921.1875,
        701.471435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0061861262656748295,
        0.3160790205001831,
        -0.9487127661705017
      ],
      "plane_d": 1915.1512451171875,
      "bbox_min": [
        -1493.7904052734375,
        -3925.01220703125,
        701.268798828125
      ],
      "bbox_max": [
        -1485.42724609375,
        -3924.54736328125,
        701.471435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.025872355327010155,
        0.26755428314208984,
        -0.9631953835487366
      ],
      "plane_d": 1764.0799560546875,
      "bbox_min": [
        -1492.7840576171875,
        -3927.484375,
        700.653076171875
      ],
      "bbox_max": [
        -1484.1671142578125,
        -3924.606201171875,
        701.4519653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0061861262656748295,
        0.3160790205001831,
        -0.9487127661705017
      ],
      "plane_d": 1915.1512451171875,
      "bbox_min": [
        -1492.7840576171875,
        -3926.21484375,
        700.898193359375
      ],
      "bbox_max": [
        -1485.205078125,
        -3924.606201171875,
        701.4519653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15748168528079987,
        0.3159121870994568,
        -0.9356275796890259
      ],
      "plane_d": 1660.833740234375,
      "bbox_min": [
        -1503.0,
        -3929.0,
        700.162109375
      ],
      "bbox_max": [
        -1483.5,
        -3924.75,
        702.8997192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15920408070087433,
        0.31219446659088135,
        -0.9365835189819336
      ],
      "plane_d": 1644.32568359375,
      "bbox_min": [
        -1503.0,
        -3929.0,
        700.162109375
      ],
      "bbox_max": [
        -1483.5,
        -3924.75,
        702.88671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.025872355327010155,
        0.26755428314208984,
        -0.9631953835487366
      ],
      "plane_d": 1764.0799560546875,
      "bbox_min": [
        -1493.8817138671875,
        -3929.0,
        700.162109375
      ],
      "bbox_max": [
        -1483.5,
        -3924.75,
        701.349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0061861262656748295,
        0.3160790205001831,
        -0.9487127661705017
      ],
      "plane_d": 1915.1512451171875,
      "bbox_min": [
        -1493.8817138671875,
        -3928.3125,
        700.162109375
      ],
      "bbox_max": [
        -1488.169677734375,
        -3924.75,
        701.349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7706506252288818,
        0.5916789770126343,
        0.2366715967655182
      ],
      "plane_d": 3304.0126953125,
      "bbox_min": [
        -1485.0166015625,
        -3935.383544921875,
        692.75
      ],
      "bbox_max": [
        -1479.0841064453125,
        -3928.904541015625,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09023689478635788,
        0.9246887564659119,
        0.3698755204677582
      ],
      "plane_d": 3510.7373046875,
      "bbox_min": [
        -1485.0166015625,
        -3930.5,
        692.75
      ],
      "bbox_max": [
        -1483.5,
        -3928.904541015625,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0677989199757576,
        0.9480533599853516,
        0.3108023405075073
      ],
      "plane_d": 3610.1728515625,
      "bbox_min": [
        -1485.0166015625,
        -3929.063232421875,
        692.75
      ],
      "bbox_max": [
        -1483.5,
        -3928.904541015625,
        693.23779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8398571610450745,
        0.5427680015563965,
        0.006555740721523762
      ],
      "plane_d": 3374.7119140625,
      "bbox_min": [
        -1487.702880859375,
        -3943.1875,
        696.5
      ],
      "bbox_max": [
        -1472.1953125,
        -3920.0,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3954560160636902,
        0.17105042934417725,
        -0.9024170637130737
      ],
      "plane_d": 1893.81396484375,
      "bbox_min": [
        -1487.702880859375,
        -3941.094970703125,
        700.2144165039062
      ],
      "bbox_max": [
        -1472.1953125,
        -3920.0,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7066319584846497,
        0.15649612247943878,
        -0.6900581121444702
      ],
      "plane_d": 2146.375,
      "bbox_min": [
        -1487.702880859375,
        -3941.094970703125,
        700.2144165039062
      ],
      "bbox_max": [
        -1472.1953125,
        -3920.0,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7016903758049011,
        0.19069144129753113,
        -0.6864892244338989
      ],
      "plane_d": 2270.8984375,
      "bbox_min": [
        -1487.702880859375,
        -3929.0,
        700.2144165039062
      ],
      "bbox_max": [
        -1479.25,
        -3920.22412109375,
        704.6375122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0387420654296875,
        -0.267442911863327,
        -0.9627945423126221
      ],
      "plane_d": -316.7054748535156,
      "bbox_min": [
        -1487.702880859375,
        -3929.0,
        700.2144165039062
      ],
      "bbox_max": [
        -1483.5,
        -3920.2734375,
        701.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0061861262656748295,
        0.3160790205001831,
        -0.9487127661705017
      ],
      "plane_d": 1915.1512451171875,
      "bbox_min": [
        -1485.452392578125,
        -3924.606201171875,
        701.4519653320312
      ],
      "bbox_max": [
        -1483.5,
        -3924.5,
        701.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.025872355327010155,
        0.26755428314208984,
        -0.9631953835487366
      ],
      "plane_d": 1764.0799560546875,
      "bbox_min": [
        -1485.42724609375,
        -3929.0,
        700.25
      ],
      "bbox_max": [
        -1483.5,
        -3924.5,
        701.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0061861262656748295,
        0.3160790205001831,
        -0.9487127661705017
      ],
      "plane_d": 1915.1512451171875,
      "bbox_min": [
        -1485.42724609375,
        -3925.126220703125,
        701.2802734375
      ],
      "bbox_max": [
        -1483.5,
        -3924.5,
        701.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5843120217323303,
        -0.21720077097415924,
        -0.7819227576255798
      ],
      "plane_d": 562.9412841796875,
      "bbox_min": [
        -1485.891357421875,
        -3928.84375,
        700.229736328125
      ],
      "bbox_max": [
        -1479.25,
        -3920.22412109375,
        704.6375122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0387420654296875,
        -0.267442911863327,
        -0.9627945423126221
      ],
      "plane_d": -316.7054748535156,
      "bbox_min": [
        -1485.891357421875,
        -3924.5,
        700.229736328125
      ],
      "bbox_max": [
        -1483.5,
        -3920.22412109375,
        701.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5069491863250732,
        -0.12048893421888351,
        -0.8535131812095642
      ],
      "plane_d": 877.9398193359375,
      "bbox_min": [
        -1483.5,
        -3928.84375,
        701.5
      ],
      "bbox_max": [
        -1479.25,
        -3924.19482421875,
        704.6375122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0387420654296875,
        -0.267442911863327,
        -0.9627945423126221
      ],
      "plane_d": -316.7054748535156,
      "bbox_min": [
        -1485.4599609375,
        -3924.045654296875,
        700.2333984375
      ],
      "bbox_max": [
        -1483.5,
        -3920.0,
        701.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5069491863250732,
        -0.12048893421888351,
        -0.8535131812095642
      ],
      "plane_d": 877.9398193359375,
      "bbox_min": [
        -1483.22802734375,
        -3941.094970703125,
        701.6184692382812
      ],
      "bbox_max": [
        -1472.1953125,
        -3920.69140625,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4459066390991211,
        -0.1928723156452179,
        -0.8740522861480713
      ],
      "plane_d": 517.7322387695312,
      "bbox_min": [
        -1479.25,
        -3932.2021484375,
        704.6375122070312
      ],
      "bbox_max": [
        -1472.1953125,
        -3924.65625,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9980340003967285,
        -0.0,
        0.06267483532428741
      ],
      "plane_d": 1494.3822021484375,
      "bbox_min": [
        -1548.3494873046875,
        -3947.472900390625,
        670.0
      ],
      "bbox_max": [
        -1503.0,
        -3902.527099609375,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9981783628463745,
        0.06033017858862877
      ],
      "plane_d": 3891.263671875,
      "bbox_min": [
        -1548.3494873046875,
        -3947.472900390625,
        670.0
      ],
      "bbox_max": [
        -1503.0,
        -3902.527099609375,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1539.0,
        -3940.0,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3938.85986328125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1539.0,
        -3940.0,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3939.917724609375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9981783628463745,
        0.06033017858862877
      ],
      "plane_d": -3944.4365234375,
      "bbox_min": [
        -1548.3494873046875,
        -3947.472900390625,
        670.0
      ],
      "bbox_max": [
        -1503.0,
        -3902.527099609375,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1539.0,
        -3911.14013671875,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3909.0,
        688.8596801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1539.0,
        -3910.082275390625,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3909.0,
        688.8596801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.0,
      "bbox_min": [
        -1536.0,
        -3910.082275390625,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3910.0,
        688.8596801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5659196972846985,
        0.821273684501648,
        0.07241950184106827
      ],
      "plane_d": 4054.61279296875,
      "bbox_min": [
        -1548.3494873046875,
        -3947.472900390625,
        670.0
      ],
      "bbox_max": [
        -1503.0,
        -3902.527099609375,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1540.0,
        -3939.917724609375,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3936.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1540.0,
        -3939.917724609375,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3936.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3936.0,
      "bbox_min": [
        -1539.0,
        -3936.0,
        670.0
      ],
      "bbox_max": [
        -1538.3818359375,
        -3936.0,
        674.8300170898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1540.0,
        -3937.0,
        693.0
      ],
      "bbox_max": [
        -1539.8736572265625,
        -3936.912841796875,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5659196376800537,
        -0.8212736248970032,
        0.07241922616958618
      ],
      "plane_d": -2392.38525390625,
      "bbox_min": [
        -1548.3494873046875,
        -3940.732177734375,
        670.0
      ],
      "bbox_max": [
        -1503.0,
        -3902.527099609375,
        812.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1540.0,
        -3913.0869140625,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3910.0,
        696.7483520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3913.0,
      "bbox_min": [
        -1540.0,
        -3913.0869140625,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3910.0,
        696.7483520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.0,
      "bbox_min": [
        -1540.0,
        -3913.0,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3910.0,
        696.7483520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1540.0,
        -3913.0,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3910.082275390625,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3912.0,
      "bbox_min": [
        -1540.0,
        -3913.0,
        687.5
      ],
      "bbox_max": [
        -1537.7191162109375,
        -3912.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1536.0,
        -3910.815185546875,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3910.082275390625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1540.0,
        -3913.0869140625,
        693.0
      ],
      "bbox_max": [
        -1539.8739013671875,
        -3913.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1539.0,
        -3939.1845703125,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3937.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980340003967285,
        9.878495802695397e-06,
        0.06267527490854263
      ],
      "plane_d": -1549.5830078125,
      "bbox_min": [
        -1536.0,
        -3940.732177734375,
        670.0
      ],
      "bbox_max": [
        -1503.0,
        -3937.0,
        791.0107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1536.0,
        -3939.87353515625,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3937.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1536.0,
        -3939.87353515625,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3937.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3912.0,
      "bbox_min": [
        -1541.5,
        -3937.0,
        670.0
      ],
      "bbox_max": [
        -1503.0,
        -3909.267822265625,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.0,
      "bbox_min": [
        -1537.7193603515625,
        -3912.0,
        670.0
      ],
      "bbox_max": [
        -1503.0,
        -3909.267822265625,
        806.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1537.7193603515625,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1536.0,
        -3910.815185546875,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1536.0,
        -3911.5,
        671.9210815429688
      ],
      "bbox_max": [
        -1535.0,
        -3910.1259765625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1536.0,
        -3911.5,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3910.1259765625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1536.0,
        -3912.0,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3911.5,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1536.0,
        -3912.0,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3911.5,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980341792106628,
        3.236443080822937e-05,
        0.06267155706882477
      ],
      "plane_d": -1549.49267578125,
      "bbox_min": [
        -1541.5,
        -3937.0,
        670.0
      ],
      "bbox_max": [
        -1503.0,
        -3912.0,
        774.285400390625
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1509.1553955078125,
        -3937.0,
        693.0
      ],
      "bbox_max": [
        -1503.0,
        -3912.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -3939.6181640625,
      "bbox_min": [
        -1509.1287841796875,
        -3929.5,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05531502515077591,
        -0.9472308158874512,
        0.3157435655593872
      ],
      "plane_d": -3850.4423828125,
      "bbox_min": [
        -1503.0999755859375,
        -3921.194091796875,
        694.583740234375
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        698.1665649414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1687573939561844,
        -0.31558758020401,
        0.9337694644927979
      ],
      "plane_d": -1632.4189453125,
      "bbox_min": [
        -1503.0999755859375,
        -3921.194091796875,
        694.583740234375
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        698.1665649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05465400218963623,
        -0.9485185742378235,
        -0.31197038292884827
      ],
      "plane_d": -3582.535888671875,
      "bbox_min": [
        -1503.0999755859375,
        -3920.0029296875,
        698.1490478515625
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        698.1665649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 3507.071533203125,
      "bbox_min": [
        -1509.1287841796875,
        -3929.5,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055315032601356506,
        0.947230875492096,
        0.315743625164032
      ],
      "plane_d": 3584.84619140625,
      "bbox_min": [
        -1503.0999755859375,
        -3929.5,
        694.583740234375
      ],
      "bbox_max": [
        -1503.0,
        -3928.305908203125,
        698.1665649414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1687573939561844,
        0.31558758020401,
        0.9337694644927979
      ],
      "plane_d": 844.7857666015625,
      "bbox_min": [
        -1503.0999755859375,
        -3929.5,
        694.583740234375
      ],
      "bbox_max": [
        -1503.0,
        -3928.305908203125,
        698.1665649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05465400218963623,
        0.9485185742378235,
        -0.31197038292884827
      ],
      "plane_d": 3862.86083984375,
      "bbox_min": [
        -1503.0999755859375,
        -3929.5,
        698.1490478515625
      ],
      "bbox_max": [
        -1503.0,
        -3929.4970703125,
        698.1665649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        -0.3162277638912201
      ],
      "plane_d": 3948.630859375,
      "bbox_min": [
        -1509.1287841796875,
        -3929.5,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        -0.3162277638912201
      ],
      "plane_d": -3498.05908203125,
      "bbox_min": [
        -1509.1287841796875,
        -3929.5,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3162277638912201,
        -0.9486833214759827
      ],
      "plane_d": 1907.9600830078125,
      "bbox_min": [
        -1509.1287841796875,
        -3929.5,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277638912201,
        -0.9486833214759827
      ],
      "plane_d": -574.2697143554688,
      "bbox_min": [
        -1509.1287841796875,
        -3929.5,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15920408070087433,
        -0.31219449639320374,
        -0.9365835785865784
      ],
      "plane_d": -806.2449951171875,
      "bbox_min": [
        -1509.1287841796875,
        -3929.5,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.15920408070087433,
        0.31219446659088135,
        -0.9365835189819336
      ],
      "plane_d": 1644.32568359375,
      "bbox_min": [
        -1509.1287841796875,
        -3929.5,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        702.9165649414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.053676117211580276,
        0.9473156332969666,
        -0.31577184796333313
      ],
      "plane_d": 3862.257568359375,
      "bbox_min": [
        -1509.1287841796875,
        -3929.5,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        701.7290649414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.053676117211580276,
        -0.9473156332969666,
        -0.31577184796333313
      ],
      "plane_d": -3573.696533203125,
      "bbox_min": [
        -1509.1287841796875,
        -3928.3125,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3920.0,
        701.7290649414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.3162277638912201,
        0.9486832618713379
      ],
      "plane_d": 583.2822265625,
      "bbox_min": [
        -1509.1287841796875,
        -3928.3125,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3921.1875,
        694.6040649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17073573172092438,
        0.3115845322608948,
        0.9347536563873291
      ],
      "plane_d": 831.3506469726562,
      "bbox_min": [
        -1503.0999755859375,
        -3928.3125,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3924.72265625,
        694.6040649414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.17073573172092438,
        -0.3115845322608948,
        0.9347536563873291
      ],
      "plane_d": -1614.43212890625,
      "bbox_min": [
        -1503.0999755859375,
        -3924.75,
        693.3983154296875
      ],
      "bbox_max": [
        -1503.0,
        -3924.72265625,
        693.4165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277638912201,
        0.9486833214759827
      ],
      "plane_d": -1898.94775390625,
      "bbox_min": [
        -1509.1287841796875,
        -3924.75,
        693.4074096679688
      ],
      "bbox_max": [
        -1503.0,
        -3921.1875,
        694.6040649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17073573172092438,
        -0.3115845322608948,
        0.9347536563873291
      ],
      "plane_d": -1614.43212890625,
      "bbox_min": [
        -1503.0999755859375,
        -3924.75,
        693.4074096679688
      ],
      "bbox_max": [
        -1503.0,
        -3921.1875,
        694.6040649414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -693.0,
      "bbox_min": [
        -1541.5,
        -3937.0,
        670.0
      ],
      "bbox_max": [
        -1509.154541015625,
        -3912.0,
        709.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1536.5,
      "bbox_min": [
        -1539.0,
        -3937.0,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3912.0,
        693.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3913.0,
      "bbox_min": [
        -1539.0,
        -3937.0,
        670.0
      ],
      "bbox_max": [
        -1536.5,
        -3912.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1539.0,
        -3913.0,
        687.5
      ],
      "bbox_max": [
        -1536.5,
        -3912.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3936.0,
      "bbox_min": [
        -1539.0,
        -3937.0,
        670.0
      ],
      "bbox_max": [
        -1536.5,
        -3936.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1539.0,
        -3937.0,
        687.5
      ],
      "bbox_max": [
        -1536.5,
        -3936.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1536.5,
        -3937.0,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3936.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        -1536.5,
        -3913.0,
        670.0
      ],
      "bbox_max": [
        -1535.0,
        -3912.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -687.5,
      "bbox_min": [
        -1536.5,
        -3913.0,
        687.5
      ],
      "bbox_max": [
        -1535.0,
        -3912.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3925.0,
      "bbox_min": [
        -1541.5,
        -3925.0,
        708.0
      ],
      "bbox_max": [
        -1536.5,
        -3925.0,
        709.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.967786967754364,
        0.22291091084480286,
        0.11704368144273758
      ],
      "plane_d": 0.13446807861328125,
      "bbox_min": [
        -865.766357421875,
        -4037.0263671875,
        267.0
      ],
      "bbox_max": [
        -772.5545043945312,
        -3786.95263671875,
        1299.46826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9720523357391357,
        0.22389337420463562,
        0.07061281055212021
      ],
      "plane_d": 31.119951248168945,
      "bbox_min": [
        -865.766357421875,
        -3986.826171875,
        267.0
      ],
      "bbox_max": [
        -792.70361328125,
        -3786.95263671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9674496054649353,
        0.24035444855690002,
        0.07918946444988251
      ],
      "plane_d": 94.94546508789062,
      "bbox_min": [
        -865.766357421875,
        -3986.826171875,
        267.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3786.95263671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6840948462486267,
        0.7246696949005127,
        0.0828745886683464
      ],
      "plane_d": 2260.9384765625,
      "bbox_min": [
        -865.766357421875,
        -3986.826171875,
        267.0
      ],
      "bbox_max": [
        -838.328857421875,
        -3967.783203125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6494391560554504,
        0.7583372592926025,
        0.0561547577381134
      ],
      "plane_d": 2441.852783203125,
      "bbox_min": [
        -839.2600708007812,
        -3987.54345703125,
        657.9761962890625
      ],
      "bbox_max": [
        -838.328857421875,
        -3986.826171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6452460289001465,
        0.7534409165382385,
        0.12642896175384521
      ],
      "plane_d": 2379.466552734375,
      "bbox_min": [
        -1019.15966796875,
        -4127.744140625,
        267.0
      ],
      "bbox_max": [
        -772.455810546875,
        -3967.783203125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6494391560554504,
        0.7583372592926025,
        0.0561547577381134
      ],
      "plane_d": 2441.852783203125,
      "bbox_min": [
        -1019.15966796875,
        -4127.744140625,
        267.0
      ],
      "bbox_max": [
        -839.1663818359375,
        -3967.783203125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6840948462486267,
        0.7246696949005127,
        0.0828745886683464
      ],
      "plane_d": 2260.9384765625,
      "bbox_min": [
        -1019.15966796875,
        -4112.587890625,
        267.0
      ],
      "bbox_max": [
        -839.2600708007812,
        -3967.783203125,
        657.9761962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.967786967754364,
        0.22291091084480286,
        0.11704368144273758
      ],
      "plane_d": 0.13446807861328125,
      "bbox_min": [
        -802.7811279296875,
        -4038.2421875,
        1006.7724609375
      ],
      "bbox_max": [
        -772.455810546875,
        -4014.572265625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9988681077957153,
        0.047565147280693054
      ],
      "plane_d": -4041.039794921875,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1146.5751953125,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015727397985756397,
        -0.9987512230873108,
        0.04993755742907524
      ],
      "plane_d": -4044.1015625,
      "bbox_min": [
        -1180.0,
        -4012.0,
        706.0
      ],
      "bbox_max": [
        -1148.248046875,
        -4011.0,
        727.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009923006407916546,
        -0.9490150213241577,
        -0.3150748312473297
      ],
      "plane_d": -3566.0458984375,
      "bbox_min": [
        -1180.0,
        -4011.041259765625,
        726.0
      ],
      "bbox_max": [
        -1148.248046875,
        -4011.0,
        727.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.001734549761749804,
        0.9987508654594421,
        -0.04993754252791405
      ],
      "plane_d": 4062.31884765625,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1146.5751953125,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02990417554974556,
        -0.004798466805368662,
        0.9995412230491638
      ],
      "plane_d": -684.647705078125,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1146.5751953125,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004925165791064501,
        -0.9863442778587341,
        0.1646226942539215
      ],
      "plane_d": -4067.788330078125,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1146.5751953125,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9805806875228882,
        0.1961161345243454
      ],
      "plane_d": -4072.5478515625,
      "bbox_min": [
        -1180.0,
        -4013.0,
        701.0
      ],
      "bbox_max": [
        -1146.8577880859375,
        -4012.0,
        706.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.031730785965919495,
        -0.0,
        0.9994965195655823
      ],
      "plane_d": -663.2047729492188,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1148.248046875,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9557790160179138,
        -0.294085830450058
      ],
      "plane_d": -3620.123291015625,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1148.248046875,
        -4011.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009923006407916546,
        -0.9490150213241577,
        -0.3150748312473297
      ],
      "plane_d": -3566.0458984375,
      "bbox_min": [
        -1179.6881103515625,
        -4015.0,
        726.1341552734375
      ],
      "bbox_max": [
        -1148.248046875,
        -4011.0,
        739.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018522577360272408,
        0.8119395971298218,
        0.5834475755691528
      ],
      "plane_d": 2880.916748046875,
      "bbox_min": [
        -1180.0,
        -4030.0,
        700.0
      ],
      "bbox_max": [
        -1148.500732421875,
        -4015.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7682212591171265,
        0.6401844620704651
      ],
      "plane_d": 2643.3212890625,
      "bbox_min": [
        -1180.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1149.8199462890625,
        -4025.0,
        707.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1414213627576828,
        -0.9899495840072632
      ],
      "plane_d": 163.7659912109375,
      "bbox_min": [
        -1180.0,
        -4022.0,
        739.0
      ],
      "bbox_max": [
        -1149.7760009765625,
        -4015.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32040175795555115,
        -0.1339658796787262,
        -0.937761127948761
      ],
      "plane_d": 533.20654296875,
      "bbox_min": [
        -1240.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.054020095616579056,
        -0.997294008731842,
        0.04986470192670822
      ],
      "plane_d": -4100.091796875,
      "bbox_min": [
        -1240.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.007906542159616947,
        0.9987210631370544,
        -0.04993605613708496
      ],
      "plane_d": 4050.82080078125,
      "bbox_min": [
        -1240.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15989989042282104,
        0.8691422343254089,
        -0.467999666929245
      ],
      "plane_d": 4030.69189453125,
      "bbox_min": [
        -1240.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15606936812400818,
        0.3468208312988281,
        -0.9248554706573486
      ],
      "plane_d": 2253.873046875,
      "bbox_min": [
        -1240.0,
        -4030.0,
        707.975830078125
      ],
      "bbox_max": [
        -1180.0,
        -4022.0,
        727.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03260098770260811,
        0.9780296683311462,
        0.20590098202228546
      ],
      "plane_d": 3834.356689453125,
      "bbox_min": [
        -1240.0,
        -4030.0,
        707.975830078125
      ],
      "bbox_max": [
        -1216.2861328125,
        -4028.205322265625,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09950371831655502,
        -0.0,
        0.9950372576713562
      ],
      "plane_d": -580.1067504882812,
      "bbox_min": [
        -1240.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        739.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09997591376304626,
        -0.9509903788566589,
        -0.2926124334335327
      ],
      "plane_d": -3484.01416015625,
      "bbox_min": [
        -1240.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        739.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08468224108219147,
        -0.871017336845398,
        -0.4838985204696655
      ],
      "plane_d": -3042.4150390625,
      "bbox_min": [
        -1240.0,
        -4015.0,
        706.2138061523438
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        726.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13864785432815552,
        -0.5942050814628601,
        -0.7922734618186951
      ],
      "plane_d": -1644.5616455078125,
      "bbox_min": [
        -1240.0,
        -4015.0,
        706.2138061523438
      ],
      "bbox_max": [
        -1180.0,
        -4008.5,
        726.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.025350766256451607,
        -0.9360283017158508,
        0.35101062059402466
      ],
      "plane_d": -4033.07275390625,
      "bbox_min": [
        -1240.0,
        -4010.39306640625,
        706.2138061523438
      ],
      "bbox_max": [
        -1217.830078125,
        -4008.5,
        711.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02940469980239868,
        -0.9801567196846008,
        0.1960313469171524
      ],
      "plane_d": -4105.484375,
      "bbox_min": [
        -1240.0,
        -4010.39306640625,
        706.2138061523438
      ],
      "bbox_max": [
        -1229.8211669921875,
        -4010.0,
        707.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.025598982349038124,
        0.7679696083068848,
        0.6399745941162109
      ],
      "plane_d": 2672.662109375,
      "bbox_min": [
        -1240.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4009.793212890625,
        712.7453002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03260098770260811,
        0.9780296683311462,
        0.20590098202228546
      ],
      "plane_d": 3834.356689453125,
      "bbox_min": [
        -1240.0,
        -4030.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4009.793212890625,
        712.7453002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02940469980239868,
        -0.9801567196846008,
        0.1960313469171524
      ],
      "plane_d": -4105.484375,
      "bbox_min": [
        -1232.1380615234375,
        -4013.0,
        701.0
      ],
      "bbox_max": [
        -1180.0,
        -4009.793212890625,
        709.1525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.025350766256451607,
        -0.9360283017158508,
        0.35101062059402466
      ],
      "plane_d": -4033.07275390625,
      "bbox_min": [
        -1229.8211669921875,
        -4012.0,
        706.0
      ],
      "bbox_max": [
        -1180.0,
        -4009.793212890625,
        709.1525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07124704867601395,
        0.0,
        0.9974586367607117
      ],
      "plane_d": -793.549560546875,
      "bbox_min": [
        -1254.0,
        -4030.0,
        706.0
      ],
      "bbox_max": [
        -1240.0,
        -4008.5,
        719.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6231316924095154,
        -0.6806421875953674,
        -0.38527002930641174
      ],
      "plane_d": -1681.7119140625,
      "bbox_min": [
        -1254.0,
        -4030.0,
        706.0
      ],
      "bbox_max": [
        -1240.0,
        -4008.5,
        719.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6410201191902161,
        -0.7186553478240967,
        0.2694954574108124
      ],
      "plane_d": -2277.47607421875,
      "bbox_min": [
        -1254.0,
        -4030.0,
        706.0
      ],
      "bbox_max": [
        -1240.0,
        -4008.5,
        719.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6412478685379028,
        -0.7310077548027039,
        0.23329974710941315
      ],
      "plane_d": -2301.13671875,
      "bbox_min": [
        -1254.0,
        -4022.60009765625,
        706.0
      ],
      "bbox_max": [
        -1240.0,
        -4010.0,
        710.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6233370304107666,
        -0.6835501194000244,
        -0.3797500729560852
      ],
      "plane_d": -1697.0703125,
      "bbox_min": [
        -1254.0,
        -4030.0,
        706.0
      ],
      "bbox_max": [
        -1240.0,
        -4008.5,
        719.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47026392817497253,
        -0.5295156240463257,
        -0.7060206532478333
      ],
      "plane_d": -1035.602294921875,
      "bbox_min": [
        -1254.0,
        -4030.0,
        706.0
      ],
      "bbox_max": [
        -1240.0,
        -4011.0,
        719.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.034926872700452805,
        0.977952778339386,
        0.20588478446006775
      ],
      "plane_d": 3836.942626953125,
      "bbox_min": [
        -1254.0,
        -4030.0,
        706.0
      ],
      "bbox_max": [
        -1240.0,
        -4015.0,
        719.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.021713251248002052,
        0.9821070432662964,
        0.18706801533699036
      ],
      "plane_d": 3850.5947265625,
      "bbox_min": [
        -1254.0,
        -4029.5,
        706.0
      ],
      "bbox_max": [
        -1240.0,
        -4027.5,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25949692726135254,
        -0.1365768313407898,
        -0.9560378193855286
      ],
      "plane_d": 460.3333740234375,
      "bbox_min": [
        -1254.0,
        -4030.0,
        716.0
      ],
      "bbox_max": [
        -1240.0,
        -4015.0,
        719.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17849791049957275,
        0.34548452496528625,
        -0.9212920665740967
      ],
      "plane_d": 2273.745849609375,
      "bbox_min": [
        -1254.0,
        -4030.0,
        716.0
      ],
      "bbox_max": [
        -1240.0,
        -4022.0,
        719.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0032928341533988714,
        -0.09219936281442642,
        -0.9957351088523865
      ],
      "plane_d": 337.79766845703125,
      "bbox_min": [
        -1254.0,
        -4030.0,
        716.0
      ],
      "bbox_max": [
        -1240.0,
        -4024.10009765625,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09546536207199097,
        -0.2028639018535614,
        0.9745422601699829
      ],
      "plane_d": -1380.1666259765625,
      "bbox_min": [
        -1387.965576171875,
        -4062.0,
        702.5800170898438
      ],
      "bbox_max": [
        -1254.0,
        -3948.0,
        760.537353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -710.9999389648438,
      "bbox_min": [
        -1387.965576171875,
        -4034.0,
        702.5800170898438
      ],
      "bbox_max": [
        -1273.7784423828125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9944747686386108,
        0.0,
        0.10497628152370453
      ],
      "plane_d": -1423.2564697265625,
      "bbox_min": [
        -1357.0,
        -4034.0,
        702.5800170898438
      ],
      "bbox_max": [
        -1281.5,
        -3966.0,
        711.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9961532950401306,
        0.0,
        0.08762789517641068
      ],
      "plane_d": 1281.7470703125,
      "bbox_min": [
        -1357.0,
        -4034.0,
        702.5800170898438
      ],
      "bbox_max": [
        -1281.5,
        -3966.0,
        711.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9961532950401306,
        0.08762789517641068
      ],
      "plane_d": 3948.449462890625,
      "bbox_min": [
        -1357.0,
        -4034.0,
        702.5800170898438
      ],
      "bbox_max": [
        -1348.5,
        -4025.5,
        710.9498901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9961532950401306,
        0.08762789517641068
      ],
      "plane_d": -4080.0478515625,
      "bbox_min": [
        -1357.0,
        -4034.0,
        702.5800170898438
      ],
      "bbox_max": [
        -1348.5,
        -4033.3935546875,
        709.4754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        0.10151368379592896
      ],
      "plane_d": 1239.7257080078125,
      "bbox_min": [
        -1326.5,
        -4028.5,
        703.5
      ],
      "bbox_max": [
        -1281.5,
        -3966.0,
        711.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        0.12154118716716766
      ],
      "plane_d": -1402.230712890625,
      "bbox_min": [
        -1326.5,
        -3974.5,
        704.0
      ],
      "bbox_max": [
        -1318.0,
        -3966.0,
        711.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": -4025.433837890625,
      "bbox_min": [
        -1326.5,
        -3974.5,
        704.0
      ],
      "bbox_max": [
        -1318.0,
        -3966.0,
        711.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": 3874.046630859375,
      "bbox_min": [
        -1326.5,
        -3966.71435546875,
        704.0
      ],
      "bbox_max": [
        -1318.0,
        -3966.0,
        711.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        0.12154118716716766
      ],
      "plane_d": -1365.9405517578125,
      "bbox_min": [
        -1290.0,
        -4028.5,
        703.5
      ],
      "bbox_max": [
        -1281.5,
        -4020.0,
        705.6983642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": 3927.818359375,
      "bbox_min": [
        -1290.0,
        -4028.5,
        703.5
      ],
      "bbox_max": [
        -1281.5,
        -4020.0,
        705.6983642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        0.10151368379592896
      ],
      "plane_d": 1203.465087890625,
      "bbox_min": [
        -1290.0,
        -4028.5,
        703.5
      ],
      "bbox_max": [
        -1281.5,
        -4020.0,
        704.9228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": -4079.10400390625,
      "bbox_min": [
        -1290.0,
        -4028.5,
        703.5
      ],
      "bbox_max": [
        -1284.8746337890625,
        -4028.4482421875,
        704.0067138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09105778485536575,
        -0.4442516565322876,
        0.8912625312805176
      ],
      "plane_d": -2272.49072265625,
      "bbox_min": [
        -1387.965576171875,
        -4033.0,
        711.0
      ],
      "bbox_max": [
        -1273.7784423828125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1595970243215561,
        -0.5585896372795105,
        0.813944935798645
      ],
      "plane_d": -2578.54541015625,
      "bbox_min": [
        -1347.0,
        -3965.0,
        711.0
      ],
      "bbox_max": [
        -1305.7958984375,
        -3948.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11185142397880554,
        -0.5881220102310181,
        0.8010005950927734
      ],
      "plane_d": -3042.282958984375,
      "bbox_min": [
        -1313.0,
        -3956.7373046875,
        711.0
      ],
      "bbox_max": [
        -1305.7958984375,
        -3948.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10859990119934082,
        -0.3321879208087921,
        0.9369403719902039
      ],
      "plane_d": -2122.450927734375,
      "bbox_min": [
        -1312.0,
        -3956.7373046875,
        711.0
      ],
      "bbox_max": [
        -1305.7958984375,
        -3955.0,
        711.5816040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21536336839199066,
        -0.7813403010368347,
        -0.5857695937156677
      ],
      "plane_d": -2382.54833984375,
      "bbox_min": [
        -1387.965576171875,
        -4033.0,
        711.0
      ],
      "bbox_max": [
        -1273.7784423828125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24200037121772766,
        -0.7507402896881104,
        -0.6146745085716248
      ],
      "plane_d": -2841.562255859375,
      "bbox_min": [
        -1387.965576171875,
        -4033.0,
        711.0
      ],
      "bbox_max": [
        -1273.7784423828125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1276831179857254,
        -0.8126031160354614,
        -0.5686590075492859
      ],
      "plane_d": -2972.882568359375,
      "bbox_min": [
        -1282.6744384765625,
        -3959.78955078125,
        714.0
      ],
      "bbox_max": [
        -1279.7236328125,
        -3957.0,
        717.7144165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9068138599395752,
        -0.35624831914901733,
        -0.2253350466489792
      ],
      "plane_d": -2409.507080078125,
      "bbox_min": [
        -1280.0,
        -3959.78955078125,
        714.0
      ],
      "bbox_max": [
        -1279.7236328125,
        -3957.0,
        717.3984985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11185142397880554,
        -0.5881220102310181,
        0.8010005950927734
      ],
      "plane_d": -3042.282958984375,
      "bbox_min": [
        -1387.965576171875,
        -4033.0,
        711.0
      ],
      "bbox_max": [
        -1273.7784423828125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3716106712818146,
        0.04514895752072334,
        0.927290141582489
      ],
      "plane_d": 32.260711669921875,
      "bbox_min": [
        -1387.965576171875,
        -4033.0,
        711.0
      ],
      "bbox_max": [
        -1371.0,
        -4001.886962890625,
        716.5213012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5197551250457764,
        0.8541514277458191,
        -0.016735214740037918
      ],
      "plane_d": 4152.9052734375,
      "bbox_min": [
        -1387.965576171875,
        -4004.0,
        716.0
      ],
      "bbox_max": [
        -1387.0,
        -4003.40625,
        716.357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8338351845741272,
        0.25701743364334106,
        -0.4885293245315552
      ],
      "plane_d": 2535.4140625,
      "bbox_min": [
        -1387.964111328125,
        -4018.9423828125,
        715.0944213867188
      ],
      "bbox_max": [
        -1382.9248046875,
        -4003.4033203125,
        716.5213012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5197551250457764,
        0.8541514277458191,
        -0.016735214740037918
      ],
      "plane_d": 4152.9052734375,
      "bbox_min": [
        -1387.964111328125,
        -4004.0,
        716.0
      ],
      "bbox_max": [
        -1387.0,
        -4003.4033203125,
        716.5213012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28142812848091125,
        -0.31660664081573486,
        0.9058468341827393
      ],
      "plane_d": -1520.3187255859375,
      "bbox_min": [
        -1387.9635009765625,
        -4015.35400390625,
        711.0
      ],
      "bbox_max": [
        -1273.7784423828125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10859990119934082,
        -0.3321879208087921,
        0.9369403719902039
      ],
      "plane_d": -2122.450927734375,
      "bbox_min": [
        -1387.9635009765625,
        -4015.35400390625,
        711.0
      ],
      "bbox_max": [
        -1273.7784423828125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4231202304363251,
        -0.3820405602455139,
        0.8215926289558411
      ],
      "plane_d": -1527.49658203125,
      "bbox_min": [
        -1387.9635009765625,
        -4015.35400390625,
        711.0
      ],
      "bbox_max": [
        -1273.7784423828125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4546581506729126,
        -0.40919235348701477,
        0.7911052107810974
      ],
      "plane_d": -1570.407470703125,
      "bbox_min": [
        -1385.56787109375,
        -3993.164794921875,
        711.0
      ],
      "bbox_max": [
        -1365.0,
        -3978.0,
        717.9987182617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5442876815795898,
        -0.24740350246429443,
        0.8015874028205872
      ],
      "plane_d": -808.9204711914062,
      "bbox_min": [
        -1380.823486328125,
        -3993.164794921875,
        711.0
      ],
      "bbox_max": [
        -1375.0,
        -3988.08837890625,
        715.8528442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29043591022491455,
        -0.09681197255849838,
        0.9519843459129333
      ],
      "plane_d": -1434.07568359375,
      "bbox_min": [
        -1387.9635009765625,
        -4015.35400390625,
        711.0
      ],
      "bbox_max": [
        -1273.7784423828125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6825659871101379,
        -0.6143094301223755,
        -0.3958882987499237
      ],
      "plane_d": -1223.786376953125,
      "bbox_min": [
        -1384.396484375,
        -3988.989501953125,
        716.0
      ],
      "bbox_max": [
        -1369.1060791015625,
        -3978.0,
        721.787841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20318862795829773,
        -0.9725694060325623,
        -0.11323843896389008
      ],
      "plane_d": -4078.13134765625,
      "bbox_min": [
        -1384.396484375,
        -3988.989501953125,
        716.4904174804688
      ],
      "bbox_max": [
        -1379.0211181640625,
        -3987.251708984375,
        721.6895141601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3574698269367218,
        -0.902378261089325,
        -0.24068395793437958
      ],
      "plane_d": -3920.020751953125,
      "bbox_min": [
        -1384.35791015625,
        -3987.957763671875,
        716.4904174804688
      ],
      "bbox_max": [
        -1381.660888671875,
        -3987.251708984375,
        720.1830444335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4779053330421448,
        -0.7088632583618164,
        -0.5187671184539795
      ],
      "plane_d": -1792.73486328125,
      "bbox_min": [
        -1373.1279296875,
        -3982.887939453125,
        716.0
      ],
      "bbox_max": [
        -1369.1060791015625,
        -3978.0,
        721.787841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3282020092010498,
        -0.1289364993572235,
        0.9357664585113525
      ],
      "plane_d": -1598.4375,
      "bbox_min": [
        -1387.9635009765625,
        -4015.35400390625,
        711.0
      ],
      "bbox_max": [
        -1273.7784423828125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9068138599395752,
        -0.35624831914901733,
        -0.2253350466489792
      ],
      "plane_d": -2409.507080078125,
      "bbox_min": [
        -1387.9635009765625,
        -4015.35400390625,
        711.0
      ],
      "bbox_max": [
        -1273.7784423828125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6082287430763245,
        -0.22808577120304108,
        0.7602858543395996
      ],
      "plane_d": -614.0068969726562,
      "bbox_min": [
        -1387.9635009765625,
        -4015.35400390625,
        711.0
      ],
      "bbox_max": [
        -1312.010986328125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -716.0,
      "bbox_min": [
        -1387.9635009765625,
        -4004.0,
        716.0
      ],
      "bbox_max": [
        -1381.0,
        -3987.81005859375,
        716.9507446289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3574698269367218,
        -0.902378261089325,
        -0.24068395793437958
      ],
      "plane_d": -3920.020751953125,
      "bbox_min": [
        -1381.81005859375,
        -3988.0,
        716.0
      ],
      "bbox_max": [
        -1381.0,
        -3987.81005859375,
        716.6343383789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20318862795829773,
        -0.9725694060325623,
        -0.11323843896389008
      ],
      "plane_d": -4078.13134765625,
      "bbox_min": [
        -1381.74560546875,
        -3988.95947265625,
        716.0
      ],
      "bbox_max": [
        -1379.0810546875,
        -3987.8740234375,
        720.7971801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3574698269367218,
        -0.902378261089325,
        -0.24068395793437958
      ],
      "plane_d": -3920.020751953125,
      "bbox_min": [
        -1381.74560546875,
        -3988.0,
        716.0
      ],
      "bbox_max": [
        -1381.0,
        -3987.8740234375,
        716.8233032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5442876815795898,
        -0.24740350246429443,
        0.8015874028205872
      ],
      "plane_d": -808.9204711914062,
      "bbox_min": [
        -1387.9617919921875,
        -4015.35400390625,
        711.0
      ],
      "bbox_max": [
        -1312.010986328125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4546581506729126,
        -0.40919235348701477,
        0.7911052107810974
      ],
      "plane_d": -1570.407470703125,
      "bbox_min": [
        -1387.9617919921875,
        -4015.35400390625,
        711.0
      ],
      "bbox_max": [
        -1312.010986328125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23361419141292572,
        0.9342288374900818,
        -0.26951977610588074
      ],
      "plane_d": 4257.6513671875,
      "bbox_min": [
        -1387.9617919921875,
        -4004.0,
        716.0
      ],
      "bbox_max": [
        -1385.6263427734375,
        -4002.94677734375,
        718.9072875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5197551250457764,
        0.8541514277458191,
        -0.016735214740037918
      ],
      "plane_d": 4152.9052734375,
      "bbox_min": [
        -1387.9617919921875,
        -4004.0,
        716.0
      ],
      "bbox_max": [
        -1387.0,
        -4003.390380859375,
        717.2803955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3967624008655548,
        -0.6881896257400513,
        -0.6074327230453491
      ],
      "plane_d": -1753.117431640625,
      "bbox_min": [
        -1352.2110595703125,
        -3973.78564453125,
        711.0
      ],
      "bbox_max": [
        -1312.010986328125,
        -3948.0,
        723.305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": 3874.046630859375,
      "bbox_min": [
        -1325.642822265625,
        -3973.78564453125,
        711.0
      ],
      "bbox_max": [
        -1312.010986328125,
        -3948.0,
        722.1687622070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        0.12154118716716766
      ],
      "plane_d": -1402.230712890625,
      "bbox_min": [
        -1325.642822265625,
        -3973.78564453125,
        711.0
      ],
      "bbox_max": [
        -1318.7142333984375,
        -3966.71435546875,
        720.0541381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        0.10151368379592896
      ],
      "plane_d": 1239.7257080078125,
      "bbox_min": [
        -1325.642822265625,
        -3973.78564453125,
        711.0
      ],
      "bbox_max": [
        -1318.7142333984375,
        -3966.71435546875,
        719.5798950195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": -4025.433837890625,
      "bbox_min": [
        -1325.642822265625,
        -3973.78564453125,
        711.0
      ],
      "bbox_max": [
        -1318.7142333984375,
        -3972.973876953125,
        718.95654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.008994966745376587,
        -0.7524493336677551,
        -0.6585887670516968
      ],
      "plane_d": -2487.31005859375,
      "bbox_min": [
        -1315.9375,
        -3953.434326171875,
        716.0
      ],
      "bbox_max": [
        -1312.010986328125,
        -3948.0,
        722.1687622070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -704.9999389648438,
      "bbox_min": [
        -1387.858154296875,
        -4062.0,
        703.5
      ],
      "bbox_max": [
        -1254.0,
        -3953.10986328125,
        760.537353515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        0.10151368379592896
      ],
      "plane_d": 1203.465087890625,
      "bbox_min": [
        -1289.93798828125,
        -4028.5,
        703.5
      ],
      "bbox_max": [
        -1281.5,
        -4020.145263671875,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": -4079.10400390625,
      "bbox_min": [
        -1289.93798828125,
        -4028.5,
        703.5
      ],
      "bbox_max": [
        -1281.5,
        -4020.145263671875,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        0.12154118716716766
      ],
      "plane_d": -1365.9405517578125,
      "bbox_min": [
        -1289.93798828125,
        -4028.4482421875,
        704.0067138671875
      ],
      "bbox_max": [
        -1281.6451416015625,
        -4020.145263671875,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10541902482509613,
        0.042855799198150635,
        -0.9935039281845093
      ],
      "plane_d": 783.332763671875,
      "bbox_min": [
        -1387.858154296875,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -3953.10986328125,
        760.537353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3096701502799988,
        -0.05214065685868263,
        -0.9494133591651917
      ],
      "plane_d": 924.6651611328125,
      "bbox_min": [
        -1357.0,
        -4044.05810546875,
        750.6865844726562
      ],
      "bbox_max": [
        -1281.5,
        -3966.0,
        760.537353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9961532950401306,
        -0.08762789517641068
      ],
      "plane_d": -3951.93603515625,
      "bbox_min": [
        -1357.0,
        -4034.0,
        757.5554809570312
      ],
      "bbox_max": [
        -1348.5,
        -4025.5,
        759.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9961532950401306,
        -0.08762789517641068
      ],
      "plane_d": 4076.5615234375,
      "bbox_min": [
        -1357.0,
        -4034.0,
        757.906005859375
      ],
      "bbox_max": [
        -1348.5,
        -4025.5,
        759.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9944747686386108,
        0.0,
        -0.10497628152370453
      ],
      "plane_d": -1269.78125,
      "bbox_min": [
        -1357.0,
        -4034.0,
        758.425537109375
      ],
      "bbox_max": [
        -1356.89501953125,
        -4025.5,
        759.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7275522351264954,
        -0.6790456175804138,
        -0.09779921919107437
      ],
      "plane_d": -1675.52587890625,
      "bbox_min": [
        -1340.0,
        -4010.050048828125,
        757.5536499023438
      ],
      "bbox_max": [
        -1334.0,
        -4002.550048828125,
        760.537353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7275523543357849,
        0.6790457367897034,
        -0.09779923409223557
      ],
      "plane_d": 3765.395751953125,
      "bbox_min": [
        -1340.0,
        -4010.050048828125,
        757.5536499023438
      ],
      "bbox_max": [
        -1334.0,
        -4002.550048828125,
        760.537353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8294076919555664,
        -0.5529384613037109,
        -0.07963670045137405
      ],
      "plane_d": -3266.076904296875,
      "bbox_min": [
        -1340.0,
        -4010.050048828125,
        757.5536499023438
      ],
      "bbox_max": [
        -1337.5,
        -4006.300048828125,
        760.5372314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9966575503349304,
        -0.08169324696063995
      ],
      "plane_d": -3899.210205078125,
      "bbox_min": [
        -1338.1962890625,
        -4009.66845703125,
        756.88720703125
      ],
      "bbox_max": [
        -1318.0,
        -3966.0,
        759.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9966575503349304,
        -0.08169323951005936
      ],
      "plane_d": 4014.7490234375,
      "bbox_min": [
        -1326.5,
        -3974.5,
        757.237060546875
      ],
      "bbox_max": [
        -1318.0,
        -3966.0,
        759.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9951973557472229,
        0.0,
        -0.0978882685303688
      ],
      "plane_d": -1245.83203125,
      "bbox_min": [
        -1326.5,
        -3974.5,
        757.754638671875
      ],
      "bbox_max": [
        -1326.3775634765625,
        -3966.0,
        759.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7275522351264954,
        -0.6790456175804138,
        -0.09779921919107437
      ],
      "plane_d": -1675.52587890625,
      "bbox_min": [
        -1338.1962890625,
        -4009.66845703125,
        757.2691650390625
      ],
      "bbox_max": [
        -1334.2381591796875,
        -4003.4306640625,
        758.7659912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7275523543357849,
        0.6790457367897034,
        -0.09779923409223557
      ],
      "plane_d": 3765.395751953125,
      "bbox_min": [
        -1338.1962890625,
        -4009.66845703125,
        757.2691650390625
      ],
      "bbox_max": [
        -1334.2381591796875,
        -4003.4306640625,
        758.7659912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        -0.10151368379592896
      ],
      "plane_d": 1351.2689208984375,
      "bbox_min": [
        -1290.0,
        -4028.5,
        750.6865844726562
      ],
      "bbox_max": [
        -1281.5,
        -4020.0,
        752.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9948341250419617,
        -0.10151368379592896
      ],
      "plane_d": -3931.300048828125,
      "bbox_min": [
        -1290.0,
        -4028.5,
        750.6865844726562
      ],
      "bbox_max": [
        -1281.5,
        -4020.0,
        752.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        -0.12154118716716766
      ],
      "plane_d": -1188.9766845703125,
      "bbox_min": [
        -1290.0,
        -4028.5,
        751.5527954101562
      ],
      "bbox_max": [
        -1289.884033203125,
        -4020.0,
        752.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7275506258010864,
        -0.6790472865104675,
        -0.09779946506023407
      ],
      "plane_d": -3590.01513671875,
      "bbox_min": [
        -1300.0,
        -4006.550048828125,
        753.071044921875
      ],
      "bbox_max": [
        -1293.5,
        -3999.550048828125,
        755.537353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.777728796005249,
        -0.6221801042556763,
        -0.08960919082164764
      ],
      "plane_d": -1416.767333984375,
      "bbox_min": [
        -1300.0,
        -4006.550048828125,
        753.071044921875
      ],
      "bbox_max": [
        -1293.5,
        -3999.550048828125,
        755.537353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6776223182678223,
        0.7297471761703491,
        -0.0910879597067833
      ],
      "plane_d": 2108.943359375,
      "bbox_min": [
        -1300.0,
        -4002.800048828125,
        753.071044921875
      ],
      "bbox_max": [
        -1293.5,
        -3999.550048828125,
        755.537353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321856617927551,
        0.6758604645729065,
        -0.08436175435781479
      ],
      "plane_d": 3716.15478515625,
      "bbox_min": [
        -1296.5,
        -4002.800048828125,
        753.071044921875
      ],
      "bbox_max": [
        -1293.5,
        -3999.550048828125,
        755.537353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.037053558975458145,
        0.9446187019348145,
        -0.32607129216194153
      ],
      "plane_d": 4017.0,
      "bbox_min": [
        -1346.3004150390625,
        -4044.05810546875,
        754.5
      ],
      "bbox_max": [
        -1324.0,
        -4003.331787109375,
        757.6876220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7275523543357849,
        0.6790457367897034,
        -0.09779923409223557
      ],
      "plane_d": 3765.395751953125,
      "bbox_min": [
        -1338.3094482421875,
        -4009.609619140625,
        757.234375
      ],
      "bbox_max": [
        -1334.4393310546875,
        -4003.331787109375,
        757.6876220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8294076919555664,
        -0.5529384613037109,
        -0.07963670045137405
      ],
      "plane_d": -3266.076904296875,
      "bbox_min": [
        -1338.3094482421875,
        -4009.609619140625,
        757.416259765625
      ],
      "bbox_max": [
        -1337.5,
        -4008.40625,
        757.6002807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7467644214630127,
        0.45938149094581604,
        -0.48094862699508667
      ],
      "plane_d": 3226.9619140625,
      "bbox_min": [
        -1346.3004150390625,
        -4044.0,
        756.8474731445312
      ],
      "bbox_max": [
        -1346.0,
        -4043.63525390625,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23279087245464325,
        -0.04374389350414276,
        -0.971542477607727
      ],
      "plane_d": 251.79959106445312,
      "bbox_min": [
        -1387.858154296875,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -3953.10986328125,
        758.7901000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1942739486694336,
        -0.03794190287590027,
        -0.9802132844924927
      ],
      "plane_d": 331.74346923828125,
      "bbox_min": [
        -1326.4132080078125,
        -4039.806640625,
        744.6149291992188
      ],
      "bbox_max": [
        -1270.7230224609375,
        -3966.072265625,
        758.1175537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05937091261148453,
        0.1074926033616066,
        -0.992431640625
      ],
      "plane_d": 1095.9276123046875,
      "bbox_min": [
        -1326.4132080078125,
        -4039.519287109375,
        745.8762817382812
      ],
      "bbox_max": [
        -1273.0,
        -3966.072265625,
        758.1175537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12834957242012024,
        -0.10040953755378723,
        -0.986632764339447
      ],
      "plane_d": 169.8963623046875,
      "bbox_min": [
        -1326.4132080078125,
        -4039.519287109375,
        746.0
      ],
      "bbox_max": [
        -1273.0,
        -3966.072265625,
        758.1175537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9966575503349304,
        0.0,
        -0.08169324696063995
      ],
      "plane_d": 1375.5997314453125,
      "bbox_min": [
        -1326.4132080078125,
        -4028.4033203125,
        748.1385498046875
      ],
      "bbox_max": [
        -1281.6495361328125,
        -3966.072265625,
        758.1175537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9966575503349304,
        -0.08169323951005936
      ],
      "plane_d": 4014.7490234375,
      "bbox_min": [
        -1326.4132080078125,
        -3974.39794921875,
        753.6746826171875
      ],
      "bbox_max": [
        -1318.14453125,
        -3966.072265625,
        758.1175537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9966575503349304,
        -0.08169324696063995
      ],
      "plane_d": -3899.210205078125,
      "bbox_min": [
        -1326.4132080078125,
        -3974.39794921875,
        754.0126953125
      ],
      "bbox_max": [
        -1318.1732177734375,
        -3966.072265625,
        758.1175537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9951973557472229,
        0.0,
        -0.0978882685303688
      ],
      "plane_d": -1245.83203125,
      "bbox_min": [
        -1326.4132080078125,
        -3974.39794921875,
        755.5178833007812
      ],
      "bbox_max": [
        -1326.157470703125,
        -3966.072265625,
        758.1175537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9948341250419617,
        -0.10151368379592896
      ],
      "plane_d": 4075.622314453125,
      "bbox_min": [
        -1299.753662109375,
        -4028.4033203125,
        748.1385498046875
      ],
      "bbox_max": [
        -1281.6495361328125,
        -3999.805908203125,
        753.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        -0.12154118716716766
      ],
      "plane_d": -1188.9766845703125,
      "bbox_min": [
        -1289.9287109375,
        -4028.4033203125,
        748.1385498046875
      ],
      "bbox_max": [
        -1281.6495361328125,
        -4020.059326171875,
        751.9174194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9948341250419617,
        -0.10151368379592896
      ],
      "plane_d": -3931.300048828125,
      "bbox_min": [
        -1289.884033203125,
        -4028.4033203125,
        748.8970947265625
      ],
      "bbox_max": [
        -1281.68505859375,
        -4028.13232421875,
        751.5527954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.777728796005249,
        -0.6221801042556763,
        -0.08960919082164764
      ],
      "plane_d": -1416.767333984375,
      "bbox_min": [
        -1296.5,
        -4006.215087890625,
        749.8749389648438
      ],
      "bbox_max": [
        -1293.7841796875,
        -3999.805908203125,
        753.4883422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321856617927551,
        0.6758604645729065,
        -0.08436175435781479
      ],
      "plane_d": 3716.15478515625,
      "bbox_min": [
        -1296.5,
        -4002.800048828125,
        749.8749389648438
      ],
      "bbox_max": [
        -1293.7841796875,
        -3999.805908203125,
        753.4883422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        -0.10151368379592896
      ],
      "plane_d": 1351.2689208984375,
      "bbox_min": [
        -1288.9493408203125,
        -4039.519287109375,
        747.14501953125
      ],
      "bbox_max": [
        -1274.074951171875,
        -4020.660888671875,
        749.8280639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9948341250419617,
        -0.10151368379592896
      ],
      "plane_d": -3931.300048828125,
      "bbox_min": [
        -1288.9493408203125,
        -4028.227294921875,
        748.4284057617188
      ],
      "bbox_max": [
        -1281.86767578125,
        -4028.08447265625,
        749.8280639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7565224170684814,
        0.5988353490829468,
        -0.2628117501735687
      ],
      "plane_d": 1648.8375244140625,
      "bbox_min": [
        -1278.445068359375,
        -4039.519287109375,
        747.14501953125
      ],
      "bbox_max": [
        -1274.074951171875,
        -4035.074951171875,
        749.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30550703406333923,
        0.9165211319923401,
        -0.25817492604255676
      ],
      "plane_d": 3504.89306640625,
      "bbox_min": [
        -1278.445068359375,
        -4039.519287109375,
        748.0386962890625
      ],
      "bbox_max": [
        -1277.7529296875,
        -4039.0,
        749.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9526989459991455,
        -0.16641844809055328,
        -0.25430238246917725
      ],
      "plane_d": -1690.58056640625,
      "bbox_min": [
        -1307.0,
        -4011.0,
        745.8762817382812
      ],
      "bbox_max": [
        -1273.0,
        -3979.0,
        751.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1276831179857254,
        -0.8126031160354614,
        -0.5686590075492859
      ],
      "plane_d": -2972.882568359375,
      "bbox_min": [
        -1307.0,
        -3982.30615234375,
        745.8762817382812
      ],
      "bbox_max": [
        -1277.979248046875,
        -3979.0,
        751.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9068138599395752,
        -0.35624831914901733,
        -0.2253350466489792
      ],
      "plane_d": -2409.507080078125,
      "bbox_min": [
        -1279.098876953125,
        -3982.30615234375,
        745.8762817382812
      ],
      "bbox_max": [
        -1277.979248046875,
        -3979.528564453125,
        749.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1276831179857254,
        -0.8126031160354614,
        -0.5686590075492859
      ],
      "plane_d": -2972.882568359375,
      "bbox_min": [
        -1307.0,
        -4039.806640625,
        744.6149291992188
      ],
      "bbox_max": [
        -1270.7230224609375,
        -3978.696533203125,
        752.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9526989459991455,
        -0.16641844809055328,
        -0.25430238246917725
      ],
      "plane_d": -1690.58056640625,
      "bbox_min": [
        -1299.3780517578125,
        -4039.806640625,
        744.6149291992188
      ],
      "bbox_max": [
        -1270.7230224609375,
        -3978.696533203125,
        752.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8819280862808228,
        -0.3965337574481964,
        -0.2548801898956299
      ],
      "plane_d": -2523.05078125,
      "bbox_min": [
        -1273.0,
        -4011.601318359375,
        744.6638793945312
      ],
      "bbox_max": [
        -1272.343505859375,
        -4010.89599609375,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5005024671554565,
        -0.01881587877869606,
        -0.8655305504798889
      ],
      "plane_d": -66.92431640625,
      "bbox_min": [
        -1299.3780517578125,
        -4039.806640625,
        744.6149291992188
      ],
      "bbox_max": [
        -1270.7230224609375,
        -3978.696533203125,
        752.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9094005227088928,
        -0.09110631048679352,
        -0.4058205783367157
      ],
      "plane_d": -1220.35205078125,
      "bbox_min": [
        -1299.3780517578125,
        -4039.806640625,
        744.6149291992188
      ],
      "bbox_max": [
        -1270.7230224609375,
        -3978.696533203125,
        750.91064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7565224170684814,
        0.5988353490829468,
        -0.2628117501735687
      ],
      "plane_d": 1648.8375244140625,
      "bbox_min": [
        -1299.3780517578125,
        -4039.806640625,
        744.6149291992188
      ],
      "bbox_max": [
        -1270.8746337890625,
        -3978.696533203125,
        750.91064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        -0.12154118716716766
      ],
      "plane_d": -1188.9766845703125,
      "bbox_min": [
        -1299.3780517578125,
        -4039.806640625,
        744.6149291992188
      ],
      "bbox_max": [
        -1272.6741943359375,
        -3978.696533203125,
        750.91064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9948341250419617,
        -0.10151368379592896
      ],
      "plane_d": 4075.622314453125,
      "bbox_min": [
        -1289.69091796875,
        -4039.806640625,
        744.6149291992188
      ],
      "bbox_max": [
        -1272.6741943359375,
        -3978.696533203125,
        749.9755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9948341250419617,
        -0.10151368379592896
      ],
      "plane_d": -3931.300048828125,
      "bbox_min": [
        -1289.69091796875,
        -4039.806640625,
        747.1825561523438
      ],
      "bbox_max": [
        -1277.6082763671875,
        -4020.445068359375,
        749.9755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        -0.10151368379592896
      ],
      "plane_d": 1351.2689208984375,
      "bbox_min": [
        -1282.02197265625,
        -4028.08447265625,
        747.3846435546875
      ],
      "bbox_max": [
        -1281.91552734375,
        -4020.445068359375,
        748.4284057617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30550703406333923,
        0.9165211319923401,
        -0.25817492604255676
      ],
      "plane_d": 3504.89306640625,
      "bbox_min": [
        -1278.6912841796875,
        -4039.806640625,
        747.1825561523438
      ],
      "bbox_max": [
        -1277.6082763671875,
        -4039.329345703125,
        748.1831665039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9068138599395752,
        -0.35624831914901733,
        -0.2253350466489792
      ],
      "plane_d": -2409.507080078125,
      "bbox_min": [
        -1279.1322021484375,
        -4011.0,
        744.6149291992188
      ],
      "bbox_max": [
        -1272.6741943359375,
        -3978.696533203125,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9629088044166565,
        -0.13755840063095093,
        -0.23212981224060059
      ],
      "plane_d": -1604.36083984375,
      "bbox_min": [
        -1273.0,
        -4011.0,
        744.7081909179688
      ],
      "bbox_max": [
        -1272.6741943359375,
        -4009.950439453125,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8819280862808228,
        -0.3965337574481964,
        -0.2548801898956299
      ],
      "plane_d": -2523.05078125,
      "bbox_min": [
        -1273.0,
        -4011.0,
        744.7113647460938
      ],
      "bbox_max": [
        -1272.6741943359375,
        -4010.799560546875,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7275506258010864,
        -0.6790472865104675,
        -0.09779946506023407
      ],
      "plane_d": -3590.01513671875,
      "bbox_min": [
        -1299.3780517578125,
        -4005.818359375,
        749.5034790039062
      ],
      "bbox_max": [
        -1294.15234375,
        -4000.21142578125,
        750.91064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6776223182678223,
        0.7297471761703491,
        -0.0910879597067833
      ],
      "plane_d": 2108.943359375,
      "bbox_min": [
        -1299.3780517578125,
        -4005.818359375,
        749.5034790039062
      ],
      "bbox_max": [
        -1294.15234375,
        -4000.21142578125,
        750.91064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.777728796005249,
        -0.6221801042556763,
        -0.08960919082164764
      ],
      "plane_d": -1416.767333984375,
      "bbox_min": [
        -1296.5,
        -4005.818359375,
        749.5034790039062
      ],
      "bbox_max": [
        -1294.15234375,
        -4000.21142578125,
        750.4570922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321856617927551,
        0.6758604645729065,
        -0.08436175435781479
      ],
      "plane_d": 3716.15478515625,
      "bbox_min": [
        -1296.5,
        -4002.800048828125,
        749.5034790039062
      ],
      "bbox_max": [
        -1294.15234375,
        -4000.21142578125,
        750.2400512695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3096701502799988,
        -0.05214065685868263,
        -0.9494133591651917
      ],
      "plane_d": 924.6651611328125,
      "bbox_min": [
        -1387.858154296875,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -3953.10986328125,
        758.7901000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9944747686386108,
        0.0,
        -0.10497628152370453
      ],
      "plane_d": -1269.78125,
      "bbox_min": [
        -1356.9334716796875,
        -4033.91259765625,
        752.6614990234375
      ],
      "bbox_max": [
        -1337.1583251953125,
        -4002.958251953125,
        758.7901000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9961532950401306,
        -0.08762789517641068
      ],
      "plane_d": 4076.5615234375,
      "bbox_min": [
        -1356.9334716796875,
        -4033.91259765625,
        752.6614990234375
      ],
      "bbox_max": [
        -1337.1583251953125,
        -4002.958251953125,
        758.7901000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9961532950401306,
        -0.08762789517641068
      ],
      "plane_d": -3951.93603515625,
      "bbox_min": [
        -1356.89501953125,
        -4033.91259765625,
        753.051513671875
      ],
      "bbox_max": [
        -1348.6331787109375,
        -4025.633056640625,
        758.425537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9961532950401306,
        0.0,
        -0.08762789517641068
      ],
      "plane_d": 1409.859130859375,
      "bbox_min": [
        -1348.8831787109375,
        -4033.8359375,
        755.064697265625
      ],
      "bbox_max": [
        -1348.6331787109375,
        -4025.633056640625,
        757.906005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8294075727462769,
        0.5529384613037109,
        -0.07963669300079346
      ],
      "plane_d": 1164.3978271484375,
      "bbox_min": [
        -1339.73681640625,
        -4008.40625,
        756.9974975585938
      ],
      "bbox_max": [
        -1337.1583251953125,
        -4002.958251953125,
        757.7960205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8294076919555664,
        -0.5529384613037109,
        -0.07963670045137405
      ],
      "plane_d": -3266.076904296875,
      "bbox_min": [
        -1339.73681640625,
        -4008.40625,
        756.9974975585938
      ],
      "bbox_max": [
        -1337.1583251953125,
        -4002.958251953125,
        757.7960205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3967624008655548,
        -0.6881896257400513,
        -0.6074327230453491
      ],
      "plane_d": -1753.117431640625,
      "bbox_min": [
        -1365.019287109375,
        -4001.321044921875,
        748.45263671875
      ],
      "bbox_max": [
        -1333.0,
        -3985.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6342411637306213,
        -0.42796802520751953,
        -0.6438800096511841
      ],
      "plane_d": -365.262451171875,
      "bbox_min": [
        -1357.06201171875,
        -3993.971435546875,
        750.6444702148438
      ],
      "bbox_max": [
        -1353.0,
        -3992.5615234375,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4779053330421448,
        -0.7088632583618164,
        -0.5187671184539795
      ],
      "plane_d": -1792.73486328125,
      "bbox_min": [
        -1355.9176025390625,
        -3993.0,
        750.9498291015625
      ],
      "bbox_max": [
        -1353.0,
        -3992.5615234375,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4779053330421448,
        -0.7088632583618164,
        -0.5187671184539795
      ],
      "plane_d": -1792.73486328125,
      "bbox_min": [
        -1355.5357666015625,
        -3993.0,
        751.0648803710938
      ],
      "bbox_max": [
        -1352.9443359375,
        -3991.050048828125,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5845581293106079,
        -0.6112359166145325,
        -0.5335564017295837
      ],
      "plane_d": -1247.456298828125,
      "bbox_min": [
        -1354.2781982421875,
        -3993.0,
        751.4436645507812
      ],
      "bbox_max": [
        -1352.9443359375,
        -3991.050048828125,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09437675029039383,
        0.9123086333274841,
        -0.3984795808792114
      ],
      "plane_d": 4114.98388671875,
      "bbox_min": [
        -1387.858154296875,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -3953.10986328125,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.037053558975458145,
        0.9446187019348145,
        -0.32607129216194153
      ],
      "plane_d": 4017.0,
      "bbox_min": [
        -1350.7955322265625,
        -4059.0,
        714.0
      ],
      "bbox_max": [
        -1324.0,
        -4040.81103515625,
        756.8819580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7467644214630127,
        0.45938149094581604,
        -0.48094862699508667
      ],
      "plane_d": 3226.9619140625,
      "bbox_min": [
        -1350.7955322265625,
        -4043.97509765625,
        750.5559692382812
      ],
      "bbox_max": [
        -1346.113525390625,
        -4040.81103515625,
        756.8819580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21536336839199066,
        -0.7813403010368347,
        -0.5857695937156677
      ],
      "plane_d": -2382.54833984375,
      "bbox_min": [
        -1387.858154296875,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -3953.10986328125,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9966575503349304,
        -0.08169323951005936
      ],
      "plane_d": 4014.7490234375,
      "bbox_min": [
        -1326.193603515625,
        -3974.24462890625,
        738.0888671875
      ],
      "bbox_max": [
        -1318.4088134765625,
        -3966.285400390625,
        755.8849487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9951973557472229,
        0.0,
        -0.0978882685303688
      ],
      "plane_d": -1245.83203125,
      "bbox_min": [
        -1326.193603515625,
        -3974.24462890625,
        738.0888671875
      ],
      "bbox_max": [
        -1318.4088134765625,
        -3966.285400390625,
        755.8849487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9966575503349304,
        0.0,
        -0.08169324696063995
      ],
      "plane_d": 1375.5997314453125,
      "bbox_min": [
        -1326.193603515625,
        -3974.24462890625,
        739.7001342773438
      ],
      "bbox_max": [
        -1318.4088134765625,
        -3966.4365234375,
        755.8849487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9966575503349304,
        -0.08169324696063995
      ],
      "plane_d": -3899.210205078125,
      "bbox_min": [
        -1326.193603515625,
        -3974.24462890625,
        745.3882446289062
      ],
      "bbox_max": [
        -1318.4088134765625,
        -3973.38427734375,
        755.8849487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2554076313972473,
        0.8797374367713928,
        -0.40103480219841003
      ],
      "plane_d": 3522.43896484375,
      "bbox_min": [
        -1387.858154296875,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -3953.10986328125,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7565224170684814,
        0.5988353490829468,
        -0.2628117501735687
      ],
      "plane_d": 1648.8375244140625,
      "bbox_min": [
        -1277.6082763671875,
        -4046.038330078125,
        718.2675170898438
      ],
      "bbox_max": [
        -1272.243896484375,
        -4033.4296875,
        747.1825561523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9966575503349304,
        0.0,
        -0.08169324696063995
      ],
      "plane_d": 1375.5997314453125,
      "bbox_min": [
        -1325.1611328125,
        -3973.595947265625,
        738.3536987304688
      ],
      "bbox_max": [
        -1318.904052734375,
        -3967.58203125,
        747.9710083007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9966575503349304,
        -0.08169324696063995
      ],
      "plane_d": -3899.210205078125,
      "bbox_min": [
        -1325.1611328125,
        -3973.595947265625,
        738.3536987304688
      ],
      "bbox_max": [
        -1318.904052734375,
        -3967.58203125,
        747.9710083007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9951973557472229,
        0.0,
        -0.0978882685303688
      ],
      "plane_d": -1245.83203125,
      "bbox_min": [
        -1325.1611328125,
        -3973.38427734375,
        738.3536987304688
      ],
      "bbox_max": [
        -1319.5819091796875,
        -3967.58203125,
        745.38818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9526989459991455,
        -0.16641844809055328,
        -0.25430238246917725
      ],
      "plane_d": -1690.58056640625,
      "bbox_min": [
        -1277.6239013671875,
        -3982.858154296875,
        744.0989990234375
      ],
      "bbox_max": [
        -1277.478515625,
        -3982.412841796875,
        744.616455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23361419141292572,
        0.9342288374900818,
        -0.26951977610588074
      ],
      "plane_d": 4257.6513671875,
      "bbox_min": [
        -1387.858154296875,
        -4003.607421875,
        718.5511474609375
      ],
      "bbox_max": [
        -1377.806396484375,
        -3988.677978515625,
        734.9609985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06704727560281754,
        -0.4625547230243683,
        -0.8840519785881042
      ],
      "plane_d": -1292.00390625,
      "bbox_min": [
        -1385.3629150390625,
        -3996.718017578125,
        730.650146484375
      ],
      "bbox_max": [
        -1378.6229248046875,
        -3988.9482421875,
        734.2665405273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20318862795829773,
        -0.9725694060325623,
        -0.11323843896389008
      ],
      "plane_d": -4078.13134765625,
      "bbox_min": [
        -1384.62646484375,
        -3989.31640625,
        730.650146484375
      ],
      "bbox_max": [
        -1382.9024658203125,
        -3988.9482421875,
        730.7183837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.248297318816185,
        0.8697090148925781,
        -0.42656153440475464
      ],
      "plane_d": 4134.18896484375,
      "bbox_min": [
        -1387.3033447265625,
        -4002.0,
        727.7186889648438
      ],
      "bbox_max": [
        -1380.0,
        -3988.677978515625,
        731.4819946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20318862795829773,
        -0.9725694060325623,
        -0.11323843896389008
      ],
      "plane_d": -4078.13134765625,
      "bbox_min": [
        -1384.6263427734375,
        -3989.314208984375,
        728.2182006835938
      ],
      "bbox_max": [
        -1382.9080810546875,
        -3988.677978515625,
        730.7099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3716106712818146,
        0.04514895752072334,
        0.927290141582489
      ],
      "plane_d": 32.260711669921875,
      "bbox_min": [
        -1384.56396484375,
        -4037.0,
        714.0
      ],
      "bbox_max": [
        -1378.0,
        -3988.64697265625,
        732.6738891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06704727560281754,
        -0.4625547230243683,
        -0.8840519785881042
      ],
      "plane_d": -1292.00390625,
      "bbox_min": [
        -1384.56396484375,
        -3993.40234375,
        727.93798828125
      ],
      "bbox_max": [
        -1380.4974365234375,
        -3988.64697265625,
        732.6738891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20318862795829773,
        -0.9725694060325623,
        -0.11323843896389008
      ],
      "plane_d": -4078.13134765625,
      "bbox_min": [
        -1384.56396484375,
        -3989.33935546875,
        727.93798828125
      ],
      "bbox_max": [
        -1382.79443359375,
        -3988.64697265625,
        730.7222290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7467644214630127,
        0.45938149094581604,
        -0.48094862699508667
      ],
      "plane_d": 3226.9619140625,
      "bbox_min": [
        -1384.5567626953125,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -3959.78955078125,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3967624008655548,
        -0.6881896257400513,
        -0.6074327230453491
      ],
      "plane_d": -1753.117431640625,
      "bbox_min": [
        -1384.5567626953125,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -3959.78955078125,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4779053330421448,
        -0.7088632583618164,
        -0.5187671184539795
      ],
      "plane_d": -1792.73486328125,
      "bbox_min": [
        -1384.5567626953125,
        -3999.235107421875,
        720.9471435546875
      ],
      "bbox_max": [
        -1354.2781982421875,
        -3980.28466796875,
        751.4436645507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06704727560281754,
        -0.4625547230243683,
        -0.8840519785881042
      ],
      "plane_d": -1292.00390625,
      "bbox_min": [
        -1382.6114501953125,
        -3995.85888671875,
        730.7359619140625
      ],
      "bbox_max": [
        -1375.0,
        -3989.42138671875,
        733.8538818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6342411637306213,
        -0.42796802520751953,
        -0.6438800096511841
      ],
      "plane_d": -365.262451171875,
      "bbox_min": [
        -1381.7431640625,
        -3999.235107421875,
        720.9471435546875
      ],
      "bbox_max": [
        -1355.9176025390625,
        -3982.887939453125,
        750.9498291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06704727560281754,
        -0.4625547230243683,
        -0.8840519785881042
      ],
      "plane_d": -1292.00390625,
      "bbox_min": [
        -1379.108642578125,
        -3999.235107421875,
        731.0
      ],
      "bbox_max": [
        -1375.0,
        -3991.0,
        734.998291015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1629147231578827,
        0.8011069893836975,
        -0.5759221911430359
      ],
      "plane_d": 3850.69970703125,
      "bbox_min": [
        -1378.4202880859375,
        -3999.235107421875,
        733.2928466796875
      ],
      "bbox_max": [
        -1376.079345703125,
        -3998.16064453125,
        734.998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20318862795829773,
        -0.9725694060325623,
        -0.11323843896389008
      ],
      "plane_d": -4078.13134765625,
      "bbox_min": [
        -1381.7431640625,
        -3991.0,
        720.9471435546875
      ],
      "bbox_max": [
        -1375.0,
        -3988.464599609375,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47394466400146484,
        0.6032022833824158,
        0.6415008306503296
      ],
      "plane_d": 2630.19189453125,
      "bbox_min": [
        -1382.7137451171875,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -3959.78955078125,
        757.6504516601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8002145886421204,
        0.10950305312871933,
        -0.5896317958831787
      ],
      "plane_d": 1972.368896484375,
      "bbox_min": [
        -1382.7137451171875,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -3959.78955078125,
        757.6504516601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1629147231578827,
        0.8011069893836975,
        -0.5759221911430359
      ],
      "plane_d": 3850.69970703125,
      "bbox_min": [
        -1380.0,
        -4002.0,
        729.0
      ],
      "bbox_max": [
        -1376.060302734375,
        -3998.46826171875,
        734.9987182617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8819280862808228,
        -0.3965337574481964,
        -0.2548801898956299
      ],
      "plane_d": -2523.05078125,
      "bbox_min": [
        -1272.719482421875,
        -4034.22509765625,
        705.0
      ],
      "bbox_max": [
        -1254.0,
        -4006.0,
        744.7870483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8733698725700378,
        -0.39604711532592773,
        -0.2834990918636322
      ],
      "plane_d": -2489.83251953125,
      "bbox_min": [
        -1266.0,
        -4029.5,
        705.796630859375
      ],
      "bbox_max": [
        -1254.0,
        -4006.0,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823386669158936,
        0.18711212277412415
      ],
      "plane_d": 3824.267822265625,
      "bbox_min": [
        -1258.260009765625,
        -4029.5,
        705.8291625976562
      ],
      "bbox_max": [
        -1254.0,
        -4021.10009765625,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.008654806762933731,
        -0.09219640493392944,
        -0.9957032799720764
      ],
      "plane_d": 352.76910400390625,
      "bbox_min": [
        -1258.260009765625,
        -4029.5,
        705.8291625976562
      ],
      "bbox_max": [
        -1254.0,
        -4021.10009765625,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950371831655502,
        -0.9950371384620667
      ],
      "plane_d": 311.9938659667969,
      "bbox_min": [
        -1258.260009765625,
        -4029.5,
        716.0
      ],
      "bbox_max": [
        -1254.0,
        -4024.5,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08888152986764908,
        -0.8668120503425598,
        -0.49064943194389343
      ],
      "plane_d": -3025.3759765625,
      "bbox_min": [
        -1258.260009765625,
        -4026.735595703125,
        705.8291625976562
      ],
      "bbox_max": [
        -1254.0,
        -4021.10009765625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08164354413747787,
        -0.8697181344032288,
        -0.4867490231990814
      ],
      "plane_d": -3048.939453125,
      "bbox_min": [
        -1258.260009765625,
        -4024.5,
        710.7000122070312
      ],
      "bbox_max": [
        -1254.0,
        -4021.5,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06649525463581085,
        -0.9578752517700195,
        0.2793799936771393
      ],
      "plane_d": -3967.00634765625,
      "bbox_min": [
        -1257.9000244140625,
        -4026.735595703125,
        705.8291625976562
      ],
      "bbox_max": [
        -1254.0,
        -4021.10009765625,
        710.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09722144901752472,
        -0.9481465220451355,
        0.3025991916656494
      ],
      "plane_d": -3905.733642578125,
      "bbox_min": [
        -1257.9000244140625,
        -4022.60009765625,
        706.0
      ],
      "bbox_max": [
        -1254.0,
        -4021.10009765625,
        710.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09757836163043976,
        0.0,
        0.9952278733253479
      ],
      "plane_d": -824.994140625,
      "bbox_min": [
        -1255.742431640625,
        -4026.735595703125,
        705.8291625976562
      ],
      "bbox_max": [
        -1254.0,
        -4022.60009765625,
        706.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8904147744178772,
        -0.4439114034175873,
        -0.10051900148391724
      ],
      "plane_d": -2833.8037109375,
      "bbox_min": [
        -1266.0,
        -4029.5,
        705.796630859375
      ],
      "bbox_max": [
        -1254.0,
        -4006.0,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06649525463581085,
        -0.9578752517700195,
        0.2793799936771393
      ],
      "plane_d": -3967.00634765625,
      "bbox_min": [
        -1257.9000244140625,
        -4028.12646484375,
        705.796630859375
      ],
      "bbox_max": [
        -1254.0,
        -4021.5,
        710.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09757836163043976,
        0.0,
        0.9952278733253479
      ],
      "plane_d": -824.994140625,
      "bbox_min": [
        -1256.0740966796875,
        -4028.12646484375,
        705.796630859375
      ],
      "bbox_max": [
        -1254.0,
        -4022.77099609375,
        709.289306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9823386669158936,
        0.18711212277412415
      ],
      "plane_d": 3824.267822265625,
      "bbox_min": [
        -1254.4373779296875,
        -4028.12646484375,
        705.9982299804688
      ],
      "bbox_max": [
        -1254.0,
        -4027.5,
        709.289306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9823386669158936,
        0.18711212277412415
      ],
      "plane_d": 3824.267822265625,
      "bbox_min": [
        -1258.131591796875,
        -4029.5,
        707.9264526367188
      ],
      "bbox_max": [
        -1254.412841796875,
        -4020.8486328125,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06649525463581085,
        -0.9578752517700195,
        0.2793799936771393
      ],
      "plane_d": -3967.00634765625,
      "bbox_min": [
        -1257.9136962890625,
        -4021.798828125,
        709.6114501953125
      ],
      "bbox_max": [
        -1257.6282958984375,
        -4021.5,
        710.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9094005227088928,
        -0.09110631048679352,
        -0.4058205783367157
      ],
      "plane_d": -1220.35205078125,
      "bbox_min": [
        -1272.343505859375,
        -4034.22509765625,
        705.0
      ],
      "bbox_max": [
        -1254.0205078125,
        -4006.0,
        744.7870483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823386669158936,
        0.18711212277412415
      ],
      "plane_d": 3824.267822265625,
      "bbox_min": [
        -1258.260009765625,
        -4029.5,
        708.3424072265625
      ],
      "bbox_max": [
        -1254.4974365234375,
        -4024.5,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950371831655502,
        -0.9950371384620667
      ],
      "plane_d": 311.9938659667969,
      "bbox_min": [
        -1258.260009765625,
        -4029.5,
        716.0
      ],
      "bbox_max": [
        -1256.156494140625,
        -4024.5,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9250443577766418,
        0.07373745739459991,
        -0.3726334571838379
      ],
      "plane_d": -600.38427734375,
      "bbox_min": [
        -1269.1884765625,
        -4034.22509765625,
        705.0
      ],
      "bbox_max": [
        -1254.0205078125,
        -4006.0,
        741.8925170898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015595672652125359,
        0.9835212230682373,
        0.18011882901191711
      ],
      "plane_d": 3814.410888671875,
      "bbox_min": [
        -1258.8599853515625,
        -4029.5,
        705.9591064453125
      ],
      "bbox_max": [
        -1254.0205078125,
        -4024.5,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823386669158936,
        0.18711212277412415
      ],
      "plane_d": 3824.267822265625,
      "bbox_min": [
        -1258.8599853515625,
        -4029.5,
        706.0810546875
      ],
      "bbox_max": [
        -1254.0374755859375,
        -4027.515380859375,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950371831655502,
        -0.9950371384620667
      ],
      "plane_d": 311.9938659667969,
      "bbox_min": [
        -1258.8599853515625,
        -4029.5,
        716.4985961914062
      ],
      "bbox_max": [
        -1257.9820556640625,
        -4029.48583984375,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950371831655502,
        -0.9950371384620667
      ],
      "plane_d": 311.9938659667969,
      "bbox_min": [
        -1258.8599853515625,
        -4029.5,
        705.9591064453125
      ],
      "bbox_max": [
        -1254.0205078125,
        -4024.5,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09757836163043976,
        0.0,
        0.9952278733253479
      ],
      "plane_d": -824.994140625,
      "bbox_min": [
        -1254.4549560546875,
        -4027.5,
        705.9591064453125
      ],
      "bbox_max": [
        -1254.0205078125,
        -4026.65869140625,
        705.9982299804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08625808358192444,
        0.01035171840339899,
        0.9962190389633179
      ],
      "plane_d": -769.8067626953125,
      "bbox_min": [
        -1254.4549560546875,
        -4027.5,
        705.9591064453125
      ],
      "bbox_max": [
        -1254.0205078125,
        -4027.03955078125,
        705.9982299804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7525136470794678,
        0.6028929352760315,
        -0.2650345265865326
      ],
      "plane_d": 1671.9449462890625,
      "bbox_min": [
        -1268.9581298828125,
        -4034.22509765625,
        705.0
      ],
      "bbox_max": [
        -1254.3883056640625,
        -4006.0,
        741.224853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09757836163043976,
        0.0,
        0.9952278733253479
      ],
      "plane_d": -824.994140625,
      "bbox_min": [
        -1257.6282958984375,
        -4027.35986328125,
        705.739013671875
      ],
      "bbox_max": [
        -1254.3883056640625,
        -4021.798828125,
        709.6114501953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6736137270927429,
        0.4187908172607422,
        0.6089818477630615
      ],
      "plane_d": 403.19677734375,
      "bbox_min": [
        -1262.4078369140625,
        -4034.22509765625,
        713.0686645507812
      ],
      "bbox_max": [
        -1258.8599853515625,
        -4029.5,
        716.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26980075240135193,
        0.0323784314095974,
        0.9623717069625854
      ],
      "plane_d": -888.221923828125,
      "bbox_min": [
        -1259.5,
        -4027.5,
        705.0
      ],
      "bbox_max": [
        -1254.443603515625,
        -4017.0,
        710.3118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08625808358192444,
        0.01035171840339899,
        0.9962190389633179
      ],
      "plane_d": -769.8067626953125,
      "bbox_min": [
        -1258.6199951171875,
        -4027.5,
        705.5999755859375
      ],
      "bbox_max": [
        -1254.443603515625,
        -4022.796630859375,
        705.9742431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06649525463581085,
        -0.9578752517700195,
        0.2793799936771393
      ],
      "plane_d": -3967.00634765625,
      "bbox_min": [
        -1258.0799560546875,
        -4023.0,
        705.5999755859375
      ],
      "bbox_max": [
        -1256.66162109375,
        -4022.796630859375,
        705.9742431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9705181121826172,
        -0.21980787813663483,
        0.09888923168182373
      ],
      "plane_d": -2175.052734375,
      "bbox_min": [
        -1259.5,
        -4023.0,
        705.0
      ],
      "bbox_max": [
        -1256.7203369140625,
        -4017.0,
        710.3118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06649525463581085,
        -0.9578752517700195,
        0.2793799936771393
      ],
      "plane_d": -3967.00634765625,
      "bbox_min": [
        -1258.0799560546875,
        -4023.0,
        705.5999755859375
      ],
      "bbox_max": [
        -1256.7203369140625,
        -4021.6142578125,
        710.3118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9068138599395752,
        -0.35624831914901733,
        -0.2253350466489792
      ],
      "plane_d": -2409.507080078125,
      "bbox_min": [
        -1382.7137451171875,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1260.773681640625,
        -3959.78955078125,
        757.6504516601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2003403604030609,
        0.7512763738632202,
        0.6288461089134216
      ],
      "plane_d": 2337.488037109375,
      "bbox_min": [
        -1322.0,
        -4054.0,
        705.0
      ],
      "bbox_max": [
        -1288.61376953125,
        -4044.306884765625,
        714.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3500594198703766,
        0.7001188397407532,
        0.6223278045654297
      ],
      "plane_d": 1941.662841796875,
      "bbox_min": [
        -1292.0,
        -4053.0,
        705.0
      ],
      "bbox_max": [
        -1288.61376953125,
        -4044.306884765625,
        714.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7525136470794678,
        0.6028929352760315,
        -0.2650345265865326
      ],
      "plane_d": 1671.9449462890625,
      "bbox_min": [
        -1382.7137451171875,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1260.773681640625,
        -3967.58984375,
        757.6504516601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7565224170684814,
        0.5988353490829468,
        -0.2628117501735687
      ],
      "plane_d": 1648.8375244140625,
      "bbox_min": [
        -1272.736083984375,
        -4047.0,
        714.0
      ],
      "bbox_max": [
        -1270.5,
        -4031.5,
        745.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30550703406333923,
        0.9165211319923401,
        -0.25817492604255676
      ],
      "plane_d": 3504.89306640625,
      "bbox_min": [
        -1272.736083984375,
        -4047.0,
        714.0
      ],
      "bbox_max": [
        -1272.0,
        -4046.038330078125,
        718.267333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07752637565135956,
        0.7494215965270996,
        0.6575385332107544
      ],
      "plane_d": 2677.08056640625,
      "bbox_min": [
        -1382.7137451171875,
        -4062.0,
        705.0
      ],
      "bbox_max": [
        -1260.773681640625,
        -3967.58984375,
        757.6504516601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.084839828312397,
        0.7352785468101501,
        0.6724342703819275
      ],
      "plane_d": 2618.9111328125,
      "bbox_min": [
        -1382.7137451171875,
        -4059.0,
        705.0
      ],
      "bbox_max": [
        -1260.773681640625,
        -3967.58984375,
        757.6504516601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4318082332611084,
        -0.022601524367928505,
        -0.9016821980476379
      ],
      "plane_d": 1173.85693359375,
      "bbox_min": [
        -1382.7137451171875,
        -4053.0,
        705.0
      ],
      "bbox_max": [
        -1260.773681640625,
        -3967.58984375,
        757.6504516601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31366872787475586,
        -0.044809818267822266,
        0.9484745264053345
      ],
      "plane_d": -1253.8236083984375,
      "bbox_min": [
        -1277.5,
        -4029.37939453125,
        705.0
      ],
      "bbox_max": [
        -1260.773681640625,
        -3972.836669921875,
        714.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11131274700164795,
        -0.6678765416145325,
        0.7359010577201843
      ],
      "plane_d": -3341.86865234375,
      "bbox_min": [
        -1271.5,
        -4029.37939453125,
        705.0
      ],
      "bbox_max": [
        -1260.773681640625,
        -4006.0,
        714.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32220691442489624,
        0.9323589205741882,
        0.16398048400878906
      ],
      "plane_d": 3233.8349609375,
      "bbox_min": [
        -1264.201904296875,
        -4029.37939453125,
        705.3180541992188
      ],
      "bbox_max": [
        -1260.773681640625,
        -4028.22509765625,
        708.1655883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3282020092010498,
        -0.1289364993572235,
        0.9357664585113525
      ],
      "plane_d": -1598.4375,
      "bbox_min": [
        -1274.5794677734375,
        -3985.0,
        713.015380859375
      ],
      "bbox_max": [
        -1269.0,
        -3972.836669921875,
        714.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7275523543357849,
        0.6790457367897034,
        -0.09779923409223557
      ],
      "plane_d": 3765.395751953125,
      "bbox_min": [
        -1382.7137451171875,
        -4053.0,
        705.0
      ],
      "bbox_max": [
        -1261.3240966796875,
        -3967.58984375,
        757.6504516601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6342411637306213,
        -0.42796802520751953,
        -0.6438800096511841
      ],
      "plane_d": -365.262451171875,
      "bbox_min": [
        -1382.7137451171875,
        -4037.0,
        709.1412353515625
      ],
      "bbox_max": [
        -1348.844482421875,
        -3993.923095703125,
        755.504150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06704727560281754,
        -0.4625547230243683,
        -0.8840519785881042
      ],
      "plane_d": -1292.00390625,
      "bbox_min": [
        -1376.1182861328125,
        -3998.54052734375,
        734.8829956054688
      ],
      "bbox_max": [
        -1375.970703125,
        -3998.280517578125,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1629147231578827,
        0.8011069893836975,
        -0.5759221911430359
      ],
      "plane_d": 3850.69970703125,
      "bbox_min": [
        -1376.1182861328125,
        -3998.54052734375,
        734.9104614257812
      ],
      "bbox_max": [
        -1376.0,
        -3998.48876953125,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8013066053390503,
        0.09639780968427658,
        -0.5904364585876465
      ],
      "plane_d": 1922.015380859375,
      "bbox_min": [
        -1376.0,
        -4002.0,
        735.0
      ],
      "bbox_max": [
        -1366.0,
        -3998.5,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9944747686386108,
        0.0,
        -0.10497628152370453
      ],
      "plane_d": -1269.78125,
      "bbox_min": [
        -1379.9964599609375,
        -4033.298828125,
        711.1068725585938
      ],
      "bbox_max": [
        -1354.0,
        -4026.094482421875,
        752.947021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9944747686386108,
        0.0,
        0.10497628152370453
      ],
      "plane_d": -1423.2564697265625,
      "bbox_min": [
        -1379.9964599609375,
        -4031.5,
        711.1068725585938
      ],
      "bbox_max": [
        -1354.0,
        -4028.0,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3716106712818146,
        0.04514895752072334,
        0.927290141582489
      ],
      "plane_d": 32.260711669921875,
      "bbox_min": [
        -1379.9964599609375,
        -4030.039794921875,
        711.925537109375
      ],
      "bbox_max": [
        -1373.6956787109375,
        -4029.457275390625,
        714.432861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9944747686386108,
        0.0,
        0.10497628152370453
      ],
      "plane_d": -1423.2564697265625,
      "bbox_min": [
        -1379.84228515625,
        -4037.0,
        709.1412353515625
      ],
      "bbox_max": [
        -1351.0,
        -4029.75,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9961532950401306,
        0.08762789517641068
      ],
      "plane_d": -4080.0478515625,
      "bbox_min": [
        -1356.2720947265625,
        -4033.4228515625,
        709.1412353515625
      ],
      "bbox_max": [
        -1351.0,
        -4031.5,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3716106712818146,
        0.04514895752072334,
        0.927290141582489
      ],
      "plane_d": 32.260711669921875,
      "bbox_min": [
        -1379.84228515625,
        -4037.0,
        711.0
      ],
      "bbox_max": [
        -1371.0,
        -4029.822265625,
        714.3994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9944747686386108,
        0.0,
        0.10497628152370453
      ],
      "plane_d": -1423.2564697265625,
      "bbox_min": [
        -1382.7137451171875,
        -4029.828857421875,
        710.2097778320312
      ],
      "bbox_max": [
        -1351.0,
        -3998.5,
        744.9974365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9961532950401306,
        0.08762789517641068
      ],
      "plane_d": 3948.449462890625,
      "bbox_min": [
        -1356.116455078125,
        -4028.0,
        710.6300659179688
      ],
      "bbox_max": [
        -1351.0,
        -4026.208251953125,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8013066053390503,
        0.09639780968427658,
        -0.5904364585876465
      ],
      "plane_d": 1922.015380859375,
      "bbox_min": [
        -1382.7137451171875,
        -4029.674072265625,
        711.9686889648438
      ],
      "bbox_max": [
        -1368.21240234375,
        -3998.5,
        744.9974365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1629147231578827,
        0.8011069893836975,
        -0.5759221911430359
      ],
      "plane_d": 3850.69970703125,
      "bbox_min": [
        -1380.0,
        -4002.0,
        729.0
      ],
      "bbox_max": [
        -1376.0,
        -3998.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3716106712818146,
        0.04514895752072334,
        0.927290141582489
      ],
      "plane_d": 32.260711669921875,
      "bbox_min": [
        -1382.7137451171875,
        -4029.674072265625,
        711.9686889648438
      ],
      "bbox_max": [
        -1373.8212890625,
        -4019.191162109375,
        715.02197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8294076919555664,
        -0.5529384613037109,
        -0.07963670045137405
      ],
      "plane_d": -3266.076904296875,
      "bbox_min": [
        -1339.66015625,
        -4009.6005859375,
        734.5
      ],
      "bbox_max": [
        -1337.5,
        -4006.300048828125,
        757.5536499023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9961532950401306,
        0.08762789517641068
      ],
      "plane_d": -4080.0478515625,
      "bbox_min": [
        -1352.9228515625,
        -4033.456787109375,
        708.7540893554688
      ],
      "bbox_max": [
        -1349.0430908203125,
        -4026.177490234375,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9961532950401306,
        0.08762789517641068
      ],
      "plane_d": 3948.449462890625,
      "bbox_min": [
        -1352.7918701171875,
        -4028.0,
        710.2824096679688
      ],
      "bbox_max": [
        -1349.1776123046875,
        -4026.177490234375,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2176428735256195,
        0.6529286503791809,
        0.7254762053489685
      ],
      "plane_d": 1847.5704345703125,
      "bbox_min": [
        -1325.101318359375,
        -4053.0,
        705.0
      ],
      "bbox_max": [
        -1261.3240966796875,
        -3967.58984375,
        750.7398681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3500594198703766,
        0.7001188397407532,
        0.6223278045654297
      ],
      "plane_d": 1941.662841796875,
      "bbox_min": [
        -1290.0,
        -4053.0,
        705.0
      ],
      "bbox_max": [
        -1278.0,
        -4039.0,
        714.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": -4079.10400390625,
      "bbox_min": [
        -1299.3551025390625,
        -4053.0,
        705.0
      ],
      "bbox_max": [
        -1281.6529541015625,
        -4000.248779296875,
        750.7398681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        0.12154118716716766
      ],
      "plane_d": -1365.9405517578125,
      "bbox_min": [
        -1289.81640625,
        -4028.346923828125,
        705.0
      ],
      "bbox_max": [
        -1287.0,
        -4020.224365234375,
        745.1487426757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.777728796005249,
        -0.6221801042556763,
        -0.08960919082164764
      ],
      "plane_d": -1416.767333984375,
      "bbox_min": [
        -1296.5,
        -4005.77978515625,
        729.5
      ],
      "bbox_max": [
        -1294.1951904296875,
        -4000.248779296875,
        750.18994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321856617927551,
        0.6758604645729065,
        -0.08436175435781479
      ],
      "plane_d": 3716.15478515625,
      "bbox_min": [
        -1296.5,
        -4002.800048828125,
        729.5
      ],
      "bbox_max": [
        -1294.1951904296875,
        -4000.248779296875,
        749.9408569335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9948341250419617,
        -0.10151368379592896
      ],
      "plane_d": 4075.622314453125,
      "bbox_min": [
        -1289.6146240234375,
        -4024.25,
        728.0
      ],
      "bbox_max": [
        -1284.0,
        -4020.337646484375,
        749.3523559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        -0.12154118716716766
      ],
      "plane_d": -1188.9766845703125,
      "bbox_min": [
        -1289.6146240234375,
        -4024.25,
        728.0
      ],
      "bbox_max": [
        -1287.0,
        -4020.337646484375,
        749.3523559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        -0.12154118716716766
      ],
      "plane_d": -1188.9766845703125,
      "bbox_min": [
        -1289.6395263671875,
        -4028.199462890625,
        728.0
      ],
      "bbox_max": [
        -1287.0,
        -4023.821044921875,
        749.5554809570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30550703406333923,
        0.9165211319923401,
        -0.25817492604255676
      ],
      "plane_d": 3504.89306640625,
      "bbox_min": [
        -1290.0,
        -4053.0,
        714.0
      ],
      "bbox_max": [
        -1282.571533203125,
        -4050.08056640625,
        715.78955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        -0.10151368379592896
      ],
      "plane_d": 1351.2689208984375,
      "bbox_min": [
        -1286.1129150390625,
        -4050.52392578125,
        705.0
      ],
      "bbox_max": [
        -1261.3240966796875,
        -4016.832763671875,
        748.7066040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9948341250419617,
        -0.10151368379592896
      ],
      "plane_d": -3931.300048828125,
      "bbox_min": [
        -1286.1129150390625,
        -4028.11279296875,
        728.0
      ],
      "bbox_max": [
        -1281.9884033203125,
        -4020.42333984375,
        748.7066040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9948341250419617,
        -0.10151368379592896
      ],
      "plane_d": 4075.622314453125,
      "bbox_min": [
        -1286.0767822265625,
        -4022.5,
        728.0
      ],
      "bbox_max": [
        -1282.02197265625,
        -4020.42333984375,
        748.3516845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6736137270927429,
        0.4187908172607422,
        0.6089818477630615
      ],
      "plane_d": 403.19677734375,
      "bbox_min": [
        -1282.7540283203125,
        -4050.52392578125,
        705.0
      ],
      "bbox_max": [
        -1261.3240966796875,
        -4016.832763671875,
        745.2247924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32220691442489624,
        0.9323589205741882,
        0.16398048400878906
      ],
      "plane_d": 3233.8349609375,
      "bbox_min": [
        -1270.5,
        -4031.5,
        705.0
      ],
      "bbox_max": [
        -1261.3240966796875,
        -4025.8837890625,
        713.0686645507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06758368015289307,
        0.05127038061618805,
        0.996395468711853
      ],
      "plane_d": -581.6273193359375,
      "bbox_min": [
        -1270.5,
        -4031.5,
        705.0
      ],
      "bbox_max": [
        -1264.201904296875,
        -4025.8837890625,
        705.3180541992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47566473484039307,
        0.47566473484039307,
        0.7399228811264038
      ],
      "plane_d": 791.6646728515625,
      "bbox_min": [
        -1282.7540283203125,
        -4050.52392578125,
        705.0
      ],
      "bbox_max": [
        -1268.9581298828125,
        -4016.832763671875,
        745.2247924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9094005227088928,
        -0.09110631048679352,
        -0.4058205783367157
      ],
      "plane_d": -1220.35205078125,
      "bbox_min": [
        -1282.7540283203125,
        -4050.52392578125,
        714.0
      ],
      "bbox_max": [
        -1268.9581298828125,
        -4016.832763671875,
        745.2247924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5005024671554565,
        -0.01881587877869606,
        -0.8655305504798889
      ],
      "plane_d": -66.92431640625,
      "bbox_min": [
        -1270.8746337890625,
        -4031.87451171875,
        745.0
      ],
      "bbox_max": [
        -1270.5,
        -4029.6708984375,
        745.2247924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9966575503349304,
        -0.08169324696063995
      ],
      "plane_d": -3899.210205078125,
      "bbox_min": [
        -1325.101318359375,
        -3973.341796875,
        718.4366455078125
      ],
      "bbox_max": [
        -1319.1583251953125,
        -3967.58984375,
        744.8693237304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9966575503349304,
        0.0,
        -0.08169324696063995
      ],
      "plane_d": 1375.5997314453125,
      "bbox_min": [
        -1325.101318359375,
        -3973.341796875,
        718.8194580078125
      ],
      "bbox_max": [
        -1319.1583251953125,
        -3967.58984375,
        744.8693237304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9951973557472229,
        0.0,
        -0.0978882685303688
      ],
      "plane_d": -1245.83203125,
      "bbox_min": [
        -1325.101318359375,
        -3973.33447265625,
        719.3118286132812
      ],
      "bbox_max": [
        -1319.688232421875,
        -3967.605712890625,
        744.7796630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9966575503349304,
        -0.08169323951005936
      ],
      "plane_d": 4014.7490234375,
      "bbox_min": [
        -1324.443115234375,
        -3968.5,
        719.736083984375
      ],
      "bbox_max": [
        -1319.688232421875,
        -3967.605712890625,
        738.4029541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": 3874.046630859375,
      "bbox_min": [
        -1323.5,
        -3968.5,
        719.736083984375
      ],
      "bbox_max": [
        -1320.5,
        -3967.605712890625,
        728.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        0.12154118716716766
      ],
      "plane_d": -1402.230712890625,
      "bbox_min": [
        -1324.6251220703125,
        -3972.0,
        719.3118286132812
      ],
      "bbox_max": [
        -1322.6513671875,
        -3967.61962890625,
        728.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": 3874.046630859375,
      "bbox_min": [
        -1324.5341796875,
        -3968.5,
        719.87353515625
      ],
      "bbox_max": [
        -1322.6513671875,
        -3967.61962890625,
        728.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        0.10151368379592896
      ],
      "plane_d": 1239.7257080078125,
      "bbox_min": [
        -1321.21826171875,
        -3972.0,
        718.8194580078125
      ],
      "bbox_max": [
        -1319.51220703125,
        -3967.58984375,
        728.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": 3874.046630859375,
      "bbox_min": [
        -1321.21826171875,
        -3968.5,
        719.5798950195312
      ],
      "bbox_max": [
        -1319.58984375,
        -3967.58984375,
        728.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9948341250419617,
        0.10151368379592896
      ],
      "plane_d": -4025.433837890625,
      "bbox_min": [
        -1324.6685791015625,
        -3973.02685546875,
        718.4366455078125
      ],
      "bbox_max": [
        -1319.47314453125,
        -3971.206298828125,
        728.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9948341250419617,
        0.0,
        0.10151368379592896
      ],
      "plane_d": 1239.7257080078125,
      "bbox_min": [
        -1324.6685791015625,
        -3973.02685546875,
        718.4366455078125
      ],
      "bbox_max": [
        -1319.47314453125,
        -3971.206298828125,
        728.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9925863146781921,
        0.0,
        0.12154118716716766
      ],
      "plane_d": -1402.230712890625,
      "bbox_min": [
        -1324.6685791015625,
        -3972.973876953125,
        718.95654296875
      ],
      "bbox_max": [
        -1323.5,
        -3971.246826171875,
        728.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -716.9999389648438,
      "bbox_min": [
        -1471.0,
        -4039.25341796875,
        709.5
      ],
      "bbox_max": [
        -1384.121826171875,
        -3944.51220703125,
        775.7373046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19620098173618317,
        0.0012416653335094452,
        0.9805629849433899
      ],
      "plane_d": -968.05126953125,
      "bbox_min": [
        -1448.5,
        -4029.0,
        709.5
      ],
      "bbox_max": [
        -1384.121826171875,
        -3949.43359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3247.49072265625,
      "bbox_min": [
        -1413.4136962890625,
        -4021.5,
        709.5
      ],
      "bbox_max": [
        -1394.5,
        -4003.74658203125,
        713.306884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4003.74658203125,
      "bbox_min": [
        -1413.4136962890625,
        -4003.74658203125,
        709.5
      ],
      "bbox_max": [
        -1405.0,
        -4003.74658203125,
        711.1834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.187813863158226,
        -0.07920645922422409,
        0.979005753993988
      ],
      "plane_d": -746.3431396484375,
      "bbox_min": [
        -1448.5,
        -4029.0,
        709.5
      ],
      "bbox_max": [
        -1384.121826171875,
        -3949.43359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3989.24658203125,
      "bbox_min": [
        -1446.5,
        -4007.0,
        709.5
      ],
      "bbox_max": [
        -1413.218994140625,
        -3989.24658203125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3257.754150390625,
      "bbox_min": [
        -1426.0,
        -4007.0,
        709.5
      ],
      "bbox_max": [
        -1413.218994140625,
        -3989.24658203125,
        713.0680541992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4003.74658203125,
      "bbox_min": [
        -1416.92431640625,
        -4003.74658203125,
        709.5
      ],
      "bbox_max": [
        -1413.218994140625,
        -4003.74658203125,
        710.249755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11815007030963898,
        -0.1164906844496727,
        0.9861391186714172
      ],
      "plane_d": -998.7362670898438,
      "bbox_min": [
        -1448.5,
        -4029.0,
        709.5389404296875
      ],
      "bbox_max": [
        -1384.121826171875,
        -3949.43359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02373497560620308,
        -0.10811063647270203,
        0.9938554763793945
      ],
      "plane_d": -1104.4442138671875,
      "bbox_min": [
        -1448.5,
        -4029.0,
        709.5389404296875
      ],
      "bbox_max": [
        -1384.121826171875,
        -3949.43359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28258100152015686,
        -0.09443750977516174,
        0.9545834064483643
      ],
      "plane_d": -654.3199462890625,
      "bbox_min": [
        -1448.5,
        -4029.0,
        709.5389404296875
      ],
      "bbox_max": [
        -1384.121826171875,
        -3949.43359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2028341442346573,
        -0.1263923943042755,
        0.971021831035614
      ],
      "plane_d": -907.6112060546875,
      "bbox_min": [
        -1448.5,
        -4015.525390625,
        713.4112548828125
      ],
      "bbox_max": [
        -1428.2984619140625,
        -3975.80078125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3989.24658203125,
      "bbox_min": [
        -1445.9959716796875,
        -3989.24658203125,
        713.6049194335938
      ],
      "bbox_max": [
        -1428.2984619140625,
        -3989.24658203125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9182132482528687,
        -0.003922795876860619,
        -0.39606696367263794
      ],
      "plane_d": 1598.2540283203125,
      "bbox_min": [
        -1448.5,
        -4015.525390625,
        714.2433471679688
      ],
      "bbox_max": [
        -1430.4552001953125,
        -3989.24658203125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9024856090545654,
        -0.4112361967563629,
        -0.12807978689670563
      ],
      "plane_d": -245.24267578125,
      "bbox_min": [
        -1448.5,
        -3998.438720703125,
        716.816162109375
      ],
      "bbox_max": [
        -1448.4202880859375,
        -3998.32080078125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3989.24658203125,
      "bbox_min": [
        -1448.5,
        -3998.438720703125,
        714.2433471679688
      ],
      "bbox_max": [
        -1430.4552001953125,
        -3989.24658203125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9024856090545654,
        -0.4112361967563629,
        -0.12807978689670563
      ],
      "plane_d": -245.24267578125,
      "bbox_min": [
        -1448.5,
        -3998.438720703125,
        716.816162109375
      ],
      "bbox_max": [
        -1446.0081787109375,
        -3993.027587890625,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.030282754451036453,
        -0.1385878622531891,
        0.9898871183395386
      ],
      "plane_d": -1298.9024658203125,
      "bbox_min": [
        -1448.5,
        -4029.0,
        709.5389404296875
      ],
      "bbox_max": [
        -1384.121826171875,
        -3949.43359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004285666160285473,
        0.9506165385246277,
        -0.31033822894096375
      ],
      "plane_d": 4046.370849609375,
      "bbox_min": [
        -1448.5,
        -4029.0,
        709.5389404296875
      ],
      "bbox_max": [
        -1384.121826171875,
        -3949.43359375,
        717.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4003.74658203125,
      "bbox_min": [
        -1448.5,
        -4017.0,
        709.5389404296875
      ],
      "bbox_max": [
        -1401.5716552734375,
        -3991.58984375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9182132482528687,
        -0.003922795876860619,
        -0.39606696367263794
      ],
      "plane_d": 1598.2540283203125,
      "bbox_min": [
        -1448.5,
        -4017.0,
        716.9854125976562
      ],
      "bbox_max": [
        -1448.492919921875,
        -4015.356689453125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3257.754150390625,
      "bbox_min": [
        -1424.1141357421875,
        -4003.74658203125,
        710.249755859375
      ],
      "bbox_max": [
        -1416.9241943359375,
        -3991.58984375,
        713.1112060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3247.49072265625,
      "bbox_min": [
        -1410.6483154296875,
        -4021.5,
        711.6390380859375
      ],
      "bbox_max": [
        -1394.5,
        -4003.74658203125,
        715.1561889648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3247.49072265625,
      "bbox_min": [
        -1410.768798828125,
        -4021.5,
        712.3363647460938
      ],
      "bbox_max": [
        -1394.5,
        -4003.74658203125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4003.74658203125,
      "bbox_min": [
        -1410.768798828125,
        -4003.74658203125,
        712.3363647460938
      ],
      "bbox_max": [
        -1405.0,
        -4003.74658203125,
        712.8682861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038779765367507935,
        0.12549948692321777,
        0.9913354516029358
      ],
      "plane_d": -149.58624267578125,
      "bbox_min": [
        -1439.7672119140625,
        -4028.95556640625,
        711.2045288085938
      ],
      "bbox_max": [
        -1384.121826171875,
        -3949.43359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4003.74658203125,
      "bbox_min": [
        -1417.7607421875,
        -4007.0,
        712.3512573242188
      ],
      "bbox_max": [
        -1406.18798828125,
        -4002.616943359375,
        713.5183715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3257.754150390625,
      "bbox_min": [
        -1416.92431640625,
        -4007.0,
        713.1112060546875
      ],
      "bbox_max": [
        -1415.0,
        -4003.74658203125,
        713.5183715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3257.754150390625,
      "bbox_min": [
        -1417.5924072265625,
        -4003.74658203125,
        713.0648803710938
      ],
      "bbox_max": [
        -1416.92431640625,
        -4002.616943359375,
        713.1817626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.019443856552243233,
        0.16905193030834198,
        0.9854152798652649
      ],
      "plane_d": 1.8010196685791016,
      "bbox_min": [
        -1439.7672119140625,
        -4028.95556640625,
        711.359375
      ],
      "bbox_max": [
        -1384.121826171875,
        -3949.43359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40796294808387756,
        0.8298066258430481,
        -0.38077184557914734
      ],
      "plane_d": 3036.29736328125,
      "bbox_min": [
        -1421.5,
        -4028.95556640625,
        712.7618408203125
      ],
      "bbox_max": [
        -1406.04541015625,
        -4003.74658203125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6158796548843384,
        0.7665209770202637,
        -0.18203774094581604
      ],
      "plane_d": 2343.302978515625,
      "bbox_min": [
        -1421.5,
        -4028.95556640625,
        716.8668212890625
      ],
      "bbox_max": [
        -1421.4053955078125,
        -4028.847900390625,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4003.74658203125,
      "bbox_min": [
        -1406.99267578125,
        -4003.74658203125,
        712.7618408203125
      ],
      "bbox_max": [
        -1406.04541015625,
        -4003.74658203125,
        712.7933349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04386037960648537,
        -0.16419099271297455,
        0.9854530096054077
      ],
      "plane_d": -1416.5255126953125,
      "bbox_min": [
        -1413.5,
        -3968.04638671875,
        713.3890991210938
      ],
      "bbox_max": [
        -1397.9110107421875,
        -3949.43359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007675220258533955,
        -0.01399427093565464,
        0.9998726844787598
      ],
      "plane_d": -761.1514282226562,
      "bbox_min": [
        -1402.796142578125,
        -3951.874755859375,
        716.6843872070312
      ],
      "bbox_max": [
        -1397.9110107421875,
        -3949.43359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09817931801080704,
        -0.0766526460647583,
        0.9922122359275818
      ],
      "plane_d": -1151.4757080078125,
      "bbox_min": [
        -1400.1846923828125,
        -3951.874755859375,
        716.6843872070312
      ],
      "bbox_max": [
        -1397.9110107421875,
        -3949.43359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18893006443977356,
        -0.03277101740241051,
        0.9814436435699463
      ],
      "plane_d": -1097.3944091796875,
      "bbox_min": [
        -1400.1846923828125,
        -3951.874755859375,
        716.6843872070312
      ],
      "bbox_max": [
        -1398.8841552734375,
        -3949.494873046875,
        716.9786376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1773027777671814,
        -0.18303455412387848,
        0.9669861197471619
      ],
      "plane_d": -1165.509521484375,
      "bbox_min": [
        -1413.5,
        -3968.04638671875,
        713.3890991210938
      ],
      "bbox_max": [
        -1412.1341552734375,
        -3954.3173828125,
        715.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1462811827659607,
        -0.12060075998306274,
        0.9818642139434814
      ],
      "plane_d": -1384.430419921875,
      "bbox_min": [
        -1439.7672119140625,
        -4027.0341796875,
        711.359375
      ],
      "bbox_max": [
        -1384.121826171875,
        -3950.46484375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1477833092212677,
        -0.12308232486248016,
        0.9813311100006104
      ],
      "plane_d": -1396.003173828125,
      "bbox_min": [
        -1404.0,
        -3984.619873046875,
        711.359375
      ],
      "bbox_max": [
        -1386.5,
        -3968.158447265625,
        714.852294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12063074856996536,
        -0.16313017904758453,
        0.9792020916938782
      ],
      "plane_d": -1515.3319091796875,
      "bbox_min": [
        -1439.7672119140625,
        -4027.0341796875,
        712.6126098632812
      ],
      "bbox_max": [
        -1384.121826171875,
        -3950.46484375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09817931801080704,
        -0.0766526460647583,
        0.9922122359275818
      ],
      "plane_d": -1151.4757080078125,
      "bbox_min": [
        -1400.0,
        -3952.972900390625,
        716.6843872070312
      ],
      "bbox_max": [
        -1395.9530029296875,
        -3950.46484375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9437916874885559,
        0.2530621886253357,
        -0.212642103433609
      ],
      "plane_d": -149.93310546875,
      "bbox_min": [
        -1439.7672119140625,
        -4027.0341796875,
        712.6126098632812
      ],
      "bbox_max": [
        -1384.121826171875,
        -3954.554443359375,
        717.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -716.0,
      "bbox_min": [
        -1397.3939208984375,
        -4021.26513671875,
        713.6813354492188
      ],
      "bbox_max": [
        -1384.121826171875,
        -3984.956787109375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.915902853012085,
        0.21392999589443207,
        -0.3396410644054413
      ],
      "plane_d": -177.03466796875,
      "bbox_min": [
        -1397.2388916015625,
        -4017.025146484375,
        713.6813354492188
      ],
      "bbox_max": [
        -1392.5,
        -4001.143798828125,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3247.49072265625,
      "bbox_min": [
        -1397.2388916015625,
        -4017.025146484375,
        715.96533203125
      ],
      "bbox_max": [
        -1397.1466064453125,
        -4016.869140625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5197551250457764,
        0.8541514277458191,
        -0.016735214740037918
      ],
      "plane_d": 4152.9052734375,
      "bbox_min": [
        -1397.3939208984375,
        -4021.26513671875,
        716.0
      ],
      "bbox_max": [
        -1384.121826171875,
        -3984.956787109375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3247.49072265625,
      "bbox_min": [
        -1397.3939208984375,
        -4021.26513671875,
        716.0
      ],
      "bbox_max": [
        -1394.638916015625,
        -4016.60693359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3574698269367218,
        -0.902378261089325,
        -0.24068395793437958
      ],
      "plane_d": -3920.020751953125,
      "bbox_min": [
        -1388.950439453125,
        -3987.007568359375,
        716.0
      ],
      "bbox_max": [
        -1384.121826171875,
        -3984.956787109375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3247.49072265625,
      "bbox_min": [
        -1408.0,
        -4022.6875,
        715.1373291015625
      ],
      "bbox_max": [
        -1397.2335205078125,
        -4012.85546875,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7564694881439209,
        0.6088069677352905,
        -0.2389724999666214
      ],
      "plane_d": 1555.0506591796875,
      "bbox_min": [
        -1408.0,
        -4022.6875,
        716.0626220703125
      ],
      "bbox_max": [
        -1407.50341796875,
        -4021.70263671875,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40796294808387756,
        0.8298066258430481,
        -0.38077184557914734
      ],
      "plane_d": 3036.29736328125,
      "bbox_min": [
        -1408.0,
        -4022.6875,
        716.0626220703125
      ],
      "bbox_max": [
        -1407.917236328125,
        -4022.216552734375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3257.754150390625,
      "bbox_min": [
        -1439.7672119140625,
        -4027.0341796875,
        712.6126098632812
      ],
      "bbox_max": [
        -1386.5,
        -3954.554443359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3989.24658203125,
      "bbox_min": [
        -1439.7672119140625,
        -4027.0341796875,
        713.0680541992188
      ],
      "bbox_max": [
        -1407.9964599609375,
        -3989.24658203125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4003.74658203125,
      "bbox_min": [
        -1426.0,
        -4003.74658203125,
        713.1817626953125
      ],
      "bbox_max": [
        -1416.9241943359375,
        -4003.74658203125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13335657119750977,
        -0.20721040666103363,
        0.9691644906997681
      ],
      "plane_d": -1325.1123046875,
      "bbox_min": [
        -1433.9688720703125,
        -4013.3671875,
        712.7000122070312
      ],
      "bbox_max": [
        -1386.5,
        -3954.554443359375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1773027777671814,
        -0.18303455412387848,
        0.9669861197471619
      ],
      "plane_d": -1165.509521484375,
      "bbox_min": [
        -1419.433349609375,
        -3968.04638671875,
        713.3890991210938
      ],
      "bbox_max": [
        -1412.78564453125,
        -3954.554443359375,
        716.5728149414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4003.74658203125,
      "bbox_min": [
        -1416.92431640625,
        -4003.74658203125,
        712.7745971679688
      ],
      "bbox_max": [
        -1405.0,
        -4003.74658203125,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.933750569820404,
        -0.22511443495750427,
        -0.2782685160636902
      ],
      "plane_d": -1991.00048828125,
      "bbox_min": [
        -1389.8203125,
        -3966.49365234375,
        715.8765869140625
      ],
      "bbox_max": [
        -1389.5,
        -3965.804931640625,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.915902853012085,
        0.21392999589443207,
        -0.3396410644054413
      ],
      "plane_d": -177.03466796875,
      "bbox_min": [
        -1395.349853515625,
        -4008.16796875,
        713.6813354492188
      ],
      "bbox_max": [
        -1392.5,
        -4000.31396484375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8632397055625916,
        0.4522571861743927,
        -0.2242334485054016
      ],
      "plane_d": 767.4315185546875,
      "bbox_min": [
        -1393.340576171875,
        -4000.916015625,
        716.0
      ],
      "bbox_max": [
        -1392.8360595703125,
        -4000.31396484375,
        717.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9313905239105225,
        -0.35498949885368347,
        -0.08058612793684006
      ],
      "plane_d": -14.373779296875,
      "bbox_min": [
        -1471.0,
        -4038.25341796875,
        717.0
      ],
      "bbox_max": [
        -1412.1629638671875,
        -3954.327880859375,
        775.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9024856090545654,
        -0.4112361967563629,
        -0.12807978689670563
      ],
      "plane_d": -245.24267578125,
      "bbox_min": [
        -1471.0,
        -4037.58642578125,
        717.0
      ],
      "bbox_max": [
        -1428.2015380859375,
        -3960.16552734375,
        759.8094482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415736794471741,
        -0.32656940817832947,
        -0.08240924030542374
      ],
      "plane_d": 114.458251953125,
      "bbox_min": [
        -1471.0,
        -4033.225341796875,
        717.7014770507812
      ],
      "bbox_max": [
        -1428.2015380859375,
        -3960.16552734375,
        759.8094482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -722.9999389648438,
      "bbox_min": [
        -1471.0,
        -4033.225341796875,
        720.0
      ],
      "bbox_max": [
        -1449.58544921875,
        -4002.74658203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4002.74658203125,
      "bbox_min": [
        -1460.5,
        -4002.74658203125,
        720.0
      ],
      "bbox_max": [
        -1449.58544921875,
        -4002.74658203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9005752205848694,
        -0.4347001016139984,
        0.0
      ],
      "plane_d": -433.1175537109375,
      "bbox_min": [
        -1436.5,
        -3972.379638671875,
        717.7014770507812
      ],
      "bbox_max": [
        -1428.2015380859375,
        -3960.16552734375,
        759.8094482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9298749566078186,
        -0.3217651844024658,
        -0.17832475900650024
      ],
      "plane_d": 189.2982177734375,
      "bbox_min": [
        -1432.75,
        -3971.259521484375,
        756.108642578125
      ],
      "bbox_max": [
        -1428.2015380859375,
        -3960.16552734375,
        759.8094482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -722.9999389648438,
      "bbox_min": [
        -1463.4737548828125,
        -4037.58642578125,
        717.0
      ],
      "bbox_max": [
        -1436.5,
        -3972.379638671875,
        749.4652099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2028341442346573,
        -0.1263923943042755,
        0.971021831035614
      ],
      "plane_d": -907.6112060546875,
      "bbox_min": [
        -1456.0,
        -4019.464111328125,
        717.0
      ],
      "bbox_max": [
        -1436.5,
        -3972.379638671875,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -1456.0,
        -4019.464111328125,
        717.0
      ],
      "bbox_max": [
        -1446.82763671875,
        -3997.974609375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 791.4398193359375,
      "bbox_min": [
        -1456.0,
        -4016.5,
        717.0
      ],
      "bbox_max": [
        -1447.289794921875,
        -3998.19970703125,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9182132482528687,
        -0.003922795876860619,
        -0.39606696367263794
      ],
      "plane_d": 1598.2540283203125,
      "bbox_min": [
        -1448.4676513671875,
        -4003.55419921875,
        717.0
      ],
      "bbox_max": [
        -1447.289794921875,
        -3998.19970703125,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9606903791427612,
        0.2072286605834961,
        -0.18474413454532623
      ],
      "plane_d": 2352.57861328125,
      "bbox_min": [
        -1448.4676513671875,
        -4001.30712890625,
        717.0
      ],
      "bbox_max": [
        -1447.289794921875,
        -3998.19970703125,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9606903791427612,
        0.2072286605834961,
        -0.18474413454532623
      ],
      "plane_d": 2352.57861328125,
      "bbox_min": [
        -1450.01123046875,
        -4002.74658203125,
        720.0
      ],
      "bbox_max": [
        -1446.82763671875,
        -3997.974609375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4002.74658203125,
      "bbox_min": [
        -1450.01123046875,
        -4002.74658203125,
        720.0
      ],
      "bbox_max": [
        -1447.615478515625,
        -4002.74658203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9606903791427612,
        0.2072286605834961,
        -0.18474413454532623
      ],
      "plane_d": 2352.57861328125,
      "bbox_min": [
        -1447.4110107421875,
        -4000.678955078125,
        723.0
      ],
      "bbox_max": [
        -1442.75,
        -3995.988525390625,
        749.4652099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622904181480408,
        0.3780217170715332,
        -0.5253692269325256
      ],
      "plane_d": 831.8089599609375,
      "bbox_min": [
        -1460.8944091796875,
        -4038.25341796875,
        717.0
      ],
      "bbox_max": [
        -1412.1629638671875,
        -3954.327880859375,
        775.730224609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3808218538761139,
        0.4321991801261902,
        -0.8174219131469727
      ],
      "plane_d": 2890.0390625,
      "bbox_min": [
        -1460.8944091796875,
        -4038.25341796875,
        723.0
      ],
      "bbox_max": [
        -1415.418701171875,
        -3987.5537109375,
        767.4558715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -722.9999389648438,
      "bbox_min": [
        -1460.8944091796875,
        -4038.25341796875,
        723.0
      ],
      "bbox_max": [
        -1455.378173828125,
        -4034.50341796875,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34051716327667236,
        0.2407263219356537,
        -0.9088997840881348
      ],
      "plane_d": 2139.46728515625,
      "bbox_min": [
        -1416.024169921875,
        -3988.568115234375,
        767.2045288085938
      ],
      "bbox_max": [
        -1415.418701171875,
        -3987.5537109375,
        767.4558715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8664013147354126,
        0.07516343891620636,
        -0.4936591684818268
      ],
      "plane_d": 1912.6346435546875,
      "bbox_min": [
        -1459.7193603515625,
        -4038.25341796875,
        717.0
      ],
      "bbox_max": [
        -1412.1629638671875,
        -3954.327880859375,
        775.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -722.9999389648438,
      "bbox_min": [
        -1459.7193603515625,
        -4038.25341796875,
        720.0
      ],
      "bbox_max": [
        -1427.4935302734375,
        -3969.385498046875,
        764.5227661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -1454.2469482421875,
        -4030.620361328125,
        720.0
      ],
      "bbox_max": [
        -1447.6488037109375,
        -4007.4306640625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8414371609687805,
        0.08744072914123535,
        -0.5332332849502563
      ],
      "plane_d": 1956.001220703125,
      "bbox_min": [
        -1432.75,
        -3993.3037109375,
        756.108642578125
      ],
      "bbox_max": [
        -1427.4935302734375,
        -3969.385498046875,
        764.5227661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9298749566078186,
        -0.3217651844024658,
        -0.17832475900650024
      ],
      "plane_d": 189.2982177734375,
      "bbox_min": [
        -1432.75,
        -3971.259521484375,
        756.108642578125
      ],
      "bbox_max": [
        -1431.95654296875,
        -3969.385498046875,
        756.8643188476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9606903791427612,
        0.2072286605834961,
        -0.18474413454532623
      ],
      "plane_d": 2352.57861328125,
      "bbox_min": [
        -1446.1697998046875,
        -4015.62841796875,
        727.2694091796875
      ],
      "bbox_max": [
        -1441.75,
        -3995.988525390625,
        749.4652099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -1429.01953125,
        -4034.25341796875,
        717.0
      ],
      "bbox_max": [
        -1419.178466796875,
        -4026.313720703125,
        720.1367797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        -0.5090650916099548,
        0.0
      ],
      "plane_d": -827.59033203125,
      "bbox_min": [
        -1424.5,
        -4034.25341796875,
        717.0
      ],
      "bbox_max": [
        -1419.1849365234375,
        -4026.379638671875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40796294808387756,
        0.8298066258430481,
        -0.38077184557914734
      ],
      "plane_d": 3036.29736328125,
      "bbox_min": [
        -1421.4053955078125,
        -4028.847900390625,
        717.0
      ],
      "bbox_max": [
        -1421.09228515625,
        -4028.49169921875,
        717.4409790039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40796294808387756,
        0.8298066258430481,
        -0.38077184557914734
      ],
      "plane_d": 3036.29736328125,
      "bbox_min": [
        -1421.260986328125,
        -4028.77685546875,
        717.0
      ],
      "bbox_max": [
        -1419.1849365234375,
        -4026.379638671875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -1447.87158203125,
        -4038.25341796875,
        720.0
      ],
      "bbox_max": [
        -1421.215087890625,
        -4027.004638671875,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -722.9999389648438,
      "bbox_min": [
        -1446.2476806640625,
        -4038.25341796875,
        720.0
      ],
      "bbox_max": [
        -1432.84716796875,
        -4027.004638671875,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        -0.5090650916099548,
        0.0
      ],
      "plane_d": -816.7158203125,
      "bbox_min": [
        -1439.5,
        -4038.25341796875,
        720.0
      ],
      "bbox_max": [
        -1432.84716796875,
        -4027.004638671875,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -1447.9171142578125,
        -4029.0,
        717.0
      ],
      "bbox_max": [
        -1423.60791015625,
        -4021.4453125,
        740.0859985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8866892457008362,
        0.3715364336967468,
        -0.27521437406539917
      ],
      "plane_d": 2971.96826171875,
      "bbox_min": [
        -1441.264404296875,
        -4029.0,
        717.0
      ],
      "bbox_max": [
        -1440.480224609375,
        -4027.651611328125,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7838971018791199,
        0.48993563652038574,
        -0.3814033567905426
      ],
      "plane_d": 3377.0126953125,
      "bbox_min": [
        -1441.264404296875,
        -4029.0,
        717.0
      ],
      "bbox_max": [
        -1441.0,
        -4028.340087890625,
        717.7716064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8866892457008362,
        0.3715364336967468,
        -0.27521437406539917
      ],
      "plane_d": 2971.96826171875,
      "bbox_min": [
        -1446.286376953125,
        -4028.018310546875,
        720.0
      ],
      "bbox_max": [
        -1432.7554931640625,
        -4021.4453125,
        740.0859985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -722.9999389648438,
      "bbox_min": [
        -1446.286376953125,
        -4027.064697265625,
        723.0
      ],
      "bbox_max": [
        -1439.9603271484375,
        -4026.619140625,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -722.9999389648438,
      "bbox_min": [
        -1440.091064453125,
        -4027.986328125,
        720.0
      ],
      "bbox_max": [
        -1432.7554931640625,
        -4026.724609375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        -0.5090650916099548,
        0.0
      ],
      "plane_d": -816.7158203125,
      "bbox_min": [
        -1433.427734375,
        -4027.986328125,
        720.0
      ],
      "bbox_max": [
        -1432.7554931640625,
        -4026.849609375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -1449.6605224609375,
        -4028.69189453125,
        717.0
      ],
      "bbox_max": [
        -1412.1629638671875,
        -3954.327880859375,
        775.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3261.7294921875,
      "bbox_min": [
        -1448.6224365234375,
        -4028.69189453125,
        717.0
      ],
      "bbox_max": [
        -1417.6248779296875,
        -3998.74658203125,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7838971018791199,
        0.48993563652038574,
        -0.3814033567905426
      ],
      "plane_d": 3377.0126953125,
      "bbox_min": [
        -1448.6224365234375,
        -4028.69189453125,
        717.0
      ],
      "bbox_max": [
        -1419.05517578125,
        -3998.74658203125,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8866892457008362,
        0.3715364336967468,
        -0.27521437406539917
      ],
      "plane_d": 2971.96826171875,
      "bbox_min": [
        -1441.1439208984375,
        -4028.340087890625,
        717.7716064453125
      ],
      "bbox_max": [
        -1440.6337890625,
        -4026.434326171875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9606903791427612,
        0.2072286605834961,
        -0.18474413454532623
      ],
      "plane_d": 2352.57861328125,
      "bbox_min": [
        -1447.2303466796875,
        -4001.8984375,
        719.7918090820312
      ],
      "bbox_max": [
        -1447.1414794921875,
        -4001.62255859375,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        -0.5090650916099548,
        0.0
      ],
      "plane_d": -827.59033203125,
      "bbox_min": [
        -1421.210693359375,
        -4028.69189453125,
        717.0
      ],
      "bbox_max": [
        -1419.05517578125,
        -4025.04736328125,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29733017086982727,
        -0.20318518579006195,
        0.9329044222831726
      ],
      "plane_d": -1049.560791015625,
      "bbox_min": [
        -1441.945556640625,
        -3986.5078125,
        717.0
      ],
      "bbox_max": [
        -1425.20751953125,
        -3959.07568359375,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28258100152015686,
        -0.09443750977516174,
        0.9545834064483643
      ],
      "plane_d": -654.3199462890625,
      "bbox_min": [
        -1436.5,
        -3975.80078125,
        717.0
      ],
      "bbox_max": [
        -1433.9688720703125,
        -3971.896484375,
        717.7014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4480781555175781,
        0.2917606830596924,
        -0.8450453877449036
      ],
      "plane_d": 2446.28466796875,
      "bbox_min": [
        -1448.2198486328125,
        -4027.776611328125,
        720.0
      ],
      "bbox_max": [
        -1412.1629638671875,
        -3954.327880859375,
        775.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3276.6767578125,
      "bbox_min": [
        -1448.2198486328125,
        -4027.776611328125,
        720.0
      ],
      "bbox_max": [
        -1412.1629638671875,
        -3954.327880859375,
        775.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -722.9999389648438,
      "bbox_min": [
        -1448.2198486328125,
        -4027.776611328125,
        720.0
      ],
      "bbox_max": [
        -1429.0,
        -3999.92236328125,
        740.0859985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9182132482528687,
        -0.003922795876860619,
        -0.39606696367263794
      ],
      "plane_d": 1598.2540283203125,
      "bbox_min": [
        -1447.8751220703125,
        -4027.776611328125,
        720.0
      ],
      "bbox_max": [
        -1429.0,
        -4000.678955078125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9606903791427612,
        0.2072286605834961,
        -0.18474413454532623
      ],
      "plane_d": 2352.57861328125,
      "bbox_min": [
        -1447.8751220703125,
        -4005.158447265625,
        720.0
      ],
      "bbox_max": [
        -1445.8509521484375,
        -4000.678955078125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4002.74658203125,
      "bbox_min": [
        -1447.8751220703125,
        -4002.74658203125,
        720.0
      ],
      "bbox_max": [
        -1446.38134765625,
        -4002.74658203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4002.74658203125,
      "bbox_min": [
        -1446.8079833984375,
        -4002.74658203125,
        720.7813720703125
      ],
      "bbox_max": [
        -1445.8509521484375,
        -4002.74658203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8866892457008362,
        0.3715364336967468,
        -0.27521437406539917
      ],
      "plane_d": 2971.96826171875,
      "bbox_min": [
        -1441.287841796875,
        -4027.651611328125,
        720.0
      ],
      "bbox_max": [
        -1440.091064453125,
        -4023.86865234375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        -0.5090650916099548,
        0.0
      ],
      "plane_d": -816.7158203125,
      "bbox_min": [
        -1447.14501953125,
        -4027.776611328125,
        720.0
      ],
      "bbox_max": [
        -1429.0,
        -4002.74658203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4002.74658203125,
      "bbox_min": [
        -1447.14501953125,
        -4002.74658203125,
        720.0
      ],
      "bbox_max": [
        -1439.5,
        -4002.74658203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8866892457008362,
        0.3715364336967468,
        -0.27521437406539917
      ],
      "plane_d": 2971.96826171875,
      "bbox_min": [
        -1446.82763671875,
        -4026.724609375,
        723.0
      ],
      "bbox_max": [
        -1437.0,
        -3999.92236328125,
        740.0859985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7838971018791199,
        0.48993563652038574,
        -0.3814033567905426
      ],
      "plane_d": 3377.0126953125,
      "bbox_min": [
        -1445.90966796875,
        -4023.86865234375,
        723.0
      ],
      "bbox_max": [
        -1441.287841796875,
        -4012.875244140625,
        732.6351318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9182132482528687,
        -0.003922795876860619,
        -0.39606696367263794
      ],
      "plane_d": 1598.2540283203125,
      "bbox_min": [
        -1445.90966796875,
        -4016.4736328125,
        723.0
      ],
      "bbox_max": [
        -1441.75,
        -4012.875244140625,
        732.6351318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9606903791427612,
        0.2072286605834961,
        -0.18474413454532623
      ],
      "plane_d": 2352.57861328125,
      "bbox_min": [
        -1446.82763671875,
        -4015.62841796875,
        723.0
      ],
      "bbox_max": [
        -1441.75,
        -3999.92236328125,
        732.6351318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9182132482528687,
        -0.003922795876860619,
        -0.39606696367263794
      ],
      "plane_d": 1598.2540283203125,
      "bbox_min": [
        -1445.894287109375,
        -4015.62841796875,
        723.0
      ],
      "bbox_max": [
        -1441.75,
        -4005.158447265625,
        732.6351318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3496655225753784,
        0.20403356850147247,
        -0.9143873453140259
      ],
      "plane_d": 2011.044189453125,
      "bbox_min": [
        -1435.5546875,
        -3970.530517578125,
        720.0
      ],
      "bbox_max": [
        -1412.1629638671875,
        -3954.327880859375,
        775.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9005752205848694,
        -0.4347001016139984,
        0.0
      ],
      "plane_d": -433.1175537109375,
      "bbox_min": [
        -1435.5546875,
        -3970.530517578125,
        720.0
      ],
      "bbox_max": [
        -1412.1629638671875,
        -3954.327880859375,
        775.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9757429361343384,
        -0.12071535736322403,
        -0.18262936174869537
      ],
      "plane_d": 1051.5247802734375,
      "bbox_min": [
        -1425.0,
        -3970.1845703125,
        767.0311889648438
      ],
      "bbox_max": [
        -1422.8682861328125,
        -3958.224365234375,
        771.998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18476253747940063,
        0.14780493080615997,
        -0.971605122089386
      ],
      "plane_d": 1599.0875244140625,
      "bbox_min": [
        -1432.047607421875,
        -3969.54638671875,
        756.68017578125
      ],
      "bbox_max": [
        -1412.1629638671875,
        -3954.327880859375,
        775.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9298749566078186,
        -0.3217651844024658,
        -0.17832475900650024
      ],
      "plane_d": 189.2982177734375,
      "bbox_min": [
        -1432.047607421875,
        -3969.54638671875,
        756.68017578125
      ],
      "bbox_max": [
        -1428.0263671875,
        -3960.101806640625,
        760.6077270507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7679734826087952,
        0.623094916343689,
        -0.14822064340114594
      ],
      "plane_d": 1500.572265625,
      "bbox_min": [
        -1415.5,
        -3988.568115234375,
        717.0
      ],
      "bbox_max": [
        -1385.194580078125,
        -3944.51220703125,
        775.7373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9724577069282532,
        0.1684877723455429,
        -0.16105273365974426
      ],
      "plane_d": -572.4436645507812,
      "bbox_min": [
        -1415.5,
        -3988.568115234375,
        717.0
      ],
      "bbox_max": [
        -1387.0718994140625,
        -3951.874755859375,
        773.716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.938503086566925,
        -0.20408958196640015,
        -0.27849480509757996
      ],
      "plane_d": -1914.0616455078125,
      "bbox_min": [
        -1405.89013671875,
        -3984.17724609375,
        717.0
      ],
      "bbox_max": [
        -1387.0718994140625,
        -3953.909912109375,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.933750569820404,
        -0.22511443495750427,
        -0.2782685160636902
      ],
      "plane_d": -1991.00048828125,
      "bbox_min": [
        -1404.9569091796875,
        -3980.614990234375,
        717.0
      ],
      "bbox_max": [
        -1387.0718994140625,
        -3965.865234375,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86363285779953,
        0.4986172616481781,
        -0.07429099828004837
      ],
      "plane_d": 3248.1513671875,
      "bbox_min": [
        -1404.9010009765625,
        -3979.464111328125,
        759.8096313476562
      ],
      "bbox_max": [
        -1399.0,
        -3972.535888671875,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86363285779953,
        -0.4986172616481781,
        -0.07429100573062897
      ],
      "plane_d": -716.8529052734375,
      "bbox_min": [
        -1404.9010009765625,
        -3979.464111328125,
        759.8096313476562
      ],
      "bbox_max": [
        -1399.0,
        -3972.535888671875,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9972366690635681,
        -0.0742911621928215
      ],
      "plane_d": 4018.9853515625,
      "bbox_min": [
        -1404.9010009765625,
        -3979.464111328125,
        762.1338500976562
      ],
      "bbox_max": [
        -1401.0,
        -3972.535888671875,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9972366690635681,
        -0.0742911621928215
      ],
      "plane_d": -3911.04052734375,
      "bbox_min": [
        -1403.2303466796875,
        -3979.464111328125,
        766.095947265625
      ],
      "bbox_max": [
        -1401.0,
        -3978.94970703125,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9389446377754211,
        -0.21199221909046173,
        -0.2710024118423462
      ],
      "plane_d": -1951.379150390625,
      "bbox_min": [
        -1404.9569091796875,
        -3980.614990234375,
        717.0
      ],
      "bbox_max": [
        -1387.0718994140625,
        -3966.49365234375,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9972366690635681,
        -0.0742911621928215
      ],
      "plane_d": 4018.9853515625,
      "bbox_min": [
        -1404.9569091796875,
        -3979.464111328125,
        759.325927734375
      ],
      "bbox_max": [
        -1400.1346435546875,
        -3972.535888671875,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86363285779953,
        -0.4986172616481781,
        -0.07429100573062897
      ],
      "plane_d": -716.8529052734375,
      "bbox_min": [
        -1401.4818115234375,
        -3978.94970703125,
        759.325927734375
      ],
      "bbox_max": [
        -1400.1346435546875,
        -3973.345458984375,
        766.09619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86363285779953,
        0.4986172616481781,
        -0.07429099828004837
      ],
      "plane_d": 3248.1513671875,
      "bbox_min": [
        -1401.4818115234375,
        -3976.0,
        759.325927734375
      ],
      "bbox_max": [
        -1400.1346435546875,
        -3973.345458984375,
        762.1338500976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.762108325958252,
        0.31198468804359436,
        -0.5673239827156067
      ],
      "plane_d": 600.5391845703125,
      "bbox_min": [
        -1405.89013671875,
        -3984.17724609375,
        717.0
      ],
      "bbox_max": [
        -1391.919921875,
        -3953.909912109375,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9972366690635681,
        -0.0742911621928215
      ],
      "plane_d": 4018.9853515625,
      "bbox_min": [
        -1405.89013671875,
        -3979.464111328125,
        753.6220703125
      ],
      "bbox_max": [
        -1400.17626953125,
        -3972.550048828125,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9972366690635681,
        -0.0742911621928215
      ],
      "plane_d": -3911.04052734375,
      "bbox_min": [
        -1405.89013671875,
        -3979.464111328125,
        753.6220703125
      ],
      "bbox_max": [
        -1400.17626953125,
        -3973.370361328125,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86363285779953,
        -0.4986172616481781,
        -0.07429099828004837
      ],
      "plane_d": -3140.20654296875,
      "bbox_min": [
        -1405.89013671875,
        -3979.464111328125,
        753.6220703125
      ],
      "bbox_max": [
        -1400.17626953125,
        -3973.370361328125,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86363285779953,
        0.4986172616481781,
        -0.07429099828004837
      ],
      "plane_d": 3248.1513671875,
      "bbox_min": [
        -1401.72021484375,
        -3976.0,
        753.6220703125
      ],
      "bbox_max": [
        -1400.17626953125,
        -3973.370361328125,
        761.798095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86363285779953,
        0.4986172616481781,
        -0.07429099828004837
      ],
      "plane_d": 3248.1513671875,
      "bbox_min": [
        -1403.058349609375,
        -3978.1708984375,
        717.0
      ],
      "bbox_max": [
        -1391.919921875,
        -3953.909912109375,
        757.4676513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86363285779953,
        -0.4986172616481781,
        -0.07429100573062897
      ],
      "plane_d": -716.8529052734375,
      "bbox_min": [
        -1403.058349609375,
        -3978.1708984375,
        746.9420776367188
      ],
      "bbox_max": [
        -1400.6669921875,
        -3973.69287109375,
        757.4676513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9972366690635681,
        -0.0742911621928215
      ],
      "plane_d": 4018.9853515625,
      "bbox_min": [
        -1402.5850830078125,
        -3974.0419921875,
        752.7824096679688
      ],
      "bbox_max": [
        -1401.72021484375,
        -3973.69287109375,
        757.4676513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86363285779953,
        -0.4986172616481781,
        -0.07429099828004837
      ],
      "plane_d": -3140.20654296875,
      "bbox_min": [
        -1412.949462890625,
        -3987.61962890625,
        726.5
      ],
      "bbox_max": [
        -1401.2415771484375,
        -3969.69140625,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9972366690635681,
        -0.0742911621928215
      ],
      "plane_d": 4018.9853515625,
      "bbox_min": [
        -1405.9578857421875,
        -3979.8349609375,
        726.5
      ],
      "bbox_max": [
        -1401.2415771484375,
        -3969.69140625,
        773.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9972366690635681,
        -0.0742911621928215
      ],
      "plane_d": -3911.04052734375,
      "bbox_min": [
        -1405.9578857421875,
        -3979.8349609375,
        726.5
      ],
      "bbox_max": [
        -1401.2415771484375,
        -3973.4912109375,
        764.4600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86363285779953,
        0.4986172616481781,
        -0.07429099828004837
      ],
      "plane_d": 3248.1513671875,
      "bbox_min": [
        -1405.9578857421875,
        -3978.296875,
        726.5
      ],
      "bbox_max": [
        -1401.2415771484375,
        -3973.4912109375,
        760.8845825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86363285779953,
        -0.4986172616481781,
        -0.07429100573062897
      ],
      "plane_d": -716.8529052734375,
      "bbox_min": [
        -1405.9578857421875,
        -3978.296875,
        726.5
      ],
      "bbox_max": [
        -1401.2415771484375,
        -3973.4912109375,
        760.8845825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.773141622543335,
        0.3082776665687561,
        -0.5542715191841125
      ],
      "plane_d": 560.444091796875,
      "bbox_min": [
        -1405.9578857421875,
        -3978.296875,
        755.6406860351562
      ],
      "bbox_max": [
        -1402.5849609375,
        -3973.4912109375,
        760.8845825195312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.762108325958252,
        0.31198468804359436,
        -0.5673239827156067
      ],
      "plane_d": 600.5391845703125,
      "bbox_min": [
        -1403.3916015625,
        -3979.8349609375,
        754.9618530273438
      ],
      "bbox_max": [
        -1403.0582275390625,
        -3978.1708984375,
        755.8472900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.773141622543335,
        0.3082776665687561,
        -0.5542715191841125
      ],
      "plane_d": 560.444091796875,
      "bbox_min": [
        -1404.4483642578125,
        -3973.692626953125,
        757.4675903320312
      ],
      "bbox_max": [
        -1402.1619873046875,
        -3969.69140625,
        760.17431640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.762108325958252,
        0.31198468804359436,
        -0.5673239827156067
      ],
      "plane_d": 600.5391845703125,
      "bbox_min": [
        -1403.958251953125,
        -3984.27587890625,
        753.1904296875
      ],
      "bbox_max": [
        -1403.234130859375,
        -3979.61181640625,
        755.2960815429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7377917170524597,
        0.2596794664859772,
        -0.6230810284614563
      ],
      "plane_d": 469.435546875,
      "bbox_min": [
        -1415.5,
        -3988.568115234375,
        717.0
      ],
      "bbox_max": [
        -1392.5,
        -3951.874755859375,
        773.716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7336153984069824,
        0.2788398265838623,
        -0.6197232007980347
      ],
      "plane_d": 548.771240234375,
      "bbox_min": [
        -1413.5,
        -3968.158447265625,
        759.7252197265625
      ],
      "bbox_max": [
        -1400.0,
        -3951.874755859375,
        773.3890991210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6817938685417175,
        0.1887175291776657,
        -0.7067834138870239
      ],
      "plane_d": 331.74285888671875,
      "bbox_min": [
        -1413.5,
        -3968.04638671875,
        764.6843872070312
      ],
      "bbox_max": [
        -1400.0,
        -3951.874755859375,
        773.3890991210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.773141622543335,
        0.3082776665687561,
        -0.5542715191841125
      ],
      "plane_d": 560.444091796875,
      "bbox_min": [
        -1415.5,
        -3988.568115234375,
        717.0
      ],
      "bbox_max": [
        -1392.5,
        -3953.909912109375,
        773.716796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6817938685417175,
        0.1887175291776657,
        -0.7067834138870239
      ],
      "plane_d": 331.74285888671875,
      "bbox_min": [
        -1413.5,
        -3968.04638671875,
        717.0
      ],
      "bbox_max": [
        -1392.5,
        -3953.909912109375,
        773.716796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.14021065831184387,
        -0.14995090663433075,
        0.9787009954452515
      ],
      "plane_d": -1490.1278076171875,
      "bbox_min": [
        -1393.287109375,
        -3955.458251953125,
        717.0
      ],
      "bbox_max": [
        -1392.5,
        -3953.909912109375,
        717.269287109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6817938685417175,
        0.1887175291776657,
        -0.7067834138870239
      ],
      "plane_d": 331.74285888671875,
      "bbox_min": [
        -1413.3138427734375,
        -3966.13623046875,
        717.0
      ],
      "bbox_max": [
        -1385.194580078125,
        -3944.51220703125,
        775.7373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6423875093460083,
        0.29963013529777527,
        -0.70537930727005
      ],
      "plane_d": 824.150634765625,
      "bbox_min": [
        -1402.796142578125,
        -3951.874755859375,
        764.6843872070312
      ],
      "bbox_max": [
        -1398.8841552734375,
        -3949.494873046875,
        767.636962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5873640775680542,
        0.3236426115036011,
        -0.7417944669723511
      ],
      "plane_d": 1023.924072265625,
      "bbox_min": [
        -1400.1846923828125,
        -3951.874755859375,
        764.6843872070312
      ],
      "bbox_max": [
        -1398.8841552734375,
        -3949.494873046875,
        765.6624755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18476253747940063,
        0.14780493080615997,
        -0.971605122089386
      ],
      "plane_d": 1599.0875244140625,
      "bbox_min": [
        -1413.3138427734375,
        -3966.13623046875,
        717.0
      ],
      "bbox_max": [
        -1385.194580078125,
        -3944.51220703125,
        775.7373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09817931801080704,
        -0.0766526460647583,
        0.9922122359275818
      ],
      "plane_d": -1151.4757080078125,
      "bbox_min": [
        -1400.0,
        -3954.944091796875,
        717.0
      ],
      "bbox_max": [
        -1385.194580078125,
        -3944.51220703125,
        764.6843872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12063074856996536,
        -0.16313017904758453,
        0.9792020916938782
      ],
      "plane_d": -1515.3319091796875,
      "bbox_min": [
        -1395.9530029296875,
        -3954.944091796875,
        717.0
      ],
      "bbox_max": [
        -1392.5,
        -3952.972900390625,
        717.269287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13770407438278198,
        -0.06695916503667831,
        0.9882075190544128
      ],
      "plane_d": -1165.3143310546875,
      "bbox_min": [
        -1400.0,
        -3953.909912109375,
        717.269287109375
      ],
      "bbox_max": [
        -1385.194580078125,
        -3944.51220703125,
        764.6843872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8383132219314575,
        0.4159788489341736,
        -0.35240957140922546
      ],
      "plane_d": 739.7398681640625,
      "bbox_min": [
        -1400.0,
        -3951.874755859375,
        760.1801147460938
      ],
      "bbox_max": [
        -1396.493896484375,
        -3948.624755859375,
        764.6843872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8630246520042419,
        0.4982661008834839,
        -0.08318309485912323
      ],
      "plane_d": 3274.628662109375,
      "bbox_min": [
        -1419.3258056640625,
        -4027.825439453125,
        717.0
      ],
      "bbox_max": [
        -1384.17822265625,
        -3977.99560546875,
        767.2045288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9965343475341797,
        -0.08318327367305756
      ],
      "plane_d": -3934.25927734375,
      "bbox_min": [
        -1419.3258056640625,
        -4027.825439453125,
        717.0
      ],
      "bbox_max": [
        -1404.9698486328125,
        -3991.994384765625,
        765.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8630246520042419,
        -0.4982661008834839,
        -0.08318309485912323
      ],
      "plane_d": -719.4725341796875,
      "bbox_min": [
        -1417.6767578125,
        -4011.464111328125,
        719.5
      ],
      "bbox_max": [
        -1407.0,
        -3991.994384765625,
        765.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9965343475341797,
        -0.08318327367305756
      ],
      "plane_d": 4053.9599609375,
      "bbox_min": [
        -1417.6767578125,
        -4011.464111328125,
        719.5
      ],
      "bbox_max": [
        -1408.621337890625,
        -3991.994384765625,
        765.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8630246520042419,
        0.4982661008834839,
        -0.08318309485912323
      ],
      "plane_d": 839.173095703125,
      "bbox_min": [
        -1417.6767578125,
        -4011.464111328125,
        719.5
      ],
      "bbox_max": [
        -1408.621337890625,
        -4004.535888671875,
        761.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8630246520042419,
        -0.4982661008834839,
        -0.08318309485912323
      ],
      "plane_d": -3154.92822265625,
      "bbox_min": [
        -1415.62353515625,
        -4011.464111328125,
        719.5
      ],
      "bbox_max": [
        -1408.621337890625,
        -4005.385498046875,
        761.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7310777306556702,
        0.3696667551994324,
        -0.5734734535217285
      ],
      "plane_d": 878.5799560546875,
      "bbox_min": [
        -1414.0472412109375,
        -4010.330810546875,
        744.1795043945312
      ],
      "bbox_max": [
        -1408.621337890625,
        -4005.385498046875,
        751.1144409179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622904181480408,
        0.3780217170715332,
        -0.5253692269325256
      ],
      "plane_d": 831.8089599609375,
      "bbox_min": [
        -1414.0472412109375,
        -4008.086669921875,
        750.9581298828125
      ],
      "bbox_max": [
        -1413.683837890625,
        -4007.384765625,
        751.1144409179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7310777306556702,
        0.3696667551994324,
        -0.5734734535217285
      ],
      "plane_d": 878.5799560546875,
      "bbox_min": [
        -1415.62353515625,
        -4010.66943359375,
        747.4255981445312
      ],
      "bbox_max": [
        -1412.3460693359375,
        -4008.000244140625,
        751.4811401367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622904181480408,
        0.3780217170715332,
        -0.5253692269325256
      ],
      "plane_d": 831.8089599609375,
      "bbox_min": [
        -1415.62353515625,
        -4010.66943359375,
        750.7005004882812
      ],
      "bbox_max": [
        -1413.9822998046875,
        -4008.000244140625,
        751.4811401367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7310777306556702,
        0.3696667551994324,
        -0.5734734535217285
      ],
      "plane_d": 878.5799560546875,
      "bbox_min": [
        -1413.683837890625,
        -4007.385009765625,
        750.821533203125
      ],
      "bbox_max": [
        -1412.50927734375,
        -4005.3505859375,
        751.2380981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622904181480408,
        0.3780217170715332,
        -0.5253692269325256
      ],
      "plane_d": 831.8089599609375,
      "bbox_min": [
        -1417.08203125,
        -4005.704345703125,
        747.0025024414062
      ],
      "bbox_max": [
        -1409.6748046875,
        -3991.994384765625,
        765.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7310777306556702,
        0.3696667551994324,
        -0.5734734535217285
      ],
      "plane_d": 878.5799560546875,
      "bbox_min": [
        -1412.8184814453125,
        -4005.704345703125,
        747.0025024414062
      ],
      "bbox_max": [
        -1409.6748046875,
        -4001.978759765625,
        751.5831298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7310777306556702,
        0.3696667551994324,
        -0.5734734535217285
      ],
      "plane_d": 878.5799560546875,
      "bbox_min": [
        -1409.80224609375,
        -4010.073974609375,
        741.8828735351562
      ],
      "bbox_max": [
        -1407.7642822265625,
        -4008.000244140625,
        744.3483276367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40796294808387756,
        0.8298066258430481,
        -0.38077184557914734
      ],
      "plane_d": 3036.29736328125,
      "bbox_min": [
        -1419.3258056640625,
        -4027.825439453125,
        717.0
      ],
      "bbox_max": [
        -1404.9698486328125,
        -4012.240478515625,
        737.556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7140094637870789,
        0.6368358731269836,
        -0.29091307520866394
      ],
      "plane_d": 1764.7784423828125,
      "bbox_min": [
        -1407.50341796875,
        -4021.70263671875,
        717.0
      ],
      "bbox_max": [
        -1404.9698486328125,
        -4017.48583984375,
        721.0132446289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622904181480408,
        0.3780217170715332,
        -0.5253692269325256
      ],
      "plane_d": 831.8089599609375,
      "bbox_min": [
        -1418.4185791015625,
        -4018.515625,
        749.8909912109375
      ],
      "bbox_max": [
        -1415.05322265625,
        -4010.604248046875,
        754.2914428710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8607280850410461,
        0.5090650916099548,
        0.0
      ],
      "plane_d": 3261.7294921875,
      "bbox_min": [
        -1417.6248779296875,
        -4016.5,
        717.0
      ],
      "bbox_max": [
        -1414.0,
        -4010.37109375,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7554792165756226,
        0.3579258620738983,
        -0.5487625002861023
      ],
      "plane_d": 778.9210205078125,
      "bbox_min": [
        -1415.8338623046875,
        -4018.862060546875,
        717.0
      ],
      "bbox_max": [
        -1384.17822265625,
        -3977.99560546875,
        767.2045288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622904181480408,
        0.3780217170715332,
        -0.5253692269325256
      ],
      "plane_d": 831.8089599609375,
      "bbox_min": [
        -1415.8338623046875,
        -4002.86376953125,
        719.2109375
      ],
      "bbox_max": [
        -1384.45849609375,
        -3984.507568359375,
        767.2045288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.248297318816185,
        0.8697090148925781,
        -0.42656153440475464
      ],
      "plane_d": 4134.18896484375,
      "bbox_min": [
        -1395.2275390625,
        -4002.86376953125,
        719.2109375
      ],
      "bbox_max": [
        -1384.45849609375,
        -3988.015869140625,
        734.77587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06803738325834274,
        -0.46372783184051514,
        -0.8833614587783813
      ],
      "plane_d": -1298.564453125,
      "bbox_min": [
        -1395.2275390625,
        -4002.86376953125,
        719.2109375
      ],
      "bbox_max": [
        -1384.45849609375,
        -3988.015869140625,
        734.77587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06704727560281754,
        -0.4625547230243683,
        -0.8840519785881042
      ],
      "plane_d": -1292.00390625,
      "bbox_min": [
        -1389.9278564453125,
        -3992.138671875,
        730.5008544921875
      ],
      "bbox_max": [
        -1384.6263427734375,
        -3988.015869140625,
        732.3817138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20318862795829773,
        -0.9725694060325623,
        -0.11323843896389008
      ],
      "plane_d": -4078.13134765625,
      "bbox_min": [
        -1389.005126953125,
        -3988.948974609375,
        730.5008544921875
      ],
      "bbox_max": [
        -1384.6263427734375,
        -3988.015869140625,
        730.6569213867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23361419141292572,
        0.9342288374900818,
        -0.26951977610588074
      ],
      "plane_d": 4257.6513671875,
      "bbox_min": [
        -1391.8992919921875,
        -4002.86376953125,
        719.2109375
      ],
      "bbox_max": [
        -1384.45849609375,
        -3988.015869140625,
        730.650146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20318862795829773,
        -0.9725694060325623,
        -0.11323843896389008
      ],
      "plane_d": -4078.13134765625,
      "bbox_min": [
        -1389.005126953125,
        -3988.9482421875,
        724.1074829101562
      ],
      "bbox_max": [
        -1384.45849609375,
        -3988.015869140625,
        730.650146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.773141622543335,
        0.3082776665687561,
        -0.5542715191841125
      ],
      "plane_d": 560.444091796875,
      "bbox_min": [
        -1415.5,
        -3988.568115234375,
        753.359375
      ],
      "bbox_max": [
        -1404.0,
        -3984.507568359375,
        767.2045288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622904181480408,
        0.3780217170715332,
        -0.5253692269325256
      ],
      "plane_d": 831.8089599609375,
      "bbox_min": [
        -1414.135009765625,
        -4001.978515625,
        751.5831298828125
      ],
      "bbox_max": [
        -1404.0,
        -3984.36181640625,
        760.0159912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.773141622543335,
        0.3082776665687561,
        -0.5542715191841125
      ],
      "plane_d": 560.444091796875,
      "bbox_min": [
        -1404.58154296875,
        -3984.619873046875,
        753.359375
      ],
      "bbox_max": [
        -1404.0,
        -3984.36181640625,
        754.2329711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9437949657440186,
        0.2530507445335388,
        -0.21264156699180603
      ],
      "plane_d": -149.983642578125,
      "bbox_min": [
        -1406.864990234375,
        -4018.862060546875,
        717.0
      ],
      "bbox_max": [
        -1384.17822265625,
        -3977.99560546875,
        753.7674560546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3574698269367218,
        -0.902378261089325,
        -0.24068395793437958
      ],
      "plane_d": -3920.020751953125,
      "bbox_min": [
        -1395.5164794921875,
        -4003.395263671875,
        717.0
      ],
      "bbox_max": [
        -1384.17822265625,
        -3985.1171875,
        734.5848999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20318862795829773,
        -0.9725694060325623,
        -0.11323843896389008
      ],
      "plane_d": -4078.13134765625,
      "bbox_min": [
        -1392.5391845703125,
        -3988.583251953125,
        720.1830444335938
      ],
      "bbox_max": [
        -1384.35791015625,
        -3987.262939453125,
        730.8366088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06704727560281754,
        -0.4625547230243683,
        -0.8840519785881042
      ],
      "plane_d": -1292.00390625,
      "bbox_min": [
        -1392.5391845703125,
        -3988.583251953125,
        730.3748779296875
      ],
      "bbox_max": [
        -1389.005126953125,
        -3987.262939453125,
        730.8366088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5197551250457764,
        0.8541514277458191,
        -0.016735214740037918
      ],
      "plane_d": 4152.9052734375,
      "bbox_min": [
        -1395.5164794921875,
        -4003.395263671875,
        717.0
      ],
      "bbox_max": [
        -1387.8389892578125,
        -3987.262939453125,
        734.5848999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06803738325834274,
        -0.46372783184051514,
        -0.8833614587783813
      ],
      "plane_d": -1298.564453125,
      "bbox_min": [
        -1395.5164794921875,
        -3994.98779296875,
        730.3748779296875
      ],
      "bbox_max": [
        -1389.517822265625,
        -3987.262939453125,
        734.5848999023438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1629147231578827,
        0.8011069893836975,
        -0.5759221911430359
      ],
      "plane_d": 3850.69970703125,
      "bbox_min": [
        -1395.5164794921875,
        -3994.98779296875,
        734.4588623046875
      ],
      "bbox_max": [
        -1395.1832275390625,
        -3994.833984375,
        734.5848999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8308296203613281,
        0.37965837121009827,
        -0.40691715478897095
      ],
      "plane_d": 655.3731689453125,
      "bbox_min": [
        -1406.864990234375,
        -4018.862060546875,
        717.0
      ],
      "bbox_max": [
        -1387.0577392578125,
        -3977.99560546875,
        753.7674560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.508754551410675,
        0.4258534610271454,
        -0.7482096552848816
      ],
      "plane_d": 1540.857421875,
      "bbox_min": [
        -1406.0,
        -4011.316650390625,
        728.9957885742188
      ],
      "bbox_max": [
        -1393.25,
        -3981.115234375,
        740.8457641601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8216143250465393,
        0.42859968543052673,
        -0.37583547830581665
      ],
      "plane_d": 841.68896484375,
      "bbox_min": [
        -1406.0,
        -4011.316650390625,
        730.6937255859375
      ],
      "bbox_max": [
        -1395.5164794921875,
        -3994.833984375,
        738.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7658306360244751,
        0.3526405096054077,
        -0.5377249121665955
      ],
      "plane_d": 735.0123291015625,
      "bbox_min": [
        -1406.864990234375,
        -4018.862060546875,
        717.0
      ],
      "bbox_max": [
        -1387.0577392578125,
        -3977.99560546875,
        753.7674560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.933750569820404,
        -0.22511443495750427,
        -0.2782685160636902
      ],
      "plane_d": -1991.00048828125,
      "bbox_min": [
        -1393.6937255859375,
        -3981.115234375,
        740.1484375
      ],
      "bbox_max": [
        -1393.0689697265625,
        -3980.399169921875,
        741.8031616210938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7140094637870789,
        0.6368358731269836,
        -0.29091307520866394
      ],
      "plane_d": 1764.7784423828125,
      "bbox_min": [
        -1406.864990234375,
        -4018.862060546875,
        717.0
      ],
      "bbox_max": [
        -1393.0252685546875,
        -3980.210693359375,
        753.7674560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40796294808387756,
        0.8298066258430481,
        -0.38077184557914734
      ],
      "plane_d": 3036.29736328125,
      "bbox_min": [
        -1406.864990234375,
        -4013.516357421875,
        734.3208618164062
      ],
      "bbox_max": [
        -1406.0,
        -4011.316650390625,
        739.4730834960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6158796548843384,
        0.7665209770202637,
        -0.18203774094581604
      ],
      "plane_d": 2343.302978515625,
      "bbox_min": [
        -1406.864990234375,
        -4012.240478515625,
        737.556640625
      ],
      "bbox_max": [
        -1406.0,
        -4011.316650390625,
        739.4730834960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8766123652458191,
        0.41099995374679565,
        -0.2502591907978058
      ],
      "plane_d": 602.3924560546875,
      "bbox_min": [
        -1404.189697265625,
        -4008.076171875,
        717.0
      ],
      "bbox_max": [
        -1393.0252685546875,
        -3980.210693359375,
        753.7674560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.915902853012085,
        0.21392999589443207,
        -0.3396410644054413
      ],
      "plane_d": -177.03466796875,
      "bbox_min": [
        -1400.25,
        -4008.076171875,
        717.0
      ],
      "bbox_max": [
        -1393.0252685546875,
        -3997.711181640625,
        730.6937255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8632397055625916,
        0.4522571861743927,
        -0.2242334485054016
      ],
      "plane_d": 767.4315185546875,
      "bbox_min": [
        -1400.25,
        -4007.314697265625,
        717.0
      ],
      "bbox_max": [
        -1393.0252685546875,
        -3997.711181640625,
        730.6937255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8614370226860046,
        0.416966050863266,
        -0.2899405360221863
      ],
      "plane_d": 676.5447998046875,
      "bbox_min": [
        -1400.25,
        -4007.314697265625,
        726.4027709960938
      ],
      "bbox_max": [
        -1394.8040771484375,
        -3997.711181640625,
        730.6937255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.762108325958252,
        0.31198468804359436,
        -0.5673239827156067
      ],
      "plane_d": 600.5391845703125,
      "bbox_min": [
        -1404.189697265625,
        -3984.619873046875,
        752.5824584960938
      ],
      "bbox_max": [
        -1403.1591796875,
        -3983.978759765625,
        753.7674560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.773141622543335,
        0.3082776665687561,
        -0.5542715191841125
      ],
      "plane_d": 560.444091796875,
      "bbox_min": [
        -1404.189697265625,
        -3984.619873046875,
        753.359375
      ],
      "bbox_max": [
        -1403.958251953125,
        -3984.27587890625,
        753.7674560546875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: mt02a",
      "entity_class": "CGameArea",
      "piece_name": "mt02a",
      "offset": 54,
      "centroid": [
        -1341.5,
        -3972.875,
        708.25
      ],
      "bbox_min": [
        -1494.0,
        -4033.0,
        691.2000122070312
      ],
      "bbox_max": [
        -1189.0,
        -3918.39990234375,
        739.5
      ],
      "dimensions_source": {
        "span_x": 305.0,
        "span_y": 114.60009765625,
        "height_z": 48.29998779296875,
        "door_width": 305.0,
        "door_depth": 114.60009765625,
        "leaf_depth": 114.60009765625,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          1.0,
          -0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -1494.0,
          -3930.60009765625,
          691.2000122070312
        ],
        [
          -1494.0,
          -3930.60009765625,
          701.7999877929688
        ],
        [
          -1494.0,
          -3918.39990234375,
          701.7999877929688
        ],
        [
          -1494.0,
          -3918.39990234375,
          691.2000122070312
        ],
        [
          -1189.0,
          -4033.0,
          700.5
        ],
        [
          -1189.0,
          -4009.5,
          700.5
        ],
        [
          -1189.0,
          -4009.5,
          739.5
        ],
        [
          -1189.0,
          -4033.0,
          739.5
        ]
      ],
      "plane_distance": 1494.0
    }
  ],
  "tutorial_messages": []
}